
  document.addEventListener('DOMContentLoaded', function() {
    var currentTabSet = "RAL";
    var extraInfo = {
    };

    var colorSets = {
      "RAL": [      { hex: "#CDBA88", name: "1000 - Groenbeige" }, 
      { hex: "#D0B084", name: "1001 - Beige" }, 
      { hex: "#D2AA6D", name: "1002 - Zandgeel" }, 
      { hex: "#F9A900", name: "1003 - Signaalgeel" }, 
      { hex: "#E49E00", name: "1004 - Goudgeel" }, 
      { hex: "#CB8F00", name: "1005 - Honinggeel" }, 
      { hex: "#E19000", name: "1006 - Maisgeel" }, 
      { hex: "#E88C00", name: "1007 - Narcissengeel" }, 
      { hex: "#AF8050", name: "1011 - Bruinbeige" }, 
      { hex: "#DDAF28", name: "1012 - Citroengeel" }, 
      { hex: "#E3D9C7", name: "1013 - Parelwit" }, 
      { hex: "#DDC49B", name: "1014 - Ivoorkleurig" }, 
      { hex: "#E6D2B5", name: "1015 - Licht ivoorkleurig" }, 
      { hex: "#F1DD39", name: "1016 - Zwavelgeel" }, 
      { hex: "#F6A951", name: "1017 - Saffraangeel" }, 
      { hex: "#FACA31", name: "1018 - Zinkgeel" }, 
      { hex: "#A48F7A", name: "1019 - Grijsbeige" }, 
      { hex: "#A08F65", name: "1020 - Olijfgeel" }, 
      { hex: "#F6B600", name: "1021 - Koolzaadgeel" }, 
      { hex: "#F7B500", name: "1023 - Verkeersgeel" }, 
      { hex: "#BA8F4C", name: "1024 - Okergeel" }, 
      { hex: "#FFFF00", name: "1026 - Briljantgeel" }, 
      { hex: "#A77F0F", name: "1027 - Kerriegeel" }, 
      { hex: "#FF9C00", name: "1028 - Meloengeel" }, 
      { hex: "#E2A300", name: "1032 - Bremgeel" }, 
      { hex: "#F99A1D", name: "1033 - Dahliageel" }, 
      { hex: "#EB9C52", name: "1034 - Pastelgeel" }, 
      { hex: "#8F8370", name: "1035 - Parelmoergrijs" }, 
      { hex: "#806440", name: "1036 - Parelmoergoud" }, 
      { hex: "#F09200", name: "1037 - Zonnegeel" }, 
      { hex: "#DA6E00", name: "2000 - Geeloranje" }, 
      { hex: "#BA481C", name: "2001 - Roodoranje" }, 
      { hex: "#BF3922", name: "2002 - Vermiljoen" }, 
      { hex: "#F67829", name: "2003 - Pasteloranje" }, 
      { hex: "#E25304", name: "2004 - Zuiver oranje" }, 
      { hex: "#FF4D08", name: "2005 - Briljantoranje" }, 
      { hex: "#FFB200", name: "2007 - Briljant lichtoranje" }, 
      { hex: "#EC6B22", name: "2008 - Licht roodoranje" }, 
      { hex: "#DE5308", name: "2009 - Verkeersoranje" }, 
      { hex: "#D05D29", name: "2010 - Signaaloranje" }, 
      { hex: "#E26E0F", name: "2011 - Dieporanje" }, 
      { hex: "#D5654E", name: "2012 - Zalmoranje" }, 
      { hex: "#923E25", name: "2013 - Parelmoeroranje" }, 
      { hex: "#FC5500", name: "2017 - RAL oranje" }, 
      { hex: "#A72920", name: "3000 - Vuurrood" }, 
      { hex: "#9B2423", name: "3001 - Signaalrood" }, 
      { hex: "#9B2321", name: "3002 - Karmijnrood" }, 
      { hex: "#861A22", name: "3003 - Robijnrood" }, 
      { hex: "#6B1C23", name: "3004 - Purperrood" }, 
      { hex: "#59191F", name: "3005 - Wijnrood" }, 
      { hex: "#3E2022", name: "3007 - Zwartrood" }, 
      { hex: "#6D342D", name: "3009 - Oxyderood" }, 
      { hex: "#782423", name: "3011 - Bruinrood" }, 
      { hex: "#C5856D", name: "3012 - Beigerood" }, 
      { hex: "#972E25", name: "3013 - Tomaatrood" }, 
      { hex: "#CB7375", name: "3014 - Oudroze" }, 
      { hex: "#D8A0A6", name: "3015 - Lichtroze" }, 
      { hex: "#A63D30", name: "3016 - Koraalrood" }, 
      { hex: "#CA555D", name: "3017 - Bleekrood" }, 
      { hex: "#C63F4A", name: "3018 - Aardbeirood" }, 
      { hex: "#BB1F11", name: "3020 - Verkeersrood" }, 
      { hex: "#CF6955", name: "3022 - Zalmrood" }, 
      { hex: "#FF2D21", name: "3024 - Briljantrood" }, 
      { hex: "#FF2A1C", name: "3026 - Briljant lichtrood" }, 
      { hex: "#AB273C", name: "3027 - Framboosrood" }, 
      { hex: "#CC2C24", name: "3028 - Zuiver rood" }, 
      { hex: "#A63437", name: "3031 - Oriëntrood" }, 
      { hex: "#701D24", name: "3032 - Parelmoerdonkerrood" }, 
      { hex: "#A53A2E", name: "3033 - Parelmoerlichtrood" }, 
      { hex: "#816183", name: "4001 - Roodlila" }, 
      { hex: "#8D3C4B", name: "4002 - Roodpaars" }, 
      { hex: "#C4618C", name: "4003 - Heidepaars" }, 
      { hex: "#651E38", name: "4004 - Bordeauxpaars" }, 
      { hex: "#76689A", name: "4005 - Blauwlila" }, 
      { hex: "#903373", name: "4006 - Verkeerspurper" }, 
      { hex: "#47243C", name: "4007 - Purperviolet" }, 
      { hex: "#844C82", name: "4008 - Signaalviolet" }, 
      { hex: "#9D8692", name: "4009 - Pastelviolet" }, 
      { hex: "#BB4077", name: "4010 - Telemagenta" }, 
      { hex: "#6E6387", name: "4011 - Parelmoerdonkerviolet" }, 
      { hex: "#6A6B7F", name: "4012 - Parelmoerlichtviolet" }, 
      { hex: "#304F6E", name: "5000 - Paarsblauw" }, 
      { hex: "#0E4C64", name: "5001 - Groenblauw" }, 
      { hex: "#00387A", name: "5002 - Ultramarijnblauw" }, 
      { hex: "#1F3855", name: "5003 - Saffierblauw" }, 
      { hex: "#191E28", name: "5004 - Zwartblauw" }, 
      { hex: "#005387", name: "5005 - Signaalblauw" }, 
      { hex: "#376B8C", name: "5007 - Briljantblauw" }, 
      { hex: "#2B3A44", name: "5008 - Grijsblauw" }, 
      { hex: "#215F78", name: "5009 - Azuurblauw" }, 
      { hex: "#004F7C", name: "5010 - Gentiaanblauw" }, 
      { hex: "#1A2B3C", name: "5011 - Staalblauw" }, 
      { hex: "#0089B6", name: "5012 - Lichtblauw" }, 
      { hex: "#193153", name: "5013 - Kobaltblauw" }, 
      { hex: "#637D96", name: "5014 - Duifblauw" }, 
      { hex: "#007CAF", name: "5015 - Hemelsblauw" }, 
      { hex: "#005B8C", name: "5017 - Verkeersblauw" }, 
      { hex: "#048B8C", name: "5018 - Turkooisblauw" }, 
      { hex: "#005E83", name: "5019 - Capriblauw" }, 
      { hex: "#00414B", name: "5020 - Oceaanblauw" }, 
      { hex: "#007577", name: "5021 - Waterblauw" }, 
      { hex: "#222D5A", name: "5022 - Nachtblauw" }, 
      { hex: "#41698C", name: "5023 - Verblauw" }, 
      { hex: "#6093AC", name: "5024 - Pastelblauw" }, 
      { hex: "#20697C", name: "5025 - Parelmoerblauw" }, 
      { hex: "#0F3052", name: "5026 - Parelmoernachtblauw" }, 
      { hex: "#3C7460", name: "6000 - Patinagroen" }, 
      { hex: "#366735", name: "6001 - Smaragdgroen" }, 
      { hex: "#325928", name: "6002 - Loofgroen" }, 
      { hex: "#50533C", name: "6003 - Olijfgroen" }, 
      { hex: "#024442", name: "6004 - Blauwgroen" }, 
      { hex: "#114232", name: "6005 - Mosgroen" }, 
      { hex: "#3C392E", name: "6006 - Grijs olijfgroen" }, 
      { hex: "#2C3222", name: "6007 - Flessengroen" }, 
      { hex: "#36342A", name: "6008 - Bruingroen" }, 
      { hex: "#27352A", name: "6009 - Dennengroen" }, 
      { hex: "#4D6F39", name: "6010 - Grasgroen" }, 
      { hex: "#6B7C59", name: "6011 - Resedagroen" }, 
      { hex: "#2F3D3A", name: "6012 - Zwartgroen" }, 
      { hex: "#7C765A", name: "6013 - Rietgroen" }, 
      { hex: "#474135", name: "6014 - Geel olijfgroen" }, 
      { hex: "#3D3D36", name: "6015 - Zwart olijfgroen" }, 
      { hex: "#00694C", name: "6016 - Turkooisgroen" }, 
      { hex: "#587F40", name: "6017 - Meigroen" }, 
      { hex: "#60993B", name: "6018 - Geelgroen" }, 
      { hex: "#B9CEAC", name: "6019 - Witgroen" }, 
      { hex: "#37422F", name: "6020 - Chroomoxydegroen" }, 
      { hex: "#8A9977", name: "6021 - Bleekgroen" }, 
      { hex: "#3A3327", name: "6022 - Bruin olijfgroen" }, 
      { hex: "#008351", name: "6024 - Verkeersgroen" }, 
      { hex: "#5E6E3B", name: "6025 - Varengroen" }, 
      { hex: "#005F4E", name: "6026 - Opaalgroen" }, 
      { hex: "#7EBAB5", name: "6027 - Lichtgroen" }, 
      { hex: "#315442", name: "6028 - Pijnboomgroen" }, 
      { hex: "#006F3D", name: "6029 - Mintgroen" }, 
      { hex: "#237F52", name: "6032 - Signaalgroen" }, 
      { hex: "#45877F", name: "6033 - Mintturquoise" }, 
      { hex: "#7AADAC", name: "6034 - Pastelturquoise" }, 
      { hex: "#194D25", name: "6035 - Parelmoerdonkergroen" }, 
      { hex: "#04574B", name: "6036 - Parelmoerlichtgroen" }, 
      { hex: "#008B29", name: "6037 - Zuiver groen" }, 
      { hex: "#00B51B", name: "6038 - Briljantgroen" }, 
      { hex: "#B3C43E", name: "6039 - Fibergroen" }, 
      { hex: "#7A888E", name: "7000 - Pelsgrijs" }, 
      { hex: "#8C979C", name: "7001 - Zilvergrijs" }, 
      { hex: "#817863", name: "7002 - Olijfgrijs" }, 
      { hex: "#797669", name: "7003 - Mosgrijs" }, 
      { hex: "#9A9B9B", name: "7004 - Signaalgrijs" }, 
      { hex: "#6B6E6B", name: "7005 - Muisgrijs" }, 
      { hex: "#766A5E", name: "7006 - Beigegrijs" }, 
      { hex: "#745F3D", name: "7008 - Kakigrijs" }, 
      { hex: "#5D6058", name: "7009 - Groengrijs" }, 
      { hex: "#585C56", name: "7010 - Zeildoekgrijs" }, 
      { hex: "#52595D", name: "7011 - IJzergrijs" }, 
      { hex: "#575D5E", name: "7012 - Bazaltgrijs" }, 
      { hex: "#575044", name: "7013 - Bruingrijs" }, 
      { hex: "#4F5358", name: "7015 - Leigrijs" }, 
      { hex: "#383E42", name: "7016 - Antracietgrijs" }, 
      { hex: "#2F3234", name: "7021 - Zwartgrijs" }, 
      { hex: "#4C4A44", name: "7022 - Ombergrijs" }, 
      { hex: "#808076", name: "7023 - Betongrijs" }, 
      { hex: "#45494E", name: "7024 - Grafietgrijs" }, 
      { hex: "#374345", name: "7026 - Granietgrijs" }, 
      { hex: "#928E85", name: "7030 - Steengrijs" }, 
      { hex: "#5B686D", name: "7031 - Blauwgrijs" }, 
      { hex: "#B5B0A1", name: "7032 - Kiezelgrijs" }, 
      { hex: "#7F8274", name: "7033 - Cementgrijs" }, 
      { hex: "#92886F", name: "7034 - Geelgrijs" }, 
      { hex: "#C5C7C4", name: "7035 - Lichtgrijs" }, 
      { hex: "#979392", name: "7036 - Platinagrijs" }, 
      { hex: "#7A7B7A", name: "7037 - Stofgrijs" }, 
      { hex: "#B0B0A9", name: "7038 - Agaatgrijs" }, 
      { hex: "#6B665E", name: "7039 - Kwartsgrijs" }, 
      { hex: "#989EA1", name: "7040 - Venstergrijs" }, 
      { hex: "#8E9291", name: "7042 - Verkeersgrijs A" }, 
      { hex: "#4F5250", name: "7043 - Verkeersgrijs B" }, 
      { hex: "#B7B3A8", name: "7044 - Zijdegrijs" }, 
      { hex: "#8D9295", name: "7045 - Telegrijs 1" }, 
      { hex: "#7E868A", name: "7046 - Telegrijs 2" }, 
      { hex: "#C8C8C7", name: "7047 - Telegrijs 4" }, 
      { hex: "#817B73", name: "7048 - Parelmoermuisgrijs" }, 
      { hex: "#89693F", name: "8000 - Groenbruin" }, 
      { hex: "#9D622B", name: "8001 - Okerbruin" }, 
      { hex: "#794D3E", name: "8002 - Signaalbruin" }, 
      { hex: "#7E4B27", name: "8003 - Leembruin" }, 
      { hex: "#8D4931", name: "8004 - Koperbruin" }, 
      { hex: "#70462B", name: "8007 - Reebruin" }, 
      { hex: "#724A25", name: "8008 - Olijfbruin" }, 
      { hex: "#5A3827", name: "8011 - Notenbruin" }, 
      { hex: "#66332B", name: "8012 - Roodbruin" }, 
      { hex: "#4A3526", name: "8014 - Sepiabruin" }, 
      { hex: "#5E2F26", name: "8015 - Kastanjebruin" }, 
      { hex: "#4C2B20", name: "8016 - Mahoniebruin" }, 
      { hex: "#442F29", name: "8017 - Chocoladebruin" }, 
      { hex: "#3D3635", name: "8019 - Grijsbruin" }, 
      { hex: "#1A1719", name: "8022 - Zwartbruin" }, 
      { hex: "#A45729", name: "8023 - Oranjebruin" }, 
      { hex: "#795038", name: "8024 - Beigebruin" }, 
      { hex: "#755847", name: "8025 - Bleekbruin" }, 
      { hex: "#513A2A", name: "8028 - Terrabruin" }, 
      { hex: "#7F4031", name: "8029 - Parelmoerkoper" }, 
      { hex: "#E9E0D2", name: "9001 - Crèmewit" }, 
      { hex: "#D6D5CB", name: "9002 - Grijswit" }, 
      { hex: "#ECECE7", name: "9003 - Signaalwit" }, 
      { hex: "#2B2B2C", name: "9004 - Signaalzwart" }, 
      { hex: "#0E0E10", name: "9005 - Gitzwart" }, 
      { hex: "#A1A1A0", name: "9006 - Blank aluminiumkleurig" }, 
      { hex: "#868581", name: "9007 - Grijs aluminiumkleurig" }, 
      { hex: "#F1EDE1", name: "9010 - Zuiver wit" }, 
      { hex: "#27292B", name: "9011 - Grafietzwart" }, 
      { hex: "#F8F2E1", name: "9012 - Ultrareine zone wit" }, 
      { hex: "#F1F1EA", name: "9016 - Verkeerswit" }, 
      { hex: "#29292A", name: "9017 - Verkeerszwart" }, 
      { hex: "#C8CBC4", name: "9018 - Papyruswit" }, 
      { hex: "#858583", name: "9022 - Parelmoerlichtgrijs" }, 
      { hex: "#787B7A", name: "9023 - Parelmoerdonkergrijs" }
    ],
      "Lucite house-paint": [      { hex: "#FFFFFF", name: "1000T" }, 
      { hex: "#f6ebe3", name: "1001T" }, 
      { hex: "#a16b43", name: "1002T" }, 
      { hex: "#d6cac1", name: "1003T" }, 
      { hex: "#79864d", name: "1004T" }, 
      { hex: "#d2d6c5", name: "1005T" }, 
      { hex: "#f1dcc5", name: "1006T" }, 
      { hex: "#e4d2ad", name: "1007T" }, 
      { hex: "#f1ed77", name: "1009T" }, 
      { hex: "#495e6b", name: "1011T" }, 
      { hex: "#504947", name: "1013T" }, 
      { hex: "#404341", name: "1014T" }, 
      { hex: "#bca045", name: "1016T" }, 
      { hex: "#50504a", name: "1017T" }, 
      { hex: "#f1eecd", name: "1018T" }, 
      { hex: "#131515", name: "1021T" }, 
      { hex: "#d6c251", name: "1022T" }, 
      { hex: "#848661", name: "1023T" }, 
      { hex: "#863c41", name: "1024T" }, 
      { hex: "#865342", name: "1025T" }, 
      { hex: "#504e4a", name: "Lucite HP 1" }, 
      { hex: "#866a68", name: "Lucite HP 10" }, 
      { hex: "#86827a", name: "Lucite HP 11" }, 
      { hex: "#bc9096", name: "Lucite HP 12" }, 
      { hex: "#6b4441", name: "Lucite HP 13" }, 
      { hex: "#6b4841", name: "Lucite HP 14" }, 
      { hex: "#6b3f42", name: "Lucite HP 15" }, 
      { hex: "#866146", name: "Lucite HP 16" }, 
      { hex: "#a1915d", name: "Lucite HP 17" }, 
      { hex: "#bc8775", name: "Lucite HP 18" }, 
      { hex: "#a16d52", name: "Lucite HP 19" }, 
      { hex: "#504c48", name: "Lucite HP 2" }, 
      { hex: "#bc5a45", name: "Lucite HP 21" }, 
      { hex: "#d65950", name: "Lucite HP 22" }, 
      { hex: "#f18973", name: "Lucite HP 23" }, 
      { hex: "#d6c3af", name: "Lucite HP 24" }, 
      { hex: "#bca96c", name: "Lucite HP 25" }, 
      { hex: "#d6b979", name: "Lucite HP 26" }, 
      { hex: "#d6c17c", name: "Lucite HP 27" }, 
      { hex: "#e4cdab", name: "Lucite HP 28" }, 
      { hex: "#E1C8A3", name: "Lucite HP 29" }, 
      { hex: "#868472", name: "Lucite HP 3" }, 
      { hex: "#f1e4b9", name: "Lucite HP 30" }, 
      { hex: "#86805f", name: "Lucite HP 31" }, 
      { hex: "#a16b43", name: "Lucite HP 32" }, 
      { hex: "#d6c97e", name: "Lucite HP 33" }, 
      { hex: "#e4dcb1", name: "Lucite HP 34" }, 
      { hex: "#f1efae", name: "Lucite HP 35" }, 
      { hex: "#f4edd8", name: "Lucite HP 36" }, 
      { hex: "#a19571", name: "Lucite HP 37" }, 
      { hex: "#a19c73", name: "Lucite HP 38" }, 
      { hex: "#b9bc87", name: "Lucite HP 39" }, 
      { hex: "#9fa174", name: "Lucite HP 4" }, 
      { hex: "#d6d5b7", name: "Lucite HP 40" }, 
      { hex: "#c8d696", name: "Lucite HP 41" }, 
      { hex: "#e4dfd1", name: "Lucite HP 42" }, 
      { hex: "#646b4b", name: "Lucite HP 43" }, 
      { hex: "#8aa171", name: "Lucite HP 45" }, 
      { hex: "#a8bc81", name: "Lucite HP 46" }, 
      { hex: "#c0d6b7", name: "Lucite HP 47" }, 
      { hex: "#404341", name: "Lucite HP 49" }, 
      { hex: "#bcbbae", name: "Lucite HP 5" }, 
      { hex: "#50504a", name: "Lucite HP 50" }, 
      { hex: "#646b4b", name: "Lucite HP 51" }, 
      { hex: "#676b5a", name: "Lucite HP 52" }, 
      { hex: "#638665", name: "Lucite HP 53" }, 
      { hex: "#8e9193", name: "Lucite HP 54" }, 
      { hex: "#4a4f50", name: "Lucite HP 55" }, 
      { hex: "#618685", name: "Lucite HP 56" }, 
      { hex: "#747976", name: "Lucite HP 57" }, 
      { hex: "#94a187", name: "Lucite HP 58" }, 
      { hex: "#b1bcad", name: "Lucite HP 59" }, 
      { hex: "#5f616b", name: "Lucite HP 60" }, 
      { hex: "#6e8ea1", name: "Lucite HP 61" }, 
      { hex: "#7094a1", name: "Lucite HP 62" }, 
      { hex: "#83adbc", name: "Lucite HP 63" }, 
      { hex: "#b6d3d6", name: "Lucite HP 64" }, 
      { hex: "#414243", name: "Lucite HP 66" }, 
      { hex: "#504a4f", name: "Lucite HP 67" }, 
      { hex: "#503f3e", name: "Lucite HP 68" }, 
      { hex: "#a14b55", name: "Lucite HP 69" }, 
      { hex: "#6b684d", name: "Lucite HP 7" }, 
      { hex: "#bc6e73", name: "Lucite HP 70" }, 
      { hex: "#d6a9a6", name: "Lucite HP 71" }, 
      { hex: "#404341", name: "Lucite HP 72" }, 
      { hex: "#6b5a55", name: "Lucite HP 9" }
    ],
      "RAL Design": [      { hex: "#A14844", name: "030 40 50" }, 
      { hex: "#DFE4E2", name: "85 00" }, 
      { hex: "#FDF3DE", name: "075 90 10" }, 
      { hex: "#C0D6E5", name: "250 80 10" }, 
      { hex: "#CDD2ED", name: "290 80 15" }, 
      { hex: "#ADB9C0", name: "260 70 05" }, 
      { hex: "#D6D5CA", name: "080 80 05" }, 
      { hex: "#896055", name: "040 40 20" }, 
      { hex: "#464A49", name: "25 00" }, 
      { hex: "#A69889", name: "060 60 10" }, 
      { hex: "#F2CE88", name: "080 80 40" }, 
      { hex: "#595D5C", name: "35 00" }, 
      { hex: "#664855", name: "350 30 20" }, 
      { hex: "#68A3C2", name: "240 60 25" }, 
      { hex: "#929B91", name: "080 60 05" }, 
      { hex: "#FFF4DC", name: "090 90 10" }, 
      { hex: "#788086", name: "260 50 05" }, 
      { hex: "#7C817F", name: "50 00" }, 
      { hex: "#493F3E", name: "010 20 10" }, 
      { hex: "#4B3B3D", name: "010 20 15" }, 
      { hex: "#53393B", name: "010 20 20" }, 
      { hex: "#54373C", name: "010 20 25" }, 
      { hex: "#5E4F50", name: "010 30 10" }, 
      { hex: "#624C4F", name: "010 30 15" }, 
      { hex: "#694A4D", name: "010 30 20" }, 
      { hex: "#78454D", name: "010 30 25" }, 
      { hex: "#75404A", name: "010 30 30" }, 
      { hex: "#78404A", name: "010 30 35" }, 
      { hex: "#7D3C48", name: "010 30 40" }, 
      { hex: "#823847", name: "010 30 44" }, 
      { hex: "#746364", name: "010 40 10" }, 
      { hex: "#7A6064", name: "010 40 15" }, 
      { hex: "#825E64", name: "010 40 20" }, 
      { hex: "#895B62", name: "010 40 25" }, 
      { hex: "#9A5760", name: "010 40 30" }, 
      { hex: "#92525D", name: "010 40 35" }, 
      { hex: "#994F5E", name: "010 40 40" }, 
      { hex: "#A14A5D", name: "010 40 45" }, 
      { hex: "#A6455B", name: "010 40 50" }, 
      { hex: "#A9425A", name: "010 40 53" }, 
      { hex: "#8D7C7E", name: "010 50 10" }, 
      { hex: "#94787B", name: "010 50 15" }, 
      { hex: "#9A7479", name: "010 50 20" }, 
      { hex: "#A2717A", name: "010 50 25" }, 
      { hex: "#AB6D76", name: "010 50 30" }, 
      { hex: "#B06977", name: "010 50 35" }, 
      { hex: "#B56474", name: "010 50 40" }, 
      { hex: "#BB5E72", name: "010 50 45" }, 
      { hex: "#C65B72", name: "010 50 50" }, 
      { hex: "#A99596", name: "010 60 10" }, 
      { hex: "#B29296", name: "010 60 15" }, 
      { hex: "#B98D94", name: "010 60 20" }, 
      { hex: "#C18992", name: "010 60 25" }, 
      { hex: "#C8848F", name: "010 60 30" }, 
      { hex: "#D0818F", name: "010 60 35" }, 
      { hex: "#D77E8F", name: "010 60 40" }, 
      { hex: "#E0788C", name: "010 60 45" }, 
      { hex: "#C6B2B5", name: "010 70 10" }, 
      { hex: "#CEAEB2", name: "010 70 15" }, 
      { hex: "#D8AAB0", name: "010 70 20" }, 
      { hex: "#E0A5AD", name: "010 70 25" }, 
      { hex: "#E7A4AF", name: "010 70 30" }, 
      { hex: "#EF9DAB", name: "010 70 35" }, 
      { hex: "#E4CED0", name: "010 80 10" }, 
      { hex: "#ECCACE", name: "010 80 15" }, 
      { hex: "#F7C7CD", name: "010 80 20" }, 
      { hex: "#F9F0EE", name: "010 90 05" }, 
      { hex: "#4B3F3D", name: "020 20 05" }, 
      { hex: "#473D3B", name: "020 20 10" }, 
      { hex: "#523938", name: "020 20 20" }, 
      { hex: "#573536", name: "020 20 29" }, 
      { hex: "#56514F", name: "020 30 05" }, 
      { hex: "#5C4D4B", name: "020 30 10" }, 
      { hex: "#684846", name: "020 30 20" }, 
      { hex: "#7A4142", name: "020 30 30" }, 
      { hex: "#7E3B3F", name: "020 30 40" }, 
      { hex: "#83353C", name: "020 30 48" }, 
      { hex: "#6D6766", name: "020 40 05" }, 
      { hex: "#746362", name: "020 40 10" }, 
      { hex: "#815C5C", name: "020 40 20" }, 
      { hex: "#8F5658", name: "020 40 30" }, 
      { hex: "#984E52", name: "020 40 40" }, 
      { hex: "#9F434B", name: "020 40 50" }, 
      { hex: "#907F7C", name: "020 50 05" }, 
      { hex: "#8D7A79", name: "020 50 10" }, 
      { hex: "#A67474", name: "020 50 20" }, 
      { hex: "#A86B6D", name: "020 50 30" }, 
      { hex: "#B56468", name: "020 50 40" }, 
      { hex: "#C25B64", name: "020 50 50" }, 
      { hex: "#D05460", name: "020 50 58" }, 
      { hex: "#9E9897", name: "020 60 05" }, 
      { hex: "#A79393", name: "020 60 10" }, 
      { hex: "#B88E8F", name: "020 60 20" }, 
      { hex: "#C78588", name: "020 60 30" }, 
      { hex: "#D47E84", name: "020 60 40" }, 
      { hex: "#C7B5B3", name: "020 70 05" }, 
      { hex: "#C4B0B0", name: "020 70 10" }, 
      { hex: "#D8AAAC", name: "020 70 20" }, 
      { hex: "#E8A3A6", name: "020 70 30" }, 
      { hex: "#DCD3D1", name: "020 80 05" }, 
      { hex: "#EDCDCC", name: "020 80 10" }, 
      { hex: "#F6C7C8", name: "020 80 20" }, 
      { hex: "#FAF1EE", name: "020 90 05" }, 
      { hex: "#493F3B", name: "030 20 10" }, 
      { hex: "#5C4F4B", name: "030 30 10" }, 
      { hex: "#664944", name: "030 30 20" }, 
      { hex: "#72433D", name: "030 30 30" }, 
      { hex: "#7E3E3A", name: "030 30 40" }, 
      { hex: "#7F3935", name: "030 30 45" }, 
      { hex: "#70625E", name: "030 40 10" }, 
      { hex: "#825E58", name: "030 40 20" }, 
      { hex: "#8D564F", name: "030 40 30" }, 
      { hex: "#8E5049", name: "030 40 40" }, 
      { hex: "#AB413F", name: "030 40 60" }, 
      { hex: "#8C7975", name: "030 50 10" }, 
      { hex: "#9A746E", name: "030 50 20" }, 
      { hex: "#C5B1AC", name: "030 70 10" }, 
      { hex: "#D5A7A0", name: "030 70 20" }, 
      { hex: "#E6A299", name: "030 70 30" }, 
      { hex: "#F39A8F", name: "030 70 40" }, 
      { hex: "#E2CDC8", name: "030 80 10" }, 
      { hex: "#F3C5C0", name: "030 80 20" }, 
      { hex: "#FEEFE8", name: "030 90 10" }, 
      { hex: "#43413D", name: "040 20 05" }, 
      { hex: "#47403B", name: "040 20 10" }, 
      { hex: "#895848", name: "040 40 30" }, 
      { hex: "#945140", name: "040 40 40" }, 
      { hex: "#A04F3B", name: "040 40 50" }, 
      { hex: "#A24533", name: "040 40 60" }, 
      { hex: "#AF432F", name: "040 40 67" }, 
      { hex: "#857E7A", name: "040 50 05" }, 
      { hex: "#8D7C74", name: "040 50 10" }, 
      { hex: "#EE9F86", name: "040 70 40" }, 
      { hex: "#FC9678", name: "040 70 50" }, 
      { hex: "#DAD2CC", name: "040 80 05" }, 
      { hex: "#E3CEC5", name: "040 80 10" }, 
      { hex: "#F8CBBC", name: "040 80 20" }, 
      { hex: "#FAF1EB", name: "040 90 05" }, 
      { hex: "#F4EFE4", name: "040 90 10" }, 
      { hex: "#463F39", name: "050 20 10" }, 
      { hex: "#4D3E35", name: "050 20 16" }, 
      { hex: "#A86E65", name: "030 50 30" }, 
      { hex: "#B5675F", name: "030 50 40" }, 
      { hex: "#C15E57", name: "030 50 50" }, 
      { hex: "#CC544D", name: "030 50 60" }, 
      { hex: "#A69490", name: "030 60 10" }, 
      { hex: "#B88D87", name: "030 60 20" }, 
      { hex: "#C5847E", name: "030 60 30" }, 
      { hex: "#D48076", name: "030 60 40" }, 
      { hex: "#503D35", name: "040 20 19" }, 
      { hex: "#54504B", name: "040 30 05" }, 
      { hex: "#5A4E49", name: "040 30 10" }, 
      { hex: "#664A40", name: "040 30 20" }, 
      { hex: "#71473B", name: "040 30 30" }, 
      { hex: "#794235", name: "040 30 40" }, 
      { hex: "#6C6662", name: "040 40 05" }, 
      { hex: "#7C645C", name: "040 40 10" }, 
      { hex: "#997568", name: "040 50 20" }, 
      { hex: "#A8705E", name: "040 50 30" }, 
      { hex: "#CF5E43", name: "040 50 60" }, 
      { hex: "#D2573D", name: "040 50 70" }, 
      { hex: "#9F9994", name: "040 60 05" }, 
      { hex: "#A8968D", name: "040 60 10" }, 
      { hex: "#B1B4AF", name: "040 70 05" }, 
      { hex: "#C5B0A7", name: "040 70 10" }, 
      { hex: "#D5AB9C", name: "040 70 20" }, 
      { hex: "#6B6959", name: "085 40 10" }, 
      { hex: "#6E6648", name: "085 40 20" }, 
      { hex: "#766741", name: "085 40 30" }, 
      { hex: "#85816E", name: "085 50 10" }, 
      { hex: "#8A7F5F", name: "085 50 20" }, 
      { hex: "#907F4F", name: "085 50 30" }, 
      { hex: "#917C42", name: "085 50 40" }, 
      { hex: "#927C36", name: "085 50 50" }, 
      { hex: "#9E9A8A", name: "085 60 10" }, 
      { hex: "#A59975", name: "085 60 20" }, 
      { hex: "#AB9865", name: "085 60 30" }, 
      { hex: "#AE9654", name: "085 60 40" }, 
      { hex: "#B59845", name: "085 60 50" }, 
      { hex: "#B49534", name: "085 60 60" }, 
      { hex: "#B9B4A1", name: "085 70 10" }, 
      { hex: "#C2B48F", name: "085 70 20" }, 
      { hex: "#C8B57B", name: "085 70 30" }, 
      { hex: "#CCB36A", name: "085 70 40" }, 
      { hex: "#D0B259", name: "085 70 50" }, 
      { hex: "#CFAF44", name: "085 70 60" }, 
      { hex: "#D1AC31", name: "085 70 70" }, 
      { hex: "#DBB127", name: "085 70 75" }, 
      { hex: "#D8D3BD", name: "085 80 10" }, 
      { hex: "#DFD2AB", name: "085 80 20" }, 
      { hex: "#EDD185", name: "085 80 40" }, 
      { hex: "#574C43", name: "050 30 10" }, 
      { hex: "#624B3C", name: "050 30 20" }, 
      { hex: "#6C4735", name: "050 30 30" }, 
      { hex: "#734833", name: "050 30 36" }, 
      { hex: "#7A6258", name: "050 40 10" }, 
      { hex: "#7C604F", name: "050 40 20" }, 
      { hex: "#855D48", name: "050 40 30" }, 
      { hex: "#8F573B", name: "050 40 40" }, 
      { hex: "#985436", name: "050 40 50" }, 
      { hex: "#8C7E73", name: "050 50 10" }, 
      { hex: "#967765", name: "050 50 20" }, 
      { hex: "#AB6D4B", name: "050 50 40" }, 
      { hex: "#B76840", name: "050 50 50" }, 
      { hex: "#B96235", name: "050 50 60" }, 
      { hex: "#C95B2C", name: "050 50 70" }, 
      { hex: "#D06228", name: "050 50 78" }, 
      { hex: "#A5968A", name: "050 60 10" }, 
      { hex: "#E6723D", name: "050 60 70" }, 
      { hex: "#F46E34", name: "050 60 80" }, 
      { hex: "#C4B3A7", name: "050 70 10" }, 
      { hex: "#D1AF9A", name: "050 70 20" }, 
      { hex: "#DEA88A", name: "050 70 30" }, 
      { hex: "#ECD0C5", name: "050 80 10" }, 
      { hex: "#F0C9B3", name: "050 80 20" }, 
      { hex: "#FFF0E1", name: "050 90 10" }, 
      { hex: "#41413B", name: "060 20 05" }, 
      { hex: "#47433C", name: "060 20 10" }, 
      { hex: "#54514B", name: "060 30 05" }, 
      { hex: "#594F45", name: "060 30 10" }, 
      { hex: "#5E4C3B", name: "060 30 20" }, 
      { hex: "#674E39", name: "060 30 27" }, 
      { hex: "#6C6760", name: "060 40 05" }, 
      { hex: "#706558", name: "060 40 10" }, 
      { hex: "#835F42", name: "060 40 30" }, 
      { hex: "#8D5D39", name: "060 40 40" }, 
      { hex: "#857F77", name: "060 50 05" }, 
      { hex: "#897D70", name: "060 50 10" }, 
      { hex: "#B0703D", name: "060 50 50" }, 
      { hex: "#B7692D", name: "060 50 60" }, 
      { hex: "#A09B93", name: "060 60 05" }, 
      { hex: "#C6B7AF", name: "060 70 05" }, 
      { hex: "#C4B4A6", name: "060 70 10" }, 
      { hex: "#D9D4CB", name: "060 80 05" }, 
      { hex: "#DFD1C2", name: "060 80 10" }, 
      { hex: "#F8F2E6", name: "060 90 05" }, 
      { hex: "#FEEFDD", name: "060 90 10" }, 
      { hex: "#FFE9D3", name: "060 90 15" }, 
      { hex: "#454138", name: "070 20 10" }, 
      { hex: "#534E42", name: "070 30 10" }, 
      { hex: "#5D503C", name: "070 30 20" }, 
      { hex: "#7C6242", name: "070 40 30" }, 
      { hex: "#786135", name: "070 40 40" }, 
      { hex: "#867D6E", name: "070 50 10" }, 
      { hex: "#A29786", name: "070 60 10" }, 
      { hex: "#FCF2DF", name: "070 90 10" }, 
      { hex: "#444339", name: "075 20 10" }, 
      { hex: "#585347", name: "075 30 10" }, 
      { hex: "#5D513D", name: "075 30 20" }, 
      { hex: "#766659", name: "075 40 10" }, 
      { hex: "#72644B", name: "075 40 20" }, 
      { hex: "#78613E", name: "075 40 30" }, 
      { hex: "#867F70", name: "075 50 10" }, 
      { hex: "#9C7944", name: "075 50 40" }, 
      { hex: "#A17734", name: "075 50 50" }, 
      { hex: "#A29988", name: "075 60 10" }, 
      { hex: "#BEB6A4", name: "075 70 10" }, 
      { hex: "#DDAC5D", name: "075 70 50" }, 
      { hex: "#DCD3C2", name: "075 80 10" }, 
      { hex: "#FFEDC9", name: "075 90 20" }, 
      { hex: "#41423C", name: "080 20 05" }, 
      { hex: "#3A4338", name: "080 20 10" }, 
      { hex: "#5C524A", name: "080 30 05" }, 
      { hex: "#524F42", name: "080 30 10" }, 
      { hex: "#594F39", name: "080 30 20" }, 
      { hex: "#5B4E33", name: "080 30 26" }, 
      { hex: "#696960", name: "080 40 05" }, 
      { hex: "#6C6757", name: "080 40 10" }, 
      { hex: "#716548", name: "080 40 20" }, 
      { hex: "#75623B", name: "080 40 30" }, 
      { hex: "#7C6331", name: "080 40 40" }, 
      { hex: "#828077", name: "080 50 05" }, 
      { hex: "#867F6D", name: "080 50 10" }, 
      { hex: "#8D7E5E", name: "080 50 20" }, 
      { hex: "#927D4E", name: "080 50 30" }, 
      { hex: "#95793F", name: "080 50 40" }, 
      { hex: "#A09986", name: "080 60 10" }, 
      { hex: "#A89976", name: "080 60 20" }, 
      { hex: "#AE9763", name: "080 60 30" }, 
      { hex: "#B99443", name: "080 60 50" }, 
      { hex: "#BD9233", name: "080 60 60" }, 
      { hex: "#B7B6AC", name: "080 70 05" }, 
      { hex: "#BCB5A2", name: "080 70 10" }, 
      { hex: "#BBB390", name: "080 70 20" }, 
      { hex: "#CBB17F", name: "080 70 30" }, 
      { hex: "#D3B169", name: "080 70 40" }, 
      { hex: "#D8B05A", name: "080 70 50" }, 
      { hex: "#DDAF47", name: "080 70 60" }, 
      { hex: "#DED5C0", name: "080 80 10" }, 
      { hex: "#E2D0AB", name: "080 80 20" }, 
      { hex: "#F7CC73", name: "080 80 50" }, 
      { hex: "#F8F6E9", name: "080 90 05" }, 
      { hex: "#F9F1DC", name: "080 90 10" }, 
      { hex: "#FFEFC9", name: "080 90 20" }, 
      { hex: "#444438", name: "085 20 10" }, 
      { hex: "#565447", name: "085 30 10" }, 
      { hex: "#585038", name: "085 30 20" }, 
      { hex: "#F0CF71", name: "085 80 50" }, 
      { hex: "#F3CC5C", name: "085 80 60" }, 
      { hex: "#F9CD49", name: "085 80 70" }, 
      { hex: "#FAF5E0", name: "085 90 10" }, 
      { hex: "#FEF1C8", name: "085 90 20" }, 
      { hex: "#FFECB1", name: "085 90 30" }, 
      { hex: "#414237", name: "090 20 10" }, 
      { hex: "#525142", name: "090 30 10" }, 
      { hex: "#575238", name: "090 30 20" }, 
      { hex: "#6B6959", name: "090 40 10" }, 
      { hex: "#6E6647", name: "090 40 20" }, 
      { hex: "#706739", name: "090 40 30" }, 
      { hex: "#827F6F", name: "090 50 10" }, 
      { hex: "#88805E", name: "090 50 20" }, 
      { hex: "#8B7F4B", name: "090 50 30" }, 
      { hex: "#8F803F", name: "090 50 40" }, 
      { hex: "#9C9A87", name: "090 60 10" }, 
      { hex: "#A29974", name: "090 60 20" }, 
      { hex: "#A69965", name: "090 60 30" }, 
      { hex: "#A79851", name: "090 60 40" }, 
      { hex: "#A7953D", name: "090 60 50" }, 
      { hex: "#AC9931", name: "090 60 60" }, 
      { hex: "#C4B7A2", name: "090 70 10" }, 
      { hex: "#C0B58D", name: "090 70 20" }, 
      { hex: "#C3B37C", name: "090 70 30" }, 
      { hex: "#C9B669", name: "090 70 40" }, 
      { hex: "#CCB658", name: "090 70 50" }, 
      { hex: "#CDB441", name: "090 70 60" }, 
      { hex: "#D0B630", name: "090 70 70" }, 
      { hex: "#D1B421", name: "090 70 80" }, 
      { hex: "#D7D2BB", name: "090 80 10" }, 
      { hex: "#DBD1A9", name: "090 80 20" }, 
      { hex: "#E4D499", name: "090 80 30" }, 
      { hex: "#E7D487", name: "090 80 40" }, 
      { hex: "#EDD46C", name: "090 80 50" }, 
      { hex: "#F1D245", name: "090 80 70" }, 
      { hex: "#F8CD27", name: "090 80 80" }, 
      { hex: "#FCF4C7", name: "090 90 20" }, 
      { hex: "#FFF2B4", name: "090 90 30" }, 
      { hex: "#42443A", name: "095 20 10" }, 
      { hex: "#545548", name: "095 30 10" }, 
      { hex: "#56563F", name: "095 30 18" }, 
      { hex: "#6A6A5A", name: "095 40 10" }, 
      { hex: "#6B6849", name: "095 40 20" }, 
      { hex: "#6E693E", name: "095 40 30" }, 
      { hex: "#807F6F", name: "095 50 10" }, 
      { hex: "#848060", name: "095 50 20" }, 
      { hex: "#888150", name: "095 50 30" }, 
      { hex: "#8B823E", name: "095 50 40" }, 
      { hex: "#8C8235", name: "095 50 50" }, 
      { hex: "#9C9B88", name: "095 60 10" }, 
      { hex: "#9F9B76", name: "095 60 20" }, 
      { hex: "#A39B64", name: "095 60 30" }, 
      { hex: "#A49A53", name: "095 60 40" }, 
      { hex: "#A59C40", name: "095 60 50" }, 
      { hex: "#A39832", name: "095 60 60" }, 
      { hex: "#B9B7A4", name: "095 70 10" }, 
      { hex: "#C8B893", name: "095 70 20" }, 
      { hex: "#C1B87F", name: "095 70 30" }, 
      { hex: "#C2B769", name: "095 70 40" }, 
      { hex: "#C3B75A", name: "095 70 50" }, 
      { hex: "#C4B545", name: "095 70 60" }, 
      { hex: "#C6B631", name: "095 70 70" }, 
      { hex: "#D5D4C0", name: "095 80 10" }, 
      { hex: "#DBD5AD", name: "095 80 20" }, 
      { hex: "#E1D79A", name: "095 80 30" }, 
      { hex: "#3F433D", name: "100 20 05" }, 
      { hex: "#3F4237", name: "100 20 10" }, 
      { hex: "#4D5148", name: "100 30 05" }, 
      { hex: "#505241", name: "100 30 10" }, 
      { hex: "#525336", name: "100 30 20" }, 
      { hex: "#65685E", name: "100 40 05" }, 
      { hex: "#676957", name: "100 40 10" }, 
      { hex: "#68684A", name: "100 40 20" }, 
      { hex: "#9D9D77", name: "100 60 20" }, 
      { hex: "#9C9B64", name: "100 60 30" }, 
      { hex: "#959E56", name: "100 60 40" }, 
      { hex: "#A09F40", name: "100 60 50" }, 
      { hex: "#B6B9AE", name: "100 70 05" }, 
      { hex: "#C2B8A2", name: "100 70 10" }, 
      { hex: "#B9B890", name: "100 70 20" }, 
      { hex: "#B9B87C", name: "100 70 30" }, 
      { hex: "#BEBB6C", name: "100 70 40" }, 
      { hex: "#DBDC2E", name: "100 80 80" }, 
      { hex: "#F2F4E5", name: "100 90 05" }, 
      { hex: "#F3F4DC", name: "100 90 10" }, 
      { hex: "#F7F4C7", name: "100 90 20" }, 
      { hex: "#F8F3B1", name: "100 90 30" }, 
      { hex: "#FBF78C", name: "100 90 50" }, 
      { hex: "#3C4236", name: "110 20 10" }, 
      { hex: "#4E5345", name: "110 30 10" }, 
      { hex: "#4E553B", name: "110 30 20" }, 
      { hex: "#1F945F", name: "160 50 55" }, 
      { hex: "#1D985E", name: "160 50 60" }, 
      { hex: "#8F9C96", name: "160 60 05" }, 
      { hex: "#879E93", name: "160 60 10" }, 
      { hex: "#81A190", name: "160 60 15" }, 
      { hex: "#79A38C", name: "160 60 20" }, 
      { hex: "#71A486", name: "160 60 25" }, 
      { hex: "#6AA887", name: "160 60 30" }, 
      { hex: "#79C79F", name: "160 70 35" }, 
      { hex: "#71C99C", name: "160 70 40" }, 
      { hex: "#6FCB97", name: "160 70 45" }, 
      { hex: "#5ECD96", name: "160 70 49" }, 
      { hex: "#C6D5CE", name: "160 80 05" }, 
      { hex: "#BFD9CB", name: "160 80 10" }, 
      { hex: "#B6DCC7", name: "160 80 15" }, 
      { hex: "#ADDEC3", name: "160 80 20" }, 
      { hex: "#A7E0C1", name: "160 80 25" }, 
      { hex: "#3A584C", name: "170 30 15" }, 
      { hex: "#40584A", name: "170 30 20" }, 
      { hex: "#305C4C", name: "170 30 25" }, 
      { hex: "#2A5C4B", name: "170 30 30" }, 
      { hex: "#235F4A", name: "170 30 35" }, 
      { hex: "#186049", name: "170 30 40" }, 
      { hex: "#566B62", name: "170 40 10" }, 
      { hex: "#4E6C60", name: "170 40 15" }, 
      { hex: "#65887B", name: "170 50 15" }, 
      { hex: "#5C8979", name: "170 50 20" }, 
      { hex: "#538A75", name: "170 50 25" }, 
      { hex: "#498C75", name: "170 50 30" }, 
      { hex: "#3E8D73", name: "170 50 35" }, 
      { hex: "#368F6F", name: "170 50 40" }, 
      { hex: "#859F96", name: "170 60 10" }, 
      { hex: "#7EA294", name: "170 60 15" }, 
      { hex: "#74A593", name: "170 60 20" }, 
      { hex: "#E5D886", name: "095 80 40" }, 
      { hex: "#E5D773", name: "095 80 50" }, 
      { hex: "#E5D547", name: "095 80 70" }, 
      { hex: "#E2D231", name: "095 80 80" }, 
      { hex: "#F3F3DC", name: "095 90 10" }, 
      { hex: "#F9F3C9", name: "095 90 20" }, 
      { hex: "#FCF1B2", name: "095 90 30" }, 
      { hex: "#FFF189", name: "095 90 50" }, 
      { hex: "#FFEE74", name: "095 90 59" }, 
      { hex: "#6B6A3D", name: "100 40 30" }, 
      { hex: "#7E8177", name: "100 50 05" }, 
      { hex: "#7F806D", name: "100 50 10" }, 
      { hex: "#83825F", name: "100 50 20" }, 
      { hex: "#82804D", name: "100 50 30" }, 
      { hex: "#848241", name: "100 50 40" }, 
      { hex: "#848233", name: "100 50 50" }, 
      { hex: "#999B91", name: "100 60 05" }, 
      { hex: "#979886", name: "100 60 10" }, 
      { hex: "#BBB855", name: "100 70 50" }, 
      { hex: "#BAB941", name: "100 70 60" }, 
      { hex: "#D0D4C8", name: "100 80 05" }, 
      { hex: "#D6D7BF", name: "100 80 10" }, 
      { hex: "#DBD9AD", name: "100 80 20" }, 
      { hex: "#D9D697", name: "100 80 30" }, 
      { hex: "#DBD883", name: "100 80 40" }, 
      { hex: "#DBD870", name: "100 80 50" }, 
      { hex: "#DFDB45", name: "100 80 70" }, 
      { hex: "#646A59", name: "110 40 10" }, 
      { hex: "#626948", name: "110 40 20" }, 
      { hex: "#636C3F", name: "110 40 30" }, 
      { hex: "#7D816F", name: "110 50 10" }, 
      { hex: "#7B8360", name: "110 50 20" }, 
      { hex: "#7B8350", name: "110 50 30" }, 
      { hex: "#798540", name: "110 50 40" }, 
      { hex: "#748334", name: "110 50 50" }, 
      { hex: "#969C88", name: "110 60 10" }, 
      { hex: "#929B76", name: "110 60 20" }, 
      { hex: "#959E68", name: "110 60 30" }, 
      { hex: "#93A056", name: "110 60 40" }, 
      { hex: "#90A144", name: "110 60 50" }, 
      { hex: "#8FA436", name: "110 60 60" }, 
      { hex: "#B3B8A2", name: "110 70 10" }, 
      { hex: "#B1B990", name: "110 70 20" }, 
      { hex: "#AEB97F", name: "110 70 30" }, 
      { hex: "#AFBC6E", name: "110 70 40" }, 
      { hex: "#ABBF49", name: "110 70 60" }, 
      { hex: "#A3BE2A", name: "110 70 70" }, 
      { hex: "#CDD4BE", name: "110 80 10" }, 
      { hex: "#D1D8AC", name: "110 80 20" }, 
      { hex: "#CDDC87", name: "110 80 40" }, 
      { hex: "#CEDE76", name: "110 80 50" }, 
      { hex: "#CBDF61", name: "110 80 60" }, 
      { hex: "#C7DF4B", name: "110 80 70" }, 
      { hex: "#F1F6DE", name: "110 90 10" }, 
      { hex: "#F0F6C9", name: "110 90 20" }, 
      { hex: "#EFF7B3", name: "110 90 30" }, 
      { hex: "#3D433D", name: "120 20 05" }, 
      { hex: "#3B4136", name: "120 20 10" }, 
      { hex: "#4B5149", name: "120 30 05" }, 
      { hex: "#3F5242", name: "120 30 10" }, 
      { hex: "#485439", name: "120 30 20" }, 
      { hex: "#6C685E", name: "120 40 05" }, 
      { hex: "#5F6857", name: "120 40 10" }, 
      { hex: "#5D6B4B", name: "120 40 20" }, 
      { hex: "#5C6D41", name: "120 40 30" }, 
      { hex: "#7C8176", name: "120 50 05" }, 
      { hex: "#79826F", name: "120 50 10" }, 
      { hex: "#6C8460", name: "120 50 20" }, 
      { hex: "#72854F", name: "120 50 30" }, 
      { hex: "#6E8745", name: "120 50 40" }, 
      { hex: "#688837", name: "120 50 50" }, 
      { hex: "#979E93", name: "120 60 05" }, 
      { hex: "#939D8B", name: "120 60 10" }, 
      { hex: "#91A07A", name: "120 60 20" }, 
      { hex: "#8CA36B", name: "120 60 30" }, 
      { hex: "#93A55B", name: "120 60 40" }, 
      { hex: "#83A54B", name: "120 60 50" }, 
      { hex: "#7EA639", name: "120 60 60" }, 
      { hex: "#7BA638", name: "120 60 63" }, 
      { hex: "#7BA638", name: "120 60 70" }, 
      { hex: "#B0B7AB", name: "120 70 05" }, 
      { hex: "#AEB7A2", name: "120 70 10" }, 
      { hex: "#AABA92", name: "120 70 20" }, 
      { hex: "#A9BF84", name: "120 70 30" }, 
      { hex: "#A2C173", name: "120 70 40" }, 
      { hex: "#99C24D", name: "120 70 60" }, 
      { hex: "#96C640", name: "120 70 70" }, 
      { hex: "#90C032", name: "120 70 75" }, 
      { hex: "#CED6CA", name: "120 80 05" }, 
      { hex: "#CBD6BF", name: "120 80 10" }, 
      { hex: "#CADAB1", name: "120 80 20" }, 
      { hex: "#C1DF8D", name: "120 80 40" }, 
      { hex: "#BCE27B", name: "120 80 50" }, 
      { hex: "#B9E46C", name: "120 80 60" }, 
      { hex: "#EBF3E7", name: "120 90 05" }, 
      { hex: "#F0F8E1", name: "120 90 10" }, 
      { hex: "#E8F8CC", name: "120 90 20" }, 
      { hex: "#E3FCBA", name: "120 90 30" }, 
      { hex: "#394237", name: "130 20 10" }, 
      { hex: "#4A5446", name: "130 30 10" }, 
      { hex: "#44553D", name: "130 30 20" }, 
      { hex: "#606B5B", name: "130 40 10" }, 
      { hex: "#56694C", name: "130 40 20" }, 
      { hex: "#556E44", name: "130 40 30" }, 
      { hex: "#758271", name: "130 50 10" }, 
      { hex: "#738666", name: "130 50 20" }, 
      { hex: "#6A8959", name: "130 50 30" }, 
      { hex: "#628B4B", name: "130 50 40" }, 
      { hex: "#4F8C40", name: "130 50 50" }, 
      { hex: "#919E8B", name: "130 60 10" }, 
      { hex: "#8AA07E", name: "130 60 20" }, 
      { hex: "#83A372", name: "130 60 30" }, 
      { hex: "#76A854", name: "130 60 50" }, 
      { hex: "#6CAA46", name: "130 60 60" }, 
      { hex: "#ACBAA8", name: "130 70 10" }, 
      { hex: "#A7BE9A", name: "130 70 20" }, 
      { hex: "#9EC08A", name: "130 70 30" }, 
      { hex: "#97C27A", name: "130 70 40" }, 
      { hex: "#92C56D", name: "130 70 50" }, 
      { hex: "#CAD8C3", name: "130 80 10" }, 
      { hex: "#C4DBB5", name: "130 80 20" }, 
      { hex: "#B5E197", name: "130 80 40" }, 
      { hex: "#ADE487", name: "130 80 50" }, 
      { hex: "#EBFAE2", name: "130 90 10" }, 
      { hex: "#E1F9D1", name: "130 90 20" }, 
      { hex: "#42403A", name: "140 20 05" }, 
      { hex: "#374236", name: "140 20 10" }, 
      { hex: "#374635", name: "140 20 20" }, 
      { hex: "#4C554D", name: "140 30 05" }, 
      { hex: "#4A5748", name: "140 30 10" }, 
      { hex: "#445A42", name: "140 30 20" }, 
      { hex: "#626C63", name: "140 40 05" }, 
      { hex: "#5D6C5D", name: "140 40 10" }, 
      { hex: "#526C50", name: "140 40 20" }, 
      { hex: "#4D7147", name: "140 40 30" }, 
      { hex: "#447540", name: "140 40 40" }, 
      { hex: "#3D773A", name: "140 40 50" }, 
      { hex: "#768078", name: "140 50 05" }, 
      { hex: "#748373", name: "140 50 10" }, 
      { hex: "#6B8666", name: "140 50 20" }, 
      { hex: "#648B5D", name: "140 50 30" }, 
      { hex: "#578B50", name: "140 50 40" }, 
      { hex: "#509148", name: "140 50 50" }, 
      { hex: "#44913D", name: "140 50 60" }, 
      { hex: "#919B93", name: "140 60 05" }, 
      { hex: "#8C9D8C", name: "140 60 10" }, 
      { hex: "#86A583", name: "140 60 20" }, 
      { hex: "#7CA774", name: "140 60 30" }, 
      { hex: "#75AB69", name: "140 60 40" }, 
      { hex: "#67AB5C", name: "140 60 50" }, 
      { hex: "#5EAE53", name: "140 60 60" }, 
      { hex: "#51AD48", name: "140 60 70" }, 
      { hex: "#A2B8AF", name: "140 70 05" }, 
      { hex: "#A7B9A8", name: "140 70 10" }, 
      { hex: "#9FBF9D", name: "140 70 20" }, 
      { hex: "#B2D1B0", name: "140 70 30" }, 
      { hex: "#8EC683", name: "140 70 40" }, 
      { hex: "#83C875", name: "140 70 50" }, 
      { hex: "#CCD7CC", name: "140 80 05" }, 
      { hex: "#C6D8C5", name: "140 80 10" }, 
      { hex: "#B3DCB6", name: "140 80 20" }, 
      { hex: "#E9F5E9", name: "140 90 05" }, 
      { hex: "#363B39", name: "15 00" }, 
      { hex: "#38453C", name: "150 20 10" }, 
      { hex: "#49594D", name: "150 30 10" }, 
      { hex: "#3F5B47", name: "150 30 20" }, 
      { hex: "#355B3E", name: "150 30 30" }, 
      { hex: "#5C6D60", name: "150 40 10" }, 
      { hex: "#537159", name: "150 40 20" }, 
      { hex: "#46734F", name: "150 40 30" }, 
      { hex: "#3A7548", name: "150 40 40" }, 
      { hex: "#2E7744", name: "150 40 50" }, 
      { hex: "#708274", name: "150 50 10" }, 
      { hex: "#67896E", name: "150 50 20" }, 
      { hex: "#5D8D66", name: "150 50 30" }, 
      { hex: "#529061", name: "150 50 40" }, 
      { hex: "#419254", name: "150 50 50" }, 
      { hex: "#31964D", name: "150 50 60" }, 
      { hex: "#8DA192", name: "150 60 10" }, 
      { hex: "#81A589", name: "150 60 20" }, 
      { hex: "#75A67D", name: "150 60 30" }, 
      { hex: "#5FAA75", name: "150 60 40" }, 
      { hex: "#5EAF6F", name: "150 60 50" }, 
      { hex: "#47B061", name: "150 60 60" }, 
      { hex: "#A5BBAC", name: "150 70 10" }, 
      { hex: "#91C69A", name: "150 70 30" }, 
      { hex: "#84C78F", name: "150 70 40" }, 
      { hex: "#75CA84", name: "150 70 50" }, 
      { hex: "#C5DACA", name: "150 80 10" }, 
      { hex: "#B8DEBF", name: "150 80 20" }, 
      { hex: "#AAE2B6", name: "150 80 30" }, 
      { hex: "#E2F9E6", name: "150 90 10" }, 
      { hex: "#3C4541", name: "160 20 05" }, 
      { hex: "#35453C", name: "160 20 10" }, 
      { hex: "#2E4438", name: "160 20 15" }, 
      { hex: "#2D4338", name: "160 20 20" }, 
      { hex: "#4A554F", name: "160 30 05" }, 
      { hex: "#46574D", name: "160 30 10" }, 
      { hex: "#3F5748", name: "160 30 15" }, 
      { hex: "#375746", name: "160 30 20" }, 
      { hex: "#365A44", name: "160 30 25" }, 
      { hex: "#2B5B41", name: "160 30 30" }, 
      { hex: "#255B3E", name: "160 30 35" }, 
      { hex: "#215E3D", name: "160 30 38" }, 
      { hex: "#606B65", name: "160 40 05" }, 
      { hex: "#576B62", name: "160 40 10" }, 
      { hex: "#5B6E5F", name: "160 40 15" }, 
      { hex: "#4C6F5C", name: "160 40 20" }, 
      { hex: "#447057", name: "160 40 25" }, 
      { hex: "#3F7256", name: "160 40 30" }, 
      { hex: "#377453", name: "160 40 35" }, 
      { hex: "#2F7752", name: "160 40 40" }, 
      { hex: "#32744D", name: "160 40 45" }, 
      { hex: "#1C7549", name: "160 40 50" }, 
      { hex: "#187848", name: "160 40 55" }, 
      { hex: "#76827C", name: "160 50 05" }, 
      { hex: "#6E8478", name: "160 50 10" }, 
      { hex: "#688676", name: "160 50 15" }, 
      { hex: "#608874", name: "160 50 20" }, 
      { hex: "#4F896F", name: "160 50 25" }, 
      { hex: "#528C6D", name: "160 50 30" }, 
      { hex: "#4C8E6A", name: "160 50 35" }, 
      { hex: "#2D9161", name: "160 50 50" }, 
      { hex: "#62AB84", name: "160 60 35" }, 
      { hex: "#58AB81", name: "160 60 40" }, 
      { hex: "#51AE7E", name: "160 60 45" }, 
      { hex: "#42AE7A", name: "160 60 50" }, 
      { hex: "#3BAD75", name: "160 60 55" }, 
      { hex: "#38B173", name: "160 60 58" }, 
      { hex: "#A9B8B1", name: "160 70 05" }, 
      { hex: "#A2BBAE", name: "160 70 10" }, 
      { hex: "#A3BCA9", name: "160 70 15" }, 
      { hex: "#A2E5BF", name: "160 80 30" }, 
      { hex: "#E6F5EB", name: "160 90 05" }, 
      { hex: "#DCF7E6", name: "160 90 10" }, 
      { hex: "#D5FAE3", name: "160 90 15" }, 
      { hex: "#33443D", name: "170 20 10" }, 
      { hex: "#30453C", name: "170 20 15" }, 
      { hex: "#29473D", name: "170 20 20" }, 
      { hex: "#25473A", name: "170 20 25" }, 
      { hex: "#43574F", name: "170 30 10" }, 
      { hex: "#477161", name: "170 40 20" }, 
      { hex: "#49705D", name: "170 40 25" }, 
      { hex: "#3A755F", name: "170 40 30" }, 
      { hex: "#2B745B", name: "170 40 35" }, 
      { hex: "#23765B", name: "170 40 40" }, 
      { hex: "#127658", name: "170 40 45" }, 
      { hex: "#E7757", name: "170 40 50" }, 
      { hex: "#6B837B", name: "170 50 10" }, 
      { hex: "#6CA692", name: "170 60 25" }, 
      { hex: "#62A98F", name: "170 60 30" }, 
      { hex: "#56AD8E", name: "170 60 35" }, 
      { hex: "#4CAD8C", name: "170 60 40" }, 
      { hex: "#3DAD88", name: "170 60 45" }, 
      { hex: "#30B18A", name: "170 60 50" }, 
      { hex: "#A0BCB2", name: "170 70 10" }, 
      { hex: "#99BEB0", name: "170 70 15" }, 
      { hex: "#90C2AE", name: "170 70 20" }, 
      { hex: "#26453E", name: "180 20 20" }, 
      { hex: "#4B5754", name: "180 30 05" }, 
      { hex: "#415651", name: "180 30 10" }, 
      { hex: "#3A5851", name: "180 30 15" }, 
      { hex: "#345B51", name: "180 30 20" }, 
      { hex: "#2C5D52", name: "180 30 25" }, 
      { hex: "#215C50", name: "180 30 30" }, 
      { hex: "#175D4F", name: "180 30 35" }, 
      { hex: "#A1BDC4", name: "220 70 10" }, 
      { hex: "#97C1CA", name: "220 70 15" }, 
      { hex: "#8CC2CF", name: "220 70 20" }, 
      { hex: "#7DC3D4", name: "220 70 25" }, 
      { hex: "#70C3D7", name: "220 70 30" }, 
      { hex: "#60C7DF", name: "220 70 35" }, 
      { hex: "#C6D7D9", name: "220 80 05" }, 
      { hex: "#BEDDE2", name: "220 80 10" }, 
      { hex: "#ADDBE5", name: "220 80 15" }, 
      { hex: "#7280A3", name: "280 50 20" }, 
      { hex: "#6F81AA", name: "280 50 25" }, 
      { hex: "#6B80B3", name: "280 50 30" }, 
      { hex: "#6680BA", name: "280 50 35" }, 
      { hex: "#959BA3", name: "280 60 05" }, 
      { hex: "#919AAC", name: "280 60 10" }, 
      { hex: "#8F9AB5", name: "280 60 15" }, 
      { hex: "#8C9ABD", name: "280 60 20" }, 
      { hex: "#B0B6BE", name: "280 70 05" }, 
      { hex: "#67C8A5", name: "170 70 40" }, 
      { hex: "#BFDAD0", name: "170 80 10" }, 
      { hex: "#B3DDCD", name: "170 80 15" }, 
      { hex: "#B4E1CD", name: "170 80 20" }, 
      { hex: "#9FE1C9", name: "170 80 25" }, 
      { hex: "#DAF9EC", name: "170 90 10" }, 
      { hex: "#3B4743", name: "180 20 05" }, 
      { hex: "#32443F", name: "180 20 10" }, 
      { hex: "#2D4640", name: "180 20 15" }, 
      { hex: "#F5E4F", name: "180 30 36" }, 
      { hex: "#666B67", name: "180 40 05" }, 
      { hex: "#556D66", name: "180 40 10" }, 
      { hex: "#4D6F66", name: "180 40 15" }, 
      { hex: "#417166", name: "180 40 20" }, 
      { hex: "#3A7265", name: "180 40 25" }, 
      { hex: "#2D7567", name: "180 40 30" }, 
      { hex: "#1E7464", name: "180 40 35" }, 
      { hex: "#E7463", name: "180 40 40" }, 
      { hex: "#07763", name: "180 40 45" }, 
      { hex: "#768481", name: "180 50 05" }, 
      { hex: "#6A857F", name: "180 50 10" }, 
      { hex: "#61867E", name: "180 50 15" }, 
      { hex: "#56887D", name: "180 50 20" }, 
      { hex: "#4D8B7E", name: "180 50 25" }, 
      { hex: "#418E7D", name: "180 50 30" }, 
      { hex: "#36907E", name: "180 50 35" }, 
      { hex: "#29907D", name: "180 50 40" }, 
      { hex: "#979D9A", name: "180 60 05" }, 
      { hex: "#839F99", name: "180 60 10" }, 
      { hex: "#79A298", name: "180 60 15" }, 
      { hex: "#6FA498", name: "180 60 20" }, 
      { hex: "#62A597", name: "180 60 25" }, 
      { hex: "#58A998", name: "180 60 30" }, 
      { hex: "#4DAA97", name: "180 60 35" }, 
      { hex: "#3CAD98", name: "180 60 40" }, 
      { hex: "#29AF97", name: "180 60 45" }, 
      { hex: "#B2B9B5", name: "180 70 05" }, 
      { hex: "#9DBBB2", name: "180 70 10" }, 
      { hex: "#92BEB3", name: "180 70 15" }, 
      { hex: "#D0D7D1", name: "180 80 05" }, 
      { hex: "#BBD8D1", name: "180 80 10" }, 
      { hex: "#A9DDD2", name: "180 80 15" }, 
      { hex: "#A3E0D1", name: "180 80 20" }, 
      { hex: "#A5E1D1", name: "180 80 25" }, 
      { hex: "#92E6D2", name: "180 80 30" }, 
      { hex: "#E5F7F2", name: "180 90 05" }, 
      { hex: "#DAFCF2", name: "180 90 10" }, 
      { hex: "#314541", name: "190 20 10" }, 
      { hex: "#2C4844", name: "190 20 15" }, 
      { hex: "#254843", name: "190 20 20" }, 
      { hex: "#405553", name: "190 30 10" }, 
      { hex: "#395956", name: "190 30 15" }, 
      { hex: "#2F5A56", name: "190 30 20" }, 
      { hex: "#285C57", name: "190 30 25" }, 
      { hex: "#1C5E58", name: "190 30 30" }, 
      { hex: "#125E59", name: "190 30 35" }, 
      { hex: "#496B68", name: "190 40 10" }, 
      { hex: "#4B6F6C", name: "190 40 15" }, 
      { hex: "#3F716D", name: "190 40 20" }, 
      { hex: "#35726E", name: "190 40 25" }, 
      { hex: "#29756F", name: "190 40 30" }, 
      { hex: "#137570", name: "190 40 35" }, 
      { hex: "#07770", name: "190 40 40" }, 
      { hex: "#6B8683", name: "190 50 10" }, 
      { hex: "#5F8883", name: "190 50 15" }, 
      { hex: "#548984", name: "190 50 20" }, 
      { hex: "#478C86", name: "190 50 25" }, 
      { hex: "#398D88", name: "190 50 30" }, 
      { hex: "#298F88", name: "190 50 35" }, 
      { hex: "#14928B", name: "190 50 40" }, 
      { hex: "#0958D", name: "190 50 45" }, 
      { hex: "#84A09D", name: "190 60 10" }, 
      { hex: "#79A29D", name: "190 60 15" }, 
      { hex: "#6FA59F", name: "190 60 20" }, 
      { hex: "#6DA49F", name: "190 60 25" }, 
      { hex: "#53AAA4", name: "190 60 30" }, 
      { hex: "#43ACA6", name: "190 60 35" }, 
      { hex: "#2BAEA6", name: "190 60 40" }, 
      { hex: "#15ADA5", name: "190 60 45" }, 
      { hex: "#9DBCB9", name: "190 70 10" }, 
      { hex: "#93BEB8", name: "190 70 15" }, 
      { hex: "#87C0BB", name: "190 70 20" }, 
      { hex: "#7BC3BE", name: "190 70 25" }, 
      { hex: "#70C7C1", name: "190 70 30" }, 
      { hex: "#B8DAD5", name: "190 80 10" }, 
      { hex: "#B0DDD9", name: "190 80 15" }, 
      { hex: "#A2DED8", name: "190 80 20" }, 
      { hex: "#97E1DA", name: "190 80 25" }, 
      { hex: "#D8FAF5", name: "190 90 10" }, 
      { hex: "#32413F", name: "20 00" }, 
      { hex: "#394442", name: "200 20 05" }, 
      { hex: "#304342", name: "200 20 10" }, 
      { hex: "#2A4343", name: "200 20 15" }, 
      { hex: "#254747", name: "200 20 20" }, 
      { hex: "#1A4747", name: "200 20 23" }, 
      { hex: "#485553", name: "200 30 05" }, 
      { hex: "#405857", name: "200 30 10" }, 
      { hex: "#385958", name: "200 30 15" }, 
      { hex: "#265A5B", name: "200 30 20" }, 
      { hex: "#225B5B", name: "200 30 25" }, 
      { hex: "#185D5E", name: "200 30 30" }, 
      { hex: "#65E60", name: "200 30 35" }, 
      { hex: "#5C6B6B", name: "200 40 05" }, 
      { hex: "#536D6D", name: "200 40 10" }, 
      { hex: "#4A6F6E", name: "200 40 15" }, 
      { hex: "#3F7272", name: "200 40 20" }, 
      { hex: "#357374", name: "200 40 25" }, 
      { hex: "#1A7577", name: "200 40 30" }, 
      { hex: "#728281", name: "200 50 05" }, 
      { hex: "#6B8586", name: "200 50 10" }, 
      { hex: "#5F8988", name: "200 50 15" }, 
      { hex: "#53898A", name: "200 50 20" }, 
      { hex: "#488C8F", name: "200 50 25" }, 
      { hex: "#358D90", name: "200 50 30" }, 
      { hex: "#249296", name: "200 50 35" }, 
      { hex: "#09398", name: "200 50 40" }, 
      { hex: "#8C9D9D", name: "200 60 05" }, 
      { hex: "#84A0A0", name: "200 60 10" }, 
      { hex: "#6DA2A3", name: "200 60 15" }, 
      { hex: "#75A4A5", name: "200 60 20" }, 
      { hex: "#5DA6A7", name: "200 60 25" }, 
      { hex: "#51A9AB", name: "200 60 30" }, 
      { hex: "#44ABAF", name: "200 60 35" }, 
      { hex: "#2CAEB2", name: "200 60 40" }, 
      { hex: "#A8B9B9", name: "200 70 05" }, 
      { hex: "#9DBDBD", name: "200 70 10" }, 
      { hex: "#8FBDBD", name: "200 70 15" }, 
      { hex: "#88C2C2", name: "200 70 20" }, 
      { hex: "#7CC5C8", name: "200 70 25" }, 
      { hex: "#6BC9CC", name: "200 70 30" }, 
      { hex: "#C7D7D6", name: "200 80 05" }, 
      { hex: "#B9DAD9", name: "200 80 10" }, 
      { hex: "#ADDBD9", name: "200 80 15" }, 
      { hex: "#ACE0E0", name: "200 80 20" }, 
      { hex: "#96E2E3", name: "200 80 25" }, 
      { hex: "#E5F7F5", name: "200 90 05" }, 
      { hex: "#D8F9F6", name: "200 90 10" }, 
      { hex: "#324546", name: "210 20 10" }, 
      { hex: "#2C4748", name: "210 20 15" }, 
      { hex: "#425657", name: "210 30 10" }, 
      { hex: "#39595C", name: "210 30 15" }, 
      { hex: "#2E5C60", name: "210 30 20" }, 
      { hex: "#255C62", name: "210 30 25" }, 
      { hex: "#165C65", name: "210 30 30" }, 
      { hex: "#526B6D", name: "210 40 10" }, 
      { hex: "#4B6F73", name: "210 40 15" }, 
      { hex: "#407277", name: "210 40 20" }, 
      { hex: "#327279", name: "210 40 25" }, 
      { hex: "#21747E", name: "210 40 30" }, 
      { hex: "#37683", name: "210 40 35" }, 
      { hex: "#07483", name: "210 40 38" }, 
      { hex: "#5F8589", name: "210 50 10" }, 
      { hex: "#61878A", name: "210 50 15" }, 
      { hex: "#53888E", name: "210 50 20" }, 
      { hex: "#478C94", name: "210 50 25" }, 
      { hex: "#368C98", name: "210 50 30" }, 
      { hex: "#268E9C", name: "210 50 35" }, 
      { hex: "#091A0", name: "210 50 40" }, 
      { hex: "#839FA1", name: "210 60 10" }, 
      { hex: "#78A1A5", name: "210 60 15" }, 
      { hex: "#6FA7AD", name: "210 60 20" }, 
      { hex: "#5EA9B2", name: "210 60 25" }, 
      { hex: "#50AAB6", name: "210 60 30" }, 
      { hex: "#3CABB8", name: "210 60 35" }, 
      { hex: "#9FBDBF", name: "210 70 10" }, 
      { hex: "#94BEC3", name: "210 70 15" }, 
      { hex: "#87C1C9", name: "210 70 20" }, 
      { hex: "#79C2CD", name: "210 70 25" }, 
      { hex: "#6AC6D2", name: "210 70 30" }, 
      { hex: "#5BC8D6", name: "210 70 35" }, 
      { hex: "#BEDBDD", name: "210 80 10" }, 
      { hex: "#B0DEE1", name: "210 80 15" }, 
      { hex: "#A4E0E6", name: "210 80 20" }, 
      { hex: "#98E2EC", name: "210 80 25" }, 
      { hex: "#D6F6F6", name: "210 90 10" }, 
      { hex: "#394444", name: "220 20 05" }, 
      { hex: "#324447", name: "220 20 10" }, 
      { hex: "#28444A", name: "220 20 15" }, 
      { hex: "#42717C", name: "220 30 05" }, 
      { hex: "#367381", name: "220 30 10" }, 
      { hex: "#247487", name: "220 30 15" }, 
      { hex: "#1E768C", name: "220 30 20" }, 
      { hex: "#0788F", name: "220 30 25" }, 
      { hex: "#1E5B6B", name: "220 30 30" }, 
      { hex: "#5C6A6C", name: "220 40 05" }, 
      { hex: "#566D71", name: "220 40 10" }, 
      { hex: "#4B6F77", name: "220 40 15" }, 
      { hex: "#42717C", name: "220 40 20" }, 
      { hex: "#367381", name: "220 40 25" }, 
      { hex: "#247487", name: "220 40 30" }, 
      { hex: "#1D768C", name: "220 40 35" }, 
      { hex: "#0788F", name: "220 40 40" }, 
      { hex: "#778586", name: "220 50 05" }, 
      { hex: "#6D858A", name: "220 50 10" }, 
      { hex: "#618790", name: "220 50 15" }, 
      { hex: "#548995", name: "220 50 20" }, 
      { hex: "#478A98", name: "220 50 25" }, 
      { hex: "#368A9E", name: "220 50 30" }, 
      { hex: "#2A8EA3", name: "220 50 35" }, 
      { hex: "#1891AA", name: "220 50 40" }, 
      { hex: "#989D9E", name: "220 60 05" }, 
      { hex: "#849FA5", name: "220 60 10" }, 
      { hex: "#7BA3AC", name: "220 60 15" }, 
      { hex: "#6FA3B0", name: "220 60 20" }, 
      { hex: "#62A6B7", name: "220 60 25" }, 
      { hex: "#A9BABD", name: "220 70 05" }, 
      { hex: "#A6E0EE", name: "220 80 20" }, 
      { hex: "#9EE3F3", name: "220 80 25" }, 
      { hex: "#E4F7F7", name: "220 90 05" }, 
      { hex: "#354549", name: "230 20 10" }, 
      { hex: "#2D464E", name: "230 20 15" }, 
      { hex: "#22444F", name: "230 20 20" }, 
      { hex: "#46595E", name: "230 30 10" }, 
      { hex: "#3E5A63", name: "230 30 15" }, 
      { hex: "#335A67", name: "230 30 20" }, 
      { hex: "#285B6D", name: "230 30 25" }, 
      { hex: "#566C72", name: "230 40 10" }, 
      { hex: "#516F79", name: "230 40 15" }, 
      { hex: "#477382", name: "230 40 20" }, 
      { hex: "#397287", name: "230 40 25" }, 
      { hex: "#31758D", name: "230 40 30" }, 
      { hex: "#237693", name: "230 40 35" }, 
      { hex: "#07797", name: "230 40 40" }, 
      { hex: "#6D848C", name: "230 50 10" }, 
      { hex: "#648793", name: "230 50 15" }, 
      { hex: "#5A8A9C", name: "230 50 20" }, 
      { hex: "#538BA0", name: "230 50 25" }, 
      { hex: "#428FAA", name: "230 50 30" }, 
      { hex: "#338DAC", name: "230 50 35" }, 
      { hex: "#158FB4", name: "230 50 40" }, 
      { hex: "#88A1A9", name: "230 60 10" }, 
      { hex: "#7CA0AD", name: "230 60 15" }, 
      { hex: "#72A3B5", name: "230 60 20" }, 
      { hex: "#65A4BB", name: "230 60 25" }, 
      { hex: "#A5BEC7", name: "230 70 10" }, 
      { hex: "#98BFCC", name: "230 70 15" }, 
      { hex: "#8BC1D5", name: "230 70 20" }, 
      { hex: "#83C2DB", name: "230 70 25" }, 
      { hex: "#76C3DF", name: "230 70 30" }, 
      { hex: "#BFDBE3", name: "230 80 10" }, 
      { hex: "#B2D9E6", name: "230 80 15" }, 
      { hex: "#AADEF1", name: "230 80 20" }, 
      { hex: "#E5F5F6", name: "230 90 05" }, 
      { hex: "#3B4446", name: "240 20 05" }, 
      { hex: "#34444A", name: "240 20 10" }, 
      { hex: "#2D454F", name: "240 20 15" }, 
      { hex: "#274554", name: "240 20 20" }, 
      { hex: "#214355", name: "240 20 22" }, 
      { hex: "#4A5658", name: "240 30 05" }, 
      { hex: "#44575E", name: "240 30 10" }, 
      { hex: "#3A5562", name: "240 30 15" }, 
      { hex: "#365B6C", name: "240 30 20" }, 
      { hex: "#275971", name: "240 30 25" }, 
      { hex: "#1E5A77", name: "240 30 30" }, 
      { hex: "#F5D7B", name: "240 30 35" }, 
      { hex: "#696A6E", name: "240 40 05" }, 
      { hex: "#586C75", name: "240 40 10" }, 
      { hex: "#4F6D7C", name: "240 40 15" }, 
      { hex: "#517084", name: "240 40 20" }, 
      { hex: "#3C718C", name: "240 40 25" }, 
      { hex: "#2E7191", name: "240 40 30" }, 
      { hex: "#1A7298", name: "240 40 35" }, 
      { hex: "#1739D", name: "240 40 40" }, 
      { hex: "#778287", name: "240 50 05" }, 
      { hex: "#6E848F", name: "240 50 10" }, 
      { hex: "#658797", name: "240 50 15" }, 
      { hex: "#5B879E", name: "240 50 20" }, 
      { hex: "#4E88A5", name: "240 50 25" }, 
      { hex: "#4489AB", name: "240 50 30" }, 
      { hex: "#2F8AB3", name: "240 50 35" }, 
      { hex: "#1B8AB9", name: "240 50 40" }, 
      { hex: "#8E9CA2", name: "240 60 05" }, 
      { hex: "#859DA9", name: "240 60 10" }, 
      { hex: "#7FA0B1", name: "240 60 15" }, 
      { hex: "#72A1BA", name: "240 60 20" }, 
      { hex: "#AAB8BE", name: "240 70 05" }, 
      { hex: "#A1BAC6", name: "240 70 10" }, 
      { hex: "#98BDD0", name: "240 70 15" }, 
      { hex: "#8EBED7", name: "240 70 20" }, 
      { hex: "#84C0DF", name: "240 70 25" }, 
      { hex: "#7DC0E5", name: "240 70 30" }, 
      { hex: "#C6D5DA", name: "240 80 05" }, 
      { hex: "#C0D9E5", name: "240 80 10" }, 
      { hex: "#B5DAED", name: "240 80 15" }, 
      { hex: "#A8DDF6", name: "240 80 20" }, 
      { hex: "#E5F5F9", name: "240 90 05" }, 
      { hex: "#34434B", name: "250 20 10" }, 
      { hex: "#24424E", name: "250 20 15" }, 
      { hex: "#264354", name: "250 20 20" }, 
      { hex: "#21445B", name: "250 20 25" }, 
      { hex: "#43535D", name: "250 30 10" }, 
      { hex: "#3C5564", name: "250 30 15" }, 
      { hex: "#33566B", name: "250 30 20" }, 
      { hex: "#2C5772", name: "250 30 25" }, 
      { hex: "#20587B", name: "250 30 30" }, 
      { hex: "#576B76", name: "250 40 10" }, 
      { hex: "#4F6C7E", name: "250 40 15" }, 
      { hex: "#476C84", name: "250 40 20" }, 
      { hex: "#3C6E8E", name: "250 40 25" }, 
      { hex: "#316E94", name: "250 40 30" }, 
      { hex: "#1F6E9B", name: "250 40 35" }, 
      { hex: "#C71A2", name: "250 40 40" }, 
      { hex: "#6F8390", name: "250 50 10" }, 
      { hex: "#678498", name: "250 50 15" }, 
      { hex: "#5F85A0", name: "250 50 20" }, 
      { hex: "#5486A8", name: "250 50 25" }, 
      { hex: "#4986B0", name: "250 50 30" }, 
      { hex: "#3A88B9", name: "250 50 35" }, 
      { hex: "#889CAA", name: "250 60 10" }, 
      { hex: "#809EB3", name: "250 60 15" }, 
      { hex: "#759EBB", name: "250 60 20" }, 
      { hex: "#A3BAC8", name: "250 70 10" }, 
      { hex: "#9BBBD2", name: "250 70 15" }, 
      { hex: "#9BBCDB", name: "250 70 20" }, 
      { hex: "#88BCE1", name: "250 70 25" }, 
      { hex: "#7CBDEA", name: "250 70 30" }, 
      { hex: "#BADAF0", name: "250 80 15" }, 
      { hex: "#AAD5F2", name: "250 80 20" }, 
      { hex: "#3B4346", name: "260 20 05" }, 
      { hex: "#38434B", name: "260 20 10" }, 
      { hex: "#2F4150", name: "260 20 15" }, 
      { hex: "#2C4457", name: "260 20 20" }, 
      { hex: "#4C5559", name: "260 30 05" }, 
      { hex: "#485661", name: "260 30 10" }, 
      { hex: "#425667", name: "260 30 15" }, 
      { hex: "#3C576E", name: "260 30 20" }, 
      { hex: "#345673", name: "260 30 25" }, 
      { hex: "#2F587C", name: "260 30 30" }, 
      { hex: "#1C5784", name: "260 30 35" }, 
      { hex: "#616A6F", name: "260 40 05" }, 
      { hex: "#5C6B78", name: "260 40 10" }, 
      { hex: "#576C7F", name: "260 40 15" }, 
      { hex: "#4D6B86", name: "260 40 20" }, 
      { hex: "#476C8E", name: "260 40 25" }, 
      { hex: "#346C95", name: "260 40 30" }, 
      { hex: "#346D9D", name: "260 40 35" }, 
      { hex: "#2470A9", name: "260 40 40" }, 
      { hex: "#738290", name: "260 50 10" }, 
      { hex: "#6C8297", name: "260 50 15" }, 
      { hex: "#6885A2", name: "260 50 20" }, 
      { hex: "#5F86AD", name: "260 50 25" }, 
      { hex: "#5486B4", name: "260 50 30" }, 
      { hex: "#4986BB", name: "260 50 35" }, 
      { hex: "#919BA3", name: "260 60 05" }, 
      { hex: "#8C9CAB", name: "260 60 10" }, 
      { hex: "#88A0B6", name: "260 60 15" }, 
      { hex: "#A9BAC9", name: "260 70 10" }, 
      { hex: "#AAB9D4", name: "260 70 15" }, 
      { hex: "#99BADB", name: "260 70 20" }, 
      { hex: "#91BBE4", name: "260 70 25" }, 
      { hex: "#CBD6DD", name: "260 80 05" }, 
      { hex: "#C4D6E6", name: "260 80 10" }, 
      { hex: "#BED7F0", name: "260 80 15" }, 
      { hex: "#E7F1F7", name: "260 90 05" }, 
      { hex: "#38424B", name: "270 20 10" }, 
      { hex: "#354351", name: "270 20 15" }, 
      { hex: "#314258", name: "270 20 20" }, 
      { hex: "#2A3F5B", name: "270 20 25" }, 
      { hex: "#264163", name: "270 20 29" }, 
      { hex: "#47535F", name: "270 30 10" }, 
      { hex: "#445466", name: "270 30 15" }, 
      { hex: "#3F546D", name: "270 30 20" }, 
      { hex: "#385374", name: "270 30 25" }, 
      { hex: "#32537B", name: "270 30 30" }, 
      { hex: "#2A5282", name: "270 30 35" }, 
      { hex: "#5E6A77", name: "270 40 10" }, 
      { hex: "#5A6A7F", name: "270 40 15" }, 
      { hex: "#536986", name: "270 40 20" }, 
      { hex: "#4F6A8F", name: "270 40 25" }, 
      { hex: "#476997", name: "270 40 30" }, 
      { hex: "#3D689F", name: "270 40 35" }, 
      { hex: "#768292", name: "270 50 10" }, 
      { hex: "#72839A", name: "270 50 15" }, 
      { hex: "#6A81A2", name: "270 50 20" }, 
      { hex: "#5B82AA", name: "270 50 25" }, 
      { hex: "#5D81B3", name: "270 50 30" }, 
      { hex: "#5480B9", name: "270 50 35" }, 
      { hex: "#8C9AAB", name: "270 60 10" }, 
      { hex: "#8B9CB6", name: "270 60 15" }, 
      { hex: "#AAB8CA", name: "270 70 10" }, 
      { hex: "#A4B7D3", name: "270 70 15" }, 
      { hex: "#A0B8DD", name: "270 70 20" }, 
      { hex: "#97B6E4", name: "270 70 25" }, 
      { hex: "#D2D5E6", name: "270 80 10" }, 
      { hex: "#C1D4EF", name: "270 80 15" }, 
      { hex: "#EAF2F6", name: "270 90 05" }, 
      { hex: "#414549", name: "280 20 05" }, 
      { hex: "#3E454E", name: "280 20 10" }, 
      { hex: "#3B4553", name: "280 20 15" }, 
      { hex: "#374358", name: "280 20 20" }, 
      { hex: "#36445F", name: "280 20 25" }, 
      { hex: "#324465", name: "280 20 30" }, 
      { hex: "#4F5559", name: "280 30 05" }, 
      { hex: "#4E5662", name: "280 30 10" }, 
      { hex: "#4C5669", name: "280 30 15" }, 
      { hex: "#495670", name: "280 30 20" }, 
      { hex: "#445677", name: "280 30 25" }, 
      { hex: "#3E547F", name: "280 30 30" }, 
      { hex: "#3C5584", name: "280 30 35" }, 
      { hex: "#63696F", name: "280 40 05" }, 
      { hex: "#606977", name: "280 40 10" }, 
      { hex: "#5D697F", name: "280 40 15" }, 
      { hex: "#5A6887", name: "280 40 20" }, 
      { hex: "#5B6B91", name: "280 40 25" }, 
      { hex: "#5E6A97", name: "280 40 30" }, 
      { hex: "#4F6A9F", name: "280 40 35" }, 
      { hex: "#7A8188", name: "280 50 05" }, 
      { hex: "#798191", name: "280 50 10" }, 
      { hex: "#778199", name: "280 50 15" }, 
      { hex: "#AFB8C9", name: "280 70 10" }, 
      { hex: "#A1B7D3", name: "280 70 15" }, 
      { hex: "#B1B7DC", name: "280 70 20" }, 
      { hex: "#A5B6E5", name: "280 70 25" }, 
      { hex: "#CFD6DD", name: "280 80 05" }, 
      { hex: "#CAD3E5", name: "280 80 10" }, 
      { hex: "#C6D2EE", name: "280 80 15" }, 
      { hex: "#EAF2F8", name: "280 90 05" }, 
      { hex: "#3B404B", name: "290 20 10" }, 
      { hex: "#3D4250", name: "290 20 15" }, 
      { hex: "#3C4157", name: "290 20 20" }, 
      { hex: "#39405C", name: "290 20 25" }, 
      { hex: "#363E61", name: "290 20 30" }, 
      { hex: "#343E66", name: "290 20 35" }, 
      { hex: "#50535F", name: "290 30 10" }, 
      { hex: "#4D5266", name: "290 30 15" }, 
      { hex: "#4C516B", name: "290 30 20" }, 
      { hex: "#4A5174", name: "290 30 25" }, 
      { hex: "#474F78", name: "290 30 30" }, 
      { hex: "#465184", name: "290 30 35" }, 
      { hex: "#636675", name: "290 40 10" }, 
      { hex: "#63677D", name: "290 40 15" }, 
      { hex: "#606586", name: "290 40 20" }, 
      { hex: "#5F658D", name: "290 40 25" }, 
      { hex: "#5D6496", name: "290 40 30" }, 
      { hex: "#7A7E90", name: "290 50 10" }, 
      { hex: "#707E96", name: "290 50 15" }, 
      { hex: "#777B9F", name: "290 50 20" }, 
      { hex: "#787DAA", name: "290 50 25" }, 
      { hex: "#767CB1", name: "290 50 30" }, 
      { hex: "#9397AA", name: "290 60 10" }, 
      { hex: "#9498B4", name: "290 60 15" }, 
      { hex: "#9095BC", name: "290 60 20" }, 
      { hex: "#9196C7", name: "290 60 25" }, 
      { hex: "#B2B6C9", name: "290 70 10" }, 
      { hex: "#AFB3D1", name: "290 70 15" }, 
      { hex: "#ACB3DA", name: "290 70 20" }, 
      { hex: "#ACB1E2", name: "290 70 25" }, 
      { hex: "#CCD1E5", name: "290 80 10" }, 
      { hex: "#EDF2F9", name: "290 90 05" }, 
      { hex: "#4E5251", name: "30 00" }, 
      { hex: "#404346", name: "300 20 05" }, 
      { hex: "#47404A", name: "300 20 10" }, 
      { hex: "#404050", name: "300 20 15" }, 
      { hex: "#3F3F54", name: "300 20 20" }, 
      { hex: "#3F3F59", name: "300 20 25" }, 
      { hex: "#3C3E61", name: "300 20 30" }, 
      { hex: "#52555A", name: "300 30 05" }, 
      { hex: "#525260", name: "300 30 10" }, 
      { hex: "#505063", name: "300 30 15" }, 
      { hex: "#504F6A", name: "300 30 20" }, 
      { hex: "#514E71", name: "300 30 25" }, 
      { hex: "#504D77", name: "300 30 30" }, 
      { hex: "#504D7E", name: "300 30 35" }, 
      { hex: "#686A70", name: "300 40 05" }, 
      { hex: "#666675", name: "300 40 10" }, 
      { hex: "#66647A", name: "300 40 15" }, 
      { hex: "#676482", name: "300 40 20" }, 
      { hex: "#67628A", name: "300 40 25" }, 
      { hex: "#686291", name: "300 40 30" }, 
      { hex: "#7E8087", name: "300 50 05" }, 
      { hex: "#7E7D8D", name: "300 50 10" }, 
      { hex: "#807D96", name: "300 50 15" }, 
      { hex: "#807C9E", name: "300 50 20" }, 
      { hex: "#7F79A5", name: "300 50 25" }, 
      { hex: "#8079AD", name: "300 50 30" }, 
      { hex: "#999BA4", name: "300 60 05" }, 
      { hex: "#9898A9", name: "300 60 10" }, 
      { hex: "#9996B1", name: "300 60 15" }, 
      { hex: "#9A95B9", name: "300 60 20" }, 
      { hex: "#9993C1", name: "300 60 25" }, 
      { hex: "#9991C9", name: "300 60 30" }, 
      { hex: "#B4B6BF", name: "300 70 05" }, 
      { hex: "#BEB3C5", name: "300 70 10" }, 
      { hex: "#B5B2CF", name: "300 70 15" }, 
      { hex: "#ACB2D7", name: "300 70 20" }, 
      { hex: "#D1D4DD", name: "300 80 05" }, 
      { hex: "#D0D0E6", name: "300 80 10" }, 
      { hex: "#D1CFED", name: "300 80 15" }, 
      { hex: "#EEF1F9", name: "300 90 05" }, 
      { hex: "#434249", name: "310 20 10" }, 
      { hex: "#44404F", name: "310 20 15" }, 
      { hex: "#454053", name: "310 20 20" }, 
      { hex: "#473F58", name: "310 20 25" }, 
      { hex: "#453C5E", name: "310 20 30" }, 
      { hex: "#5E525D", name: "310 30 10" }, 
      { hex: "#575365", name: "310 30 15" }, 
      { hex: "#564F68", name: "310 30 20" }, 
      { hex: "#5A4F6F", name: "310 30 25" }, 
      { hex: "#5C4E75", name: "310 30 30" }, 
      { hex: "#5A4B77", name: "310 30 35" }, 
      { hex: "#6C6875", name: "310 40 10" }, 
      { hex: "#6E677C", name: "310 40 15" }, 
      { hex: "#6F6581", name: "310 40 20" }, 
      { hex: "#726489", name: "310 40 25" }, 
      { hex: "#71608C", name: "310 40 30" }, 
      { hex: "#837E8E", name: "310 50 10" }, 
      { hex: "#8E7D94", name: "310 50 15" }, 
      { hex: "#877B9A", name: "310 50 20" }, 
      { hex: "#8A7AA1", name: "310 50 25" }, 
      { hex: "#8B78A9", name: "310 50 30" }, 
      { hex: "#8B75AD", name: "310 50 35" }, 
      { hex: "#9C97A8", name: "310 60 10" }, 
      { hex: "#A097B0", name: "310 60 15" }, 
      { hex: "#A294B6", name: "310 60 20" }, 
      { hex: "#A492BC", name: "310 60 25" }, 
      { hex: "#A590C2", name: "310 60 30" }, 
      { hex: "#B8B3C3", name: "310 70 10" }, 
      { hex: "#BBB1CB", name: "310 70 15" }, 
      { hex: "#BCAED1", name: "310 70 20" }, 
      { hex: "#D3CEE0", name: "310 80 10" }, 
      { hex: "#D7CEE8", name: "310 80 15" }, 
      { hex: "#F1F2F8", name: "310 90 05" }, 
      { hex: "#434447", name: "320 20 05" }, 
      { hex: "#454048", name: "320 20 10" }, 
      { hex: "#453E4B", name: "320 20 15" }, 
      { hex: "#3E3F50", name: "320 20 20" }, 
      { hex: "#493C54", name: "320 20 25" }, 
      { hex: "#545357", name: "320 30 05" }, 
      { hex: "#564F5A", name: "320 30 10" }, 
      { hex: "#574C5D", name: "320 30 15" }, 
      { hex: "#5A4A62", name: "320 30 20" }, 
      { hex: "#5D4765", name: "320 30 25" }, 
      { hex: "#5F476C", name: "320 30 30" }, 
      { hex: "#624671", name: "320 30 35" }, 
      { hex: "#69686D", name: "320 40 05" }, 
      { hex: "#6C6471", name: "320 40 10" }, 
      { hex: "#706377", name: "320 40 15" }, 
      { hex: "#71607A", name: "320 40 20" }, 
      { hex: "#755E81", name: "320 40 25" }, 
      { hex: "#767E84", name: "320 50 05" }, 
      { hex: "#7A7A89", name: "320 50 10" }, 
      { hex: "#86788E", name: "320 50 15" }, 
      { hex: "#8C7895", name: "320 50 20" }, 
      { hex: "#8D739A", name: "320 50 25" }, 
      { hex: "#9173A0", name: "320 50 30" }, 
      { hex: "#936EA3", name: "320 50 35" }, 
      { hex: "#9A98A0", name: "320 60 05" }, 
      { hex: "#9E96A4", name: "320 60 10" }, 
      { hex: "#A293AB", name: "320 60 15" }, 
      { hex: "#A58FAF", name: "320 60 20" }, 
      { hex: "#A88DB6", name: "320 60 25" }, 
      { hex: "#AB89BB", name: "320 60 30" }, 
      { hex: "#B5B3BA", name: "320 70 05" }, 
      { hex: "#B9B0C1", name: "320 70 10" }, 
      { hex: "#BBADC7", name: "320 70 15" }, 
      { hex: "#C5ADD1", name: "320 70 20" }, 
      { hex: "#D3D1D9", name: "320 80 05" }, 
      { hex: "#D7CDDE", name: "320 80 10" }, 
      { hex: "#D1C9E3", name: "320 80 15" }, 
      { hex: "#F2F0F6", name: "320 90 05" }, 
      { hex: "#504046", name: "330 20 10" }, 
      { hex: "#483F49", name: "330 20 15" }, 
      { hex: "#4B3C4B", name: "330 20 20" }, 
      { hex: "#503B51", name: "330 20 25" }, 
      { hex: "#5A535B", name: "330 30 10" }, 
      { hex: "#5C4F5D", name: "330 30 15" }, 
      { hex: "#604C5F", name: "330 30 20" }, 
      { hex: "#654A63", name: "330 30 25" }, 
      { hex: "#674565", name: "330 30 30" }, 
      { hex: "#62466C", name: "330 30 35" }, 
      { hex: "#6F426D", name: "330 30 40" }, 
      { hex: "#706771", name: "330 40 10" }, 
      { hex: "#746374", name: "330 40 15" }, 
      { hex: "#79637A", name: "330 40 20" }, 
      { hex: "#7D607E", name: "330 40 25" }, 
      { hex: "#917B88", name: "330 50 10" }, 
      { hex: "#8D7A8D", name: "330 50 15" }, 
      { hex: "#927892", name: "330 50 20" }, 
      { hex: "#957696", name: "330 50 25" }, 
      { hex: "#9A749C", name: "330 50 30" }, 
      { hex: "#9D709E", name: "330 50 35" }, 
      { hex: "#A36CA1", name: "330 50 40" }, 
      { hex: "#A196A3", name: "330 60 10" }, 
      { hex: "#A793A9", name: "330 60 15" }, 
      { hex: "#AD91AE", name: "330 60 20" }, 
      { hex: "#AE8DAE", name: "330 60 25" }, 
      { hex: "#B58BB5", name: "330 60 30" }, 
      { hex: "#B187B9", name: "330 60 35" }, 
      { hex: "#BFB2C1", name: "330 70 10" }, 
      { hex: "#C2AEC3", name: "330 70 15" }, 
      { hex: "#C8ADC8", name: "330 70 20" }, 
      { hex: "#CFA9CE", name: "330 70 25" }, 
      { hex: "#DCCEDD", name: "330 80 10" }, 
      { hex: "#D7CCE2", name: "330 80 15" }, 
      { hex: "#E9C9E5", name: "330 80 20" }, 
      { hex: "#F6F1F5", name: "330 90 05" }, 
      { hex: "#434244", name: "340 20 05" }, 
      { hex: "#473F43", name: "340 20 10" }, 
      { hex: "#483A44", name: "340 20 15" }, 
      { hex: "#4E3A47", name: "340 20 20" }, 
      { hex: "#543B4B", name: "340 20 25" }, 
      { hex: "#555255", name: "340 30 05" }, 
      { hex: "#594E55", name: "340 30 10" }, 
      { hex: "#5F4C59", name: "340 30 15" }, 
      { hex: "#634B5B", name: "340 30 20" }, 
      { hex: "#68475F", name: "340 30 25" }, 
      { hex: "#69445F", name: "340 30 30" }, 
      { hex: "#6E4061", name: "340 30 35" }, 
      { hex: "#723E63", name: "340 30 38" }, 
      { hex: "#6A676B", name: "340 40 05" }, 
      { hex: "#67636C", name: "340 40 10" }, 
      { hex: "#6D616E", name: "340 40 15" }, 
      { hex: "#7B5D70", name: "340 40 20" }, 
      { hex: "#805B75", name: "340 40 25" }, 
      { hex: "#855877", name: "340 40 30" }, 
      { hex: "#88527A", name: "340 40 35" }, 
      { hex: "#8C4F7B", name: "340 40 40" }, 
      { hex: "#944C80", name: "340 40 45" }, 
      { hex: "#837E82", name: "340 50 05" }, 
      { hex: "#8B7B85", name: "340 50 10" }, 
      { hex: "#917888", name: "340 50 15" }, 
      { hex: "#96748A", name: "340 50 20" }, 
      { hex: "#9B718E", name: "340 50 25" }, 
      { hex: "#A06E91", name: "340 50 30" }, 
      { hex: "#A26792", name: "340 50 35" }, 
      { hex: "#AA6696", name: "340 50 40" }, 
      { hex: "#AE6298", name: "340 50 45" }, 
      { hex: "#9E999E", name: "340 60 05" }, 
      { hex: "#A4939F", name: "340 60 10" }, 
      { hex: "#AB91A3", name: "340 60 15" }, 
      { hex: "#B18DA6", name: "340 60 20" }, 
      { hex: "#B489A8", name: "340 60 25" }, 
      { hex: "#BB87AC", name: "340 60 30" }, 
      { hex: "#C182AE", name: "340 60 35" }, 
      { hex: "#C77EB2", name: "340 60 40" }, 
      { hex: "#BAB4B9", name: "340 70 05" }, 
      { hex: "#C1B0BB", name: "340 70 10" }, 
      { hex: "#C9ADC0", name: "340 70 15" }, 
      { hex: "#CDAAC3", name: "340 70 20" }, 
      { hex: "#D1A5C3", name: "340 70 25" }, 
      { hex: "#D7D1D6", name: "340 80 05" }, 
      { hex: "#DFCFDC", name: "340 80 10" }, 
      { hex: "#E6CADD", name: "340 80 15" }, 
      { hex: "#F0C7E0", name: "340 80 20" }, 
      { hex: "#F6EFF4", name: "340 90 05" }, 
      { hex: "#473E43", name: "350 20 10" }, 
      { hex: "#4D3E44", name: "350 20 15" }, 
      { hex: "#513A44", name: "350 20 20" }, 
      { hex: "#543844", name: "350 20 25" }, 
      { hex: "#5A3848", name: "350 20 30" }, 
      { hex: "#5A4E53", name: "350 30 10" }, 
      { hex: "#604C54", name: "350 30 15" }, 
      { hex: "#6B4658", name: "350 30 25" }, 
      { hex: "#73455A", name: "350 30 30" }, 
      { hex: "#723F58", name: "350 30 35" }, 
      { hex: "#7A3D5B", name: "350 30 40" }, 
      { hex: "#72636A", name: "350 40 10" }, 
      { hex: "#78606B", name: "350 40 15" }, 
      { hex: "#7F5D6D", name: "350 40 20" }, 
      { hex: "#835A6E", name: "350 40 25" }, 
      { hex: "#8A566F", name: "350 40 30" }, 
      { hex: "#8E5270", name: "350 40 35" }, 
      { hex: "#945072", name: "350 40 40" }, 
      { hex: "#974D73", name: "350 40 45" }, 
      { hex: "#9D4875", name: "350 40 50" }, 
      { hex: "#8B7A82", name: "350 50 10" }, 
      { hex: "#927783", name: "350 50 15" }, 
      { hex: "#997486", name: "350 50 20" }, 
      { hex: "#9F7187", name: "350 50 25" }, 
      { hex: "#A46F8A", name: "350 50 30" }, 
      { hex: "#AD688A", name: "350 50 35" }, 
      { hex: "#B3658A", name: "350 50 40" }, 
      { hex: "#B4608C", name: "350 50 45" }, 
      { hex: "#A5949E", name: "350 60 10" }, 
      { hex: "#AD919F", name: "350 60 15" }, 
      { hex: "#B58FA2", name: "350 60 20" }, 
      { hex: "#BD8AA1", name: "350 60 25" }, 
      { hex: "#C486A3", name: "350 60 30" }, 
      { hex: "#C982A5", name: "350 60 35" }, 
      { hex: "#D07FA6", name: "350 60 40" }, 
      { hex: "#C3B2B8", name: "350 70 10" }, 
      { hex: "#CAADBA", name: "350 70 15" }, 
      { hex: "#CEA7BA", name: "350 70 20" }, 
      { hex: "#D8A5BD", name: "350 70 25" }, 
      { hex: "#E1CCD6", name: "350 80 10" }, 
      { hex: "#E8C9D6", name: "350 80 15" }, 
      { hex: "#F0C6DA", name: "350 80 20" }, 
      { hex: "#F8F0F3", name: "350 90 05" }, 
      { hex: "#444142", name: "360 20 05" }, 
      { hex: "#483E3F", name: "360 20 10" }, 
      { hex: "#4D3C3F", name: "360 20 15" }, 
      { hex: "#565151", name: "360 30 05" }, 
      { hex: "#5B4E52", name: "360 30 10" }, 
      { hex: "#604950", name: "360 30 15" }, 
      { hex: "#694A52", name: "360 30 20" }, 
      { hex: "#6B4450", name: "360 30 25" }, 
      { hex: "#6F4050", name: "360 30 30" }, 
      { hex: "#7A3F51", name: "360 30 35" }, 
      { hex: "#7B3D52", name: "360 30 40" }, 
      { hex: "#6C6667", name: "360 40 05" }, 
      { hex: "#716367", name: "360 40 10" }, 
      { hex: "#796068", name: "360 40 15" }, 
      { hex: "#805C67", name: "360 40 20" }, 
      { hex: "#855865", name: "360 40 25" }, 
      { hex: "#835467", name: "360 40 30" }, 
      { hex: "#935168", name: "360 40 35" }, 
      { hex: "#9A4D6A", name: "360 40 40" }, 
      { hex: "#9E4A68", name: "360 40 45" }, 
      { hex: "#A24366", name: "360 40 50" }, 
      { hex: "#867D7E", name: "360 50 05" }, 
      { hex: "#8C7A7F", name: "360 50 10" }, 
      { hex: "#89757E", name: "360 50 15" }, 
      { hex: "#8F7480", name: "360 50 20" }, 
      { hex: "#A16F7E", name: "360 50 25" }, 
      { hex: "#A86C80", name: "360 50 30" }, 
      { hex: "#B16881", name: "360 50 35" }, 
      { hex: "#B96681", name: "360 50 40" }, 
      { hex: "#BF6181", name: "360 50 45" }, 
      { hex: "#C15B80", name: "360 50 50" }, 
      { hex: "#9F999B", name: "360 60 05" }, 
      { hex: "#A69499", name: "360 60 10" }, 
      { hex: "#AE919B", name: "360 60 15" }, 
      { hex: "#B88D9B", name: "360 60 20" }, 
      { hex: "#BE899B", name: "360 60 25" }, 
      { hex: "#BCB4B6", name: "360 70 05" }, 
      { hex: "#C3AFB5", name: "360 70 10" }, 
      { hex: "#CCACB5", name: "360 70 15" }, 
      { hex: "#DBD2D5", name: "360 80 05" }, 
      { hex: "#E1CCD2", name: "360 80 10" }, 
      { hex: "#646867", name: "40 00" }, 
      { hex: "#717573", name: "45 00" }, 
      { hex: "#898D8C", name: "55 00" }, 
      { hex: "#959A9A", name: "60 00" }, 
      { hex: "#AFAAAA", name: "65 00" }, 
      { hex: "#B3B8B7", name: "70 00" }, 
      { hex: "#C2C6C7", name: "75 00" }, 
      { hex: "#D2D6D4", name: "80 00" }, 
      { hex: "#EEF4F2", name: "90 00" }, 
      { hex: "#E1776D", name: "030 60 50" }, 
      { hex: "#B48D7E", name: "040 60 20" }, 
      { hex: "#F9C826", name: "085 80 85" }, 
      { hex: "#F7D11", name: "090 80 90" }, 
      { hex: "#F5EE9A", name: "090 90 40" }, 
      { hex: "#FFE981", name: "090 90 50" }, 
      { hex: "#FFE66B", name: "090 90 60" }, 
      { hex: "#A59A24", name: "095 60 70" }, 
      { hex: "#E3D45E", name: "095 80 60" }, 
      { hex: "#FEF19C", name: "095 90 40" }, 
      { hex: "#FFC3AD", name: "040 80 30" }, 
      { hex: "#A27459", name: "050 50 30" }, 
      { hex: "#F79C6E", name: "050 70 50" }, 
      { hex: "#FE955F", name: "050 70 60" }, 
      { hex: "#FBC3A4", name: "050 80 30" }, 
      { hex: "#9F7856", name: "060 50 30" }, 
      { hex: "#A77246", name: "060 50 40" }, 
      { hex: "#BD692A", name: "060 50 70" }, 
      { hex: "#EECDB1", name: "060 80 20" }, 
      { hex: "#766348", name: "070 40 20" }, 
      { hex: "#97774D", name: "070 50 30" }, 
      { hex: "#9F753E", name: "070 50 40" }, 
      { hex: "#9F7336", name: "070 50 50" }, 
      { hex: "#DBD0BE", name: "070 80 10" }, 
      { hex: "#EAD0AE", name: "070 80 20" }, 
      { hex: "#FBCB8A", name: "070 80 40" }, 
      { hex: "#7D6336", name: "075 40 38" }, 
      { hex: "#CFB17F", name: "075 70 30" }, 
      { hex: "#E6D1B0", name: "075 80 20" }, 
      { hex: "#F5CB8C", name: "075 80 40" }, 
      { hex: "#9A7931", name: "080 50 50" }, 
      { hex: "#B29455", name: "080 60 40" }, 
      { hex: "#BE8F23", name: "080 60 70" }, 
      { hex: "#DFAC33", name: "080 70 70" }, 
      { hex: "#E2AA1B", name: "080 70 80" }, 
      { hex: "#E9CF9A", name: "080 80 30" }, 
      { hex: "#E7D196", name: "085 80 30" }, 
      { hex: "#FBCB30", name: "085 80 80" }, 
      { hex: "#ECD055", name: "090 80 60" }, 
      { hex: "#368F67", name: "160 50 40" }, 
      { hex: "#3B9266", name: "160 50 45" }, 
      { hex: "#9A982B", name: "100 60 60" }, 
      { hex: "#E0DB5B", name: "100 80 60" }, 
      { hex: "#FBF7A0", name: "100 90 40" }, 
      { hex: "#626E36", name: "110 40 40" }, 
      { hex: "#75872F", name: "110 50 55" }, 
      { hex: "#AFBF5D", name: "110 70 50" }, 
      { hex: "#A2BA2B", name: "110 70 77" }, 
      { hex: "#CFDA9A", name: "110 80 30" }, 
      { hex: "#E9F6A9", name: "110 90 35" }, 
      { hex: "#EFFBA2", name: "110 90 40" }, 
      { hex: "#556E32", name: "120 40 40" }, 
      { hex: "#9FC35F", name: "120 70 50" }, 
      { hex: "#C5DD9E", name: "120 80 30" }, 
      { hex: "#74A663", name: "130 60 40" }, 
      { hex: "#8BC85F", name: "130 70 60" }, 
      { hex: "#BCDEA6", name: "130 80 30" }, 
      { hex: "#385A36", name: "140 30 30" }, 
      { hex: "#285936", name: "140 30 40" }, 
      { hex: "#79CD6A", name: "140 70 60" }, 
      { hex: "#B3DFAA", name: "140 80 30" }, 
      { hex: "#A5E39C", name: "140 80 40" }, 
      { hex: "#9DC1A5", name: "150 70 20" }, 
      { hex: "#A1E8AE", name: "150 80 40" }, 
      { hex: "#93BEA6", name: "160 70 20" }, 
      { hex: "#8BC3A5", name: "160 70 25" }, 
      { hex: "#82C5A1", name: "160 70 30" }, 
      { hex: "#269170", name: "170 50 45" }, 
      { hex: "#18936E", name: "170 50 50" }, 
      { hex: "#0936C", name: "170 50 55" }, 
      { hex: "#88C4AD", name: "170 70 25" }, 
      { hex: "#7AC7AC", name: "170 70 30" }, 
      { hex: "#70C7A8", name: "170 70 35" }, 
      { hex: "#1937C", name: "180 50 45" }, 
      { hex: "#7CC3B3", name: "180 70 25" }, 
      { hex: "#73C6B4", name: "180 70 30" }, 
      { hex: "#64C9B4", name: "180 70 35" }, 
      { hex: "#56CAB3", name: "180 70 40" }, 
      { hex: "#07D75", name: "190 40 45" }, 
      { hex: "#5EC7BF", name: "190 70 35" }, 
      { hex: "#127679", name: "200 40 35" }, 
      { hex: "#0797D", name: "200 40 40" }, 
      { hex: "#5CC9CD", name: "200 70 35" }, 
      { hex: "#54AABE", name: "220 60 30" }, 
      { hex: "#47A9C0", name: "220 60 35" }, 
      { hex: "#35ABC6", name: "220 60 40" }, 
      { hex: "#59A6C1", name: "230 60 30" }, 
      { hex: "#52A8C9", name: "230 60 35" }, 
      { hex: "#2CAAD2", name: "230 60 40" }, 
      { hex: "#5AA4C9", name: "240 60 30" }, 
      { hex: "#4AA6D1", name: "240 60 35" }, 
      { hex: "#35A8D8", name: "240 60 40" }, 
      { hex: "#6C9FC4", name: "250 60 25" }, 
      { hex: "#60A0CC", name: "250 60 30" }, 
      { hex: "#53A1D5", name: "250 60 35" }, 
      { hex: "#ACB7BF", name: "260 70 05" }, 
      { hex: "#1E538D", name: "270 30 40" }, 
      { hex: "#1B5792", name: "270 30 45" }, 
      { hex: "#849CBF", name: "270 60 20" }, 
      { hex: "#7F9DC8", name: "270 60 25" }, 
      { hex: "#789DD1", name: "270 60 30" }, 
      { hex: "#8899C7", name: "280 60 25" }, 
      { hex: "#849ACF", name: "280 60 30" }, 
      { hex: "#7F9FBE", name: "260 60 20" }, 
      { hex: "#77A0C7", name: "260 60 25" }, 
      { hex: "#6EA0D0", name: "260 60 30" }, 
      { hex: "#63A1D9", name: "260 60 35" }, 
      { hex: "#676197", name: "300 40 35" }, 
      { hex: "#B5AEDD", name: "300 70 25" }, 
      { hex: "#715E92", name: "310 40 35" }, 
      { hex: "#BFADD8", name: "310 70 25" }, 
      { hex: "#785A84", name: "320 40 30" }, 
      { hex: "#7A5788", name: "320 40 35" }, 
      { hex: "#C7A9D5", name: "320 70 25" }, 
      { hex: "#835C81", name: "330 40 30" }, 
      { hex: "#875A85", name: "330 40 35" }, 
      { hex: "#885586", name: "330 40 40" }, 
      { hex: "#8B5389", name: "330 40 45" }, 
      { hex: "#D2A7D1", name: "330 70 30" }, 
      { hex: "#D8A0C8", name: "340 70 30" }, 
      { hex: "#E09ECD", name: "340 70 35" }, 
      { hex: "#E1A1BF", name: "350 70 30" }, 
      { hex: "#E79EC1", name: "350 70 35" }
    ],
      "NCS": [      { hex: "#f7f7f7", name: "0300-N" }, 
      { hex: "#f2f2f2", name: "0500-N" }, 
      { hex: "#f5fbff", name: "0502-B" }, 
      { hex: "#f7fffe", name: "0502-B50G" }, 
      { hex: "#f4fff8", name: "0502-G" }, 
      { hex: "#fdfff6", name: "0502-G50Y" }, 
      { hex: "#fff1f2", name: "0502-R" }, 
      { hex: "#fef6fd", name: "0502-R50B" }, 
      { hex: "#fffdf6", name: "0502-Y" }, 
      { hex: "#fef8f4", name: "0502-Y50R" }, 
      { hex: "#e8f6fe", name: "0505-B" }, 
      { hex: "#eafbff", name: "0505-B20G" }, 
      { hex: "#ecfffe", name: "0505-B50G" }, 
      { hex: "#eafffa", name: "0505-B80G" }, 
      { hex: "#e4ffef", name: "0505-G" }, 
      { hex: "#ecffec", name: "0505-G10Y" }, 
      { hex: "#f1ffeb", name: "0505-G20Y" }, 
      { hex: "#f4ffea", name: "0505-G30Y" }, 
      { hex: "#f7ffe9", name: "0505-G40Y" }, 
      { hex: "#faffea", name: "0505-G50Y" }, 
      { hex: "#fcffeb", name: "0505-G60Y" }, 
      { hex: "#feffeb", name: "0505-G70Y" }, 
      { hex: "#fffeec", name: "0505-G80Y" }, 
      { hex: "#fefdeb", name: "0505-G90Y" }, 
      { hex: "#ffdee0", name: "0505-R" }, 
      { hex: "#ffdfe3", name: "0505-R10B" }, 
      { hex: "#ffe1e7", name: "0505-R20B" }, 
      { hex: "#ffe3ec", name: "0505-R30B" }, 
      { hex: "#fee6f2", name: "0505-R40B" }, 
      { hex: "#ffeafb", name: "0505-R50B" }, 
      { hex: "#f8e9fe", name: "0505-R60B" }, 
      { hex: "#f0e8ff", name: "0505-R70B" }, 
      { hex: "#e1e6ff", name: "0505-R80B" }, 
      { hex: "#e3ecfe", name: "0505-R90B" }, 
      { hex: "#fffbea", name: "0505-Y" }, 
      { hex: "#fffaea", name: "0505-Y10R" }, 
      { hex: "#fff7e9", name: "0505-Y20R" }, 
      { hex: "#fff5e8", name: "0505-Y30R" }, 
      { hex: "#fff3e6", name: "0505-Y40R" }, 
      { hex: "#fff0e5", name: "0505-Y50R" }, 
      { hex: "#feede4", name: "0505-Y60R" }, 
      { hex: "#ffe9e2", name: "0505-Y70R" }, 
      { hex: "#fee5e0", name: "0505-Y80R" }, 
      { hex: "#ffe2e0", name: "0505-Y90R" }, 
      { hex: "#dff3ff", name: "0507-B" }, 
      { hex: "#e3faff", name: "0507-B20G" }, 
      { hex: "#e2fff8", name: "0507-B80G" }, 
      { hex: "#dbffe9", name: "0507-G" }, 
      { hex: "#f4ffe0", name: "0507-G40Y" }, 
      { hex: "#fffee4", name: "0507-G80Y" }, 
      { hex: "#ffd2d5", name: "0507-R" }, 
      { hex: "#ffd6de", name: "0507-R20B" }, 
      { hex: "#ffddee", name: "0507-R40B" }, 
      { hex: "#f5e0ff", name: "0507-R60B" }, 
      { hex: "#d6ddff", name: "0507-R80B" }, 
      { hex: "#fffae3", name: "0507-Y" }, 
      { hex: "#fff5e0", name: "0507-Y20R" }, 
      { hex: "#ffeedd", name: "0507-Y40R" }, 
      { hex: "#ffe6da", name: "0507-Y60R" }, 
      { hex: "#fedcd5", name: "0507-Y80R" }, 
      { hex: "#d3eeff", name: "0510-B" }, 
      { hex: "#d6f4ff", name: "0510-B10G" }, 
      { hex: "#d9fbff", name: "0510-B30G" }, 
      { hex: "#dafffd", name: "0510-B50G" }, 
      { hex: "#d8fef9", name: "0510-B70G" }, 
      { hex: "#d1ffea", name: "0510-B90G" }, 
      { hex: "#cdffe0", name: "0510-G" }, 
      { hex: "#dbffdc", name: "0510-G10Y" }, 
      { hex: "#e4ffd9", name: "0510-G20Y" }, 
      { hex: "#ebffd6", name: "0510-G30Y" }, 
      { hex: "#f0ffd4", name: "0510-G40Y" }, 
      { hex: "#f5ffd6", name: "0510-G50Y" }, 
      { hex: "#f9ffd8", name: "0510-G60Y" }, 
      { hex: "#fdffd9", name: "0510-G70Y" }, 
      { hex: "#fffdda", name: "0510-G80Y" }, 
      { hex: "#fefbd8", name: "0510-G90Y" }, 
      { hex: "#ffc2c6", name: "0510-R" }, 
      { hex: "#ffc4cb", name: "0510-R10B" }, 
      { hex: "#ffc7d2", name: "0510-R20B" }, 
      { hex: "#ffcbdb", name: "0510-R30B" }, 
      { hex: "#ffd0e7", name: "0510-R40B" }, 
      { hex: "#ffd7f7", name: "0510-R50B" }, 
      { hex: "#f1d4ff", name: "0510-R60B" }, 
      { hex: "#e3d4ff", name: "0510-R70B" }, 
      { hex: "#c6d1ff", name: "0510-R80B" }, 
      { hex: "#cbdcff", name: "0510-R90B" }, 
      { hex: "#fff9d8", name: "0510-Y" }, 
      { hex: "#fff5d6", name: "0510-Y10R" }, 
      { hex: "#fff1d4", name: "0510-Y20R" }, 
      { hex: "#ffedd2", name: "0510-Y30R" }, 
      { hex: "#ffe8d0", name: "0510-Y40R" }, 
      { hex: "#ffe3ce", name: "0510-Y50R" }, 
      { hex: "#ffddcc", name: "0510-Y60R" }, 
      { hex: "#fed7c9", name: "0510-Y70R" }, 
      { hex: "#ffd0c6", name: "0510-Y80R" }, 
      { hex: "#ffc9c5", name: "0510-Y90R" }, 
      { hex: "#c0e7ff", name: "0515-B" }, 
      { hex: "#c5f5fe", name: "0515-B20G" }, 
      { hex: "#c8fffd", name: "0515-B50G" }, 
      { hex: "#c4fff1", name: "0515-B80G" }, 
      { hex: "#b8ffd4", name: "0515-G" }, 
      { hex: "#d8ffc8", name: "0515-G20Y" }, 
      { hex: "#eaffc1", name: "0515-G40Y" }, 
      { hex: "#f7fec6", name: "0515-G60Y" }, 
      { hex: "#fffdc8", name: "0515-G80Y" }, 
      { hex: "#fff9c7", name: "0515-G90Y" }, 
      { hex: "#feaaaf", name: "0515-R" }, 
      { hex: "#feadb7", name: "0515-R10B" }, 
      { hex: "#feb1c0", name: "0515-R20B" }, 
      { hex: "#ffbcdd", name: "0515-R40B" }, 
      { hex: "#ebc1ff", name: "0515-R60B" }, 
      { hex: "#b0befe", name: "0515-R80B" }, 
      { hex: "#b6ceff", name: "0515-R90B" }, 
      { hex: "#fff6c6", name: "0515-Y" }, 
      { hex: "#fff1c4", name: "0515-Y10R" }, 
      { hex: "#ffebc1", name: "0515-Y20R" }, 
      { hex: "#ffe5bf", name: "0515-Y30R" }, 
      { hex: "#ffdebc", name: "0515-Y40R" }, 
      { hex: "#ffd7b9", name: "0515-Y50R" }, 
      { hex: "#ffcfb6", name: "0515-Y60R" }, 
      { hex: "#ffc6b3", name: "0515-Y70R" }, 
      { hex: "#ffbdaf", name: "0515-Y80R" }, 
      { hex: "#ffb4ae", name: "0515-Y90R" }, 
      { hex: "#aee0ff", name: "0520-B" }, 
      { hex: "#b2ebff", name: "0520-B10G" }, 
      { hex: "#b6f8ff", name: "0520-B30G" }, 
      { hex: "#b8fcff", name: "0520-B40G" }, 
      { hex: "#b8fffc", name: "0520-B50G" }, 
      { hex: "#b7fff8", name: "0520-B60G" }, 
      { hex: "#b5fff4", name: "0520-B70G" }, 
      { hex: "#abffd9", name: "0520-B90G" }, 
      { hex: "#a5ffc8", name: "0520-G" }, 
      { hex: "#bdffc0", name: "0520-G10Y" }, 
      { hex: "#cdffb9", name: "0520-G20Y" }, 
      { hex: "#daffb4", name: "0520-G30Y" }, 
      { hex: "#e4ffb0", name: "0520-G40Y" }, 
      { hex: "#edffb3", name: "0520-G50Y" }, 
      { hex: "#f4feb5", name: "0520-G60Y" }, 
      { hex: "#fbffb8", name: "0520-G70Y" }, 
      { hex: "#fffcb8", name: "0520-G80Y" }, 
      { hex: "#fff7b6", name: "0520-G90Y" }, 
      { hex: "#ff959c", name: "0520-R" }, 
      { hex: "#ff98a5", name: "0520-R10B" }, 
      { hex: "#ff9cb0", name: "0520-R20B" }, 
      { hex: "#ffa2c0", name: "0520-R30B" }, 
      { hex: "#ffa9d4", name: "0520-R40B" }, 
      { hex: "#ffb4f0", name: "0520-R50B" }, 
      { hex: "#e5b0ff", name: "0520-R60B" }, 
      { hex: "#cbb0ff", name: "0520-R70B" }, 
      { hex: "#9caeff", name: "0520-R80B" }, 
      { hex: "#a3c1ff", name: "0520-R90B" }, 
      { hex: "#fff3b5", name: "0520-Y" }, 
      { hex: "#feedb2", name: "0520-Y10R" }, 
      { hex: "#ffe5b0", name: "0520-Y20R" }, 
      { hex: "#ffddad", name: "0520-Y30R" }, 
      { hex: "#ffd5aa", name: "0520-Y40R" }, 
      { hex: "#ffcca7", name: "0520-Y50R" }, 
      { hex: "#ffc2a3", name: "0520-Y60R" }, 
      { hex: "#ffb89f", name: "0520-Y70R" }, 
      { hex: "#ffac9b", name: "0520-Y80R" }, 
      { hex: "#ffa19b", name: "0520-Y90R" }, 
      { hex: "#e09ffe", name: "0525-R60B" }, 
      { hex: "#c1a0ff", name: "0525-R70B" }, 
      { hex: "#8ed4ff", name: "0530-B" }, 
      { hex: "#92e3ff", name: "0530-B10G" }, 
      { hex: "#98f5ff", name: "0530-B30G" }, 
      { hex: "#9afcff", name: "0530-B40G" }, 
      { hex: "#9afffb", name: "0530-B50G" }, 
      { hex: "#98fff5", name: "0530-B60G" }, 
      { hex: "#96ffef", name: "0530-B70G" }, 
      { hex: "#8bffcb", name: "0530-B90G" }, 
      { hex: "#84ffb4", name: "0530-G" }, 
      { hex: "#a3ffa7", name: "0530-G10Y" }, 
      { hex: "#baff9e", name: "0530-G20Y" }, 
      { hex: "#cbff96", name: "0530-G30Y" }, 
      { hex: "#dafe90", name: "0530-G40Y" }, 
      { hex: "#e6ff93", name: "0530-G50Y" }, 
      { hex: "#f0fe96", name: "0530-G60Y" }, 
      { hex: "#f9fe99", name: "0530-G70Y" }, 
      { hex: "#fefb9a", name: "0530-G80Y" }, 
      { hex: "#fef598", name: "0530-G90Y" }, 
      { hex: "#ff737c", name: "0530-R" }, 
      { hex: "#ff7687", name: "0530-R10B" }, 
      { hex: "#fe7b95", name: "0530-R20B" }, 
      { hex: "#ff81a9", name: "0530-R30B" }, 
      { hex: "#fe89c4", name: "0530-R40B" }, 
      { hex: "#ff95ea", name: "0530-R50B" }, 
      { hex: "#7a92ff", name: "0530-R80B" }, 
      { hex: "#81aaff", name: "0530-R90B" }, 
      { hex: "#ffef96", name: "0530-Y" }, 
      { hex: "#fee593", name: "0530-Y10R" }, 
      { hex: "#ffdb90", name: "0530-Y20R" }, 
      { hex: "#ffd08d", name: "0530-Y30R" }, 
      { hex: "#fec589", name: "0530-Y40R" }, 
      { hex: "#feb986", name: "0530-Y50R" }, 
      { hex: "#feac82", name: "0530-Y60R" }, 
      { hex: "#ff9f7e", name: "0530-Y70R" }, 
      { hex: "#ff9079", name: "0530-Y80R" }, 
      { hex: "#ff8279", name: "0530-Y90R" }, 
      { hex: "#72caff", name: "0540-B" }, 
      { hex: "#76dcff", name: "0540-B10G" }, 
      { hex: "#7cf2ff", name: "0540-B30G" }, 
      { hex: "#68ffa3", name: "0540-G" }, 
      { hex: "#8eff93", name: "0540-G10Y" }, 
      { hex: "#a9ff86", name: "0540-G20Y" }, 
      { hex: "#bfff7c", name: "0540-G30Y" }, 
      { hex: "#d0ff74", name: "0540-G40Y" }, 
      { hex: "#dfff77", name: "0540-G50Y" }, 
      { hex: "#ecff7a", name: "0540-G60Y" }, 
      { hex: "#f8fe7d", name: "0540-G70Y" }, 
      { hex: "#fffa7e", name: "0540-G80Y" }, 
      { hex: "#fff27c", name: "0540-G90Y" }, 
      { hex: "#ff5863", name: "0540-R" }, 
      { hex: "#ff5b6f", name: "0540-R10B" }, 
      { hex: "#ff5f7f", name: "0540-R20B" }, 
      { hex: "#ff6596", name: "0540-R30B" }, 
      { hex: "#6598ff", name: "0540-R90B" }, 
      { hex: "#ffeb7a", name: "0540-Y" }, 
      { hex: "#ffdf77", name: "0540-Y10R" }, 
      { hex: "#ffd274", name: "0540-Y20R" }, 
      { hex: "#ffc571", name: "0540-Y30R" }, 
      { hex: "#ffb76d", name: "0540-Y40R" }, 
      { hex: "#ffa96a", name: "0540-Y50R" }, 
      { hex: "#fe9a66", name: "0540-Y60R" }, 
      { hex: "#ff8a62", name: "0540-Y70R" }, 
      { hex: "#ff7a5e", name: "0540-Y80R" }, 
      { hex: "#ff695f", name: "0540-Y90R" }, 
      { hex: "#7bff81", name: "0550-G10Y" }, 
      { hex: "#9aff71", name: "0550-G20Y" }, 
      { hex: "#b3ff65", name: "0550-G30Y" }, 
      { hex: "#c8ff5b", name: "0550-G40Y" }, 
      { hex: "#daff5e", name: "0550-G50Y" }, 
      { hex: "#e8ff61", name: "0550-G60Y" }, 
      { hex: "#f7ff64", name: "0550-G70Y" }, 
      { hex: "#fffa65", name: "0550-G80Y" }, 
      { hex: "#ffef62", name: "0550-G90Y" }, 
      { hex: "#ff424e", name: "0550-R" }, 
      { hex: "#ff455b", name: "0550-R10B" }, 
      { hex: "#ffe761", name: "0550-Y" }, 
      { hex: "#ffd95e", name: "0550-Y10R" }, 
      { hex: "#ffca5b", name: "0550-Y20R" }, 
      { hex: "#ffbb58", name: "0550-Y30R" }, 
      { hex: "#ffab55", name: "0550-Y40R" }, 
      { hex: "#ff9b52", name: "0550-Y50R" }, 
      { hex: "#ff8a4e", name: "0550-Y60R" }, 
      { hex: "#fe794b", name: "0550-Y70R" }, 
      { hex: "#ff6747", name: "0550-Y80R" }, 
      { hex: "#ff5549", name: "0550-Y90R" }, 
      { hex: "#6bff71", name: "0560-G10Y" }, 
      { hex: "#8eff5f", name: "0560-G20Y" }, 
      { hex: "#a9ff51", name: "0560-G30Y" }, 
      { hex: "#c0ff45", name: "0560-G40Y" }, 
      { hex: "#d4ff47", name: "0560-G50Y" }, 
      { hex: "#e5ff4a", name: "0560-G60Y" }, 
      { hex: "#f6ff4d", name: "0560-G70Y" }, 
      { hex: "#fff94d", name: "0560-G80Y" }, 
      { hex: "#ffed4b", name: "0560-G90Y" }, 
      { hex: "#ff303e", name: "0560-R" }, 
      { hex: "#fee34a", name: "0560-Y" }, 
      { hex: "#ffd347", name: "0560-Y10R" }, 
      { hex: "#ffc345", name: "0560-Y20R" }, 
      { hex: "#ffb242", name: "0560-Y30R" }, 
      { hex: "#ffa140", name: "0560-Y40R" }, 
      { hex: "#fe8f3d", name: "0560-Y50R" }, 
      { hex: "#ff7d3a", name: "0560-Y60R" }, 
      { hex: "#ff6a37", name: "0560-Y70R" }, 
      { hex: "#ff5734", name: "0560-Y80R" }, 
      { hex: "#ff4437", name: "0560-Y90R" }, 
      { hex: "#63ff6a", name: "0565-G10Y" }, 
      { hex: "#d2ff3d", name: "0565-G50Y" }, 
      { hex: "#ff2836", name: "0565-R" }, 
      { hex: "#82ff4f", name: "0570-G20Y" }, 
      { hex: "#a1ff3f", name: "0570-G30Y" }, 
      { hex: "#baff31", name: "0570-G40Y" }, 
      { hex: "#e2ff35", name: "0570-G60Y" }, 
      { hex: "#f4ff37", name: "0570-G70Y" }, 
      { hex: "#fff837", name: "0570-G80Y" }, 
      { hex: "#ffeb36", name: "0570-G90Y" }, 
      { hex: "#ffe035", name: "0570-Y" }, 
      { hex: "#ffcf33", name: "0570-Y10R" }, 
      { hex: "#ffbd31", name: "0570-Y20R" }, 
      { hex: "#feaa2f", name: "0570-Y30R" }, 
      { hex: "#fe982d", name: "0570-Y40R" }, 
      { hex: "#ff852b", name: "0570-Y50R" }, 
      { hex: "#ff7128", name: "0570-Y60R" }, 
      { hex: "#ff5e26", name: "0570-Y70R" }, 
      { hex: "#fe4a24", name: "0570-Y80R" }, 
      { hex: "#fe3628", name: "0570-Y90R" }, 
      { hex: "#7dff48", name: "0575-G20Y" }, 
      { hex: "#b7ff28", name: "0575-G40Y" }, 
      { hex: "#e1ff2b", name: "0575-G60Y" }, 
      { hex: "#f4ff2d", name: "0575-G70Y" }, 
      { hex: "#ffea2c", name: "0575-G90Y" }, 
      { hex: "#99ff2e", name: "0580-G30Y" }, 
      { hex: "#ffdd22", name: "0580-Y" }, 
      { hex: "#ffca20", name: "0580-Y10R" }, 
      { hex: "#feb71f", name: "0580-Y20R" }, 
      { hex: "#ffa31d", name: "0580-Y30R" }, 
      { hex: "#ff901c", name: "0580-Y40R" }, 
      { hex: "#ff7b1b", name: "0580-Y50R" }, 
      { hex: "#ff6719", name: "0580-Y60R" }, 
      { hex: "#ff5318", name: "0580-Y70R" }, 
      { hex: "#ff3e16", name: "0580-Y80R" }, 
      { hex: "#ff2a1b", name: "0580-Y90R" }, 
      { hex: "#ffb416", name: "0585-Y20R" }, 
      { hex: "#ffa015", name: "0585-Y30R" }, 
      { hex: "#fe8c14", name: "0585-Y40R" }, 
      { hex: "#ff7713", name: "0585-Y50R" }, 
      { hex: "#ff6212", name: "0585-Y60R" }, 
      { hex: "#ff4e11", name: "0585-Y70R" }, 
      { hex: "#ff3910", name: "0585-Y80R" }, 
      { hex: "#f7fcef", name: "0603-G40Y" }, 
      { hex: "#fcfbf0", name: "0603-G80Y" }, 
      { hex: "#fceaed", name: "0603-R20B" }, 
      { hex: "#fcedf4", name: "0603-R40B" }, 
      { hex: "#f8effc", name: "0603-R60B" }, 
      { hex: "#e9edfc", name: "0603-R80B" }, 
      { hex: "#fcf8ef", name: "0603-Y20R" }, 
      { hex: "#fcf5ed", name: "0603-Y40R" }, 
      { hex: "#fcf1eb", name: "0603-Y60R" }, 
      { hex: "#fcede9", name: "0603-Y80R" }, 
      { hex: "#e8f6f6", name: "0804-B50G" }, 
      { hex: "#ecf6e7", name: "0804-G20Y" }, 
      { hex: "#f4f6e7", name: "0804-G60Y" }, 
      { hex: "#f6f5e7", name: "0804-G90Y" }, 
      { hex: "#f6dee1", name: "0804-R10B" }, 
      { hex: "#f6e1e8", name: "0804-R30B" }, 
      { hex: "#f6e7f3", name: "0804-R50B" }, 
      { hex: "#ebe5f6", name: "0804-R70B" }, 
      { hex: "#e1e8f6", name: "0804-R90B" }, 
      { hex: "#f6f3e6", name: "0804-Y10R" }, 
      { hex: "#f6efe5", name: "0804-Y30R" }, 
      { hex: "#f6ebe3", name: "0804-Y50R" }, 
      { hex: "#f6e6e0", name: "0804-Y70R" }, 
      { hex: "#f6e0de", name: "0804-Y90R" }, 
      { hex: "#d9eff4", name: "0907-B20G" }, 
      { hex: "#d8f4ee", name: "0907-B80G" }, 
      { hex: "#e1f4da", name: "0907-G20Y" }, 
      { hex: "#f0f4d9", name: "0907-G60Y" }, 
      { hex: "#f4f1da", name: "0907-G90Y" }, 
      { hex: "#f4cbd0", name: "0907-R10B" }, 
      { hex: "#f4d0db", name: "0907-R30B" }, 
      { hex: "#f4d9ef", name: "0907-R50B" }, 
      { hex: "#e0d6f4", name: "0907-R70B" }, 
      { hex: "#d0dcf4", name: "0907-R90B" }, 
      { hex: "#f4edd8", name: "0907-Y10R" }, 
      { hex: "#f4e8d5", name: "0907-Y30R" }, 
      { hex: "#f4e1d2", name: "0907-Y50R" }, 
      { hex: "#f4d8cf", name: "0907-Y70R" }, 
      { hex: "#f4cecc", name: "0907-Y90R" }, 
      { hex: "#e5e5e5", name: "1000-N" }, 
      { hex: "#e8eef1", name: "1002-B" }, 
      { hex: "#eaf1f1", name: "1002-B50G" }, 
      { hex: "#e7f1eb", name: "1002-G" }, 
      { hex: "#eff1e9", name: "1002-G50Y" }, 
      { hex: "#f1e4e5", name: "1002-R" }, 
      { hex: "#f1e9f0", name: "1002-R50B" }, 
      { hex: "#f1f0e9", name: "1002-Y" }, 
      { hex: "#f1ebe7", name: "1002-Y50R" }, 
      { hex: "#dce9f1", name: "1005-B" }, 
      { hex: "#deeef1", name: "1005-B20G" }, 
      { hex: "#dff1f1", name: "1005-B50G" }, 
      { hex: "#ddf1ed", name: "1005-B80G" }, 
      { hex: "#d8f1e2", name: "1005-G" }, 
      { hex: "#dff1e0", name: "1005-G10Y" }, 
      { hex: "#e4f1de", name: "1005-G20Y" }, 
      { hex: "#e7f1dd", name: "1005-G30Y" }, 
      { hex: "#eaf1dc", name: "1005-G40Y" }, 
      { hex: "#edf1dd", name: "1005-G50Y" }, 
      { hex: "#eef1de", name: "1005-G60Y" }, 
      { hex: "#f0f1df", name: "1005-G70Y" }, 
      { hex: "#f1f1df", name: "1005-G80Y" }, 
      { hex: "#f1efdf", name: "1005-G90Y" }, 
      { hex: "#f1d2d4", name: "1005-R" }, 
      { hex: "#f1d3d7", name: "1005-R10B" }, 
      { hex: "#f1d5db", name: "1005-R20B" }, 
      { hex: "#f1d7e0", name: "1005-R30B" }, 
      { hex: "#f1dae6", name: "1005-R40B" }, 
      { hex: "#f1deed", name: "1005-R50B" }, 
      { hex: "#eadcf1", name: "1005-R60B" }, 
      { hex: "#e3dcf1", name: "1005-R70B" }, 
      { hex: "#d5daf1", name: "1005-R80B" }, 
      { hex: "#d7e0f1", name: "1005-R90B" }, 
      { hex: "#f1eede", name: "1005-Y" }, 
      { hex: "#f1ecdd", name: "1005-Y10R" }, 
      { hex: "#f1eadc", name: "1005-Y20R" }, 
      { hex: "#f1e8db", name: "1005-Y30R" }, 
      { hex: "#f1e6da", name: "1005-Y40R" }, 
      { hex: "#f1e3d9", name: "1005-Y50R" }, 
      { hex: "#f1e0d8", name: "1005-Y60R" }, 
      { hex: "#f1ddd6", name: "1005-Y70R" }, 
      { hex: "#f1d9d4", name: "1005-Y80R" }, 
      { hex: "#f1d6d4", name: "1005-Y90R" }, 
      { hex: "#c8e2f1", name: "1010-B" }, 
      { hex: "#cae7f1", name: "1010-B10G" }, 
      { hex: "#cdeef1", name: "1010-B30G" }, 
      { hex: "#cef1f0", name: "1010-B50G" }, 
      { hex: "#ccf1ec", name: "1010-B70G" }, 
      { hex: "#c6f1de", name: "1010-B90G" }, 
      { hex: "#c2f1d5", name: "1010-G" }, 
      { hex: "#cff1d1", name: "1010-G10Y" }, 
      { hex: "#d8f1cd", name: "1010-G20Y" }, 
      { hex: "#def1cb", name: "1010-G30Y" }, 
      { hex: "#e4f1c9", name: "1010-G40Y" }, 
      { hex: "#e8f1cb", name: "1010-G50Y" }, 
      { hex: "#ecf1cc", name: "1010-G60Y" }, 
      { hex: "#eff1ce", name: "1010-G70Y" }, 
      { hex: "#f1f0ce", name: "1010-G80Y" }, 
      { hex: "#f1eecd", name: "1010-G90Y" }, 
      { hex: "#f1b8bb", name: "1010-R" }, 
      { hex: "#f1bac0", name: "1010-R10B" }, 
      { hex: "#f1bdc7", name: "1010-R20B" }, 
      { hex: "#f1c0d0", name: "1010-R30B" }, 
      { hex: "#f1c5db", name: "1010-R40B" }, 
      { hex: "#f1ccea", name: "1010-R50B" }, 
      { hex: "#e4c9f1", name: "1010-R60B" }, 
      { hex: "#d7c8f1", name: "1010-R70B" }, 
      { hex: "#bcc6f1", name: "1010-R80B" }, 
      { hex: "#c1d1f1", name: "1010-R90B" }, 
      { hex: "#f1eccc", name: "1010-Y" }, 
      { hex: "#f1e8cb", name: "1010-Y10R" }, 
      { hex: "#f1e4c9", name: "1010-Y20R" }, 
      { hex: "#f1e0c7", name: "1010-Y30R" }, 
      { hex: "#f1dcc5", name: "1010-Y40R" }, 
      { hex: "#f1d7c3", name: "1010-Y50R" }, 
      { hex: "#f1d1c1", name: "1010-Y60R" }, 
      { hex: "#f1cbbe", name: "1010-Y70R" }, 
      { hex: "#f1c5bc", name: "1010-Y80R" }, 
      { hex: "#f1bebb", name: "1010-Y90R" }, 
      { hex: "#b6dbf1", name: "1015-B" }, 
      { hex: "#bbe8f1", name: "1015-B20G" }, 
      { hex: "#bef1ef", name: "1015-B50G" }, 
      { hex: "#baf1e5", name: "1015-B80G" }, 
      { hex: "#aef1c8", name: "1015-G" }, 
      { hex: "#cdf1be", name: "1015-G20Y" }, 
      { hex: "#def1b7", name: "1015-G40Y" }, 
      { hex: "#eaf1bc", name: "1015-G60Y" }, 
      { hex: "#f1f0be", name: "1015-G80Y" }, 
      { hex: "#f1ecbd", name: "1015-G90Y" }, 
      { hex: "#f1a1a6", name: "1015-R" }, 
      { hex: "#f1a4ad", name: "1015-R10B" }, 
      { hex: "#f1a7b6", name: "1015-R20B" }, 
      { hex: "#f1b2d2", name: "1015-R40B" }, 
      { hex: "#dfb7f1", name: "1015-R60B" }, 
      { hex: "#a6b4f1", name: "1015-R80B" }, 
      { hex: "#acc3f1", name: "1015-R90B" }, 
      { hex: "#f1e9bb", name: "1015-Y" }, 
      { hex: "#f1e4b9", name: "1015-Y10R" }, 
      { hex: "#f1dfb7", name: "1015-Y20R" }, 
      { hex: "#f1d9b5", name: "1015-Y30R" }, 
      { hex: "#f1d2b2", name: "1015-Y40R" }, 
      { hex: "#f1cbb0", name: "1015-Y50R" }, 
      { hex: "#f1c4ad", name: "1015-Y60R" }, 
      { hex: "#f1bca9", name: "1015-Y70R" }, 
      { hex: "#f1b3a6", name: "1015-Y80R" }, 
      { hex: "#f1aaa5", name: "1015-Y90R" }, 
      { hex: "#a5d5f1", name: "1020-B" }, 
      { hex: "#a8dff1", name: "1020-B10G" }, 
      { hex: "#adebf1", name: "1020-B30G" }, 
      { hex: "#afeff1", name: "1020-B40G" }, 
      { hex: "#aef1ef", name: "1020-B50G" }, 
      { hex: "#adf1eb", name: "1020-B60G" }, 
      { hex: "#abf1e7", name: "1020-B70G" }, 
      { hex: "#a2f1ce", name: "1020-B90G" }, 
      { hex: "#9cf1bd", name: "1020-G" }, 
      { hex: "#b3f1b5", name: "1020-G10Y" }, 
      { hex: "#c2f1af", name: "1020-G20Y" }, 
      { hex: "#cef1aa", name: "1020-G30Y" }, 
      { hex: "#d8f1a6", name: "1020-G40Y" }, 
      { hex: "#e1f1a9", name: "1020-G50Y" }, 
      { hex: "#e7f1ac", name: "1020-G60Y" }, 
      { hex: "#eef1ae", name: "1020-G70Y" }, 
      { hex: "#f1efae", name: "1020-G80Y" }, 
      { hex: "#f1eaad", name: "1020-G90Y" }, 
      { hex: "#f18d94", name: "1020-R" }, 
      { hex: "#f1909c", name: "1020-R10B" }, 
      { hex: "#f194a7", name: "1020-R20B" }, 
      { hex: "#f19ab5", name: "1020-R30B" }, 
      { hex: "#f1a1c9", name: "1020-R40B" }, 
      { hex: "#f1aae4", name: "1020-R50B" }, 
      { hex: "#d9a7f1", name: "1020-R60B" }, 
      { hex: "#c1a7f1", name: "1020-R70B" }, 
      { hex: "#93a5f1", name: "1020-R80B" }, 
      { hex: "#9ab7f1", name: "1020-R90B" }, 
      { hex: "#f1e7ab", name: "1020-Y" }, 
      { hex: "#f1e0a9", name: "1020-Y10R" }, 
      { hex: "#f1d9a7", name: "1020-Y20R" }, 
      { hex: "#f1d2a4", name: "1020-Y30R" }, 
      { hex: "#f1caa1", name: "1020-Y40R" }, 
      { hex: "#f1c19e", name: "1020-Y50R" }, 
      { hex: "#f1b89a", name: "1020-Y60R" }, 
      { hex: "#f1ae97", name: "1020-Y70R" }, 
      { hex: "#f1a393", name: "1020-Y80R" }, 
      { hex: "#f19892", name: "1020-Y90R" }, 
      { hex: "#86c9f1", name: "1030-B" }, 
      { hex: "#8bd7f1", name: "1030-B10G" }, 
      { hex: "#90e8f1", name: "1030-B30G" }, 
      { hex: "#92eef1", name: "1030-B40G" }, 
      { hex: "#92f1ee", name: "1030-B50G" }, 
      { hex: "#90f1e8", name: "1030-B60G" }, 
      { hex: "#8ef1e2", name: "1030-B70G" }, 
      { hex: "#84f1c0", name: "1030-B90G" }, 
      { hex: "#7df1aa", name: "1030-G" }, 
      { hex: "#9bf19f", name: "1030-G10Y" }, 
      { hex: "#b0f195", name: "1030-G20Y" }, 
      { hex: "#c1f18e", name: "1030-G30Y" }, 
      { hex: "#cef188", name: "1030-G40Y" }, 
      { hex: "#daf18b", name: "1030-G50Y" }, 
      { hex: "#e3f18e", name: "1030-G60Y" }, 
      { hex: "#ecf191", name: "1030-G70Y" }, 
      { hex: "#f1ee92", name: "1030-G80Y" }, 
      { hex: "#f1e890", name: "1030-G90Y" }, 
      { hex: "#f16d76", name: "1030-R" }, 
      { hex: "#f17080", name: "1030-R10B" }, 
      { hex: "#f1748d", name: "1030-R20B" }, 
      { hex: "#f17aa0", name: "1030-R30B" }, 
      { hex: "#f182b9", name: "1030-R40B" }, 
      { hex: "#f18dde", name: "1030-R50B" }, 
      { hex: "#d088f1", name: "1030-R60B" }, 
      { hex: "#ae8af1", name: "1030-R70B" }, 
      { hex: "#738bf1", name: "1030-R80B" }, 
      { hex: "#7aa1f1", name: "1030-R90B" }, 
      { hex: "#f1e28e", name: "1030-Y" }, 
      { hex: "#f1d98b", name: "1030-Y10R" }, 
      { hex: "#f1d088", name: "1030-Y20R" }, 
      { hex: "#f1c585", name: "1030-Y30R" }, 
      { hex: "#f1bb82", name: "1030-Y40R" }, 
      { hex: "#f1af7f", name: "1030-Y50R" }, 
      { hex: "#f1a37b", name: "1030-Y60R" }, 
      { hex: "#f19677", name: "1030-Y70R" }, 
      { hex: "#f18973", name: "1030-Y80R" }, 
      { hex: "#f17b73", name: "1030-Y90R" }, 
      { hex: "#6cbff1", name: "1040-B" }, 
      { hex: "#70d0f1", name: "1040-B10G" }, 
      { hex: "#73dcf1", name: "1040-B20G" }, 
      { hex: "#75e5f1", name: "1040-B30G" }, 
      { hex: "#77eef1", name: "1040-B40G" }, 
      { hex: "#77f1ed", name: "1040-B50G" }, 
      { hex: "#75f1e6", name: "1040-B60G" }, 
      { hex: "#74f1de", name: "1040-B70G" }, 
      { hex: "#71f1d5", name: "1040-B80G" }, 
      { hex: "#69f1b4", name: "1040-B90G" }, 
      { hex: "#63f19a", name: "1040-G" }, 
      { hex: "#86f18b", name: "1040-G10Y" }, 
      { hex: "#a0f17f", name: "1040-G20Y" }, 
      { hex: "#b5f175", name: "1040-G30Y" }, 
      { hex: "#c5f16e", name: "1040-G40Y" }, 
      { hex: "#d4f171", name: "1040-G50Y" }, 
      { hex: "#dff174", name: "1040-G60Y" }, 
      { hex: "#ebf177", name: "1040-G70Y" }, 
      { hex: "#f1ed77", name: "1040-G80Y" }, 
      { hex: "#f1e575", name: "1040-G90Y" }, 
      { hex: "#f1535e", name: "1040-R" }, 
      { hex: "#f15669", name: "1040-R10B" }, 
      { hex: "#f15a79", name: "1040-R20B" }, 
      { hex: "#f1608e", name: "1040-R30B" }, 
      { hex: "#f167ac", name: "1040-R40B" }, 
      { hex: "#f172d9", name: "1040-R50B" }, 
      { hex: "#c76ef1", name: "1040-R60B" }, 
      { hex: "#9e72f1", name: "1040-R70B" }, 
      { hex: "#5975f1", name: "1040-R80B" }, 
      { hex: "#6090f1", name: "1040-R90B" }, 
      { hex: "#f1de74", name: "1040-Y" }, 
      { hex: "#f1d371", name: "1040-Y10R" }, 
      { hex: "#f1c76e", name: "1040-Y20R" }, 
      { hex: "#f1bb6b", name: "1040-Y30R" }, 
      { hex: "#f1ae67", name: "1040-Y40R" }, 
      { hex: "#f1a064", name: "1040-Y50R" }, 
      { hex: "#f19260", name: "1040-Y60R" }, 
      { hex: "#f1835d", name: "1040-Y70R" }, 
      { hex: "#f17359", name: "1040-Y80R" }, 
      { hex: "#f1645a", name: "1040-Y90R" }, 
      { hex: "#54b6f1", name: "1050-B" }, 
      { hex: "#58caf1", name: "1050-B10G" }, 
      { hex: "#5bd8f1", name: "1050-B20G" }, 
      { hex: "#5de3f1", name: "1050-B30G" }, 
      { hex: "#5fedf1", name: "1050-B40G" }, 
      { hex: "#5ff1ec", name: "1050-B50G" }, 
      { hex: "#5df1e3", name: "1050-B60G" }, 
      { hex: "#5cf1db", name: "1050-B70G" }, 
      { hex: "#59f1cf", name: "1050-B80G" }, 
      { hex: "#52f1aa", name: "1050-B90G" }, 
      { hex: "#4cf18c", name: "1050-G" }, 
      { hex: "#75f17a", name: "1050-G10Y" }, 
      { hex: "#92f16b", name: "1050-G20Y" }, 
      { hex: "#aaf160", name: "1050-G30Y" }, 
      { hex: "#bdf156", name: "1050-G40Y" }, 
      { hex: "#cef159", name: "1050-G50Y" }, 
      { hex: "#dcf15c", name: "1050-G60Y" }, 
      { hex: "#eaf15f", name: "1050-G70Y" }, 
      { hex: "#f1ed5f", name: "1050-G80Y" }, 
      { hex: "#f1e35d", name: "1050-G90Y" }, 
      { hex: "#f13f4a", name: "1050-R" }, 
      { hex: "#f14157", name: "1050-R10B" }, 
      { hex: "#f14567", name: "1050-R20B" }, 
      { hex: "#f1497f", name: "1050-R30B" }, 
      { hex: "#f150a1", name: "1050-R40B" }, 
      { hex: "#4a81f1", name: "1050-R90B" }, 
      { hex: "#f1db5c", name: "1050-Y" }, 
      { hex: "#f1cd59", name: "1050-Y10R" }, 
      { hex: "#f1c056", name: "1050-Y20R" }, 
      { hex: "#f1b153", name: "1050-Y30R" }, 
      { hex: "#f1a250", name: "1050-Y40R" }, 
      { hex: "#f1934d", name: "1050-Y50R" }, 
      { hex: "#f1834a", name: "1050-Y60R" }, 
      { hex: "#f17247", name: "1050-Y70R" }, 
      { hex: "#f16143", name: "1050-Y80R" }, 
      { hex: "#f15045", name: "1050-Y90R" }, 
      { hex: "#47f1a5", name: "1055-B90G" }, 
      { hex: "#40aff1", name: "1060-B" }, 
      { hex: "#39f180", name: "1060-G" }, 
      { hex: "#65f16b", name: "1060-G10Y" }, 
      { hex: "#86f15a", name: "1060-G20Y" }, 
      { hex: "#a0f14c", name: "1060-G30Y" }, 
      { hex: "#b6f141", name: "1060-G40Y" }, 
      { hex: "#c9f144", name: "1060-G50Y" }, 
      { hex: "#d9f146", name: "1060-G60Y" }, 
      { hex: "#e9f149", name: "1060-G70Y" }, 
      { hex: "#f1ec49", name: "1060-G80Y" }, 
      { hex: "#f1e147", name: "1060-G90Y" }, 
      { hex: "#f12e3a", name: "1060-R" }, 
      { hex: "#f13047", name: "1060-R10B" }, 
      { hex: "#f13259", name: "1060-R20B" }, 
      { hex: "#f13672", name: "1060-R30B" }, 
      { hex: "#f1d746", name: "1060-Y" }, 
      { hex: "#f1c844", name: "1060-Y10R" }, 
      { hex: "#f1b941", name: "1060-Y20R" }, 
      { hex: "#f1a93f", name: "1060-Y30R" }, 
      { hex: "#f1983c", name: "1060-Y40R" }, 
      { hex: "#f1883a", name: "1060-Y50R" }, 
      { hex: "#f17637", name: "1060-Y60R" }, 
      { hex: "#f16534", name: "1060-Y70R" }, 
      { hex: "#f15331", name: "1060-Y80R" }, 
      { hex: "#f14134", name: "1060-Y90R" }, 
      { hex: "#57f15e", name: "1070-G10Y" }, 
      { hex: "#7bf14b", name: "1070-G20Y" }, 
      { hex: "#98f13b", name: "1070-G30Y" }, 
      { hex: "#b0f12e", name: "1070-G40Y" }, 
      { hex: "#c5f130", name: "1070-G50Y" }, 
      { hex: "#d6f132", name: "1070-G60Y" }, 
      { hex: "#e8f134", name: "1070-G70Y" }, 
      { hex: "#f1eb35", name: "1070-G80Y" }, 
      { hex: "#f1df33", name: "1070-G90Y" }, 
      { hex: "#f11f2d", name: "1070-R" }, 
      { hex: "#f1213a", name: "1070-R10B" }, 
      { hex: "#f1234c", name: "1070-R20B" }, 
      { hex: "#f1d432", name: "1070-Y" }, 
      { hex: "#f1c430", name: "1070-Y10R" }, 
      { hex: "#f1b32e", name: "1070-Y20R" }, 
      { hex: "#f1a12c", name: "1070-Y30R" }, 
      { hex: "#f1902a", name: "1070-Y40R" }, 
      { hex: "#f17e28", name: "1070-Y50R" }, 
      { hex: "#f16b26", name: "1070-Y60R" }, 
      { hex: "#f15924", name: "1070-Y70R" }, 
      { hex: "#f14622", name: "1070-Y80R" }, 
      { hex: "#f13326", name: "1070-Y90R" }, 
      { hex: "#76f144", name: "1075-G20Y" }, 
      { hex: "#adf126", name: "1075-G40Y" }, 
      { hex: "#c3f127", name: "1075-G50Y" }, 
      { hex: "#d5f129", name: "1075-G60Y" }, 
      { hex: "#e7f12b", name: "1075-G70Y" }, 
      { hex: "#f1eb2b", name: "1075-G80Y" }, 
      { hex: "#f1de2a", name: "1075-G90Y" }, 
      { hex: "#91f12c", name: "1080-G30Y" }, 
      { hex: "#f11322", name: "1080-R" }, 
      { hex: "#f1d220", name: "1080-Y" }, 
      { hex: "#f1c01e", name: "1080-Y10R" }, 
      { hex: "#f1ad1d", name: "1080-Y20R" }, 
      { hex: "#f19b1c", name: "1080-Y30R" }, 
      { hex: "#f1881b", name: "1080-Y40R" }, 
      { hex: "#f17519", name: "1080-Y50R" }, 
      { hex: "#f16218", name: "1080-Y60R" }, 
      { hex: "#f14e16", name: "1080-Y70R" }, 
      { hex: "#f13b15", name: "1080-Y80R" }, 
      { hex: "#f1281a", name: "1080-Y90R" }, 
      { hex: "#f1360f", name: "1085-Y80R" }, 
      { hex: "#f12214", name: "1085-Y90R" }, 
      { hex: "#d8d8d8", name: "1500-N" }, 
      { hex: "#dbe1e4", name: "1502-B" }, 
      { hex: "#dde4e3", name: "1502-B50G" }, 
      { hex: "#dae4de", name: "1502-G" }, 
      { hex: "#e2e4dc", name: "1502-G50Y" }, 
      { hex: "#e4d7d8", name: "1502-R" }, 
      { hex: "#e4dce2", name: "1502-R50B" }, 
      { hex: "#e4e3dc", name: "1502-Y" }, 
      { hex: "#e4deda", name: "1502-Y50R" }, 
      { hex: "#e4e3d3", name: "1505-G80Y" }, 
      { hex: "#e4e2d2", name: "1505-G90Y" }, 
      { hex: "#e4e1d2", name: "1505-Y" }, 
      { hex: "#e4dfd1", name: "1505-Y10R" }, 
      { hex: "#e4ddd0", name: "1505-Y20R" }, 
      { hex: "#e4dbcf", name: "1505-Y30R" }, 
      { hex: "#e4d9ce", name: "1505-Y40R" }, 
      { hex: "#e4d7cd", name: "1505-Y50R" }, 
      { hex: "#e4d4cc", name: "1505-Y60R" }, 
      { hex: "#e4d1ca", name: "1505-Y70R" }, 
      { hex: "#e4cdc9", name: "1505-Y80R" }, 
      { hex: "#e4cac8", name: "1505-Y90R" }, 
      { hex: "#bdd5e4", name: "1510-B" }, 
      { hex: "#c1dee4", name: "1510-B20G" }, 
      { hex: "#c3e4e3", name: "1510-B50G" }, 
      { hex: "#c0e4dc", name: "1510-B80G" }, 
      { hex: "#b8e4c9", name: "1510-G" }, 
      { hex: "#cce4c2", name: "1510-G20Y" }, 
      { hex: "#d7e4be", name: "1510-G40Y" }, 
      { hex: "#dfe4c1", name: "1510-G60Y" }, 
      { hex: "#e4e3c3", name: "1510-G80Y" }, 
      { hex: "#e4e0c2", name: "1510-G90Y" }, 
      { hex: "#e4adb1", name: "1510-R" }, 
      { hex: "#e4afb6", name: "1510-R10B" }, 
      { hex: "#e4b2bc", name: "1510-R20B" }, 
      { hex: "#e4bacf", name: "1510-R40B" }, 
      { hex: "#d8bee4", name: "1510-R60B" }, 
      { hex: "#b2bbe4", name: "1510-R80B" }, 
      { hex: "#b6c5e4", name: "1510-R90B" }, 
      { hex: "#e4dec1", name: "1510-Y" }, 
      { hex: "#e4dbbf", name: "1510-Y10R" }, 
      { hex: "#e4d8be", name: "1510-Y20R" }, 
      { hex: "#e4d4bc", name: "1510-Y30R" }, 
      { hex: "#e4d0ba", name: "1510-Y40R" }, 
      { hex: "#e4cbb8", name: "1510-Y50R" }, 
      { hex: "#e4c6b6", name: "1510-Y60R" }, 
      { hex: "#e4c0b4", name: "1510-Y70R" }, 
      { hex: "#e4bab1", name: "1510-Y80R" }, 
      { hex: "#e4b4b1", name: "1510-Y90R" }, 
      { hex: "#accfe4", name: "1515-B" }, 
      { hex: "#b1dbe4", name: "1515-B20G" }, 
      { hex: "#b3e4e2", name: "1515-B50G" }, 
      { hex: "#afe4d8", name: "1515-B80G" }, 
      { hex: "#a5e4bd", name: "1515-G" }, 
      { hex: "#c1e4b3", name: "1515-G20Y" }, 
      { hex: "#d1e4ad", name: "1515-G40Y" }, 
      { hex: "#dde4b1", name: "1515-G60Y" }, 
      { hex: "#e4e2b3", name: "1515-G80Y" }, 
      { hex: "#e4dfb2", name: "1515-G90Y" }, 
      { hex: "#e4989d", name: "1515-R" }, 
      { hex: "#e49ba3", name: "1515-R10B" }, 
      { hex: "#e49eac", name: "1515-R20B" }, 
      { hex: "#e4a8c6", name: "1515-R40B" }, 
      { hex: "#d2ade4", name: "1515-R60B" }, 
      { hex: "#9daae4", name: "1515-R80B" }, 
      { hex: "#a3b8e4", name: "1515-R90B" }, 
      { hex: "#e4dcb1", name: "1515-Y" }, 
      { hex: "#e4d7af", name: "1515-Y10R" }, 
      { hex: "#e4d2ad", name: "1515-Y20R" }, 
      { hex: "#e4cdab", name: "1515-Y30R" }, 
      { hex: "#e4c7a8", name: "1515-Y40R" }, 
      { hex: "#e4c0a6", name: "1515-Y50R" }, 
      { hex: "#e4b9a3", name: "1515-Y60R" }, 
      { hex: "#e4b1a0", name: "1515-Y70R" }, 
      { hex: "#e4a99d", name: "1515-Y80R" }, 
      { hex: "#e4a19c", name: "1515-Y90R" }, 
      { hex: "#8857e4", name: "1550-R70B" }, 
      { hex: "#405ee4", name: "1550-R80B" }, 
      { hex: "#49bce4", name: "1555-B10G" }, 
      { hex: "#824ee4", name: "1555-R70B" }, 
      { hex: "#3757e4", name: "1555-R80B" }, 
      { hex: "#346ee4", name: "1560-R90B" }, 
      { hex: "#33a1e4", name: "1565-B" }, 
      { hex: "#2de474", name: "1565-G" }, 
      { hex: "#e41931", name: "1575-R10B" }, 
      { hex: "#e41220", name: "1580-R" }, 
      { hex: "#e43814", name: "1580-Y80R" }, 
      { hex: "#e42518", name: "1580-Y90R" }, 
      { hex: "#cccccc", name: "2000-N" }, 
      { hex: "#cfd3d6", name: "2002-B" }, 
      { hex: "#d0d6d6", name: "2002-B50G" }, 
      { hex: "#cdd6d1", name: "2002-G" }, 
      { hex: "#d5d6cf", name: "2002-G50Y" }, 
      { hex: "#d6cbcb", name: "2002-R" }, 
      { hex: "#d6cfd5", name: "2002-R50B" }, 
      { hex: "#d6d5cf", name: "2002-Y" }, 
      { hex: "#d6d1cd", name: "2002-Y50R" }, 
      { hex: "#c3cfd6", name: "2005-B" }, 
      { hex: "#c5d3d6", name: "2005-B20G" }, 
      { hex: "#c6d6d6", name: "2005-B50G" }, 
      { hex: "#c5d6d2", name: "2005-B80G" }, 
      { hex: "#c0d6c9", name: "2005-G" }, 
      { hex: "#c6d6c7", name: "2005-G10Y" }, 
      { hex: "#cbd6c6", name: "2005-G20Y" }, 
      { hex: "#ced6c5", name: "2005-G30Y" }, 
      { hex: "#d0d6c4", name: "2005-G40Y" }, 
      { hex: "#d2d6c5", name: "2005-G50Y" }, 
      { hex: "#d4d6c6", name: "2005-G60Y" }, 
      { hex: "#d6d6c6", name: "2005-G70Y" }, 
      { hex: "#d6d6c6", name: "2005-G80Y" }, 
      { hex: "#d6d5c6", name: "2005-G90Y" }, 
      { hex: "#d6bbbc", name: "2005-R" }, 
      { hex: "#d6bcbf", name: "2005-R10B" }, 
      { hex: "#d6bdc2", name: "2005-R20B" }, 
      { hex: "#d6bfc7", name: "2005-R30B" }, 
      { hex: "#d6c2cc", name: "2005-R40B" }, 
      { hex: "#d6c5d3", name: "2005-R50B" }, 
      { hex: "#d0c4d6", name: "2005-R60B" }, 
      { hex: "#cac3d6", name: "2005-R70B" }, 
      { hex: "#bdc2d6", name: "2005-R80B" }, 
      { hex: "#c0c7d6", name: "2005-R90B" }, 
      { hex: "#d6d4c5", name: "2005-Y" }, 
      { hex: "#d6d2c5", name: "2005-Y10R" }, 
      { hex: "#d6d0c4", name: "2005-Y20R" }, 
      { hex: "#d6cfc3", name: "2005-Y30R" }, 
      { hex: "#d6ccc2", name: "2005-Y40R" }, 
      { hex: "#d6cac1", name: "2005-Y50R" }, 
      { hex: "#d6c7c0", name: "2005-Y60R" }, 
      { hex: "#d6c4be", name: "2005-Y70R" }, 
      { hex: "#d6c1bd", name: "2005-Y80R" }, 
      { hex: "#d6bebc", name: "2005-Y90R" }, 
      { hex: "#b2c9d6", name: "2010-B" }, 
      { hex: "#b4ced6", name: "2010-B10G" }, 
      { hex: "#b6d3d6", name: "2010-B30G" }, 
      { hex: "#b7d6d5", name: "2010-B50G" }, 
      { hex: "#b6d6d1", name: "2010-B70G" }, 
      { hex: "#b0d6c5", name: "2010-B90G" }, 
      { hex: "#add6bd", name: "2010-G" }, 
      { hex: "#b8d6b9", name: "2010-G10Y" }, 
      { hex: "#c0d6b7", name: "2010-G20Y" }, 
      { hex: "#c6d6b4", name: "2010-G30Y" }, 
      { hex: "#cad6b3", name: "2010-G40Y" }, 
      { hex: "#ced6b4", name: "2010-G50Y" }, 
      { hex: "#d2d6b6", name: "2010-G60Y" }, 
      { hex: "#d5d6b7", name: "2010-G70Y" }, 
      { hex: "#d6d5b7", name: "2010-G80Y" }, 
      { hex: "#d6d3b6", name: "2010-G90Y" }, 
      { hex: "#d6a3a6", name: "2010-R" }, 
      { hex: "#d6a5ab", name: "2010-R10B" }, 
      { hex: "#d6a8b1", name: "2010-R20B" }, 
      { hex: "#d6abb9", name: "2010-R30B" }, 
      { hex: "#d6afc3", name: "2010-R40B" }, 
      { hex: "#d6b5d0", name: "2010-R50B" }, 
      { hex: "#cbb3d6", name: "2010-R60B" }, 
      { hex: "#bfb2d6", name: "2010-R70B" }, 
      { hex: "#a7b0d6", name: "2010-R80B" }, 
      { hex: "#abb9d6", name: "2010-R90B" }, 
      { hex: "#d6d1b6", name: "2010-Y" }, 
      { hex: "#d6ceb4", name: "2010-Y10R" }, 
      { hex: "#d6cbb3", name: "2010-Y20R" }, 
      { hex: "#d6c7b1", name: "2010-Y30R" }, 
      { hex: "#d6c3af", name: "2010-Y40R" }, 
      { hex: "#d6bfae", name: "2010-Y50R" }, 
      { hex: "#d6baac", name: "2010-Y60R" }, 
      { hex: "#d6b5a9", name: "2010-Y70R" }, 
      { hex: "#d6afa7", name: "2010-Y80R" }, 
      { hex: "#d6a9a6", name: "2010-Y90R" }, 
      { hex: "#92bdd6", name: "2020-B" }, 
      { hex: "#96c6d6", name: "2020-B10G" }, 
      { hex: "#9ad1d6", name: "2020-B30G" }, 
      { hex: "#9bd5d6", name: "2020-B40G" }, 
      { hex: "#9bd6d4", name: "2020-B50G" }, 
      { hex: "#9ad6d1", name: "2020-B60G" }, 
      { hex: "#98d6cd", name: "2020-B70G" }, 
      { hex: "#90d6b7", name: "2020-B90G" }, 
      { hex: "#8bd6a8", name: "2020-G" }, 
      { hex: "#9fd6a1", name: "2020-G10Y" }, 
      { hex: "#add69c", name: "2020-G20Y" }, 
      { hex: "#b7d697", name: "2020-G30Y" }, 
      { hex: "#c0d694", name: "2020-G40Y" }, 
      { hex: "#c8d696", name: "2020-G50Y" }, 
      { hex: "#ced699", name: "2020-G60Y" }, 
      { hex: "#d3d69b", name: "2020-G70Y" }, 
      { hex: "#d6d49b", name: "2020-G80Y" }, 
      { hex: "#d6d09a", name: "2020-G90Y" }, 
      { hex: "#d67e83", name: "2020-R" }, 
      { hex: "#d6808b", name: "2020-R10B" }, 
      { hex: "#d68494", name: "2020-R20B" }, 
      { hex: "#d688a1", name: "2020-R30B" }, 
      { hex: "#d68fb3", name: "2020-R40B" }, 
      { hex: "#d697ca", name: "2020-R50B" }, 
      { hex: "#c194d6", name: "2020-R60B" }, 
      { hex: "#ab94d6", name: "2020-R70B" }, 
      { hex: "#8392d6", name: "2020-R80B" }, 
      { hex: "#89a2d6", name: "2020-R90B" }, 
      { hex: "#d6cd98", name: "2020-Y" }, 
      { hex: "#d6c796", name: "2020-Y10R" }, 
      { hex: "#d6c194", name: "2020-Y20R" }, 
      { hex: "#d6bb92", name: "2020-Y30R" }, 
      { hex: "#d6b38f", name: "2020-Y40R" }, 
      { hex: "#d6ac8c", name: "2020-Y50R" }, 
      { hex: "#d6a389", name: "2020-Y60R" }, 
      { hex: "#d69b86", name: "2020-Y70R" }, 
      { hex: "#d69183", name: "2020-Y80R" }, 
      { hex: "#d68882", name: "2020-Y90R" }, 
      { hex: "#77b3d6", name: "2030-B" }, 
      { hex: "#7bbfd6", name: "2030-B10G" }, 
      { hex: "#80ced6", name: "2030-B30G" }, 
      { hex: "#82d4d6", name: "2030-B40G" }, 
      { hex: "#81d6d3", name: "2030-B50G" }, 
      { hex: "#80d6ce", name: "2030-B60G" }, 
      { hex: "#7ed6c9", name: "2030-B70G" }, 
      { hex: "#75d6ab", name: "2030-B90G" }, 
      { hex: "#6fd697", name: "2030-G" }, 
      { hex: "#8ad68d", name: "2030-G10Y" }, 
      { hex: "#9cd685", name: "2030-G20Y" }, 
      { hex: "#abd67e", name: "2030-G30Y" }, 
      { hex: "#b7d679", name: "2030-G40Y" }, 
      { hex: "#c2d67c", name: "2030-G50Y" }, 
      { hex: "#cad67f", name: "2030-G60Y" }, 
      { hex: "#d2d681", name: "2030-G70Y" }, 
      { hex: "#d6d481", name: "2030-G80Y" }, 
      { hex: "#d6ce80", name: "2030-G90Y" }, 
      { hex: "#d66168", name: "2030-R" }, 
      { hex: "#d66471", name: "2030-R10B" }, 
      { hex: "#d6677e", name: "2030-R20B" }, 
      { hex: "#d66c8e", name: "2030-R30B" }, 
      { hex: "#d673a5", name: "2030-R40B" }, 
      { hex: "#d67dc5", name: "2030-R50B" }, 
      { hex: "#b979d6", name: "2030-R60B" }, 
      { hex: "#9b7bd6", name: "2030-R70B" }, 
      { hex: "#677bd6", name: "2030-R80B" }, 
      { hex: "#6d8fd6", name: "2030-R90B" }, 
      { hex: "#d6c97e", name: "2030-Y" }, 
      { hex: "#d6c17c", name: "2030-Y10R" }, 
      { hex: "#d6b979", name: "2030-Y20R" }, 
      { hex: "#d6b076", name: "2030-Y30R" }, 
      { hex: "#d6a674", name: "2030-Y40R" }, 
      { hex: "#d69c70", name: "2030-Y50R" }, 
      { hex: "#d6916d", name: "2030-Y60R" }, 
      { hex: "#d6856a", name: "2030-Y70R" }, 
      { hex: "#d67966", name: "2030-Y80R" }, 
      { hex: "#d66d66", name: "2030-Y90R" }, 
      { hex: "#60aad6", name: "2040-B" }, 
      { hex: "#64b9d6", name: "2040-B10G" }, 
      { hex: "#66c4d6", name: "2040-B20G" }, 
      { hex: "#68ccd6", name: "2040-B30G" }, 
      { hex: "#6ad3d6", name: "2040-B40G" }, 
      { hex: "#6ad6d3", name: "2040-B50G" }, 
      { hex: "#68d6cc", name: "2040-B60G" }, 
      { hex: "#67d6c6", name: "2040-B70G" }, 
      { hex: "#65d6bd", name: "2040-B80G" }, 
      { hex: "#5dd6a0", name: "2040-B90G" }, 
      { hex: "#58d689", name: "2040-G" }, 
      { hex: "#77d67c", name: "2040-G10Y" }, 
      { hex: "#8ed671", name: "2040-G20Y" }, 
      { hex: "#a0d668", name: "2040-G30Y" }, 
      { hex: "#afd661", name: "2040-G40Y" }, 
      { hex: "#bcd664", name: "2040-G50Y" }, 
      { hex: "#c7d667", name: "2040-G60Y" }, 
      { hex: "#d1d66a", name: "2040-G70Y" }, 
      { hex: "#d6d36a", name: "2040-G80Y" }, 
      { hex: "#d6cc68", name: "2040-G90Y" }, 
      { hex: "#d64a53", name: "2040-R" }, 
      { hex: "#d64d5d", name: "2040-R10B" }, 
      { hex: "#d6506b", name: "2040-R20B" }, 
      { hex: "#d6557e", name: "2040-R30B" }, 
      { hex: "#d65c99", name: "2040-R40B" }, 
      { hex: "#d666c1", name: "2040-R50B" }, 
      { hex: "#b162d6", name: "2040-R60B" }, 
      { hex: "#8d65d6", name: "2040-R70B" }, 
      { hex: "#4f68d6", name: "2040-R80B" }, 
      { hex: "#5580d6", name: "2040-R90B" }, 
      { hex: "#d6c667", name: "2040-Y" }, 
      { hex: "#d6bc64", name: "2040-Y10R" }, 
      { hex: "#d6b162", name: "2040-Y20R" }, 
      { hex: "#d6a65f", name: "2040-Y30R" }, 
      { hex: "#d69a5c", name: "2040-Y40R" }, 
      { hex: "#d68e59", name: "2040-Y50R" }, 
      { hex: "#d68156", name: "2040-Y60R" }, 
      { hex: "#d67452", name: "2040-Y70R" }, 
      { hex: "#d6664f", name: "2040-Y80R" }, 
      { hex: "#d65950", name: "2040-Y90R" }, 
      { hex: "#4ba2d6", name: "2050-B" }, 
      { hex: "#4fb4d6", name: "2050-B10G" }, 
      { hex: "#51c0d6", name: "2050-B20G" }, 
      { hex: "#53cad6", name: "2050-B30G" }, 
      { hex: "#55d3d6", name: "2050-B40G" }, 
      { hex: "#55d6d2", name: "2050-B50G" }, 
      { hex: "#53d6ca", name: "2050-B60G" }, 
      { hex: "#51d6c3", name: "2050-B70G" }, 
      { hex: "#4fd6b8", name: "2050-B80G" }, 
      { hex: "#49d697", name: "2050-B90G" }, 
      { hex: "#44d67d", name: "2050-G" }, 
      { hex: "#68d66c", name: "2050-G10Y" }, 
      { hex: "#82d660", name: "2050-G20Y" }, 
      { hex: "#97d655", name: "2050-G30Y" }, 
      { hex: "#a8d64d", name: "2050-G40Y" }, 
      { hex: "#b7d64f", name: "2050-G50Y" }, 
      { hex: "#c4d652", name: "2050-G60Y" }, 
      { hex: "#d0d654", name: "2050-G70Y" }, 
      { hex: "#d6d255", name: "2050-G80Y" }, 
      { hex: "#d6ca53", name: "2050-G90Y" }, 
      { hex: "#d63842", name: "2050-R" }, 
      { hex: "#d63a4d", name: "2050-R10B" }, 
      { hex: "#d63d5c", name: "2050-R20B" }, 
      { hex: "#d64171", name: "2050-R30B" }, 
      { hex: "#d6478f", name: "2050-R40B" }, 
      { hex: "#d650bd", name: "2050-R50B" }, 
      { hex: "#aa4dd6", name: "2050-R60B" }, 
      { hex: "#8052d6", name: "2050-R70B" }, 
      { hex: "#3c59d6", name: "2050-R80B" }, 
      { hex: "#4172d6", name: "2050-R90B" }, 
      { hex: "#d6c251", name: "2050-Y" }, 
      { hex: "#d6b74f", name: "2050-Y10R" }, 
      { hex: "#d6aa4d", name: "2050-Y20R" }, 
      { hex: "#d69e4a", name: "2050-Y30R" }, 
      { hex: "#d69047", name: "2050-Y40R" }, 
      { hex: "#d68345", name: "2050-Y50R" }, 
      { hex: "#d67442", name: "2050-Y60R" }, 
      { hex: "#d6663f", name: "2050-Y70R" }, 
      { hex: "#d6573c", name: "2050-Y80R" }, 
      { hex: "#d6483e", name: "2050-Y90R" }, 
      { hex: "#45b1d6", name: "2055-B10G" }, 
      { hex: "#399bd6", name: "2060-B" }, 
      { hex: "#41d6d1", name: "2060-B50G" }, 
      { hex: "#3ed6c0", name: "2060-B70G" }, 
      { hex: "#37d68f", name: "2060-B90G" }, 
      { hex: "#32d672", name: "2060-G" }, 
      { hex: "#5ad65f", name: "2060-G10Y" }, 
      { hex: "#77d650", name: "2060-G20Y" }, 
      { hex: "#8fd644", name: "2060-G30Y" }, 
      { hex: "#a2d63a", name: "2060-G40Y" }, 
      { hex: "#b3d63c", name: "2060-G50Y" }, 
      { hex: "#c1d63e", name: "2060-G60Y" }, 
      { hex: "#cfd640", name: "2060-G70Y" }, 
      { hex: "#d6d241", name: "2060-G80Y" }, 
      { hex: "#d6c83f", name: "2060-G90Y" }, 
      { hex: "#d62934", name: "2060-R" }, 
      { hex: "#d62a3f", name: "2060-R10B" }, 
      { hex: "#d62d4f", name: "2060-R20B" }, 
      { hex: "#d63065", name: "2060-R30B" }, 
      { hex: "#d63586", name: "2060-R40B" }, 
      { hex: "#7642d6", name: "2060-R70B" }, 
      { hex: "#2c4cd6", name: "2060-R80B" }, 
      { hex: "#3067d6", name: "2060-R90B" }, 
      { hex: "#d6c03e", name: "2060-Y" }, 
      { hex: "#d6b23c", name: "2060-Y10R" }, 
      { hex: "#d6a43a", name: "2060-Y20R" }, 
      { hex: "#d69638", name: "2060-Y30R" }, 
      { hex: "#d68835", name: "2060-Y40R" }, 
      { hex: "#d67933", name: "2060-Y50R" }, 
      { hex: "#d66931", name: "2060-Y60R" }, 
      { hex: "#d6592e", name: "2060-Y70R" }, 
      { hex: "#d6492c", name: "2060-Y80R" }, 
      { hex: "#d6392f", name: "2060-Y90R" }, 
      { hex: "#3098d6", name: "2065-B" }, 
      { hex: "#d62649", name: "2065-R20B" }, 
      { hex: "#2962d6", name: "2065-R90B" }, 
      { hex: "#4ed654", name: "2070-G10Y" }, 
      { hex: "#6ed643", name: "2070-G20Y" }, 
      { hex: "#87d635", name: "2070-G30Y" }, 
      { hex: "#9dd629", name: "2070-G40Y" }, 
      { hex: "#afd62b", name: "2070-G50Y" }, 
      { hex: "#bed62d", name: "2070-G60Y" }, 
      { hex: "#ced62e", name: "2070-G70Y" }, 
      { hex: "#d6d12f", name: "2070-G80Y" }, 
      { hex: "#d6c62d", name: "2070-G90Y" }, 
      { hex: "#d61c28", name: "2070-R" }, 
      { hex: "#d61d34", name: "2070-R10B" }, 
      { hex: "#d6bd2c", name: "2070-Y" }, 
      { hex: "#d6ae2b", name: "2070-Y10R" }, 
      { hex: "#d69f29", name: "2070-Y20R" }, 
      { hex: "#d68f27", name: "2070-Y30R" }, 
      { hex: "#d68026", name: "2070-Y40R" }, 
      { hex: "#d67024", name: "2070-Y50R" }, 
      { hex: "#d65f22", name: "2070-Y60R" }, 
      { hex: "#d64f20", name: "2070-Y70R" }, 
      { hex: "#d63e1e", name: "2070-Y80R" }, 
      { hex: "#d62d22", name: "2070-Y90R" }, 
      { hex: "#69d63c", name: "2075-G20Y" }, 
      { hex: "#84d62e", name: "2075-G30Y" }, 
      { hex: "#d65b1b", name: "2075-Y60R" }, 
      { hex: "#d64a1a", name: "2075-Y70R" }, 
      { hex: "#bfbfbf", name: "2500-N" }, 
      { hex: "#c2c6c9", name: "2502-B" }, 
      { hex: "#c0c9c4", name: "2502-G" }, 
      { hex: "#c9bebf", name: "2502-R" }, 
      { hex: "#c9c8c2", name: "2502-Y" }, 
      { hex: "#43b3c9", name: "2555-B20G" }, 
      { hex: "#44bcc9", name: "2555-B30G" }, 
      { hex: "#46c5c9", name: "2555-B40G" }, 
      { hex: "#44c9bd", name: "2555-B60G" }, 
      { hex: "#41c9ab", name: "2555-B80G" }, 
      { hex: "#28c967", name: "2565-G" }, 
      { hex: "#2341c9", name: "2565-R80B" }, 
      { hex: "#67c93e", name: "2570-G20Y" }, 
      { hex: "#7fc931", name: "2570-G30Y" }, 
      { hex: "#c91a25", name: "2570-R" }, 
      { hex: "#c98725", name: "2570-Y30R" }, 
      { hex: "#c97823", name: "2570-Y40R" }, 
      { hex: "#c96922", name: "2570-Y50R" }, 
      { hex: "#c95920", name: "2570-Y60R" }, 
      { hex: "#c94a1e", name: "2570-Y70R" }, 
      { hex: "#c93a1c", name: "2570-Y80R" }, 
      { hex: "#c92b20", name: "2570-Y90R" }, 
      { hex: "#b2b2b2", name: "3000-N" }, 
      { hex: "#adb9bc", name: "3005-B20G" }, 
      { hex: "#acbcb8", name: "3005-B80G" }, 
      { hex: "#b1bcad", name: "3005-G20Y" }, 
      { hex: "#b8bcac", name: "3005-G50Y" }, 
      { hex: "#bcbbae", name: "3005-G80Y" }, 
      { hex: "#bca6aa", name: "3005-R20B" }, 
      { hex: "#bcacb9", name: "3005-R50B" }, 
      { hex: "#a5aabc", name: "3005-R80B" }, 
      { hex: "#bcb6ab", name: "3005-Y20R" }, 
      { hex: "#bcb1a9", name: "3005-Y50R" }, 
      { hex: "#bca9a5", name: "3005-Y80R" }, 
      { hex: "#9cb0bc", name: "3010-B" }, 
      { hex: "#9db4bc", name: "3010-B10G" }, 
      { hex: "#a0b9bc", name: "3010-B30G" }, 
      { hex: "#a0bcbb", name: "3010-B50G" }, 
      { hex: "#9fbcb7", name: "3010-B70G" }, 
      { hex: "#9abcad", name: "3010-B90G" }, 
      { hex: "#97bca5", name: "3010-G" }, 
      { hex: "#a1bca2", name: "3010-G10Y" }, 
      { hex: "#a8bca0", name: "3010-G20Y" }, 
      { hex: "#adbc9e", name: "3010-G30Y" }, 
      { hex: "#b1bc9c", name: "3010-G40Y" }, 
      { hex: "#b5bc9e", name: "3010-G50Y" }, 
      { hex: "#b8bc9f", name: "3010-G60Y" }, 
      { hex: "#babca0", name: "3010-G70Y" }, 
      { hex: "#bcbba0", name: "3010-G80Y" }, 
      { hex: "#bcb9a0", name: "3010-G90Y" }, 
      { hex: "#bc8f92", name: "3010-R" }, 
      { hex: "#bc9096", name: "3010-R10B" }, 
      { hex: "#bc939b", name: "3010-R20B" }, 
      { hex: "#bc96a2", name: "3010-R30B" }, 
      { hex: "#bc99aa", name: "3010-R40B" }, 
      { hex: "#bc9eb6", name: "3010-R50B" }, 
      { hex: "#b29cbc", name: "3010-R60B" }, 
      { hex: "#a79cbc", name: "3010-R70B" }, 
      { hex: "#929abc", name: "3010-R80B" }, 
      { hex: "#96a2bc", name: "3010-R90B" }, 
      { hex: "#bcb79f", name: "3010-Y" }, 
      { hex: "#bcb59e", name: "3010-Y10R" }, 
      { hex: "#bcb29c", name: "3010-Y20R" }, 
      { hex: "#bcae9b", name: "3010-Y30R" }, 
      { hex: "#bcab9a", name: "3010-Y40R" }, 
      { hex: "#bca798", name: "3010-Y50R" }, 
      { hex: "#bca396", name: "3010-Y60R" }, 
      { hex: "#bc9e94", name: "3010-Y70R" }, 
      { hex: "#bc9992", name: "3010-Y80R" }, 
      { hex: "#bc9491", name: "3010-Y90R" }, 
      { hex: "#80a5bc", name: "3020-B" }, 
      { hex: "#83adbc", name: "3020-B10G" }, 
      { hex: "#86b7bc", name: "3020-B30G" }, 
      { hex: "#88babc", name: "3020-B40G" }, 
      { hex: "#88bcba", name: "3020-B50G" }, 
      { hex: "#86bcb7", name: "3020-B60G" }, 
      { hex: "#85bcb3", name: "3020-B70G" }, 
      { hex: "#7ebca0", name: "3020-B90G" }, 
      { hex: "#7abc93", name: "3020-G" }, 
      { hex: "#8bbc8d", name: "3020-G10Y" }, 
      { hex: "#97bc88", name: "3020-G20Y" }, 
      { hex: "#a1bc84", name: "3020-G30Y" }, 
      { hex: "#a8bc81", name: "3020-G40Y" }, 
      { hex: "#afbc84", name: "3020-G50Y" }, 
      { hex: "#b4bc86", name: "3020-G60Y" }, 
      { hex: "#b9bc87", name: "3020-G70Y" }, 
      { hex: "#bcba88", name: "3020-G80Y" }, 
      { hex: "#bcb686", name: "3020-G90Y" }, 
      { hex: "#bc6e73", name: "3020-R" }, 
      { hex: "#bc7079", name: "3020-R10B" }, 
      { hex: "#bc7382", name: "3020-R20B" }, 
      { hex: "#bc778d", name: "3020-R30B" }, 
      { hex: "#bc7d9c", name: "3020-R40B" }, 
      { hex: "#bc84b1", name: "3020-R50B" }, 
      { hex: "#a982bc", name: "3020-R60B" }, 
      { hex: "#9682bc", name: "3020-R70B" }, 
      { hex: "#7380bc", name: "3020-R80B" }, 
      { hex: "#788ebc", name: "3020-R90B" }, 
      { hex: "#bcb385", name: "3020-Y" }, 
      { hex: "#bcae83", name: "3020-Y10R" }, 
      { hex: "#bca982", name: "3020-Y20R" }, 
      { hex: "#bca37f", name: "3020-Y30R" }, 
      { hex: "#bc9d7d", name: "3020-Y40R" }, 
      { hex: "#bc967b", name: "3020-Y50R" }, 
      { hex: "#bc8f78", name: "3020-Y60R" }, 
      { hex: "#bc8775", name: "3020-Y70R" }, 
      { hex: "#bc7f72", name: "3020-Y80R" }, 
      { hex: "#bc7772", name: "3020-Y90R" }, 
      { hex: "#689cbc", name: "3030-B" }, 
      { hex: "#6ca7bc", name: "3030-B10G" }, 
      { hex: "#70b4bc", name: "3030-B30G" }, 
      { hex: "#71b9bc", name: "3030-B40G" }, 
      { hex: "#71bcb9", name: "3030-B50G" }, 
      { hex: "#70bcb5", name: "3030-B60G" }, 
      { hex: "#6ebcb0", name: "3030-B70G" }, 
      { hex: "#66bc95", name: "3030-B90G" }, 
      { hex: "#61bc84", name: "3030-G" }, 
      { hex: "#78bc7b", name: "3030-G10Y" }, 
      { hex: "#89bc74", name: "3030-G20Y" }, 
      { hex: "#96bc6e", name: "3030-G30Y" }, 
      { hex: "#a0bc6a", name: "3030-G40Y" }, 
      { hex: "#a9bc6c", name: "3030-G50Y" }, 
      { hex: "#b1bc6f", name: "3030-G60Y" }, 
      { hex: "#b8bc71", name: "3030-G70Y" }, 
      { hex: "#bcb971", name: "3030-G80Y" }, 
      { hex: "#bcb470", name: "3030-G90Y" }, 
      { hex: "#bc555b", name: "3030-R" }, 
      { hex: "#bc5763", name: "3030-R10B" }, 
      { hex: "#bc5a6e", name: "3030-R20B" }, 
      { hex: "#bc5f7c", name: "3030-R30B" }, 
      { hex: "#bc6590", name: "3030-R40B" }, 
      { hex: "#bc6dad", name: "3030-R50B" }, 
      { hex: "#a26abc", name: "3030-R60B" }, 
      { hex: "#876bbc", name: "3030-R70B" }, 
      { hex: "#5a6cbc", name: "3030-R80B" }, 
      { hex: "#5f7ebc", name: "3030-R90B" }, 
      { hex: "#bcb06e", name: "3030-Y" }, 
      { hex: "#bca96c", name: "3030-Y10R" }, 
      { hex: "#bca16a", name: "3030-Y20R" }, 
      { hex: "#bc9a68", name: "3030-Y30R" }, 
      { hex: "#bc9165", name: "3030-Y40R" }, 
      { hex: "#bc8862", name: "3030-Y50R" }, 
      { hex: "#bc7f5f", name: "3030-Y60R" }, 
      { hex: "#bc755c", name: "3030-Y70R" }, 
      { hex: "#bc6a59", name: "3030-Y80R" }, 
      { hex: "#bc6059", name: "3030-Y90R" }, 
      { hex: "#5495bc", name: "3040-B" }, 
      { hex: "#57a2bc", name: "3040-B10G" }, 
      { hex: "#59abbc", name: "3040-B20G" }, 
      { hex: "#5bb3bc", name: "3040-B30G" }, 
      { hex: "#5db9bc", name: "3040-B40G" }, 
      { hex: "#5dbcb8", name: "3040-B50G" }, 
      { hex: "#5bbcb3", name: "3040-B60G" }, 
      { hex: "#5abcad", name: "3040-B70G" }, 
      { hex: "#58bca5", name: "3040-B80G" }, 
      { hex: "#52bc8c", name: "3040-B90G" }, 
      { hex: "#4dbc78", name: "3040-G" }, 
      { hex: "#68bc6c", name: "3040-G10Y" }, 
      { hex: "#7dbc63", name: "3040-G20Y" }, 
      { hex: "#8cbc5b", name: "3040-G30Y" }, 
      { hex: "#99bc55", name: "3040-G40Y" }, 
      { hex: "#a5bc58", name: "3040-G50Y" }, 
      { hex: "#aebc5a", name: "3040-G60Y" }, 
      { hex: "#b7bc5c", name: "3040-G70Y" }, 
      { hex: "#bcb95d", name: "3040-G80Y" }, 
      { hex: "#bcb25b", name: "3040-G90Y" }, 
      { hex: "#bc4149", name: "3040-R" }, 
      { hex: "#bc4352", name: "3040-R10B" }, 
      { hex: "#bc465e", name: "3040-R20B" }, 
      { hex: "#bc4a6e", name: "3040-R30B" }, 
      { hex: "#bc5086", name: "3040-R40B" }, 
      { hex: "#bc59a9", name: "3040-R50B" }, 
      { hex: "#9b55bc", name: "3040-R60B" }, 
      { hex: "#7b58bc", name: "3040-R70B" }, 
      { hex: "#455bbc", name: "3040-R80B" }, 
      { hex: "#4b70bc", name: "3040-R90B" }, 
      { hex: "#bcad5a", name: "3040-Y" }, 
      { hex: "#bca458", name: "3040-Y10R" }, 
      { hex: "#bc9b55", name: "3040-Y20R" }, 
      { hex: "#bc9153", name: "3040-Y30R" }, 
      { hex: "#bc8750", name: "3040-Y40R" }, 
      { hex: "#bc7c4e", name: "3040-Y50R" }, 
      { hex: "#bc714b", name: "3040-Y60R" }, 
      { hex: "#bc6648", name: "3040-Y70R" }, 
      { hex: "#bc5a45", name: "3040-Y80R" }, 
      { hex: "#bc4d46", name: "3040-Y90R" }, 
      { hex: "#428ebc", name: "3050-B" }, 
      { hex: "#459dbc", name: "3050-B10G" }, 
      { hex: "#47a8bc", name: "3050-B20G" }, 
      { hex: "#49b1bc", name: "3050-B30G" }, 
      { hex: "#4ab8bc", name: "3050-B40G" }, 
      { hex: "#4abcb8", name: "3050-B50G" }, 
      { hex: "#49bcb1", name: "3050-B60G" }, 
      { hex: "#47bcaa", name: "3050-B70G" }, 
      { hex: "#45bca1", name: "3050-B80G" }, 
      { hex: "#40bc84", name: "3050-B90G" }, 
      { hex: "#3bbc6d", name: "3050-G" }, 
      { hex: "#5bbc5f", name: "3050-G10Y" }, 
      { hex: "#72bc54", name: "3050-G20Y" }, 
      { hex: "#84bc4a", name: "3050-G30Y" }, 
      { hex: "#93bc43", name: "3050-G40Y" }, 
      { hex: "#a0bc45", name: "3050-G50Y" }, 
      { hex: "#abbc47", name: "3050-G60Y" }, 
      { hex: "#b6bc4a", name: "3050-G70Y" }, 
      { hex: "#bcb84a", name: "3050-G80Y" }, 
      { hex: "#bcb048", name: "3050-G90Y" }, 
      { hex: "#bc313a", name: "3050-R" }, 
      { hex: "#bc3343", name: "3050-R10B" }, 
      { hex: "#bc3550", name: "3050-R20B" }, 
      { hex: "#bc3963", name: "3050-R30B" }, 
      { hex: "#bc3e7d", name: "3050-R40B" }, 
      { hex: "#bc46a5", name: "3050-R50B" }, 
      { hex: "#9543bc", name: "3050-R60B" }, 
      { hex: "#7048bc", name: "3050-R70B" }, 
      { hex: "#354ebc", name: "3050-R80B" }, 
      { hex: "#3964bc", name: "3050-R90B" }, 
      { hex: "#bcaa47", name: "3050-Y" }, 
      { hex: "#bca045", name: "3050-Y10R" }, 
      { hex: "#bc9543", name: "3050-Y20R" }, 
      { hex: "#bc8a41", name: "3050-Y30R" }, 
      { hex: "#bc7e3e", name: "3050-Y40R" }, 
      { hex: "#bc723c", name: "3050-Y50R" }, 
      { hex: "#bc663a", name: "3050-Y60R" }, 
      { hex: "#bc5937", name: "3050-Y70R" }, 
      { hex: "#bc4c34", name: "3050-Y80R" }, 
      { hex: "#bc3f36", name: "3050-Y90R" }, 
      { hex: "#41bcb7", name: "3055-B50G" }, 
      { hex: "#bc315d", name: "3055-R30B" }, 
      { hex: "#bc3679", name: "3055-R40B" }, 
      { hex: "#bc3ea3", name: "3055-R50B" }, 
      { hex: "#3188bc", name: "3060-B" }, 
      { hex: "#3499bc", name: "3060-B10G" }, 
      { hex: "#36a5bc", name: "3060-B20G" }, 
      { hex: "#37afbc", name: "3060-B30G" }, 
      { hex: "#39b8bc", name: "3060-B40G" }, 
      { hex: "#36bca8", name: "3060-B70G" }, 
      { hex: "#30bc7d", name: "3060-B90G" }, 
      { hex: "#2cbc64", name: "3060-G" }, 
      { hex: "#4fbc53", name: "3060-G10Y" }, 
      { hex: "#68bc46", name: "3060-G20Y" }, 
      { hex: "#7dbc3b", name: "3060-G30Y" }, 
      { hex: "#8ebc33", name: "3060-G40Y" }, 
      { hex: "#9cbc35", name: "3060-G50Y" }, 
      { hex: "#a9bc36", name: "3060-G60Y" }, 
      { hex: "#b5bc38", name: "3060-G70Y" }, 
      { hex: "#bcb739", name: "3060-G80Y" }, 
      { hex: "#bcaf37", name: "3060-G90Y" }, 
      { hex: "#bc232d", name: "3060-R" }, 
      { hex: "#bc2537", name: "3060-R10B" }, 
      { hex: "#bc2745", name: "3060-R20B" }, 
      { hex: "#673abc", name: "3060-R70B" }, 
      { hex: "#2742bc", name: "3060-R80B" }, 
      { hex: "#2a5abc", name: "3060-R90B" }, 
      { hex: "#bca836", name: "3060-Y" }, 
      { hex: "#bc9c34", name: "3060-Y10R" }, 
      { hex: "#bc9033", name: "3060-Y20R" }, 
      { hex: "#bc8331", name: "3060-Y30R" }, 
      { hex: "#bc772f", name: "3060-Y40R" }, 
      { hex: "#bc692d", name: "3060-Y50R" }, 
      { hex: "#bc5c2b", name: "3060-Y60R" }, 
      { hex: "#bc4e29", name: "3060-Y70R" }, 
      { hex: "#bc4026", name: "3060-Y80R" }, 
      { hex: "#bc3229", name: "3060-Y90R" }, 
      { hex: "#49bc4e", name: "3065-G10Y" }, 
      { hex: "#8bbc2b", name: "3065-G40Y" }, 
      { hex: "#9bbc2d", name: "3065-G50Y" }, 
      { hex: "#a8bc2f", name: "3065-G60Y" }, 
      { hex: "#2456bc", name: "3065-R90B" }, 
      { hex: "#bc8d2b", name: "3065-Y20R" }, 
      { hex: "#a5a5a5", name: "3500-N" }, 
      { hex: "#a8acae", name: "3502-B" }, 
      { hex: "#a7aeaa", name: "3502-G" }, 
      { hex: "#aea5a5", name: "3502-R" }, 
      { hex: "#aeada9", name: "3502-Y" }, 
      { hex: "#3baea4", name: "3555-B60G" }, 
      { hex: "#39ae94", name: "3555-B80G" }, 
      { hex: "#8836ae", name: "3555-R60B" }, 
      { hex: "#29ae5d", name: "3560-G" }, 
      { hex: "#49ae4d", name: "3560-G10Y" }, 
      { hex: "#61ae41", name: "3560-G20Y" }, 
      { hex: "#74ae37", name: "3560-G30Y" }, 
      { hex: "#84ae2f", name: "3560-G40Y" }, 
      { hex: "#91ae31", name: "3560-G50Y" }, 
      { hex: "#9dae33", name: "3560-G60Y" }, 
      { hex: "#a8ae34", name: "3560-G70Y" }, 
      { hex: "#ae212a", name: "3560-R" }, 
      { hex: "#243dae", name: "3560-R80B" }, 
      { hex: "#2754ae", name: "3560-R90B" }, 
      { hex: "#ae9c32", name: "3560-Y" }, 
      { hex: "#ae852f", name: "3560-Y20R" }, 
      { hex: "#ae7a2d", name: "3560-Y30R" }, 
      { hex: "#ae6e2b", name: "3560-Y40R" }, 
      { hex: "#ae622a", name: "3560-Y50R" }, 
      { hex: "#ae5528", name: "3560-Y60R" }, 
      { hex: "#ae4926", name: "3560-Y70R" }, 
      { hex: "#ae3c24", name: "3560-Y80R" }, 
      { hex: "#ae2f26", name: "3560-Y90R" }, 
      { hex: "#999999", name: "4000-N" }, 
      { hex: "#949fa1", name: "4005-B20G" }, 
      { hex: "#94a19e", name: "4005-B80G" }, 
      { hex: "#98a194", name: "4005-G20Y" }, 
      { hex: "#9ea194", name: "4005-G50Y" }, 
      { hex: "#a1a095", name: "4005-G80Y" }, 
      { hex: "#a18e92", name: "4005-R20B" }, 
      { hex: "#a1949e", name: "4005-R50B" }, 
      { hex: "#8e91a1", name: "4005-R80B" }, 
      { hex: "#a19c93", name: "4005-Y20R" }, 
      { hex: "#a19891", name: "4005-Y50R" }, 
      { hex: "#a1918e", name: "4005-Y80R" }, 
      { hex: "#879aa1", name: "4010-B10G" }, 
      { hex: "#899fa1", name: "4010-B30G" }, 
      { hex: "#89a1a0", name: "4010-B50G" }, 
      { hex: "#88a19d", name: "4010-B70G" }, 
      { hex: "#84a194", name: "4010-B90G" }, 
      { hex: "#8aa18b", name: "4010-G10Y" }, 
      { hex: "#94a187", name: "4010-G30Y" }, 
      { hex: "#9ba187", name: "4010-G50Y" }, 
      { hex: "#a0a189", name: "4010-G70Y" }, 
      { hex: "#a19e89", name: "4010-G90Y" }, 
      { hex: "#a17c80", name: "4010-R10B" }, 
      { hex: "#a1808b", name: "4010-R30B" }, 
      { hex: "#a1889c", name: "4010-R50B" }, 
      { hex: "#8f86a1", name: "4010-R70B" }, 
      { hex: "#808ba1", name: "4010-R90B" }, 
      { hex: "#a19b87", name: "4010-Y10R" }, 
      { hex: "#a19585", name: "4010-Y30R" }, 
      { hex: "#a18f82", name: "4010-Y50R" }, 
      { hex: "#a1887f", name: "4010-Y70R" }, 
      { hex: "#a17f7d", name: "4010-Y90R" }, 
      { hex: "#6e8ea1", name: "4020-B" }, 
      { hex: "#7094a1", name: "4020-B10G" }, 
      { hex: "#739da1", name: "4020-B30G" }, 
      { hex: "#74a19f", name: "4020-B50G" }, 
      { hex: "#72a19a", name: "4020-B70G" }, 
      { hex: "#6ca189", name: "4020-B90G" }, 
      { hex: "#68a17e", name: "4020-G" }, 
      { hex: "#77a179", name: "4020-G10Y" }, 
      { hex: "#8aa171", name: "4020-G30Y" }, 
      { hex: "#96a171", name: "4020-G50Y" }, 
      { hex: "#9fa174", name: "4020-G70Y" }, 
      { hex: "#a19c73", name: "4020-G90Y" }, 
      { hex: "#a15e62", name: "4020-R" }, 
      { hex: "#a16068", name: "4020-R10B" }, 
      { hex: "#a1636f", name: "4020-R20B" }, 
      { hex: "#a16679", name: "4020-R30B" }, 
      { hex: "#a16b86", name: "4020-R40B" }, 
      { hex: "#a17298", name: "4020-R50B" }, 
      { hex: "#916fa1", name: "4020-R60B" }, 
      { hex: "#806fa1", name: "4020-R70B" }, 
      { hex: "#626ea1", name: "4020-R80B" }, 
      { hex: "#677aa1", name: "4020-R90B" }, 
      { hex: "#a19a72", name: "4020-Y" }, 
      { hex: "#a19571", name: "4020-Y10R" }, 
      { hex: "#a1916f", name: "4020-Y20R" }, 
      { hex: "#a18c6d", name: "4020-Y30R" }, 
      { hex: "#a1876b", name: "4020-Y40R" }, 
      { hex: "#a18169", name: "4020-Y50R" }, 
      { hex: "#a17b67", name: "4020-Y60R" }, 
      { hex: "#a17464", name: "4020-Y70R" }, 
      { hex: "#a16d62", name: "4020-Y80R" }, 
      { hex: "#a16662", name: "4020-Y90R" }, 
      { hex: "#5a86a1", name: "4030-B" }, 
      { hex: "#5c8fa1", name: "4030-B10G" }, 
      { hex: "#609ba1", name: "4030-B30G" }, 
      { hex: "#61a19f", name: "4030-B50G" }, 
      { hex: "#5fa197", name: "4030-B70G" }, 
      { hex: "#58a180", name: "4030-B90G" }, 
      { hex: "#53a171", name: "4030-G" }, 
      { hex: "#67a16a", name: "4030-G10Y" }, 
      { hex: "#80a15f", name: "4030-G30Y" }, 
      { hex: "#91a15d", name: "4030-G50Y" }, 
      { hex: "#9ea161", name: "4030-G70Y" }, 
      { hex: "#a19a60", name: "4030-G90Y" }, 
      { hex: "#a1494e", name: "4030-R" }, 
      { hex: "#a14b55", name: "4030-R10B" }, 
      { hex: "#a14d5e", name: "4030-R20B" }, 
      { hex: "#a1516b", name: "4030-R30B" }, 
      { hex: "#a1567c", name: "4030-R40B" }, 
      { hex: "#a15e94", name: "4030-R50B" }, 
      { hex: "#8b5ba1", name: "4030-R60B" }, 
      { hex: "#745ca1", name: "4030-R70B" }, 
      { hex: "#4d5ca1", name: "4030-R80B" }, 
      { hex: "#516ca1", name: "4030-R90B" }, 
      { hex: "#a1975f", name: "4030-Y" }, 
      { hex: "#a1915d", name: "4030-Y10R" }, 
      { hex: "#a18a5b", name: "4030-Y20R" }, 
      { hex: "#a18459", name: "4030-Y30R" }, 
      { hex: "#a17c57", name: "4030-Y40R" }, 
      { hex: "#a17554", name: "4030-Y50R" }, 
      { hex: "#a16d52", name: "4030-Y60R" }, 
      { hex: "#a1644f", name: "4030-Y70R" }, 
      { hex: "#a15b4c", name: "4030-Y80R" }, 
      { hex: "#a1524d", name: "4030-Y90R" }, 
      { hex: "#487fa1", name: "4040-B" }, 
      { hex: "#4b8ba1", name: "4040-B10G" }, 
      { hex: "#4d93a1", name: "4040-B20G" }, 
      { hex: "#4e99a1", name: "4040-B30G" }, 
      { hex: "#509ea1", name: "4040-B40G" }, 
      { hex: "#4fa19e", name: "4040-B50G" }, 
      { hex: "#4ea199", name: "4040-B60G" }, 
      { hex: "#4da194", name: "4040-B70G" }, 
      { hex: "#4ba18e", name: "4040-B80G" }, 
      { hex: "#46a178", name: "4040-B90G" }, 
      { hex: "#42a167", name: "4040-G" }, 
      { hex: "#59a15d", name: "4040-G10Y" }, 
      { hex: "#6ba155", name: "4040-G20Y" }, 
      { hex: "#78a14e", name: "4040-G30Y" }, 
      { hex: "#83a149", name: "4040-G40Y" }, 
      { hex: "#8da14b", name: "4040-G50Y" }, 
      { hex: "#95a14d", name: "4040-G60Y" }, 
      { hex: "#9da14f", name: "4040-G70Y" }, 
      { hex: "#a19e50", name: "4040-G80Y" }, 
      { hex: "#a1994e", name: "4040-G90Y" }, 
      { hex: "#a1383e", name: "4040-R" }, 
      { hex: "#a13946", name: "4040-R10B" }, 
      { hex: "#a13c50", name: "4040-R20B" }, 
      { hex: "#a1405f", name: "4040-R30B" }, 
      { hex: "#a14573", name: "4040-R40B" }, 
      { hex: "#a14c91", name: "4040-R50B" }, 
      { hex: "#8549a1", name: "4040-R60B" }, 
      { hex: "#694ca1", name: "4040-R70B" }, 
      { hex: "#3b4ea1", name: "4040-R80B" }, 
      { hex: "#4060a1", name: "4040-R90B" }, 
      { hex: "#a1944d", name: "4040-Y" }, 
      { hex: "#a18d4b", name: "4040-Y10R" }, 
      { hex: "#a18549", name: "4040-Y20R" }, 
      { hex: "#a17c47", name: "4040-Y30R" }, 
      { hex: "#a17445", name: "4040-Y40R" }, 
      { hex: "#a16b43", name: "4040-Y50R" }, 
      { hex: "#a16140", name: "4040-Y60R" }, 
      { hex: "#a1573e", name: "4040-Y70R" }, 
      { hex: "#a14d3b", name: "4040-Y80R" }, 
      { hex: "#a1423c", name: "4040-Y90R" }, 
      { hex: "#387aa1", name: "4050-B" }, 
      { hex: "#3b87a1", name: "4050-B10G" }, 
      { hex: "#3d90a1", name: "4050-B20G" }, 
      { hex: "#3e98a1", name: "4050-B30G" }, 
      { hex: "#3f9ea1", name: "4050-B40G" }, 
      { hex: "#3fa19e", name: "4050-B50G" }, 
      { hex: "#3ea198", name: "4050-B60G" }, 
      { hex: "#3da192", name: "4050-B70G" }, 
      { hex: "#3ca18a", name: "4050-B80G" }, 
      { hex: "#36a171", name: "4050-B90G" }, 
      { hex: "#33a15d", name: "4050-G" }, 
      { hex: "#4ea151", name: "4050-G10Y" }, 
      { hex: "#62a148", name: "4050-G20Y" }, 
      { hex: "#71a140", name: "4050-G30Y" }, 
      { hex: "#7ea139", name: "4050-G40Y" }, 
      { hex: "#89a13b", name: "4050-G50Y" }, 
      { hex: "#93a13d", name: "4050-G60Y" }, 
      { hex: "#9ca13f", name: "4050-G70Y" }, 
      { hex: "#a19e3f", name: "4050-G80Y" }, 
      { hex: "#a1973e", name: "4050-G90Y" }, 
      { hex: "#a12a31", name: "4050-R" }, 
      { hex: "#a12b3a", name: "4050-R10B" }, 
      { hex: "#a12e45", name: "4050-R20B" }, 
      { hex: "#a13154", name: "4050-R30B" }, 
      { hex: "#a1356b", name: "4050-R40B" }, 
      { hex: "#a13c8e", name: "4050-R50B" }, 
      { hex: "#8039a1", name: "4050-R60B" }, 
      { hex: "#603ea1", name: "4050-R70B" }, 
      { hex: "#2d42a1", name: "4050-R80B" }, 
      { hex: "#3156a1", name: "4050-R90B" }, 
      { hex: "#a1923d", name: "4050-Y" }, 
      { hex: "#a1893b", name: "4050-Y10R" }, 
      { hex: "#a18039", name: "4050-Y20R" }, 
      { hex: "#a17637", name: "4050-Y30R" }, 
      { hex: "#a16c36", name: "4050-Y40R" }, 
      { hex: "#a16233", name: "4050-Y50R" }, 
      { hex: "#a15731", name: "4050-Y60R" }, 
      { hex: "#a14c2f", name: "4050-Y70R" }, 
      { hex: "#a1412d", name: "4050-Y80R" }, 
      { hex: "#a1362e", name: "4050-Y90R" }, 
      { hex: "#3177a1", name: "4055-B" }, 
      { hex: "#389ea1", name: "4055-B40G" }, 
      { hex: "#5c37a1", name: "4055-R70B" }, 
      { hex: "#2d5fa1", name: "4055-R95B" }, 
      { hex: "#a18734", name: "4055-Y10R" }, 
      { hex: "#8c8c8c", name: "4500-N" }, 
      { hex: "#8e9193", name: "4502-B" }, 
      { hex: "#8d9390", name: "4502-G" }, 
      { hex: "#938b8c", name: "4502-R" }, 
      { hex: "#93938f", name: "4502-Y" }, 
      { hex: "#336f93", name: "4550-B" }, 
      { hex: "#388493", name: "4550-B20G" }, 
      { hex: "#398b93", name: "4550-B30G" }, 
      { hex: "#3a9193", name: "4550-B40G" }, 
      { hex: "#3a9390", name: "4550-B50G" }, 
      { hex: "#37937f", name: "4550-B80G" }, 
      { hex: "#329368", name: "4550-B90G" }, 
      { hex: "#2e9356", name: "4550-G" }, 
      { hex: "#47934b", name: "4550-G10Y" }, 
      { hex: "#599342", name: "4550-G20Y" }, 
      { hex: "#68933a", name: "4550-G30Y" }, 
      { hex: "#749335", name: "4550-G40Y" }, 
      { hex: "#7e9336", name: "4550-G50Y" }, 
      { hex: "#879338", name: "4550-G60Y" }, 
      { hex: "#8f933a", name: "4550-G70Y" }, 
      { hex: "#583993", name: "4550-R70B" }, 
      { hex: "#293d93", name: "4550-R80B" }, 
      { hex: "#2d4f93", name: "4550-R90B" }, 
      { hex: "#938638", name: "4550-Y" }, 
      { hex: "#936c33", name: "4550-Y30R" }, 
      { hex: "#936331", name: "4550-Y40R" }, 
      { hex: "#935a2f", name: "4550-Y50R" }, 
      { hex: "#93502d", name: "4550-Y60R" }, 
      { hex: "#93462b", name: "4550-Y70R" }, 
      { hex: "#933b29", name: "4550-Y80R" }, 
      { hex: "#93312a", name: "4550-Y90R" }, 
      { hex: "#7f7f7f", name: "5000-N" }, 
      { hex: "#7b8486", name: "5005-B20G" }, 
      { hex: "#7b8684", name: "5005-B80G" }, 
      { hex: "#7f867c", name: "5005-G20Y" }, 
      { hex: "#83867b", name: "5005-G50Y" }, 
      { hex: "#86867c", name: "5005-G80Y" }, 
      { hex: "#86767a", name: "5005-R20B" }, 
      { hex: "#867b84", name: "5005-R50B" }, 
      { hex: "#767986", name: "5005-R80B" }, 
      { hex: "#86827a", name: "5005-Y20R" }, 
      { hex: "#867e79", name: "5005-Y50R" }, 
      { hex: "#867976", name: "5005-Y80R" }, 
      { hex: "#708186", name: "5010-B10G" }, 
      { hex: "#728486", name: "5010-B30G" }, 
      { hex: "#738685", name: "5010-B50G" }, 
      { hex: "#718683", name: "5010-B70G" }, 
      { hex: "#6e867b", name: "5010-B90G" }, 
      { hex: "#738674", name: "5010-G10Y" }, 
      { hex: "#7c8671", name: "5010-G30Y" }, 
      { hex: "#818671", name: "5010-G50Y" }, 
      { hex: "#858672", name: "5010-G70Y" }, 
      { hex: "#868472", name: "5010-G90Y" }, 
      { hex: "#86676b", name: "5010-R10B" }, 
      { hex: "#866b74", name: "5010-R30B" }, 
      { hex: "#867182", name: "5010-R50B" }, 
      { hex: "#776f86", name: "5010-R70B" }, 
      { hex: "#6b7486", name: "5010-R90B" }, 
      { hex: "#868171", name: "5010-Y10R" }, 
      { hex: "#867d6f", name: "5010-Y30R" }, 
      { hex: "#86776d", name: "5010-Y50R" }, 
      { hex: "#86716a", name: "5010-Y70R" }, 
      { hex: "#866a68", name: "5010-Y90R" }, 
      { hex: "#5c7686", name: "5020-B" }, 
      { hex: "#5e7c86", name: "5020-B10G" }, 
      { hex: "#608286", name: "5020-B30G" }, 
      { hex: "#618685", name: "5020-B50G" }, 
      { hex: "#5f8680", name: "5020-B70G" }, 
      { hex: "#5a8672", name: "5020-B90G" }, 
      { hex: "#578669", name: "5020-G" }, 
      { hex: "#638665", name: "5020-G10Y" }, 
      { hex: "#73865f", name: "5020-G30Y" }, 
      { hex: "#7d865e", name: "5020-G50Y" }, 
      { hex: "#848661", name: "5020-G70Y" }, 
      { hex: "#868260", name: "5020-G90Y" }, 
      { hex: "#864e52", name: "5020-R" }, 
      { hex: "#865057", name: "5020-R10B" }, 
      { hex: "#86525d", name: "5020-R20B" }, 
      { hex: "#865565", name: "5020-R30B" }, 
      { hex: "#865970", name: "5020-R40B" }, 
      { hex: "#865f7e", name: "5020-R50B" }, 
      { hex: "#795d86", name: "5020-R60B" }, 
      { hex: "#6b5d86", name: "5020-R70B" }, 
      { hex: "#525b86", name: "5020-R80B" }, 
      { hex: "#556586", name: "5020-R90B" }, 
      { hex: "#86805f", name: "5020-Y" }, 
      { hex: "#867d5e", name: "5020-Y10R" }, 
      { hex: "#86795c", name: "5020-Y20R" }, 
      { hex: "#86755b", name: "5020-Y30R" }, 
      { hex: "#867059", name: "5020-Y40R" }, 
      { hex: "#866b58", name: "5020-Y50R" }, 
      { hex: "#866656", name: "5020-Y60R" }, 
      { hex: "#866154", name: "5020-Y70R" }, 
      { hex: "#865b52", name: "5020-Y80R" }, 
      { hex: "#865551", name: "5020-Y90R" }, 
      { hex: "#4b7086", name: "5030-B" }, 
      { hex: "#4d7786", name: "5030-B10G" }, 
      { hex: "#508186", name: "5030-B30G" }, 
      { hex: "#518684", name: "5030-B50G" }, 
      { hex: "#4f867e", name: "5030-B70G" }, 
      { hex: "#49866b", name: "5030-B90G" }, 
      { hex: "#45865f", name: "5030-G" }, 
      { hex: "#568658", name: "5030-G10Y" }, 
      { hex: "#6b864f", name: "5030-G30Y" }, 
      { hex: "#79864d", name: "5030-G50Y" }, 
      { hex: "#838651", name: "5030-G70Y" }, 
      { hex: "#868150", name: "5030-G90Y" }, 
      { hex: "#863c41", name: "5030-R" }, 
      { hex: "#863e47", name: "5030-R10B" }, 
      { hex: "#86404e", name: "5030-R20B" }, 
      { hex: "#864459", name: "5030-R30B" }, 
      { hex: "#864867", name: "5030-R40B" }, 
      { hex: "#864e7b", name: "5030-R50B" }, 
      { hex: "#734c86", name: "5030-R60B" }, 
      { hex: "#614d86", name: "5030-R70B" }, 
      { hex: "#404d86", name: "5030-R80B" }, 
      { hex: "#445a86", name: "5030-R90B" }, 
      { hex: "#867e4f", name: "5030-Y" }, 
      { hex: "#86794d", name: "5030-Y10R" }, 
      { hex: "#86734c", name: "5030-Y20R" }, 
      { hex: "#866e4a", name: "5030-Y30R" }, 
      { hex: "#866848", name: "5030-Y40R" }, 
      { hex: "#866146", name: "5030-Y50R" }, 
      { hex: "#865b44", name: "5030-Y60R" }, 
      { hex: "#865342", name: "5030-Y70R" }, 
      { hex: "#864c40", name: "5030-Y80R" }, 
      { hex: "#864440", name: "5030-Y90R" }, 
      { hex: "#3c6a86", name: "5040-B" }, 
      { hex: "#3e7486", name: "5040-B10G" }, 
      { hex: "#407a86", name: "5040-B20G" }, 
      { hex: "#418086", name: "5040-B30G" }, 
      { hex: "#428486", name: "5040-B40G" }, 
      { hex: "#428684", name: "5040-B50G" }, 
      { hex: "#418680", name: "5040-B60G" }, 
      { hex: "#40867c", name: "5040-B70G" }, 
      { hex: "#3f8676", name: "5040-B80G" }, 
      { hex: "#3a8664", name: "5040-B90G" }, 
      { hex: "#378656", name: "5040-G" }, 
      { hex: "#4b864d", name: "5040-G10Y" }, 
      { hex: "#598646", name: "5040-G20Y" }, 
      { hex: "#648641", name: "5040-G30Y" }, 
      { hex: "#6e863d", name: "5040-G40Y" }, 
      { hex: "#76863f", name: "5040-G50Y" }, 
      { hex: "#7c8640", name: "5040-G60Y" }, 
      { hex: "#838642", name: "5040-G70Y" }, 
      { hex: "#868442", name: "5040-G80Y" }, 
      { hex: "#867f41", name: "5040-G90Y" }, 
      { hex: "#862e34", name: "5040-R" }, 
      { hex: "#86303a", name: "5040-R10B" }, 
      { hex: "#863243", name: "5040-R20B" }, 
      { hex: "#86354f", name: "5040-R30B" }, 
      { hex: "#863960", name: "5040-R40B" }, 
      { hex: "#863f78", name: "5040-R50B" }, 
      { hex: "#6f3d86", name: "5040-R60B" }, 
      { hex: "#583f86", name: "5040-R70B" }, 
      { hex: "#324186", name: "5040-R80B" }, 
      { hex: "#355086", name: "5040-R90B" }, 
      { hex: "#867c40", name: "5040-Y" }, 
      { hex: "#86753f", name: "5040-Y10R" }, 
      { hex: "#866f3d", name: "5040-Y20R" }, 
      { hex: "#86683b", name: "5040-Y30R" }, 
      { hex: "#866039", name: "5040-Y40R" }, 
      { hex: "#865937", name: "5040-Y50R" }, 
      { hex: "#865135", name: "5040-Y60R" }, 
      { hex: "#864933", name: "5040-Y70R" }, 
      { hex: "#864031", name: "5040-Y80R" }, 
      { hex: "#863732", name: "5040-Y90R" }, 
      { hex: "#377286", name: "5045-B10G" }, 
      { hex: "#727272", name: "5500-N" }, 
      { hex: "#747779", name: "5502-B" }, 
      { hex: "#747976", name: "5502-G" }, 
      { hex: "#797272", name: "5502-R" }, 
      { hex: "#797875", name: "5502-Y" }, 
      { hex: "#366079", name: "5540-B" }, 
      { hex: "#386879", name: "5540-B10G" }, 
      { hex: "#396e79", name: "5540-B20G" }, 
      { hex: "#3b7379", name: "5540-B30G" }, 
      { hex: "#3c7779", name: "5540-B40G" }, 
      { hex: "#3c7977", name: "5540-B50G" }, 
      { hex: "#38796a", name: "5540-B80G" }, 
      { hex: "#34795a", name: "5540-B90G" }, 
      { hex: "#31794d", name: "5540-G" }, 
      { hex: "#437945", name: "5540-G10Y" }, 
      { hex: "#50793f", name: "5540-G20Y" }, 
      { hex: "#5a793b", name: "5540-G30Y" }, 
      { hex: "#637937", name: "5540-G40Y" }, 
      { hex: "#6a7938", name: "5540-G50Y" }, 
      { hex: "#70793a", name: "5540-G60Y" }, 
      { hex: "#76793b", name: "5540-G70Y" }, 
      { hex: "#4f3979", name: "5540-R70B" }, 
      { hex: "#304879", name: "5540-R90B" }, 
      { hex: "#79322d", name: "5540-Y90R" }, 
      { hex: "#666666", name: "6000-N" }, 
      { hex: "#636a6b", name: "6005-B20G" }, 
      { hex: "#626b69", name: "6005-B80G" }, 
      { hex: "#656b63", name: "6005-G20Y" }, 
      { hex: "#696b62", name: "6005-G50Y" }, 
      { hex: "#6b6b63", name: "6005-G80Y" }, 
      { hex: "#6b5f61", name: "6005-R20B" }, 
      { hex: "#6b636a", name: "6005-R50B" }, 
      { hex: "#5f616b", name: "6005-R80B" }, 
      { hex: "#6b6862", name: "6005-Y20R" }, 
      { hex: "#6b6560", name: "6005-Y50R" }, 
      { hex: "#6b615e", name: "6005-Y80R" }, 
      { hex: "#5a676b", name: "6010-B10G" }, 
      { hex: "#5b6a6b", name: "6010-B30G" }, 
      { hex: "#5c6b6b", name: "6010-B50G" }, 
      { hex: "#5b6b69", name: "6010-B70G" }, 
      { hex: "#586b63", name: "6010-B90G" }, 
      { hex: "#5c6b5d", name: "6010-G10Y" }, 
      { hex: "#636b5a", name: "6010-G30Y" }, 
      { hex: "#676b5a", name: "6010-G50Y" }, 
      { hex: "#6a6b5c", name: "6010-G70Y" }, 
      { hex: "#6b6a5b", name: "6010-G90Y" }, 
      { hex: "#6b5356", name: "6010-R10B" }, 
      { hex: "#6b565c", name: "6010-R30B" }, 
      { hex: "#6b5a68", name: "6010-R50B" }, 
      { hex: "#5f596b", name: "6010-R70B" }, 
      { hex: "#565d6b", name: "6010-R90B" }, 
      { hex: "#6b675a", name: "6010-Y10R" }, 
      { hex: "#6b6459", name: "6010-Y30R" }, 
      { hex: "#6b5f57", name: "6010-Y50R" }, 
      { hex: "#6b5a55", name: "6010-Y70R" }, 
      { hex: "#6b5553", name: "6010-Y90R" }, 
      { hex: "#495e6b", name: "6020-B" }, 
      { hex: "#4b636b", name: "6020-B10G" }, 
      { hex: "#4d686b", name: "6020-B30G" }, 
      { hex: "#4d6b6a", name: "6020-B50G" }, 
      { hex: "#4c6b67", name: "6020-B70G" }, 
      { hex: "#486b5b", name: "6020-B90G" }, 
      { hex: "#456b54", name: "6020-G" }, 
      { hex: "#4f6b51", name: "6020-G10Y" }, 
      { hex: "#5c6b4c", name: "6020-G30Y" }, 
      { hex: "#646b4b", name: "6020-G50Y" }, 
      { hex: "#6a6b4d", name: "6020-G70Y" }, 
      { hex: "#6b684d", name: "6020-G90Y" }, 
      { hex: "#6b3f42", name: "6020-R" }, 
      { hex: "#6b4045", name: "6020-R10B" }, 
      { hex: "#6b424a", name: "6020-R20B" }, 
      { hex: "#6b4451", name: "6020-R30B" }, 
      { hex: "#6b4759", name: "6020-R40B" }, 
      { hex: "#6b4c65", name: "6020-R50B" }, 
      { hex: "#614a6b", name: "6020-R60B" }, 
      { hex: "#564a6b", name: "6020-R70B" }, 
      { hex: "#41496b", name: "6020-R80B" }, 
      { hex: "#44516b", name: "6020-R90B" }, 
      { hex: "#6b674c", name: "6020-Y" }, 
      { hex: "#6b644b", name: "6020-Y10R" }, 
      { hex: "#6b614a", name: "6020-Y20R" }, 
      { hex: "#6b5d49", name: "6020-Y30R" }, 
      { hex: "#6b5a47", name: "6020-Y40R" }, 
      { hex: "#6b5646", name: "6020-Y50R" }, 
      { hex: "#6b5245", name: "6020-Y60R" }, 
      { hex: "#6b4d43", name: "6020-Y70R" }, 
      { hex: "#6b4841", name: "6020-Y80R" }, 
      { hex: "#6b4441", name: "6020-Y90R" }, 
      { hex: "#3c596b", name: "6030-B" }, 
      { hex: "#3e606b", name: "6030-B10G" }, 
      { hex: "#40676b", name: "6030-B30G" }, 
      { hex: "#416b6a", name: "6030-B50G" }, 
      { hex: "#3f6b65", name: "6030-B70G" }, 
      { hex: "#3a6b55", name: "6030-B90G" }, 
      { hex: "#376b4c", name: "6030-G" }, 
      { hex: "#456b46", name: "6030-G10Y" }, 
      { hex: "#566b3f", name: "6030-G30Y" }, 
      { hex: "#616b3e", name: "6030-G50Y" }, 
      { hex: "#696b40", name: "6030-G70Y" }, 
      { hex: "#6b6740", name: "6030-G90Y" }, 
      { hex: "#6b3034", name: "6030-R" }, 
      { hex: "#6b3239", name: "6030-R10B" }, 
      { hex: "#6b343f", name: "6030-R20B" }, 
      { hex: "#6b3647", name: "6030-R30B" }, 
      { hex: "#6b3a52", name: "6030-R40B" }, 
      { hex: "#6b3e63", name: "6030-R50B" }, 
      { hex: "#5c3d6b", name: "6030-R60B" }, 
      { hex: "#4d3d6b", name: "6030-R70B" }, 
      { hex: "#333d6b", name: "6030-R80B" }, 
      { hex: "#36486b", name: "6030-R90B" }, 
      { hex: "#6b653f", name: "6030-Y" }, 
      { hex: "#6b613e", name: "6030-Y10R" }, 
      { hex: "#6b5c3d", name: "6030-Y20R" }, 
      { hex: "#6b583b", name: "6030-Y30R" }, 
      { hex: "#6b533a", name: "6030-Y40R" }, 
      { hex: "#6b4e38", name: "6030-Y50R" }, 
      { hex: "#6b4836", name: "6030-Y60R" }, 
      { hex: "#6b4335", name: "6030-Y70R" }, 
      { hex: "#6b3d33", name: "6030-Y80R" }, 
      { hex: "#6b3733", name: "6030-Y90R" }, 
      { hex: "#3a6b67", name: "6035-B60G" }, 
      { hex: "#595959", name: "6500-N" }, 
      { hex: "#5a5d5e", name: "6502-B" }, 
      { hex: "#5a5e5b", name: "6502-G" }, 
      { hex: "#5e5959", name: "6502-R" }, 
      { hex: "#5e5d5b", name: "6502-Y" }, 
      { hex: "#385a5e", name: "6530-B30G" }, 
      { hex: "#395e5d", name: "6530-B50G" }, 
      { hex: "#3c5e3e", name: "6530-G10Y" }, 
      { hex: "#555e36", name: "6530-G50Y" }, 
      { hex: "#4c4c4c", name: "7000-N" }, 
      { hex: "#4a4f50", name: "7005-B20G" }, 
      { hex: "#4a504f", name: "7005-B80G" }, 
      { hex: "#4c504a", name: "7005-G20Y" }, 
      { hex: "#4f504a", name: "7005-G50Y" }, 
      { hex: "#50504a", name: "7005-G80Y" }, 
      { hex: "#504749", name: "7005-R20B" }, 
      { hex: "#504a4f", name: "7005-R50B" }, 
      { hex: "#474950", name: "7005-R80B" }, 
      { hex: "#504e4a", name: "7005-Y20R" }, 
      { hex: "#504c48", name: "7005-Y50R" }, 
      { hex: "#504947", name: "7005-Y80R" }, 
      { hex: "#434d50", name: "7010-B10G" }, 
      { hex: "#444f50", name: "7010-B30G" }, 
      { hex: "#455050", name: "7010-B50G" }, 
      { hex: "#44504f", name: "7010-B70G" }, 
      { hex: "#42504a", name: "7010-B90G" }, 
      { hex: "#455046", name: "7010-G10Y" }, 
      { hex: "#4a5044", name: "7010-G30Y" }, 
      { hex: "#4e5044", name: "7010-G50Y" }, 
      { hex: "#505045", name: "7010-G70Y" }, 
      { hex: "#504f44", name: "7010-G90Y" }, 
      { hex: "#503e40", name: "7010-R10B" }, 
      { hex: "#504045", name: "7010-R30B" }, 
      { hex: "#50444e", name: "7010-R50B" }, 
      { hex: "#484350", name: "7010-R70B" }, 
      { hex: "#404650", name: "7010-R90B" }, 
      { hex: "#504d44", name: "7010-Y10R" }, 
      { hex: "#504b42", name: "7010-Y30R" }, 
      { hex: "#504841", name: "7010-Y50R" }, 
      { hex: "#50443f", name: "7010-Y70R" }, 
      { hex: "#503f3e", name: "7010-Y90R" }, 
      { hex: "#374750", name: "7020-B" }, 
      { hex: "#384a50", name: "7020-B10G" }, 
      { hex: "#3a4e50", name: "7020-B30G" }, 
      { hex: "#3a5050", name: "7020-B50G" }, 
      { hex: "#39504d", name: "7020-B70G" }, 
      { hex: "#365045", name: "7020-B90G" }, 
      { hex: "#34503f", name: "7020-G" }, 
      { hex: "#3c503c", name: "7020-G10Y" }, 
      { hex: "#455039", name: "7020-G30Y" }, 
      { hex: "#4b5038", name: "7020-G50Y" }, 
      { hex: "#4f503a", name: "7020-G70Y" }, 
      { hex: "#504e3a", name: "7020-G90Y" }, 
      { hex: "#502f31", name: "7020-R" }, 
      { hex: "#503034", name: "7020-R10B" }, 
      { hex: "#503138", name: "7020-R20B" }, 
      { hex: "#50333c", name: "7020-R30B" }, 
      { hex: "#503543", name: "7020-R40B" }, 
      { hex: "#50394c", name: "7020-R50B" }, 
      { hex: "#483750", name: "7020-R60B" }, 
      { hex: "#403750", name: "7020-R70B" }, 
      { hex: "#313750", name: "7020-R80B" }, 
      { hex: "#333d50", name: "7020-R90B" }, 
      { hex: "#504d39", name: "7020-Y" }, 
      { hex: "#504b38", name: "7020-Y10R" }, 
      { hex: "#504837", name: "7020-Y20R" }, 
      { hex: "#504637", name: "7020-Y30R" }, 
      { hex: "#504336", name: "7020-Y40R" }, 
      { hex: "#504035", name: "7020-Y50R" }, 
      { hex: "#503d33", name: "7020-Y60R" }, 
      { hex: "#503a32", name: "7020-Y70R" }, 
      { hex: "#503631", name: "7020-Y80R" }, 
      { hex: "#503331", name: "7020-Y90R" }, 
      { hex: "#3f3f3f", name: "7500-N" }, 
      { hex: "#414243", name: "7502-B" }, 
      { hex: "#404341", name: "7502-G" }, 
      { hex: "#433f40", name: "7502-R" }, 
      { hex: "#434341", name: "7502-Y" }, 
      { hex: "#323232", name: "8000-N" }, 
      { hex: "#313536", name: "8005-B20G" }, 
      { hex: "#313635", name: "8005-B80G" }, 
      { hex: "#333632", name: "8005-G20Y" }, 
      { hex: "#353631", name: "8005-G50Y" }, 
      { hex: "#363632", name: "8005-G80Y" }, 
      { hex: "#362f31", name: "8005-R20B" }, 
      { hex: "#363135", name: "8005-R50B" }, 
      { hex: "#2f3036", name: "8005-R80B" }, 
      { hex: "#363431", name: "8005-Y20R" }, 
      { hex: "#363330", name: "8005-Y50R" }, 
      { hex: "#36302f", name: "8005-Y80R" }, 
      { hex: "#2d3336", name: "8010-B10G" }, 
      { hex: "#2e3536", name: "8010-B30G" }, 
      { hex: "#2e3635", name: "8010-B50G" }, 
      { hex: "#2d3634", name: "8010-B70G" }, 
      { hex: "#2c3631", name: "8010-B90G" }, 
      { hex: "#2e362e", name: "8010-G10Y" }, 
      { hex: "#31362d", name: "8010-G30Y" }, 
      { hex: "#34362d", name: "8010-G50Y" }, 
      { hex: "#35362e", name: "8010-G70Y" }, 
      { hex: "#36352e", name: "8010-G90Y" }, 
      { hex: "#36292b", name: "8010-R10B" }, 
      { hex: "#362b2e", name: "8010-R30B" }, 
      { hex: "#362d34", name: "8010-R50B" }, 
      { hex: "#302d36", name: "8010-R70B" }, 
      { hex: "#2b2e36", name: "8010-R90B" }, 
      { hex: "#36342d", name: "8010-Y10R" }, 
      { hex: "#36322c", name: "8010-Y30R" }, 
      { hex: "#36302b", name: "8010-Y50R" }, 
      { hex: "#362d2a", name: "8010-Y70R" }, 
      { hex: "#362a2a", name: "8010-Y90R" }, 
      { hex: "#262626", name: "8500-N" }, 
      { hex: "#272828", name: "8502-B" }, 
      { hex: "#272827", name: "8502-G" }, 
      { hex: "#282626", name: "8502-R" }, 
      { hex: "#282827", name: "8502-Y" }, 
      { hex: "#252828", name: "8505-B20G" }, 
      { hex: "#252828", name: "8505-B80G" }, 
      { hex: "#262825", name: "8505-G20Y" }, 
      { hex: "#282825", name: "8505-G80Y" }, 
      { hex: "#282425", name: "8505-R20B" }, 
      { hex: "#242428", name: "8505-R80B" }, 
      { hex: "#282725", name: "8505-Y20R" }, 
      { hex: "#282423", name: "8505-Y80R" }
    ],
      "farrow-ball": [      { hex: "#E8DEC9", name: "1 - Lime White" }, 
      { hex: "#CEC3AD", name: "15 - Bone" }, 
      { hex: "#D6C39E", name: "16 - Cord" }, 
      { hex: "#B4A693", name: "17 - Light Gray" }, 
      { hex: "#B5B19A", name: "18 - French Gray" }, 
      { hex: "#A1A189", name: "19 - Lichen" }, 
      { hex: "#E5E0DB", name: "2001 - Strong White" }, 
      { hex: "#F5ECD9", name: "2002 - White Tie" }, 
      { hex: "#F7F1E3", name: "2003 - Pointing" }, 
      { hex: "#E8E0D1", name: "2004 - Slipper Satin" }, 
      { hex: "#FBF8F4", name: "2005 - All White" }, 
      { hex: "#E7DEDB", name: "2006 - Great White" }, 
      { hex: "#EEE3D3", name: "2008 - Dimity" }, 
      { hex: "#D9D2C1", name: "201 - Shaded White" }, 
      { hex: "#EDE9D8", name: "2010 - James White" }, 
      { hex: "#DDDBD9", name: "2011 - Blackened" }, 
      { hex: "#F1E6C8", name: "2012 - House White" }, 
      { hex: "#E4D5BC", name: "2013 - Matchstick" }, 
      { hex: "#EFD6C7", name: "202 - Pink Ground" }, 
      { hex: "#FDEDD7", name: "203 - Tallow" }, 
      { hex: "#D9DCD2", name: "204 - Pale Powder" }, 
      { hex: "#CCD0CD", name: "205 - Skylight" }, 
      { hex: "#DBDAB6", name: "206 - Green Ground" }, 
      { hex: "#A1C5C8", name: "210 - Blue Ground" }, 
      { hex: "#CEC1AD", name: "211 - Stony Ground" }, 
      { hex: "#B64F48", name: "212 - Blazer" }, 
      { hex: "#D8C4A8", name: "213 - Savage Ground" }, 
      { hex: "#84B59C", name: "214 - Arsenic" }, 
      { hex: "#A53C49", name: "217 - Rectory Red" }, 
      { hex: "#F2CF86", name: "218 - Yellow Ground" }, 
      { hex: "#B8BCB5", name: "22 - Light Blue" }, 
      { hex: "#636E8F", name: "220 - Pitch Blue" }, 
      { hex: "#5D3B42", name: "222 - Brinjal" }, 
      { hex: "#ECC363", name: "223 - Babouche" }, 
      { hex: "#DECFB9", name: "226 - Joa's White" }, 
      { hex: "#D1CBC3", name: "228 - Cornforth White" }, 
      { hex: "#CCBFB3", name: "229 - Elephant's Breath" }, 
      { hex: "#E6D1CB", name: "230 - Calamine" }, 
      { hex: "#DFC2AF", name: "231 - Setting Plaster" }, 
      { hex: "#F7E29D", name: "233 - Dayroom Yellow" }, 
      { hex: "#BABBA5", name: "234 - Vert de Terre" }, 
      { hex: "#D5DBDB", name: "235 - Borrowed Light" }, 
      { hex: "#C0CDC2", name: "236 - Teresa's Green" }, 
      { hex: "#6A90B4", name: "237 - Cook's Blue" }, 
      { hex: "#F7F3E8", name: "239 - Wimborne White" }, 
      { hex: "#DFD6CB", name: "241 - Skimming Stone" }, 
      { hex: "#C8C3BC", name: "242 - Pavilion Gray" }, 
      { hex: "#9F9389", name: "243 - Charleston Gray" }, 
      { hex: "#786963", name: "244 - London Clay" }, 
      { hex: "#FDE7E5", name: "245 - Middleton Pink" }, 
      { hex: "#C7A4A6", name: "246 - Cinder Rose" }, 
      { hex: "#A04344", name: "248 - Incarnadine" }, 
      { hex: "#A1A093", name: "25 - Pigeon" }, 
      { hex: "#C8BD83", name: "251 - Churlish Green" }, 
      { hex: "#E5E7DC", name: "252 - Pavilion Blue" }, 
      { hex: "#50414C", name: "254 - Pelt" }, 
      { hex: "#4D4746", name: "255 - Tanner's Brown" }, 
      { hex: "#3B3938", name: "256 - Pitch Black" }, 
      { hex: "#626664", name: "26 - Down Pipe" }, 
      { hex: "#D6C2AC", name: "264 - Oxford Stone" }, 
      { hex: "#A2A29D", name: "265 - Manor House Gray" }, 
      { hex: "#C0C2B3", name: "266 - Mizzle" }, 
      { hex: "#BBB1AB", name: "267 - Dove Tale" }, 
      { hex: "#D65F3D", name: "268 - Charlotte's Locks" }, 
      { hex: "#E8EEEA", name: "269 - Cabbage White" }, 
      { hex: "#B2BFC5", name: "27 - Parma Gray" }, 
      { hex: "#CCC8CE", name: "270 - Calluna" }, 
      { hex: "#8D8089", name: "271 - Brassica" }, 
      { hex: "#8D8D8B", name: "272 - Plummett" }, 
      { hex: "#EEE9E7", name: "273 - Wevet" }, 
      { hex: "#DDD8CF", name: "274 - Ammonite" }, 
      { hex: "#C4BEB4", name: "275 - Purbeck Stone" }, 
      { hex: "#8B857F", name: "276 - Mole's Breath" }, 
      { hex: "#D9D8D3", name: "277 - Dimpse" }, 
      { hex: "#ECB7B8", name: "278 - Nancy's Blushes" }, 
      { hex: "#B49D8D", name: "28 - Dead Salmon" }, 
      { hex: "#599EC4", name: "280 - St Giles Blue" }, 
      { hex: "#4D5B6A", name: "281 - Stiffkey Blue" }, 
      { hex: "#DED8C6", name: "282 - Shadow White" }, 
      { hex: "#C9BEAB", name: "283 - Drop Cloth" }, 
      { hex: "#D3CFCD", name: "284 - Worsted" }, 
      { hex: "#CFCEC0", name: "285 - Cromarty" }, 
      { hex: "#D6C8C3", name: "286 - Peignoir" }, 
      { hex: "#919F70", name: "287 - Yeabridge Green" }, 
      { hex: "#427E83", name: "288 - Vardo" }, 
      { hex: "#586768", name: "289 - Inchyra Blue" }, 
      { hex: "#726454", name: "290 - Salon Drab" }, 
      { hex: "#E6DFD1", name: "291 - School House White" }, 
      { hex: "#8B8A77", name: "292 - Treron" }, 
      { hex: "#C4B2A2", name: "293 - Jitney" }, 
      { hex: "#494248", name: "294 - Paean Black" }, 
      { hex: "#A0837F", name: "295 - Sulking Room Pink" }, 
      { hex: "#BF7A8F", name: "296 - Rangwali" }, 
      { hex: "#6D4247", name: "297 - Preference Red" }, 
      { hex: "#686A47", name: "298 - Bancha" }, 
      { hex: "#6A7C80", name: "299 - De Nimes" }, 
      { hex: "#E0D5BE", name: "3 - Off-White" }, 
      { hex: "#3D4E57", name: "30 - Hague Blue" }, 
      { hex: "#45484B", name: "31 - Railings" }, 
      { hex: "#C4C6A5", name: "32 - Cooking Apple Green" }, 
      { hex: "#768769", name: "34 - Calke Green" }, 
      { hex: "#534644", name: "36 - Mahogany" }, 
      { hex: "#DFC795", name: "37 - Hay" }, 
      { hex: "#CFC3AD", name: "4 - Old White" }, 
      { hex: "#998976", name: "40 - Mouse's Back" }, 
      { hex: "#A15A4D", name: "42 - Picture Gallery Red" }, 
      { hex: "#8F4E4D", name: "43 - Eating Room Red" }, 
      { hex: "#737C70", name: "47 - Green Smoke" }, 
      { hex: "#B5AFA0", name: "5 - Hardwick White" }, 
      { hex: "#DCB771", name: "51 - Sudbury Yellow" }, 
      { hex: "#444546", name: "57 - Off-Black" }, 
      { hex: "#F5E8D0", name: "59 - New White" }, 
      { hex: "#B6A38F", name: "6 - London Stone" }, 
      { hex: "#C57B67", name: "64 - Red Earth" }, 
      { hex: "#CB9E59", name: "66 - India Yellow" }, 
      { hex: "#EFDBB3", name: "67 - Farrow's Cream" }, 
      { hex: "#EFD5A1", name: "68 - Dorset Cream" }, 
      { hex: "#EADFB7", name: "71 - Pale Hound" }, 
      { hex: "#F5D27B", name: "74 - Citron" }, 
      { hex: "#BCB596", name: "75 - Ball Green" }, 
      { hex: "#899081", name: "79 - Card Room Green" }, 
      { hex: "#DDCDAE", name: "8 - String" }, 
      { hex: "#94A68A", name: "81 - Breakfast Room Green" }, 
      { hex: "#99B0AB", name: "82 - Dix Blue" }, 
      { hex: "#ADBDB2", name: "84 - Green Blue" }, 
      { hex: "#8B9D9B", name: "85 - Oval Room Blue" }, 
      { hex: "#7997A1", name: "86 - Stone Blue" }, 
      { hex: "#B2B1A9", name: "88 - Lamp Room Gray" }, 
      { hex: "#A1B8CA", name: "89 - Lulworth Blue" }, 
      { hex: "#B4B4A3", name: "91 - Blue Gray" }, 
      { hex: "#464C49", name: "93 - Studio Green" }, 
      { hex: "#994A50", name: "96 - Radicchio" }
    ],
      "ppg": [      { hex: "#F1F2EE", name: "1001-1 Delicate White" }, 
      { hex: "#E3E4E2", name: "1001-2 Aria" }, 
      { hex: "#D9DCDB", name: "1001-3 Thin Ice" }, 
      { hex: "#ACADAD", name: "1001-4 Flagstone" }, 
      { hex: "#848585", name: "1001-5 Dover Gray" }, 
      { hex: "#5C5D5D", name: "1001-6 Knight's Armor" }, 
      { hex: "#414040", name: "1001-7 Black Magic" }, 
      { hex: "#EDEBE7", name: "1002-1 Silver Feather" }, 
      { hex: "#E6E3DF", name: "1002-2 Arctic Cotton" }, 
      { hex: "#D0CCC5", name: "1002-3 Cool Slate" }, 
      { hex: "#B9B4B1", name: "1002-4 Gray Marble" }, 
      { hex: "#918E8C", name: "1002-5 Antique Silver" }, 
      { hex: "#6F6A68", name: "1002-6 Gibraltar Gray" }, 
      { hex: "#4B4441", name: "1002-7 Phantom Mist" }, 
      { hex: "#E1DDDB", name: "1003-1 Fall Chill" }, 
      { hex: "#D7D2D1", name: "1003-2 Balanced" }, 
      { hex: "#B8B4B6", name: "1003-3 Silver Bells" }, 
      { hex: "#A49F9F", name: "1003-4 Equilibrium" }, 
      { hex: "#908B8E", name: "1003-5 Shining Armor" }, 
      { hex: "#69656A", name: "1003-6 Cracked Slate" }, 
      { hex: "#49454B", name: "1003-7 Blackhearth" }, 
      { hex: "#DCD8D7", name: "1004-1 Go To Gray" }, 
      { hex: "#D1CDCA", name: "1004-2 Free Reign" }, 
      { hex: "#C4BDBA", name: "1004-3 Hush" }, 
      { hex: "#B2AAAA", name: "1004-4 Silver Service" }, 
      { hex: "#8B8283", name: "1004-5 Pewter Mug" }, 
      { hex: "#645D5E", name: "1004-6 Phantom Hue" }, 
      { hex: "#50484A", name: "1004-7 Black Elegance" }, 
      { hex: "#E5E1DE", name: "1005-1 Dusky Dawn" }, 
      { hex: "#D2CFCC", name: "1005-2 Elusion" }, 
      { hex: "#C2BDBA", name: "1005-3 Gray Shadows" }, 
      { hex: "#B4ADA9", name: "1005-4 Slate Pebble" }, 
      { hex: "#8D847F", name: "1005-5 Elephant Gray" }, 
      { hex: "#665D59", name: "1005-6 Oswego Tea" }, 
      { hex: "#4F443F", name: "1005-7 Dark Granite" }, 
      { hex: "#EEEDE4", name: "1006-1 Gypsum" }, 
      { hex: "#DFDCD5", name: "1006-2 Shark" }, 
      { hex: "#CAC7BF", name: "1006-3 Early Evening" }, 
      { hex: "#B6B0A9", name: "1006-4 Mercurial" }, 
      { hex: "#8B847C", name: "1006-5 So Sublime" }, 
      { hex: "#7B736B", name: "1006-6 Deconstruction" }, 
      { hex: "#61584F", name: "1006-7 Metropolis" }, 
      { hex: "#E7E6E0", name: "1007-1 Willow Springs" }, 
      { hex: "#CECAC1", name: "1007-2 Swirling Smoke" }, 
      { hex: "#BCB7AD", name: "1007-3 Ghost Writer" }, 
      { hex: "#ABA89E", name: "1007-4 Hot Stone" }, 
      { hex: "#97928B", name: "1007-5 Lazy Afternoon" }, 
      { hex: "#807B76", name: "1007-6 Cool Charcoal" }, 
      { hex: "#5F5854", name: "1007-7 Bark" }, 
      { hex: "#E5E0D2", name: "1008-1 Focus" }, 
      { hex: "#CFC9BC", name: "1008-2 Storm's Coming" }, 
      { hex: "#B2ACA2", name: "1008-3 Greyhound" }, 
      { hex: "#A1988B", name: "1008-4 Gray By Me" }, 
      { hex: "#8C8578", name: "1008-5 Roller Coaster" }, 
      { hex: "#746F67", name: "1008-6 Artillery" }, 
      { hex: "#605C58", name: "1008-7 Stone's Throw" }, 
      { hex: "#E1E1DB", name: "1009-1 Tundra Frost" }, 
      { hex: "#D1D3CF", name: "1009-2 Tornado" }, 
      { hex: "#C4C7C4", name: "1009-3 Solitary State" }, 
      { hex: "#B7B9B5", name: "1009-4 Gray Stone" }, 
      { hex: "#8E908D", name: "1009-5 Phoenix Fossil" }, 
      { hex: "#6A6B65", name: "1009-6 Armory" }, 
      { hex: "#4E4F48", name: "1009-7 Licorice" }, 
      { hex: "#E8E9E4", name: "1010-1 Pegasus" }, 
      { hex: "#D6D7D2", name: "1010-2 Fog" }, 
      { hex: "#BABDB8", name: "1010-3 Solstice" }, 
      { hex: "#A4A7A4", name: "1010-4 Stepping Stone" }, 
      { hex: "#898A86", name: "1010-5 Downpour" }, 
      { hex: "#6E706D", name: "1010-6 Up In Smoke" }, 
      { hex: "#595A5C", name: "1010-7 Zombie" }, 
      { hex: "#E8EAE6", name: "1011-1 Pacific Pearl" }, 
      { hex: "#D0D3D3", name: "1011-2 Elemental" }, 
      { hex: "#AFB4B6", name: "1011-3 Stargazer" }, 
      { hex: "#989FA3", name: "1011-4 Ufo" }, 
      { hex: "#6E7376", name: "1011-5 Improbable" }, 
      { hex: "#5B5E61", name: "1011-6 Glazed Granite" }, 
      { hex: "#464544", name: "1011-7 Onyx" }, 
      { hex: "#E0E5E2", name: "1012-1 Icy Bay" }, 
      { hex: "#DCE3E2", name: "1012-2 Inverness Gray" }, 
      { hex: "#D2D9DB", name: "1012-3 Tinsel" }, 
      { hex: "#B8BFC2", name: "1012-4 Gray Frost" }, 
      { hex: "#8E9598", name: "1012-5 Steeple Gray" }, 
      { hex: "#6F7678", name: "1012-6 Volcanic Ash" }, 
      { hex: "#434B4F", name: "1012-7 Black Forest" }, 
      { hex: "#E5E7E6", name: "1013-1 Radisson" }, 
      { hex: "#D9DCDD", name: "1013-2 Spring Thaw" }, 
      { hex: "#BEC0C2", name: "1013-3 Whirlwind" }, 
      { hex: "#ADB0B4", name: "1013-4 Silver Charm" }, 
      { hex: "#828388", name: "1013-5 Victorian Pewter" }, 
      { hex: "#585960", name: "1013-6 Gray Flannel" }, 
      { hex: "#404149", name: "1013-7 Napoleon" }, 
      { hex: "#EAE9E7", name: "1014-1 Glacial Ice" }, 
      { hex: "#E6E4E4", name: "1014-2 Gray Whisper" }, 
      { hex: "#E0DDDD", name: "1014-3 Silver Screen" }, 
      { hex: "#C0B2B1", name: "1014-4 Jack Rabbit" }, 
      { hex: "#9B8E8E", name: "1014-5 Gray Violet" }, 
      { hex: "#736665", name: "1014-6 Eagle Eye" }, 
      { hex: "#554747", name: "1014-7 Black Walnut" }, 
      { hex: "#F1ECE2", name: "1015-1 Vanilla Milkshake" }, 
      { hex: "#ECE4DC", name: "1015-2 Stone Quarry" }, 
      { hex: "#E6D7CC", name: "1015-3 Warmstone" }, 
      { hex: "#CCB8B3", name: "1015-4 Subdued" }, 
      { hex: "#A49491", name: "1015-5 Heliotrope" }, 
      { hex: "#816F6B", name: "1015-6 Granite Boulder" }, 
      { hex: "#5E4A47", name: "1015-7 Mustang" }, 
      { hex: "#EBDED7", name: "1016-1 Berry Frost" }, 
      { hex: "#E6D5CE", name: "1016-2 Blossom Pink" }, 
      { hex: "#DCC7C0", name: "1016-3 Cheerful Heart" }, 
      { hex: "#D2BBB2", name: "1016-4 Forever Fairytale" }, 
      { hex: "#B39B94", name: "1016-5 Iris Mauve" }, 
      { hex: "#8E746C", name: "1016-6 Woodchuck" }, 
      { hex: "#664942", name: "1016-7 Spiced Wine" }, 
      { hex: "#ECDFD8", name: "1017-1 Touchable" }, 
      { hex: "#D9CAC3", name: "1017-2 First Kiss" }, 
      { hex: "#C8BCB7", name: "1017-3 Fond Memory" }, 
      { hex: "#B7A9A2", name: "1017-4 Riveter Rose" }, 
      { hex: "#8D7D77", name: "1017-5 Cinnamon Toast" }, 
      { hex: "#796660", name: "1017-6 Bold Brandy" }, 
      { hex: "#60504B", name: "1017-7 Chocolate Pretzel" }, 
      { hex: "#DDD5CE", name: "1018-1 Steel Me" }, 
      { hex: "#D4CBC4", name: "1018-2 My Alibi" }, 
      { hex: "#BAB2AB", name: "1018-3 City Street" }, 
      { hex: "#A99F97", name: "1018-4 Winter's Nap" }, 
      { hex: "#A0928B", name: "1018-5 Talavera" }, 
      { hex: "#7F726B", name: "1018-6 Flipper" }, 
      { hex: "#5B4C44", name: "1018-7 Sarsaparilla" }, 
      { hex: "#EAE1D6", name: "1019-1 Toasted Marshmallow" }, 
      { hex: "#D6CBBF", name: "1019-2 In The Buff" }, 
      { hex: "#C6BAAF", name: "1019-3 Legendary" }, 
      { hex: "#A99F96", name: "1019-4 Simmering Smoke" }, 
      { hex: "#91857C", name: "1019-5 Wild Wilderness" }, 
      { hex: "#80736A", name: "1019-6 Tattle Tail" }, 
      { hex: "#635951", name: "1019-7 Intrigue" }, 
      { hex: "#F1EEE4", name: "1020-1 Atrium White" }, 
      { hex: "#E2D8CB", name: "1020-2 Maybe Mushroom" }, 
      { hex: "#CEC1B5", name: "1020-3 Whippet" }, 
      { hex: "#B7A696", name: "1020-4 El Capitan" }, 
      { hex: "#A6978A", name: "1020-5 Earl Gray" }, 
      { hex: "#847567", name: "1020-6 Wicker Basket" }, 
      { hex: "#63584C", name: "1020-7 Monkey Madness" }, 
      { hex: "#E8E3DB", name: "1021-1 Mountain Gray" }, 
      { hex: "#CFC5B6", name: "1021-2 Synchronicity" }, 
      { hex: "#BDB0A0", name: "1021-3 Discover" }, 
      { hex: "#A99A89", name: "1021-4 Diversion" }, 
      { hex: "#8C7B6C", name: "1021-5 Thunderbird" }, 
      { hex: "#766859", name: "1021-6 Curlew" }, 
      { hex: "#5E5349", name: "1021-7 Cabin Fever" }, 
      { hex: "#E5E0D5", name: "1022-1 Hourglass" }, 
      { hex: "#CFC6BC", name: "1022-2 Intuitive" }, 
      { hex: "#BDB6AE", name: "1022-3 Silver Dollar" }, 
      { hex: "#A1968C", name: "1022-4 Rock Slide" }, 
      { hex: "#998E83", name: "1022-5 Eiffel Tower" }, 
      { hex: "#746A5E", name: "1022-6 Granite" }, 
      { hex: "#5C5042", name: "1022-7 Star Anise" }, 
      { hex: "#E7E3D6", name: "1023-1 Oatmeal" }, 
      { hex: "#D9D0C1", name: "1023-2 Cool Concrete" }, 
      { hex: "#C9BFB2", name: "1023-3 Ashen" }, 
      { hex: "#B5AB9C", name: "1023-4 Desert Dune" }, 
      { hex: "#9F9484", name: "1023-5 Stone Gray" }, 
      { hex: "#827566", name: "1023-6 Clam Shell" }, 
      { hex: "#594E40", name: "1023-7 Afternoon Tea" }, 
      { hex: "#E8E4D6", name: "1024-1 Off White" }, 
      { hex: "#E1DACA", name: "1024-2 Antique White" }, 
      { hex: "#D8CFBE", name: "1024-3 Crushed Silk" }, 
      { hex: "#D1C9BA", name: "1024-4 Moth Gray" }, 
      { hex: "#A79D8D", name: "1024-5 Stonehenge Greige" }, 
      { hex: "#8A7D6B", name: "1024-6 Patches" }, 
      { hex: "#5E5241", name: "1024-7 Friar's Brown" }, 
      { hex: "#EDECE6", name: "1025-1 Commercial White" }, 
      { hex: "#DBD7CE", name: "1025-2 Silent Smoke" }, 
      { hex: "#D1CCC2", name: "1025-3 Whiskers" }, 
      { hex: "#B1AA9C", name: "1025-4 Sharkskin" }, 
      { hex: "#8C8475", name: "1025-5 Dark Ash" }, 
      { hex: "#786D5E", name: "1025-6 Sleeping Giant" }, 
      { hex: "#615544", name: "1025-7 Coffee Bean" }, 
      { hex: "#E1D8BB", name: "1026-1 Namaste" }, 
      { hex: "#D4C9A6", name: "1026-2 Sanctuary" }, 
      { hex: "#BEB394", name: "1026-3 Easy" }, 
      { hex: "#B2A484", name: "1026-4 Karma" }, 
      { hex: "#A29371", name: "1026-5 Gristmill" }, 
      { hex: "#8E8062", name: "1026-6 Hindu Lotus" }, 
      { hex: "#746A51", name: "1026-7 Hip Waders" }, 
      { hex: "#DEDBCC", name: "1027-1 Cocoon" }, 
      { hex: "#D0CBB6", name: "1027-2 Skipping Stone" }, 
      { hex: "#BEB9A2", name: "1027-3 Heavy Hammock" }, 
      { hex: "#AFA78D", name: "1027-4 Olive Gray" }, 
      { hex: "#8F876B", name: "1027-5 Rattan Palm" }, 
      { hex: "#796E54", name: "1027-6 Conservation" }, 
      { hex: "#5F563F", name: "1027-7 Grapevine" }, 
      { hex: "#E5E7D5", name: "1028-1 Hint Of Pine" }, 
      { hex: "#D1D1BB", name: "1028-2 With A Twist" }, 
      { hex: "#B7B8A5", name: "1028-3 Pine Crush" }, 
      { hex: "#A1A18F", name: "1028-4 Smoky Slate" }, 
      { hex: "#817F6E", name: "1028-5 Autumn Gray" }, 
      { hex: "#746F5C", name: "1028-6 Momentum" }, 
      { hex: "#5C5644", name: "1028-7 Walnut Grove" }, 
      { hex: "#E6E5DC", name: "1029-1 Silvery Moon" }, 
      { hex: "#DAD8C9", name: "1029-2 Veil Of Dusk" }, 
      { hex: "#CAC8B6", name: "1029-3 French Gray Linen" }, 
      { hex: "#AEAD96", name: "1029-4 Photo Gray" }, 
      { hex: "#8F8C79", name: "1029-5 Meander" }, 
      { hex: "#747261", name: "1029-6 Organic" }, 
      { hex: "#656457", name: "1029-7 Plunge Pool" }, 
      { hex: "#D1D3C0", name: "1030-1 Brainstorm" }, 
      { hex: "#C3C7B2", name: "1030-2 Pale Pine" }, 
      { hex: "#B1B7A1", name: "1030-3 Mellow Mood" }, 
      { hex: "#9CA389", name: "1030-4 Edamame" }, 
      { hex: "#8E9074", name: "1030-5 Mesmerize" }, 
      { hex: "#76745D", name: "1030-6 Positively Palm" }, 
      { hex: "#686858", name: "1030-7 Double Duty" }, 
      { hex: "#CCCCBA", name: "1031-1 Mix Or Match" }, 
      { hex: "#BEC0B0", name: "1031-2 Misty Meadow" }, 
      { hex: "#A6A897", name: "1031-3 Wandering Willow" }, 
      { hex: "#939581", name: "1031-4 Restoration" }, 
      { hex: "#84846F", name: "1031-5 Seaweed Wrap" }, 
      { hex: "#666556", name: "1031-6 Nevergreen" }, 
      { hex: "#5B5A4D", name: "1031-7 Osiris" }, 
      { hex: "#CDCCBE", name: "1032-1 Metallic Mist" }, 
      { hex: "#BDBBAD", name: "1032-2 Hurricane Haze" }, 
      { hex: "#AEAB9A", name: "1032-3 Olive It" }, 
      { hex: "#979381", name: "1032-4 Sylvan" }, 
      { hex: "#84816F", name: "1032-5 Tortuga" }, 
      { hex: "#706D5E", name: "1032-6 King's Court" }, 
      { hex: "#5E5B4D", name: "1032-7 Moss Rock" }, 
      { hex: "#DDE2D7", name: "1033-1 Salty Breeze" }, 
      { hex: "#D9DCD1", name: "1033-2 Wayward Willow" }, 
      { hex: "#C3C7BD", name: "1033-3 Silent Storm" }, 
      { hex: "#A7AEA5", name: "1033-4 Light Drizzle" }, 
      { hex: "#89928A", name: "1033-5 Gray Heron" }, 
      { hex: "#646C64", name: "1033-6 Gunmetal Gray" }, 
      { hex: "#474F43", name: "1033-7 Charcoal Smoke" }, 
      { hex: "#E4ECE9", name: "1034-1 Morning Song" }, 
      { hex: "#DFEBE9", name: "1034-2 Honesty" }, 
      { hex: "#D5E1E0", name: "1034-3 Pristine Petal" }, 
      { hex: "#B5C8C9", name: "1034-4 Misty Surf" }, 
      { hex: "#8C9FA0", name: "1034-5 Aqua Smoke" }, 
      { hex: "#6B7F81", name: "1034-6 Blue Blood" }, 
      { hex: "#3B5257", name: "1034-7 Mountain Pine" }, 
      { hex: "#CFDFDD", name: "1035-1 Watery Blue" }, 
      { hex: "#C6D6D7", name: "1035-2 Sky Diving" }, 
      { hex: "#A0B7BA", name: "1035-3 Blue By You" }, 
      { hex: "#89A0A6", name: "1035-4 Symphony Of Blue" }, 
      { hex: "#6A8389", name: "1035-5 Puddle Jumper" }, 
      { hex: "#5B6E74", name: "1035-6 Superstition" }, 
      { hex: "#445055", name: "1035-7 Obsidian" }, 
      { hex: "#E0E4E2", name: "1036-1 Gray Glimpse" }, 
      { hex: "#C9D2D1", name: "1036-2 Winter Chill" }, 
      { hex: "#AAB5B7", name: "1036-3 Nautical Star" }, 
      { hex: "#919FA1", name: "1036-4 After The Storm" }, 
      { hex: "#7A8687", name: "1036-5 Rough Ride" }, 
      { hex: "#6E797B", name: "1036-6 Phantom" }, 
      { hex: "#575E5F", name: "1036-7 Mostly Metal" }, 
      { hex: "#D5DCDC", name: "1037-1 Sea Frost" }, 
      { hex: "#C9D3D3", name: "1037-2 Sky Splash" }, 
      { hex: "#A5B2B7", name: "1037-3 Special Delivery" }, 
      { hex: "#8FA0A7", name: "1037-4 Symmetry" }, 
      { hex: "#66787E", name: "1037-5 Night Rendezvous" }, 
      { hex: "#535E63", name: "1037-6 Mysterious" }, 
      { hex: "#474C50", name: "1037-7 Witchcraft" }, 
      { hex: "#E3E9E8", name: "1038-1 Evening Mist" }, 
      { hex: "#DDE4E3", name: "1038-2 Dewdrop" }, 
      { hex: "#D4DDDD", name: "1038-3 Winter's Breath" }, 
      { hex: "#ADB6B9", name: "1038-4 Smoke Screen" }, 
      { hex: "#858F94", name: "1038-5 Feldspar" }, 
      { hex: "#5E686D", name: "1038-6 Lava Gray" }, 
      { hex: "#3B484F", name: "1038-7 Midnight Hour" }, 
      { hex: "#CBD1D0", name: "1039-1 Ghost Whisperer" }, 
      { hex: "#B9C0C0", name: "1039-2 Maiden Mist " }, 
      { hex: "#A8B0B2", name: "1039-3 Mirror Mirror" }, 
      { hex: "#8F989D", name: "1039-4 Pachyderm" }, 
      { hex: "#7B8588", name: "1039-5 Garrison Gray" }, 
      { hex: "#656E72", name: "1039-6 In The Shadows" }, 
      { hex: "#445056", name: "1039-7 High Salute" }, 
      { hex: "#CFD9DE", name: "1040-1 Zen" }, 
      { hex: "#C0CED6", name: "1040-2 Keepsakes" }, 
      { hex: "#B0BEC5", name: "1040-3 Ocean Drive" }, 
      { hex: "#A0AEB8", name: "1040-4 How Handsome" }, 
      { hex: "#8D9CA7", name: "1040-5 Lost At Sea" }, 
      { hex: "#657682", name: "1040-6 Freedom Found" }, 
      { hex: "#525E68", name: "1040-7 Goblin" }, 
      { hex: "#EAEEEC", name: "1041-1 Moonlit Snow" }, 
      { hex: "#DFE6EA", name: "1041-2 City Lights" }, 
      { hex: "#D8DEE3", name: "1041-3 Billowing Clouds" }, 
      { hex: "#BCC5CF", name: "1041-4 Blue Dolphin" }, 
      { hex: "#939FA9", name: "1041-5 Quicksilver" }, 
      { hex: "#6B7680", name: "1041-6 Sheffield Gray" }, 
      { hex: "#3F4C5A", name: "1041-7 Cavalry" }, 
      { hex: "#E4EAED", name: "1042-1 Calla Lily" }, 
      { hex: "#E1E6EB", name: "1042-2 Winter Haven" }, 
      { hex: "#D4DDE2", name: "1042-3 Ocean Dream" }, 
      { hex: "#ABB5C4", name: "1042-4 Blue Beard" }, 
      { hex: "#818B9C", name: "1042-5 Prophetic Sea" }, 
      { hex: "#5B6676", name: "1042-6 Blue Zephyr" }, 
      { hex: "#404E61", name: "1042-7 Admiralty" }, 
      { hex: "#E8E9E9", name: "1043-1 Snowbank" }, 
      { hex: "#E1E1E2", name: "1043-2 Moondance" }, 
      { hex: "#DEDFE2", name: "1043-3 Wayward Winds" }, 
      { hex: "#B1B3BE", name: "1043-4 Glistening Gray" }, 
      { hex: "#8B8D98", name: "1043-5 Flannel Pajamas" }, 
      { hex: "#656874", name: "1043-6 Alley Cat" }, 
      { hex: "#484B5A", name: "1043-7 Black Flame" }, 
      { hex: "#F1EBEA", name: "1044-1 Love Bird" }, 
      { hex: "#EADDE1", name: "1044-2 Mauve Wisp" }, 
      { hex: "#E1C8D1", name: "1044-3 Tinted Rosewood" }, 
      { hex: "#D6B3C0", name: "1044-4 Mauvelous" }, 
      { hex: "#C28BA1", name: "1044-5 Winsome Rose" }, 
      { hex: "#A5647E", name: "1044-6 Wild Strawberry" }, 
      { hex: "#83455D", name: "1044-7 Wild Plum" }, 
      { hex: "#F0EEEB", name: "1045-1 Magical Moonlight" }, 
      { hex: "#EDE0E3", name: "1045-2 Barely Rose" }, 
      { hex: "#E3D0D5", name: "1045-3 Santolina Blooms" }, 
      { hex: "#CEAEBB", name: "1045-4 Pink Potion" }, 
      { hex: "#B08693", name: "1045-5 Keepsake Rose" }, 
      { hex: "#986A79", name: "1045-6 Wild Geranium" }, 
      { hex: "#6D4052", name: "1045-7 Chilled Wine" }, 
      { hex: "#E9E1DF", name: "1046-1 Milk And Cookies" }, 
      { hex: "#E9DBE0", name: "1046-2 Magic Moments" }, 
      { hex: "#D8C2CA", name: "1046-3 Old Mission Pink" }, 
      { hex: "#CAB7C0", name: "1046-4 High Society" }, 
      { hex: "#A38B93", name: "1046-5 Gothic Amethyst" }, 
      { hex: "#846C76", name: "1046-6 Velvet Slipper" }, 
      { hex: "#5C4450", name: "1046-7 Purple Basil" }, 
      { hex: "#EFE6E1", name: "1047-1 Forever Faithful" }, 
      { hex: "#E5D7D4", name: "1047-2 Lost Love" }, 
      { hex: "#D6C4C1", name: "1047-3 Just Gorgeous" }, 
      { hex: "#D0C1C3", name: "1047-4 Ancestral" }, 
      { hex: "#AB9B9C", name: "1047-5 Coffee Custard" }, 
      { hex: "#867578", name: "1047-6 Choo Choo" }, 
      { hex: "#5A484B", name: "1047-7 Carob Chip" }, 
      { hex: "#EFEAE7", name: "1048-1 Lauren's Lace" }, 
      { hex: "#EFDDDF", name: "1048-2 Silk Sheets" }, 
      { hex: "#E2C9CE", name: "1048-3 Rose Cloud" }, 
      { hex: "#D3B6BA", name: "1048-4 Rose Stain" }, 
      { hex: "#A9898D", name: "1048-5 Coffee Rose" }, 
      { hex: "#8C6C6F", name: "1048-6 Chocolate Sparkle" }, 
      { hex: "#604046", name: "1048-7 Gooseberry" }, 
      { hex: "#F1EEEB", name: "1049-1 Snowy Mount" }, 
      { hex: "#EEDADD", name: "1049-2 Sweet Bianca" }, 
      { hex: "#D6B8BD", name: "1049-3 Nostalgia" }, 
      { hex: "#C7A1A9", name: "1049-4 Lighthearted Rose" }, 
      { hex: "#AA7982", name: "1049-5 Mauve Madness" }, 
      { hex: "#8E5B68", name: "1049-6 Cabernet" }, 
      { hex: "#71424A", name: "1049-7 Red Red Wine" }, 
      { hex: "#F2E7E7", name: "1050-1 Bare Pink" }, 
      { hex: "#EACED4", name: "1050-2 Pink Pail" }, 
      { hex: "#E1B9C2", name: "1050-3 Love In A Mist" }, 
      { hex: "#D194A1", name: "1050-4 Madagascar Pink" }, 
      { hex: "#C07281", name: "1050-5 Briar Rose" }, 
      { hex: "#A9586C", name: "1050-6 Heart's Content" }, 
      { hex: "#953D55", name: "1050-7 Magenta" }, 
      { hex: "#F2DDD8", name: "1051-1 Cozy Cottage" }, 
      { hex: "#ECC9CA", name: "1051-2 Pink Cardoon" }, 
      { hex: "#E9B3B4", name: "1051-3 Strawberry Mousse" }, 
      { hex: "#D99294", name: "1051-4 Pink Clay Pot" }, 
      { hex: "#C27277", name: "1051-5 Cranberry" }, 
      { hex: "#AC545E", name: "1051-6 Grenadine" }, 
      { hex: "#903F45", name: "1051-7 Apple-a-day" }, 
      { hex: "#EFE0D7", name: "1052-1 Ginger Cream" }, 
      { hex: "#F3E2DC", name: "1052-2 Brandy Alexander" }, 
      { hex: "#DDBDBA", name: "1052-3 Strawflower" }, 
      { hex: "#C39191", name: "1052-4 Floral Tapestry" }, 
      { hex: "#AD7171", name: "1052-5 Horizon Glow" }, 
      { hex: "#92555B", name: "1052-6 Mesa Red" }, 
      { hex: "#813E45", name: "1052-7 Ruby Lips" }, 
      { hex: "#F1EDE5", name: "1053-1 Cow's Milk" }, 
      { hex: "#ECD4D2", name: "1053-2 Shangri La" }, 
      { hex: "#E3C7C6", name: "1053-3 Powdered Petals" }, 
      { hex: "#D7B1B2", name: "1053-4 Radiant Rouge" }, 
      { hex: "#B58E8B", name: "1053-5 Brandy Snaps" }, 
      { hex: "#956A66", name: "1053-6 Clay Ridge" }, 
      { hex: "#6C403E", name: "1053-7 Burgundy Wine" }, 
      { hex: "#F1E4DC", name: "1054-1 Winter Wedding" }, 
      { hex: "#F0DCD7", name: "1054-2 Sweet Truffle" }, 
      { hex: "#E6CDCA", name: "1054-3 Whirligig" }, 
      { hex: "#D9BEBC", name: "1054-4 Tea Time" }, 
      { hex: "#B39997", name: "1054-5 Tawny Mushroom" }, 
      { hex: "#8F716E", name: "1054-6 Oakwood Brown" }, 
      { hex: "#674848", name: "1054-7 Chocolate Eclair" }, 
      { hex: "#F2EBE6", name: "1055-1 Fresh Dough" }, 
      { hex: "#F3DBD9", name: "1055-2 Hawaiian Shell" }, 
      { hex: "#DBB9B6", name: "1055-3 Rose Hip" }, 
      { hex: "#C79D9B", name: "1055-4 Pepperberry" }, 
      { hex: "#A97673", name: "1055-5 Cinnamon Diamonds" }, 
      { hex: "#8E5959", name: "1055-6 Barn Door" }, 
      { hex: "#774041", name: "1055-7 Bordeaux" }, 
      { hex: "#E8DAD6", name: "1056-1 Sea Anemone" }, 
      { hex: "#E3D2CE", name: "1056-2 Romeo" }, 
      { hex: "#D9BCB7", name: "1056-3 Ashes Of Roses" }, 
      { hex: "#CDA09A", name: "1056-4 Raffia Cream" }, 
      { hex: "#B57770", name: "1056-5 Earth Rose" }, 
      { hex: "#9B5B55", name: "1056-6 Fire Weed" }, 
      { hex: "#86423E", name: "1056-7 Brick Dust" }, 
      { hex: "#EEE3DD", name: "1057-1 Macadamia Nut" }, 
      { hex: "#EBD1CD", name: "1057-2 Cool Melon" }, 
      { hex: "#E6C1BB", name: "1057-3 Rose Petal" }, 
      { hex: "#DDA69F", name: "1057-4 Coral Cove" }, 
      { hex: "#CA7C74", name: "1057-5 Chili Pepper" }, 
      { hex: "#B1635E", name: "1057-6 Sienna Red" }, 
      { hex: "#A0403E", name: "1057-7 Burning Bush" }, 
      { hex: "#F1E0DB", name: "1058-1 Potpourri" }, 
      { hex: "#EBCFC9", name: "1058-2 Cameo Peach" }, 
      { hex: "#E7CAC3", name: "1058-3 Tangy Taffy" }, 
      { hex: "#DDB1A8", name: "1058-4 Mesa Pink" }, 
      { hex: "#C7887F", name: "1058-5 Sunstone" }, 
      { hex: "#AB6057", name: "1058-6 Pizza Pie" }, 
      { hex: "#9B423F", name: "1058-7 Autumn Ridge" }, 
      { hex: "#EEDED8", name: "1059-1 Apricot Cream" }, 
      { hex: "#E9D2CC", name: "1059-2 Birthday Cake" }, 
      { hex: "#DAC0BA", name: "1059-3 Reindeer" }, 
      { hex: "#C8A6A1", name: "1059-4 Parfait" }, 
      { hex: "#AD7D76", name: "1059-5 Ferris Wheel" }, 
      { hex: "#93625B", name: "1059-6 Canyon Stone" }, 
      { hex: "#7B453E", name: "1059-7 Sweet Spiceberry" }, 
      { hex: "#EBD9D0", name: "1060-1 Winter Peach" }, 
      { hex: "#E3D1CC", name: "1060-2 China Silk" }, 
      { hex: "#DECAC5", name: "1060-3 Kangaroo Paw" }, 
      { hex: "#CDAEA5", name: "1060-4 Velveteen Crush" }, 
      { hex: "#AA8880", name: "1060-5 Bedford Brown" }, 
      { hex: "#8A5D55", name: "1060-6 Raspberry Truffle" }, 
      { hex: "#6D4741", name: "1060-7 Warm Mahogany" }, 
      { hex: "#EFE7DF", name: "1061-1 Irish Cream" }, 
      { hex: "#EADDD7", name: "1061-2 Wistful Beige" }, 
      { hex: "#E3CBC0", name: "1061-3 Belle Of The Ball" }, 
      { hex: "#C4A295", name: "1061-4 Just Rosey" }, 
      { hex: "#B4897D", name: "1061-5 Cappucino Bombe" }, 
      { hex: "#976C60", name: "1061-6 Safari Brown" }, 
      { hex: "#715145", name: "1061-7 Bigfoot" }, 
      { hex: "#EFE3D9", name: "1062-1 Butter Icing" }, 
      { hex: "#EAD6CE", name: "1062-2 Coral Cream" }, 
      { hex: "#E3CEC6", name: "1062-3 Ginger Shortbread" }, 
      { hex: "#D7B1A5", name: "1062-4 Sandpaper" }, 
      { hex: "#B98675", name: "1062-5 Big Cypress" }, 
      { hex: "#9C6757", name: "1062-6 Apple Brown Betty" }, 
      { hex: "#864F3E", name: "1062-7 Warm Wassail" }, 
      { hex: "#F4E5DD", name: "1063-1 Polo Tan" }, 
      { hex: "#F0DED3", name: "1063-2 Spice Cookie" }, 
      { hex: "#F2D1C4", name: "1063-3 Pale Coral" }, 
      { hex: "#ECBDB0", name: "1063-4 Georgia Peach" }, 
      { hex: "#D1907C", name: "1063-5 Orange Essential" }, 
      { hex: "#B7735E", name: "1063-6 Crushed Cinnamon" }, 
      { hex: "#9F543E", name: "1063-7 Ancient Copper" }, 
      { hex: "#F2E4DD", name: "1064-1 Aubergine" }, 
      { hex: "#F4DED9", name: "1064-2 Pink Chablis" }, 
      { hex: "#F1D2C9", name: "1064-3 Texas Rose" }, 
      { hex: "#ECBCB2", name: "1064-4 Peach Beige" }, 
      { hex: "#DD9789", name: "1064-5 Holland Tile" }, 
      { hex: "#C67363", name: "1064-6 Sahara Sun" }, 
      { hex: "#A4493D", name: "1064-7 Rum Raisin" }, 
      { hex: "#F1E2DE", name: "1065-1 Chantilly Lace" }, 
      { hex: "#EDD8D2", name: "1065-2 Fiesta" }, 
      { hex: "#E9CFC8", name: "1065-3 Honeysweet" }, 
      { hex: "#E2BCB3", name: "1065-4 Sweet Peach" }, 
      { hex: "#C99387", name: "1065-5 Mexican Moonlight" }, 
      { hex: "#AE6456", name: "1065-6 Cinnabar" }, 
      { hex: "#91493E", name: "1065-7 Cedar Chest" }, 
      { hex: "#F1E6E0", name: "1066-1 Siesta Sands" }, 
      { hex: "#F1DDD8", name: "1066-2 Slightly Peach" }, 
      { hex: "#F1D3CA", name: "1066-3 Cool Cantaloupe" }, 
      { hex: "#E3BEB0", name: "1066-4 Adorable" }, 
      { hex: "#C18978", name: "1066-5 Copper Trail" }, 
      { hex: "#AB6F60", name: "1066-6 Amaretto" }, 
      { hex: "#8C4F42", name: "1066-7 Baked Bean" }, 
      { hex: "#ECDBD2", name: "1067-1 Pine Hutch" }, 
      { hex: "#E8D3C9", name: "1067-2 Bare Beige" }, 
      { hex: "#E8CAC0", name: "1067-3 Au Naturel" }, 
      { hex: "#E0B4A4", name: "1067-4 Summer Tan" }, 
      { hex: "#B1715A", name: "1067-5 Copper Beech" }, 
      { hex: "#9E6654", name: "1067-6 Warm Up" }, 
      { hex: "#8F4C3A", name: "1067-7 Burled Redwood" }, 
      { hex: "#EFE4DA", name: "1068-1 Sweet Gardenia" }, 
      { hex: "#ECDFD6", name: "1068-2 Sablewood" }, 
      { hex: "#E3C9BE", name: "1068-3 Sultan Sand" }, 
      { hex: "#D9B19F", name: "1068-4 Suntan" }, 
      { hex: "#BE8973", name: "1068-5 Terrazzo Tan" }, 
      { hex: "#A8715A", name: "1068-6 Nutmeg" }, 
      { hex: "#915B41", name: "1068-7 Spiced Cider" }, 
      { hex: "#EFDBCD", name: "1069-1 Nosegay" }, 
      { hex: "#EBCCB9", name: "1069-2 Scotchtone" }, 
      { hex: "#E5BCA5", name: "1069-3 Starfish" }, 
      { hex: "#D3A083", name: "1069-4 Orange Maple" }, 
      { hex: "#BC886A", name: "1069-5 Honey Graham" }, 
      { hex: "#9F6949", name: "1069-6 Foxfire Brown" }, 
      { hex: "#935F43", name: "1069-7 Cinnamon Spice" }, 
      { hex: "#EEDACB", name: "1070-1 Canyon Peach" }, 
      { hex: "#EDD5C7", name: "1070-2 Blush Beige" }, 
      { hex: "#E7C3AC", name: "1070-3 Tantalizing Tan" }, 
      { hex: "#D8A686", name: "1070-4 Clay Fire" }, 
      { hex: "#C48D69", name: "1070-5 Hitching Post" }, 
      { hex: "#A66E49", name: "1070-6 Ginger Spice" }, 
      { hex: "#966544", name: "1070-7 Cinnamon Stick" }, 
      { hex: "#EADFD2", name: "1071-1 South Peak" }, 
      { hex: "#EAD4C4", name: "1071-2 Enjoy" }, 
      { hex: "#E2C7B6", name: "1071-3 Birthday Suit" }, 
      { hex: "#DBBBA7", name: "1071-4 Cinnamon Ice" }, 
      { hex: "#BA947B", name: "1071-5 Cool Clay" }, 
      { hex: "#996E5A", name: "1071-6 Prairie Fire" }, 
      { hex: "#805B48", name: "1071-7 Spiced Cinnamon" }, 
      { hex: "#F0E8E0", name: "1072-1 Almond Roca" }, 
      { hex: "#E9DAD2", name: "1072-2 Sandy Beach" }, 
      { hex: "#D5BFB4", name: "1072-3 Wild Rice" }, 
      { hex: "#C3A79A", name: "1072-4 Taupe Tapestry" }, 
      { hex: "#A2806F", name: "1072-5 Tattered Teddy" }, 
      { hex: "#896757", name: "1072-6 Suede Leather" }, 
      { hex: "#6C483A", name: "1072-7 Bird House Brown" }, 
      { hex: "#F2E9DC", name: "1073-1 Lotus Petal" }, 
      { hex: "#E8D9CE", name: "1073-2 Malted Milk" }, 
      { hex: "#E3D1C8", name: "1073-3 Pale Taupe" }, 
      { hex: "#D0BBB0", name: "1073-4 Pueblo" }, 
      { hex: "#A58F85", name: "1073-5 Tanglewood" }, 
      { hex: "#8A7265", name: "1073-6 Derby Brown" }, 
      { hex: "#63493E", name: "1073-7 Fudge" }, 
      { hex: "#EEE6DB", name: "1074-1 Pearls And Lace" }, 
      { hex: "#EAE0D4", name: "1074-2 Moroccan Moonlight" }, 
      { hex: "#DACBBF", name: "1074-3 Bermuda Sand" }, 
      { hex: "#BDA998", name: "1074-4 Notorious" }, 
      { hex: "#957D6F", name: "1074-5 Peppered Pecan" }, 
      { hex: "#6E564A", name: "1074-6 Caramelized Walnut" }, 
      { hex: "#604B42", name: "1074-7 Little Bear" }, 
      { hex: "#EFEBE3", name: "1075-1 Linen Ruffle" }, 
      { hex: "#EAE3D8", name: "1075-2 Indian Muslin" }, 
      { hex: "#DFD5C8", name: "1075-3 Casual Elegance" }, 
      { hex: "#BDADA4", name: "1075-4 Thumper" }, 
      { hex: "#968379", name: "1075-5 Ranch Mink" }, 
      { hex: "#736157", name: "1075-6 Poppy Pods" }, 
      { hex: "#604A3F", name: "1075-7 Fudge Truffle" }, 
      { hex: "#EAE3DB", name: "1076-1 Fuzzy Unicorn" }, 
      { hex: "#E4DED5", name: "1076-2 Ash" }, 
      { hex: "#D0C2B4", name: "1076-3 Gotta Have It" }, 
      { hex: "#B09F8F", name: "1076-4 Cuppa Coffee" }, 
      { hex: "#988171", name: "1076-5 Locomotion" }, 
      { hex: "#7D685B", name: "1076-6 Warrior" }, 
      { hex: "#63554B", name: "1076-7 Ground Coffee" }, 
      { hex: "#F0E1CF", name: "1077-1 Berkshire Lace" }, 
      { hex: "#EBDAC8", name: "1077-2 Sandpiper" }, 
      { hex: "#C4AE96", name: "1077-3 Persuasion" }, 
      { hex: "#B19C86", name: "1077-4 Weathered Wood" }, 
      { hex: "#998069", name: "1077-5 Chocolate Moment" }, 
      { hex: "#816B56", name: "1077-6 Salted Pretzel" }, 
      { hex: "#6C5B4D", name: "1077-7 Coffee House" }, 
      { hex: "#EEE9DC", name: "1078-1 Cream Puff" }, 
      { hex: "#E8E1D5", name: "1078-2 Water Chestnut" }, 
      { hex: "#E3CEB8", name: "1078-3 Comfort" }, 
      { hex: "#C4AD92", name: "1078-4 Kangaroo" }, 
      { hex: "#A98A6B", name: "1078-5 Confidence" }, 
      { hex: "#8D725A", name: "1078-6 Cocoa Delight" }, 
      { hex: "#76604E", name: "1078-7 Chocolate Ripple" }, 
      { hex: "#EBE3D8", name: "1079-1 String Of Pearls" }, 
      { hex: "#E8E0D8", name: "1079-2 Stone Harbor" }, 
      { hex: "#DBC8B6", name: "1079-3 Cocoa Cream" }, 
      { hex: "#C3AC98", name: "1079-4 Transcend" }, 
      { hex: "#AA8F7A", name: "1079-5 Cocoloco" }, 
      { hex: "#8C6E54", name: "1079-6 Caravel Brown" }, 
      { hex: "#74563D", name: "1079-7 Molasses" }, 
      { hex: "#EADAC6", name: "1080-1 Oatmeal Cookie" }, 
      { hex: "#E6C8A9", name: "1080-2 Pumpkin Cream" }, 
      { hex: "#D8B691", name: "1080-3 Nutmeg Glow" }, 
      { hex: "#C9A480", name: "1080-4 Siesta Dreams" }, 
      { hex: "#BA8F68", name: "1080-5 Tropical Tan" }, 
      { hex: "#A37D5A", name: "1080-6 Cinnamon Crunch" }, 
      { hex: "#8D6A4A", name: "1080-7 Slippery Stone" }, 
      { hex: "#F1E6D6", name: "1081-1 Elegant Ivory" }, 
      { hex: "#E6D0B6", name: "1081-2 Beachy Keen" }, 
      { hex: "#E1C6A8", name: "1081-3 My Love" }, 
      { hex: "#D3B191", name: "1081-4 Cinnamon Frost" }, 
      { hex: "#B98D68", name: "1081-5 Fire Dust" }, 
      { hex: "#9F7250", name: "1081-6 Cinnamon Twist" }, 
      { hex: "#936647", name: "1081-7 Copper Pot" }, 
      { hex: "#EEE2D5", name: "1082-1 Honeysuckle" }, 
      { hex: "#EAD9CB", name: "1082-2 Shoreland" }, 
      { hex: "#E3D0BF", name: "1082-3 Ice Cream Cone" }, 
      { hex: "#DFC0A6", name: "1082-4 Weathered Sandstone" }, 
      { hex: "#C89B75", name: "1082-5 Doeskin" }, 
      { hex: "#B27D50", name: "1082-6 Cowboy Hat" }, 
      { hex: "#97653C", name: "1082-7 Ginger" }, 
      { hex: "#F0E8DD", name: "1083-1 Percale" }, 
      { hex: "#F2E8DB", name: "1083-2 Euro Linen" }, 
      { hex: "#EED8C2", name: "1083-3 Oak Buff" }, 
      { hex: "#E7CEB5", name: "1083-4 Malibu Dune" }, 
      { hex: "#D2AD87", name: "1083-5 Cheddar Biscuit" }, 
      { hex: "#B08A61", name: "1083-6 Caramel Kiss" }, 
      { hex: "#926B43", name: "1083-7 Bourbon" }, 
      { hex: "#EFE8DC", name: "1084-1 Sugar Soap" }, 
      { hex: "#ECE2D4", name: "1084-2 Onion Powder" }, 
      { hex: "#DDCFBC", name: "1084-3 Sourdough" }, 
      { hex: "#CDB69B", name: "1084-4 Happy Trails" }, 
      { hex: "#B19576", name: "1084-5 Coffee Kiss" }, 
      { hex: "#967B5D", name: "1084-6 Cocoa Pecan" }, 
      { hex: "#75583D", name: "1084-7 Maple Syrup" }, 
      { hex: "#EAE4D6", name: "1085-1 Blank Canvas" }, 
      { hex: "#E4D9C5", name: "1085-2 Bone White" }, 
      { hex: "#DCCCB4", name: "1085-3 Seriously Sand" }, 
      { hex: "#C6B49C", name: "1085-4 Best Beige" }, 
      { hex: "#AB9378", name: "1085-5 Sauteed Mushroom" }, 
      { hex: "#8F775D", name: "1085-6 Hat Box Brown" }, 
      { hex: "#7A634D", name: "1085-7 Fig Branches" }, 
      { hex: "#EEEADD", name: "1086-1 Horseradish" }, 
      { hex: "#EAE2D1", name: "1086-2 Brandied Pears" }, 
      { hex: "#E1CFB2", name: "1086-3 Almond Cream" }, 
      { hex: "#D2BC9B", name: "1086-4 Pony Tail" }, 
      { hex: "#B89E78", name: "1086-5 Earthy Ocher" }, 
      { hex: "#A68966", name: "1086-6 Coffee With Cream" }, 
      { hex: "#967859", name: "1086-7 Cocoa Cupcake" }, 
      { hex: "#EEE6DB", name: "1087-1 Madonna Lily" }, 
      { hex: "#EFE5D9", name: "1087-2 Pearl" }, 
      { hex: "#EAD8C1", name: "1087-3 Antique Parchment" }, 
      { hex: "#E0CEB7", name: "1087-4 Chalkware" }, 
      { hex: "#D1B088", name: "1087-5 Cracker Bitz" }, 
      { hex: "#AB8659", name: "1087-6 Bread Basket" }, 
      { hex: "#977043", name: "1087-7 Chewy Caramel" }, 
      { hex: "#F0E8D9", name: "1088-1 Angel Food" }, 
      { hex: "#EEDEC7", name: "1088-2 Ethereal" }, 
      { hex: "#EBD5B7", name: "1088-3 Sugared Pears" }, 
      { hex: "#D8B98C", name: "1088-4 Splash Of Honey" }, 
      { hex: "#C9A375", name: "1088-5 Outback" }, 
      { hex: "#AD8458", name: "1088-6 Cool Copper" }, 
      { hex: "#9B7448", name: "1088-7 Sahara Splendor" }, 
      { hex: "#F5E7D2", name: "1089-1 Pita Bread" }, 
      { hex: "#F6E6CB", name: "1089-2 Magnolia Spray" }, 
      { hex: "#EFD7B3", name: "1089-3 Chai Tea Latte" }, 
      { hex: "#E2C59C", name: "1089-4 Faint Fawn" }, 
      { hex: "#C7A06C", name: "1089-5 Bleached Maple" }, 
      { hex: "#BC9263", name: "1089-6 Honey Haven" }, 
      { hex: "#A17B4D", name: "1089-7 Caramelized Pecan" }, 
      { hex: "#F4E7CE", name: "1090-1 Magnolia Blossom" }, 
      { hex: "#EBD0A4", name: "1090-2 Spice Is Nice" }, 
      { hex: "#DBB881", name: "1090-3 Honey Bunny" }, 
      { hex: "#D4AE76", name: "1090-4 Drops Of Honey" }, 
      { hex: "#C49E69", name: "1090-5 Good Life" }, 
      { hex: "#B28959", name: "1090-6 Allegro" }, 
      { hex: "#9C7647", name: "1090-7 Sugar Maple" }, 
      { hex: "#F2EBD3", name: "1091-1 Candlewick" }, 
      { hex: "#F1E9CF", name: "1091-2 Crescent Moon" }, 
      { hex: "#F0DDB8", name: "1091-3 Limitless" }, 
      { hex: "#E2C392", name: "1091-4 Halo" }, 
      { hex: "#D0AB70", name: "1091-5 More Maple" }, 
      { hex: "#B5905A", name: "1091-6 Tan Your Hide" }, 
      { hex: "#A67E4B", name: "1091-7 Look At Me" }, 
      { hex: "#F2EEDE", name: "1092-1 Queen Anne's Lace" }, 
      { hex: "#F2EBD6", name: "1092-2 Mesa Beige" }, 
      { hex: "#E7D2AD", name: "1092-3 Tuscan Bread" }, 
      { hex: "#D3B78B", name: "1092-4 Craftsman Gold" }, 
      { hex: "#C09C6A", name: "1092-5 Welcome Home" }, 
      { hex: "#AF8A5B", name: "1092-6 It Works" }, 
      { hex: "#97774D", name: "1092-7 Weathered Wicker" }, 
      { hex: "#F2EDD7", name: "1093-1 Perfect Solution" }, 
      { hex: "#F0E5C7", name: "1093-2 Soleil" }, 
      { hex: "#E1CCA6", name: "1093-3 Hearth" }, 
      { hex: "#CBB489", name: "1093-4 Somber" }, 
      { hex: "#C1A87C", name: "1093-5 Antiquity" }, 
      { hex: "#B19466", name: "1093-6 Tangled Twine" }, 
      { hex: "#A48454", name: "1093-7 Tattle Tan" }, 
      { hex: "#E6DDC6", name: "1094-1 Irresistible" }, 
      { hex: "#E3D3B5", name: "1094-2 Loofah" }, 
      { hex: "#D9C3A1", name: "1094-3 Birch Beige" }, 
      { hex: "#D4BC94", name: "1094-4 Crepe" }, 
      { hex: "#B8996B", name: "1094-5 Golden Granola" }, 
      { hex: "#AF9468", name: "1094-6 Imagine" }, 
      { hex: "#8B714B", name: "1094-7 Molasses Cookie" }, 
      { hex: "#F1E8D8", name: "1095-1 Parchment Paper" }, 
      { hex: "#EFE3D2", name: "1095-2 Glazed Pears" }, 
      { hex: "#E5D3B9", name: "1095-3 Almond Brittle" }, 
      { hex: "#D8C39F", name: "1095-4 Golden Ecru" }, 
      { hex: "#C2A377", name: "1095-5 Applesauce Cake" }, 
      { hex: "#A78658", name: "1095-6 Chicory" }, 
      { hex: "#886A3F", name: "1095-7 Shaker Peg" }, 
      { hex: "#EDE7D2", name: "1096-1 Instant Relief" }, 
      { hex: "#ECE3CC", name: "1096-2 Morocco Sand" }, 
      { hex: "#DCCAA8", name: "1096-3 Cookie Dough" }, 
      { hex: "#CCB896", name: "1096-4 Real Simple" }, 
      { hex: "#B3956C", name: "1096-5 Creamy Caramel" }, 
      { hex: "#A0855C", name: "1096-6 Timber Beam" }, 
      { hex: "#7F6640", name: "1096-7 Seasoned Acorn" }, 
      { hex: "#E9E5D7", name: "1097-1 Colonial White" }, 
      { hex: "#E4DFD1", name: "1097-2 Southern Breeze" }, 
      { hex: "#DACFBA", name: "1097-3 Toasted Almond" }, 
      { hex: "#C9BBA3", name: "1097-4 Dusty Trail" }, 
      { hex: "#AC9A7E", name: "1097-5 Stony Creek" }, 
      { hex: "#8B795F", name: "1097-6 Rain Barrel" }, 
      { hex: "#756244", name: "1097-7 Olive Wood" }, 
      { hex: "#EFE9D9", name: "1098-1 Milk Paint" }, 
      { hex: "#E8DDC6", name: "1098-2 Heavy Cream" }, 
      { hex: "#DECFB3", name: "1098-3 Sand Fossil" }, 
      { hex: "#CDBA99", name: "1098-4 Spiced Vinegar" }, 
      { hex: "#AD9773", name: "1098-5 Jute" }, 
      { hex: "#937B56", name: "1098-6 Tweed" }, 
      { hex: "#715D3D", name: "1098-7 Muddy River" }, 
      { hex: "#EBE5D2", name: "1099-1 Always Almond" }, 
      { hex: "#E6E0CC", name: "1099-2 Vanilla Love" }, 
      { hex: "#DBCEAC", name: "1099-3 Lovely Linen" }, 
      { hex: "#D0BD94", name: "1099-4 Subtle Suede" }, 
      { hex: "#AF9A73", name: "1099-5 Toasted Sesame" }, 
      { hex: "#9C8866", name: "1099-6 Iced Cappuccino" }, 
      { hex: "#877252", name: "1099-7 Favorite Fudge" }, 
      { hex: "#F2EFE1", name: "1100-1 Mother Of Pearl" }, 
      { hex: "#F2ECD9", name: "1100-2 Adobe White" }, 
      { hex: "#DACBA9", name: "1100-3 Baked Bread" }, 
      { hex: "#B8A47A", name: "1100-4 Sailor's Knot" }, 
      { hex: "#A8946B", name: "1100-5 Sweet Sparrow" }, 
      { hex: "#9A845E", name: "1100-6 Twisted Tail" }, 
      { hex: "#88724D", name: "1100-7 Paddle Wheel" }, 
      { hex: "#EAE6D9", name: "1101-1 China White" }, 
      { hex: "#E5DDC8", name: "1101-2 Navajo White" }, 
      { hex: "#CEC1A5", name: "1101-3 Stylish" }, 
      { hex: "#C0AF92", name: "1101-4 Rock Cliffs" }, 
      { hex: "#AC9877", name: "1101-5 Bear Hug" }, 
      { hex: "#867354", name: "1101-6 Leather Loafers" }, 
      { hex: "#695F4F", name: "1101-7 Lemur" }, 
      { hex: "#EBE8DB", name: "1102-1 Enduring Ice" }, 
      { hex: "#E3DDCC", name: "1102-2 Fossil Stone" }, 
      { hex: "#C4BAA1", name: "1102-3 Dancing Dolphin" }, 
      { hex: "#B9AB8F", name: "1102-4 Prairie Dust" }, 
      { hex: "#9F906E", name: "1102-5 Saddle Soap" }, 
      { hex: "#847451", name: "1102-6 Woodbridge" }, 
      { hex: "#665C46", name: "1102-7 Pine Cone" }, 
      { hex: "#F0EADA", name: "1103-1 Ivory Tower" }, 
      { hex: "#E5DBC5", name: "1103-2 Almond Paste" }, 
      { hex: "#D8CBAD", name: "1103-3 Soft Suede" }, 
      { hex: "#C5B28B", name: "1103-4 Earthy Cane" }, 
      { hex: "#A58E61", name: "1103-5 Rattan" }, 
      { hex: "#917747", name: "1103-6 Wool Tweed" }, 
      { hex: "#77623A", name: "1103-7 Twig Basket" }, 
      { hex: "#EEE9D9", name: "1104-1 White Rock" }, 
      { hex: "#EBE5D0", name: "1104-2 Abbey White" }, 
      { hex: "#E7DBBF", name: "1104-3 Deserted Beach" }, 
      { hex: "#D2C098", name: "1104-4 Sandy Pail" }, 
      { hex: "#AE996B", name: "1104-5 Cool Camel" }, 
      { hex: "#8D794F", name: "1104-6 Rustic Ranch" }, 
      { hex: "#82714D", name: "1104-7 Outrigger" }, 
      { hex: "#F0E9D6", name: "1105-1 Creamy White" }, 
      { hex: "#F0E9D1", name: "1105-2 Fuzzy Sheep" }, 
      { hex: "#E7D5AD", name: "1105-3 Caramelized Pears" }, 
      { hex: "#E1CFA5", name: "1105-4 Foothills" }, 
      { hex: "#CFB989", name: "1105-5 Appalachian Trail" }, 
      { hex: "#BB9F6A", name: "1105-6 Buffalo Hide" }, 
      { hex: "#A78A50", name: "1105-7 Graceful Gazelle" }, 
      { hex: "#F5E9CA", name: "1106-1 Maiden Hair" }, 
      { hex: "#F1D9A5", name: "1106-2 Upbeat" }, 
      { hex: "#E5C382", name: "1106-3 Autumn Glow" }, 
      { hex: "#E6C26F", name: "1106-4 Turner's Yellow" }, 
      { hex: "#D7AD62", name: "1106-5 Butterscotch Bliss" }, 
      { hex: "#C09856", name: "1106-6 Amaretto Sours" }, 
      { hex: "#B08843", name: "1106-7 Butterscotch Ripple" }, 
      { hex: "#F3EECD", name: "1107-1 Minimal" }, 
      { hex: "#F6EEC0", name: "1107-2 Joyful" }, 
      { hex: "#EDE1A8", name: "1107-3 Turning Oakleaf" }, 
      { hex: "#ECDA9E", name: "1107-4 Demeter" }, 
      { hex: "#DDC073", name: "1107-5 Tropical Siesta" }, 
      { hex: "#CBA956", name: "1107-6 Glorious Gold" }, 
      { hex: "#C39E44", name: "1107-7 Golden Field" }, 
      { hex: "#F4F0D2", name: "1108-1 Oyster Cracker" }, 
      { hex: "#F5EEC6", name: "1108-2 Silk Star" }, 
      { hex: "#F0E4B2", name: "1108-3 Butter Cookie" }, 
      { hex: "#E5D295", name: "1108-4 Wayward Wind" }, 
      { hex: "#D1B871", name: "1108-5 Spicy Mustard" }, 
      { hex: "#BBA262", name: "1108-6 Shutter Bug" }, 
      { hex: "#AE9550", name: "1108-7 Obsession" }, 
      { hex: "#EDE5BC", name: "1109-1 Slices Of Happy" }, 
      { hex: "#E8DDAE", name: "1109-2 Star Bright" }, 
      { hex: "#E2D39B", name: "1109-3 Twinkle Toes" }, 
      { hex: "#D7C275", name: "1109-4 Citrus Yellow" }, 
      { hex: "#C8B165", name: "1109-5 Split Pea Soup" }, 
      { hex: "#B59F55", name: "1109-6 Woolen Mittens" }, 
      { hex: "#A28B36", name: "1109-7 Autumn Festival" }, 
      { hex: "#EDE6B3", name: "1110-1 September Morn" }, 
      { hex: "#E4D89A", name: "1110-2 Subtle Sunshine" }, 
      { hex: "#D2C880", name: "1110-3 Serene Scene" }, 
      { hex: "#C6BB68", name: "1110-4 Secret Safari" }, 
      { hex: "#A79954", name: "1110-5 Gremlin" }, 
      { hex: "#9F9049", name: "1110-6 Off The Grid" }, 
      { hex: "#8C7F3C", name: "1110-7 Peas Please" }, 
      { hex: "#E8E6D9", name: "1111-1 Prairie Winds" }, 
      { hex: "#E3DEC6", name: "1111-2 Bamboo" }, 
      { hex: "#D0C6A1", name: "1111-3 Safari" }, 
      { hex: "#BBAC7D", name: "1111-4 Nettle" }, 
      { hex: "#9C8F60", name: "1111-5 Pineapple Sage" }, 
      { hex: "#887647", name: "1111-6 Pickled Okra" }, 
      { hex: "#75693D", name: "1111-7 Sphagnum Moss" }, 
      { hex: "#EAE6D7", name: "1112-1 Little Lamb" }, 
      { hex: "#E0DBC7", name: "1112-2 Cozy Cream" }, 
      { hex: "#D4CDB5", name: "1112-3 Only Oatmeal" }, 
      { hex: "#C6BB9C", name: "1112-4 Beach Dune" }, 
      { hex: "#B0A582", name: "1112-5 Woolen Vest" }, 
      { hex: "#9E8F66", name: "1112-6 Willow Tree" }, 
      { hex: "#726647", name: "1112-7 Russian Olive" }, 
      { hex: "#DDDBC5", name: "1113-1 I Miss You" }, 
      { hex: "#D1CEB4", name: "1113-2 Silver Sage" }, 
      { hex: "#C5C1A3", name: "1113-3 Northern Landscape" }, 
      { hex: "#AFA984", name: "1113-4 Green Gray Mist" }, 
      { hex: "#9C946E", name: "1113-5 Sweet Annie" }, 
      { hex: "#7A744D", name: "1113-6 Green Briar" }, 
      { hex: "#5D583E", name: "1113-7 Olive Green" }, 
      { hex: "#E8E7D7", name: "1114-1 Featherstone" }, 
      { hex: "#DEDBC4", name: "1114-2 River Reed" }, 
      { hex: "#D0CCA9", name: "1114-3 Canary Grass" }, 
      { hex: "#BCB58A", name: "1114-4 Cress Green" }, 
      { hex: "#A49D70", name: "1114-5 Pea Soup" }, 
      { hex: "#8D8752", name: "1114-6 Bronze Green" }, 
      { hex: "#797447", name: "1114-7 Autumn Fern" }, 
      { hex: "#E8ECDB", name: "1115-1 Really Rain" }, 
      { hex: "#E4E5D2", name: "1115-2 Sage Splash" }, 
      { hex: "#DBDCC4", name: "1115-3 Slow Dance" }, 
      { hex: "#C3C6A4", name: "1115-4 Sage Splendor" }, 
      { hex: "#9C9F75", name: "1115-5 Pine Trail" }, 
      { hex: "#8C8E65", name: "1115-6 Paid In Full" }, 
      { hex: "#71714E", name: "1115-7 Gratefully Grass" }, 
      { hex: "#EAECD3", name: "1116-1 Just Perfect" }, 
      { hex: "#E0E3C8", name: "1116-2 More Melon" }, 
      { hex: "#E1E1BE", name: "1116-3 Forgive Quickly" }, 
      { hex: "#DAD7AD", name: "1116-4 Misty Moor" }, 
      { hex: "#BAB078", name: "1116-5 Gracious Glow" }, 
      { hex: "#A69A5C", name: "1116-6 Loveliest Leaves" }, 
      { hex: "#8C8449", name: "1116-7 Frog's Legs" }, 
      { hex: "#E9EDC0", name: "1117-1 Delicate Daisy" }, 
      { hex: "#E3EBB1", name: "1117-2 Awareness" }, 
      { hex: "#D4E092", name: "1117-3 Charming" }, 
      { hex: "#BACB7C", name: "1117-4 Floral Bouquet" }, 
      { hex: "#ADB864", name: "1117-5 Beach Bag" }, 
      { hex: "#99A456", name: "1117-6 Do Not Disturb" }, 
      { hex: "#898C4A", name: "1117-7 Enough Is Enough" }, 
      { hex: "#E6E8C5", name: "1118-1 More Mint" }, 
      { hex: "#DADEB5", name: "1118-2 April Showers" }, 
      { hex: "#CDD3A3", name: "1118-3 True To You" }, 
      { hex: "#BAC08A", name: "1118-4 Jitterbug" }, 
      { hex: "#A0A667", name: "1118-5 Always Apple" }, 
      { hex: "#888F4F", name: "1118-6 Vintage Vibe" }, 
      { hex: "#757D43", name: "1118-7 Lucky" }, 
      { hex: "#E9E9D0", name: "1119-1 Magical Melon" }, 
      { hex: "#E4E4C5", name: "1119-2 Fountain Frolic" }, 
      { hex: "#DCDDB8", name: "1119-3 Beach Grass" }, 
      { hex: "#C8CC9E", name: "1119-4 Dancing Kite" }, 
      { hex: "#B4B780", name: "1119-5 Fancy Flirt" }, 
      { hex: "#9EA26B", name: "1119-6 Golden Grass" }, 
      { hex: "#868B53", name: "1119-7 Glade Green" }, 
      { hex: "#EAEEDE", name: "1120-1 Mental Note" }, 
      { hex: "#E0EAD7", name: "1120-2 Gratitude" }, 
      { hex: "#D8E6CB", name: "1120-3 Great Joy" }, 
      { hex: "#C6D4AC", name: "1120-4 Pistachio Pudding" }, 
      { hex: "#AFC195", name: "1120-5 Harmonious" }, 
      { hex: "#91A673", name: "1120-6 Luscious Lime" }, 
      { hex: "#6A7D4E", name: "1120-7 Mint Leaves" }, 
      { hex: "#E3E8D9", name: "1121-1 Milkweed" }, 
      { hex: "#DAE1CF", name: "1121-2 Lime Spritz" }, 
      { hex: "#D0DBC4", name: "1121-3 Pale Moss Green" }, 
      { hex: "#BBC6A4", name: "1121-4 Quaking Grass" }, 
      { hex: "#9AA77C", name: "1121-5 Guacamole" }, 
      { hex: "#7E8D60", name: "1121-6 Moss Point Green" }, 
      { hex: "#5F6C3C", name: "1121-7 Globe Artichoke" }, 
      { hex: "#E8E8D7", name: "1122-1 White Smoke" }, 
      { hex: "#DFE3D0", name: "1122-2 Lime Wash" }, 
      { hex: "#CFD2B5", name: "1122-3 Pickling Spice" }, 
      { hex: "#B9BD97", name: "1122-4 Bahia Grass" }, 
      { hex: "#9DA073", name: "1122-5 Dill" }, 
      { hex: "#7F8353", name: "1122-6 Oregano" }, 
      { hex: "#6D7244", name: "1122-7 Oakmoss" }, 
      { hex: "#ECECDF", name: "1123-1 Ageless" }, 
      { hex: "#EAEADB", name: "1123-2 Magical Stardust" }, 
      { hex: "#E0E1D1", name: "1123-3 Wild Wheat" }, 
      { hex: "#CBCCB5", name: "1123-4 Only Olive" }, 
      { hex: "#A4A582", name: "1123-5 Envy" }, 
      { hex: "#8B8C6B", name: "1123-6 Playing Hooky" }, 
      { hex: "#6B6D4E", name: "1123-7 Rustling Leaves" }, 
      { hex: "#E1E5D7", name: "1124-1 Touch Of Lime" }, 
      { hex: "#D8DECE", name: "1124-2 Pale Vista" }, 
      { hex: "#C7CFBE", name: "1124-3 Frosty Pine" }, 
      { hex: "#B2B9A5", name: "1124-4 Light Sage" }, 
      { hex: "#92987D", name: "1124-5 Cavern Moss" }, 
      { hex: "#6D765B", name: "1124-6 Dark Sage" }, 
      { hex: "#576049", name: "1124-7 Grape Leaves" }, 
      { hex: "#E1E1D5", name: "1125-1 Rain Cloud" }, 
      { hex: "#D2D4C3", name: "1125-2 White Sage" }, 
      { hex: "#C8CAB5", name: "1125-3 Whispering Pine" }, 
      { hex: "#ACAF95", name: "1125-4 Olive Sprig" }, 
      { hex: "#909373", name: "1125-5 Hemlock" }, 
      { hex: "#6D6F4F", name: "1125-6 Toy Tank Green" }, 
      { hex: "#57593F", name: "1125-7 Pinetop" }, 
      { hex: "#E9EBDE", name: "1126-1 Sterling Shadow" }, 
      { hex: "#E5E6D7", name: "1126-2 Twilight Twist" }, 
      { hex: "#DDDDCC", name: "1126-3 Pinch Of Pistachio" }, 
      { hex: "#BFC3AE", name: "1126-4 Side Kick" }, 
      { hex: "#9DA286", name: "1126-5 Zebra Grass" }, 
      { hex: "#797E65", name: "1126-6 Pine Garland" }, 
      { hex: "#676C58", name: "1126-7 All About Olive" }, 
      { hex: "#DDE6D7", name: "1127-1 Lime Daiquiri" }, 
      { hex: "#D8DDCC", name: "1127-2 Liberated Lime" }, 
      { hex: "#CED3C1", name: "1127-3 Merry Music" }, 
      { hex: "#ABB39E", name: "1127-4 Gargoyle " }, 
      { hex: "#81876F", name: "1127-5 Shebang" }, 
      { hex: "#636653", name: "1127-6 Winning Ticket" }, 
      { hex: "#5C5F4B", name: "1127-7 Fresh Basil" }, 
      { hex: "#DADCD3", name: "1128-1 Anonymous" }, 
      { hex: "#CFD2C7", name: "1128-2 Frivolous Folly" }, 
      { hex: "#C5CABE", name: "1128-3 Life Lesson" }, 
      { hex: "#BEC4B7", name: "1128-4 Balsam" }, 
      { hex: "#939A89", name: "1128-5 Green Tea Leaf" }, 
      { hex: "#737B6C", name: "1128-6 Thyme Green" }, 
      { hex: "#525746", name: "1128-7 Castle Stone" }, 
      { hex: "#DFE6DA", name: "1129-1 Cloudy Day" }, 
      { hex: "#CAD5C8", name: "1129-2 Falling Star" }, 
      { hex: "#CDD4C6", name: "1129-3 Castaway" }, 
      { hex: "#B4C0AF", name: "1129-4 Coastal Crush" }, 
      { hex: "#8E9B88", name: "1129-5 Farm Fresh" }, 
      { hex: "#768371", name: "1129-6 Lottery Winnings" }, 
      { hex: "#50594F", name: "1129-7 Evergreen Boughs" }, 
      { hex: "#E1E8DB", name: "1130-1 Summer Rain" }, 
      { hex: "#DCE5D8", name: "1130-2 Mint Wafer" }, 
      { hex: "#D0DDCC", name: "1130-3 St. Augustine" }, 
      { hex: "#BAD1B5", name: "1130-4 Lime Taffy" }, 
      { hex: "#91AF88", name: "1130-5 Pear Cactus" }, 
      { hex: "#729067", name: "1130-6 Moss Ring" }, 
      { hex: "#4D663E", name: "1130-7 Mountain Forest" }, 
      { hex: "#E3EEE3", name: "1131-1 Green Whisper" }, 
      { hex: "#D2E6D3", name: "1131-2 Herbal Mist" }, 
      { hex: "#C8DFC3", name: "1131-3 Dreamcatcher" }, 
      { hex: "#A2C7A3", name: "1131-4 French Market" }, 
      { hex: "#89B386", name: "1131-5 Chatty Cricket" }, 
      { hex: "#658E64", name: "1131-6 Succulent Leaves" }, 
      { hex: "#53734C", name: "1131-7 Clover Leaf" }, 
      { hex: "#DBE9DF", name: "1132-1 Clair De Lune" }, 
      { hex: "#C6DECF", name: "1132-2 Solitaire" }, 
      { hex: "#AAD0BA", name: "1132-3 Taffy Twist" }, 
      { hex: "#86BB9D", name: "1132-4 Grand Gusto" }, 
      { hex: "#64A281", name: "1132-5 Plumosa" }, 
      { hex: "#478865", name: "1132-6 Mallard Green" }, 
      { hex: "#236649", name: "1132-7 Brunswick" }, 
      { hex: "#DDE7DF", name: "1133-1 Icicle" }, 
      { hex: "#C8DBCE", name: "1133-2 Tenderness" }, 
      { hex: "#BDD0C3", name: "1133-3 Limelight" }, 
      { hex: "#9DB7A5", name: "1133-4 Silver Leaf" }, 
      { hex: "#7A9682", name: "1133-5 Slate Green" }, 
      { hex: "#56745F", name: "1133-6 Painted Turtle" }, 
      { hex: "#3F5948", name: "1133-7 Royal Hunter Green" }, 
      { hex: "#E6EAE0", name: "1134-1 Hydrangea Floret" }, 
      { hex: "#E2E8DF", name: "1134-2 Tidal Foam" }, 
      { hex: "#DEEAE0", name: "1134-3 Pine Frost" }, 
      { hex: "#B3C6B9", name: "1134-4 Pine Whisper" }, 
      { hex: "#899A8B", name: "1134-5 Birch Forest" }, 
      { hex: "#6A7B6B", name: "1134-6 English Ivy" }, 
      { hex: "#415241", name: "1134-7 Pine Forest" }, 
      { hex: "#E4E8E1", name: "1135-1 Poetic License" }, 
      { hex: "#DEE4DC", name: "1135-2 Morning Rush" }, 
      { hex: "#D7DFD6", name: "1135-3 Secret Crush" }, 
      { hex: "#B3C4BA", name: "1135-4 Aquamarine Dream" }, 
      { hex: "#83988C", name: "1135-5 Paradise Found" }, 
      { hex: "#728478", name: "1135-6 Calabash Clash" }, 
      { hex: "#54645C", name: "1135-7 Obligation" }, 
      { hex: "#E0E9E4", name: "1136-1 Sea Pearl" }, 
      { hex: "#DEE8E3", name: "1136-2 Rainsong" }, 
      { hex: "#D5E3DE", name: "1136-3 Morning Breeze" }, 
      { hex: "#BACBC4", name: "1136-4 Blue Shamrock" }, 
      { hex: "#91A49D", name: "1136-5 Spruce Shade" }, 
      { hex: "#71847D", name: "1136-6 Dwarf Spruce" }, 
      { hex: "#4A5B51", name: "1136-7 Dark Green Velvet" }, 
      { hex: "#ECF1EC", name: "1137-1 Spring Rain" }, 
      { hex: "#E6F0EA", name: "1137-2 Northern Lights" }, 
      { hex: "#DCECE7", name: "1137-3 Waterscape" }, 
      { hex: "#ADC8C0", name: "1137-4 Copenhagen" }, 
      { hex: "#829F96", name: "1137-5 Silver Laurel" }, 
      { hex: "#637D74", name: "1137-6 Salal Leaves" }, 
      { hex: "#395648", name: "1137-7 Black Spruce" }, 
      { hex: "#D8E5DD", name: "1138-1 Cactus Blossom" }, 
      { hex: "#C4D7CF", name: "1138-2 Geyser" }, 
      { hex: "#AFC7BF", name: "1138-3 Crystal Oasis" }, 
      { hex: "#8CAEA3", name: "1138-4 Donnegal" }, 
      { hex: "#6D9185", name: "1138-5 Pine Ridge" }, 
      { hex: "#477266", name: "1138-6 Christmas Ivy" }, 
      { hex: "#3C574E", name: "1138-7 Midnight Clover" }, 
      { hex: "#D3E5DB", name: "1139-1 Summer Breeze" }, 
      { hex: "#BFD6C8", name: "1139-2 Malted Mint" }, 
      { hex: "#A2C2B0", name: "1139-3 Green Silk" }, 
      { hex: "#80AA95", name: "1139-4 Catnip" }, 
      { hex: "#638F7B", name: "1139-5 Sheffield" }, 
      { hex: "#3D6C54", name: "1139-6 Country Club" }, 
      { hex: "#305A4A", name: "1139-7 Billiard Green" }, 
      { hex: "#D7E7E0", name: "1140-1 Echo" }, 
      { hex: "#BBDBD0", name: "1140-2 Sweet Nothings" }, 
      { hex: "#A1CDBF", name: "1140-3 Tarreyton" }, 
      { hex: "#7FB6A4", name: "1140-4 Key Largo" }, 
      { hex: "#599C89", name: "1140-5 Derby Green" }, 
      { hex: "#2B7B66", name: "1140-6 Pinehurst" }, 
      { hex: "#006A50", name: "1140-7 Peacock Green" }, 
      { hex: "#D8E7E1", name: "1141-1 Ice Floe" }, 
      { hex: "#C3DCD5", name: "1141-2 Green Wave" }, 
      { hex: "#AED0C9", name: "1141-3 Cassiopeia" }, 
      { hex: "#89BAB2", name: "1141-4 Caribbean Green" }, 
      { hex: "#609D91", name: "1141-5 Treasure Isle" }, 
      { hex: "#45867C", name: "1141-6 Carlisle" }, 
      { hex: "#116356", name: "1141-7 Deep Veridian" }, 
      { hex: "#D6E7E3", name: "1142-1 Peaceful Night" }, 
      { hex: "#CDE2DE", name: "1142-2 Big Sky" }, 
      { hex: "#BCD7D4", name: "1142-3 Veridian Green" }, 
      { hex: "#9BC2BD", name: "1142-4 Pitter Patter" }, 
      { hex: "#72A49F", name: "1142-5 Catalina" }, 
      { hex: "#4D8681", name: "1142-6 Jericho Jade" }, 
      { hex: "#10605A", name: "1142-7 Empress Teal" }, 
      { hex: "#E1EBE5", name: "1143-1 Delicate Mist" }, 
      { hex: "#C8D7D2", name: "1143-2 Blue Lullaby" }, 
      { hex: "#B7CCC7", name: "1143-3 Sea Sprite" }, 
      { hex: "#94B1A9", name: "1143-4 Parakeet Pete" }, 
      { hex: "#75978F", name: "1143-5 Yucca" }, 
      { hex: "#4C726B", name: "1143-6 Smoky Emerald" }, 
      { hex: "#2E5A50", name: "1143-7 Holly Leaf" }, 
      { hex: "#D0DBD7", name: "1144-1 Morning Fog" }, 
      { hex: "#CBD9D7", name: "1144-2 Thunder Bay" }, 
      { hex: "#BECFCD", name: "1144-3 Babbling Brook" }, 
      { hex: "#A2B7B5", name: "1144-4 Holly Glen" }, 
      { hex: "#7C9793", name: "1144-5 Green Granite" }, 
      { hex: "#56736F", name: "1144-6 Evening Emerald" }, 
      { hex: "#365955", name: "1144-7 Crystal Ball" }, 
      { hex: "#E7EEE8", name: "1145-1 Rain Drop" }, 
      { hex: "#DAE6E3", name: "1145-2 Jack Frost" }, 
      { hex: "#D6E5E2", name: "1145-3 Cave Pearl" }, 
      { hex: "#A8BBBA", name: "1145-4 Blue Willow" }, 
      { hex: "#809391", name: "1145-5 Scarborough" }, 
      { hex: "#576B6B", name: "1145-6 Juniper Berry" }, 
      { hex: "#3C504F", name: "1145-7 Night Watch" }, 
      { hex: "#DCE6E3", name: "1146-1 Mild Mint" }, 
      { hex: "#D3E0DE", name: "1146-2 Spring Mist" }, 
      { hex: "#C7DBD9", name: "1146-3 Julep Green" }, 
      { hex: "#A0C0BF", name: "1146-4 Frosty Glade" }, 
      { hex: "#6D9A9B", name: "1146-5 Palmetto" }, 
      { hex: "#487A7B", name: "1146-6 Lucky Shamrock" }, 
      { hex: "#155E60", name: "1146-7 Emerald Pool" }, 
      { hex: "#DCE6E5", name: "1147-1 Cameo Green" }, 
      { hex: "#CFE2E0", name: "1147-2 Mountain Dew" }, 
      { hex: "#BCDBDB", name: "1147-3 Misty Aqua" }, 
      { hex: "#8CC3C3", name: "1147-4 Aqua Fiesta" }, 
      { hex: "#57A1A0", name: "1147-5 Teal Bayou" }, 
      { hex: "#247E81", name: "1147-6 Jade Jewel" }, 
      { hex: "#00686D", name: "1147-7 Tahitian Treat" }, 
      { hex: "#D4E3E2", name: "1148-1 Meadowsweet Mist" }, 
      { hex: "#D5E2E1", name: "1148-2 Pistachio Cream" }, 
      { hex: "#CADADA", name: "1148-3 Cosmic Rays" }, 
      { hex: "#A1BDBF", name: "1148-4 Colonial Aqua" }, 
      { hex: "#7A999C", name: "1148-5 Cathedral Glass" }, 
      { hex: "#4B7378", name: "1148-6 Vining Ivy" }, 
      { hex: "#2A545C", name: "1148-7 Deep Emerald" }, 
      { hex: "#DBE4E5", name: "1149-1 Alpine Blue" }, 
      { hex: "#CEDEE2", name: "1149-2 High Sierra" }, 
      { hex: "#C2D3D6", name: "1149-3 Scandinavian Sky" }, 
      { hex: "#96AFB7", name: "1149-4 Mountain Stream" }, 
      { hex: "#708E95", name: "1149-5 Baritone" }, 
      { hex: "#4A6871", name: "1149-6 Azalea Leaf" }, 
      { hex: "#2D5360", name: "1149-7 Blue Bayberry" }, 
      { hex: "#D3E4E6", name: "1150-1 Aqua Sparkle" }, 
      { hex: "#CEE0E3", name: "1150-2 Water Lily" }, 
      { hex: "#B7D7DE", name: "1150-3 Everglade Mist" }, 
      { hex: "#8FBCC4", name: "1150-4 Kingston Aqua" }, 
      { hex: "#4E9AA8", name: "1150-5 Acapulco Cliffs" }, 
      { hex: "#1B7D8D", name: "1150-6 Bermuda" }, 
      { hex: "#00697C", name: "1150-7 Caribbean Splash" }, 
      { hex: "#D9E4E5", name: "1151-1 Beachcomber" }, 
      { hex: "#CBDEE2", name: "1151-2 Embellishment" }, 
      { hex: "#B4D0D9", name: "1151-3 Midsummer's Dream" }, 
      { hex: "#88B5C4", name: "1151-4 Crystal Lake" }, 
      { hex: "#5E97A9", name: "1151-5 Aqua Blue" }, 
      { hex: "#34788C", name: "1151-6 Adventure" }, 
      { hex: "#04627A", name: "1151-7 Jamaican Dream" }, 
      { hex: "#D9E3E5", name: "1152-1 Subtle Blue" }, 
      { hex: "#D1DEE4", name: "1152-2 Breakwater" }, 
      { hex: "#A8C0CE", name: "1152-3 Graceful" }, 
      { hex: "#7F9DAF", name: "1152-4 Americana" }, 
      { hex: "#638496", name: "1152-5 Granite Falls" }, 
      { hex: "#365D73", name: "1152-6 Brigade" }, 
      { hex: "#2B526A", name: "1152-7 Shimmering Sea" }, 
      { hex: "#E8EFEC", name: "1153-1 Ice Castles" }, 
      { hex: "#E3EBEA", name: "1153-2 Artemesia" }, 
      { hex: "#D7E0E2", name: "1153-3 Blue Smoke" }, 
      { hex: "#ADBFC8", name: "1153-4 Chambray" }, 
      { hex: "#7B8F99", name: "1153-5 Chalky Blue" }, 
      { hex: "#526771", name: "1153-6 Silent Night" }, 
      { hex: "#334B58", name: "1153-7 Sailor's Coat" }, 
      { hex: "#ECF0EB", name: "1154-1 Shooting Star" }, 
      { hex: "#D4E2E6", name: "1154-2 Aloof" }, 
      { hex: "#CDDCE3", name: "1154-3 Dartmoor Mist" }, 
      { hex: "#ADC6D3", name: "1154-4 Twinkle" }, 
      { hex: "#819DAA", name: "1154-5 Serene Stream" }, 
      { hex: "#5D7B89", name: "1154-6 Prussian Blue" }, 
      { hex: "#2D5367", name: "1154-7 Regatta Bay" }, 
      { hex: "#E1EAEC", name: "1155-1 Summer Shower" }, 
      { hex: "#DFEBEE", name: "1155-2 Prelude" }, 
      { hex: "#CEDDE7", name: "1155-3 Simply Elegant" }, 
      { hex: "#BCCEDB", name: "1155-4 Constellation" }, 
      { hex: "#8EA7B9", name: "1155-5 Dresden Dream" }, 
      { hex: "#607B8E", name: "1155-6 Canyon Blue" }, 
      { hex: "#2E5169", name: "1155-7 Blue Lava" }, 
      { hex: "#DEE6E7", name: "1156-1 Austrian Ice" }, 
      { hex: "#CAD7DE", name: "1156-2 Bit Of Heaven" }, 
      { hex: "#A2BACB", name: "1156-3 Always Blue" }, 
      { hex: "#7595AB", name: "1156-4 American Anthem" }, 
      { hex: "#53778F", name: "1156-5 Smoke Blue" }, 
      { hex: "#2D5975", name: "1156-6 Mountain Lake" }, 
      { hex: "#2C4D69", name: "1156-7 Celestial Blue" }, 
      { hex: "#D7E2E5", name: "1157-1 Glassine" }, 
      { hex: "#C5D9E3", name: "1157-2 Blue Pearl" }, 
      { hex: "#ABC8D8", name: "1157-3 Sonata" }, 
      { hex: "#82ACC4", name: "1157-4 Arabella" }, 
      { hex: "#5692B2", name: "1157-5 Vanity" }, 
      { hex: "#347699", name: "1157-6 Cosmic Dust" }, 
      { hex: "#005E88", name: "1157-7 Blue Flame" }, 
      { hex: "#D8E4E8", name: "1158-1 Baby's Breath" }, 
      { hex: "#C3D9E4", name: "1158-2 Magic Wand" }, 
      { hex: "#A4C3D7", name: "1158-3 Blue Bows" }, 
      { hex: "#78A7C3", name: "1158-4 Serene Sea" }, 
      { hex: "#528BAB", name: "1158-5 Cosmopolitan" }, 
      { hex: "#296D93", name: "1158-6 Blue Oasis" }, 
      { hex: "#185887", name: "1158-7 Stunning Sapphire" }, 
      { hex: "#DFE7E8", name: "1159-1 Filigree" }, 
      { hex: "#C4D3DC", name: "1159-2 Sentimental Lady" }, 
      { hex: "#A3BBCD", name: "1159-3 Heavenly Blue" }, 
      { hex: "#789BB6", name: "1159-4 Walden Pond" }, 
      { hex: "#507B9A", name: "1159-5 Stormy Ridge" }, 
      { hex: "#1D5C83", name: "1159-6 Animation" }, 
      { hex: "#2B4D68", name: "1159-7 Singing The Blues" }, 
      { hex: "#DAE1E3", name: "1160-1 Harbor Mist" }, 
      { hex: "#C1CEDA", name: "1160-2 Magical" }, 
      { hex: "#ABBED0", name: "1160-3 Rendezvous" }, 
      { hex: "#8DA8BE", name: "1160-4 Kaleidoscope" }, 
      { hex: "#5A809E", name: "1160-5 Blue Beads" }, 
      { hex: "#3A5F7D", name: "1160-6 Chinese Porcelain" }, 
      { hex: "#2A4B6E", name: "1160-7 Blue Tang" }, 
      { hex: "#DAE3E7", name: "1161-1 Cityscape" }, 
      { hex: "#BED1E1", name: "1161-2 Sleep Baby Sleep" }, 
      { hex: "#A1BED9", name: "1161-3 Everlasting" }, 
      { hex: "#729CC2", name: "1161-4 Blue Promise" }, 
      { hex: "#4F84AF", name: "1161-5 Ship's Harbor" }, 
      { hex: "#286492", name: "1161-6 Starry Night" }, 
      { hex: "#234E86", name: "1161-7 Brilliant Blue" }, 
      { hex: "#D7E0E7", name: "1162-1 Harbor Light" }, 
      { hex: "#C7D3E0", name: "1162-2 Stratosphere" }, 
      { hex: "#ADC0D6", name: "1162-3 Blue Thistle" }, 
      { hex: "#7E9EC2", name: "1162-4 Alaskan Blue" }, 
      { hex: "#5D84B1", name: "1162-5 Shrinking Violet" }, 
      { hex: "#326395", name: "1162-6 Teeny Bikini" }, 
      { hex: "#314A76", name: "1162-7 Dragonfly" }, 
      { hex: "#DDE4E8", name: "1163-1 Elusive Blue" }, 
      { hex: "#C7D1DB", name: "1163-2 Memory Lane" }, 
      { hex: "#B6C3D1", name: "1163-3 Pageant Song" }, 
      { hex: "#9EAFC2", name: "1163-4 Sterling Silver" }, 
      { hex: "#6C8096", name: "1163-5 Silver Blueberry" }, 
      { hex: "#4C6177", name: "1163-6 Blue Fjord" }, 
      { hex: "#314D67", name: "1163-7 Blueberry Pie" }, 
      { hex: "#E8ECEE", name: "1164-1 Windswept" }, 
      { hex: "#DAE4EE", name: "1164-2 Iceberg" }, 
      { hex: "#D6DFE7", name: "1164-3 Blustery Day" }, 
      { hex: "#AEBBD0", name: "1164-4 Sailor Boy" }, 
      { hex: "#8290A6", name: "1164-5 Blueberry Muffin" }, 
      { hex: "#627188", name: "1164-6 Blue Cloud" }, 
      { hex: "#384A66", name: "1164-7 Annapolis Blue" }, 
      { hex: "#DFE2E5", name: "1165-1 January Dawn" }, 
      { hex: "#D0D7DF", name: "1165-2 Twinkle Blue" }, 
      { hex: "#BFC7D4", name: "1165-3 Northern Exposure" }, 
      { hex: "#A4B0C4", name: "1165-4 Innuendo" }, 
      { hex: "#7B8CA8", name: "1165-5 Evening Hush" }, 
      { hex: "#556682", name: "1165-6 Stained Glass" }, 
      { hex: "#3A405A", name: "1165-7 Victory Blue" }, 
      { hex: "#DDE2E6", name: "1166-1 Bright Star" }, 
      { hex: "#D4DAE2", name: "1166-2 Aster Petal" }, 
      { hex: "#BBC6D9", name: "1166-3 Blue Opal" }, 
      { hex: "#99AAC8", name: "1166-4 Easter Egg" }, 
      { hex: "#6D86B6", name: "1166-5 Kimono" }, 
      { hex: "#4F6997", name: "1166-6 Blue Odyssey" }, 
      { hex: "#374874", name: "1166-7 Daring Indigo" }, 
      { hex: "#E3E5E8", name: "1167-1 Arctic Dawn" }, 
      { hex: "#DCDFE5", name: "1167-2 Windsor Haze" }, 
      { hex: "#CBD0DD", name: "1167-3 Debonaire" }, 
      { hex: "#A7B0CC", name: "1167-4 Lovely Lilac" }, 
      { hex: "#818DB3", name: "1167-5 Skysail Blue" }, 
      { hex: "#627099", name: "1167-6 Blueberry Patch" }, 
      { hex: "#465383", name: "1167-7 Blue Jewel" }, 
      { hex: "#E6E6E7", name: "1168-1 Moon Lily" }, 
      { hex: "#DADBDF", name: "1168-2 Cumberland Fog" }, 
      { hex: "#C7CCD8", name: "1168-3 Pale Violet" }, 
      { hex: "#A4ABBF", name: "1168-4 Lilac Time" }, 
      { hex: "#838BA4", name: "1168-5 Violet Aura" }, 
      { hex: "#606A88", name: "1168-6 Grape Haze" }, 
      { hex: "#3D496D", name: "1168-7 Egyptian Violet" }, 
      { hex: "#E3E4E5", name: "1169-1 Windswept Beach" }, 
      { hex: "#DBDCE2", name: "1169-2 Rare Orchid" }, 
      { hex: "#D1D2DC", name: "1169-3 Glacier Pearl" }, 
      { hex: "#AFB2C4", name: "1169-4 Timeless Lilac" }, 
      { hex: "#898CA3", name: "1169-5 Violet Verbena" }, 
      { hex: "#6B6D85", name: "1169-6 Great Grape" }, 
      { hex: "#464B6A", name: "1169-7 Royal Hyacinth" }, 
      { hex: "#E2E3EB", name: "1170-1 Water Iris" }, 
      { hex: "#DDE0EA", name: "1170-2 Monet's Lavender" }, 
      { hex: "#D1D3E0", name: "1170-3 Violet Shadow" }, 
      { hex: "#B1B3CB", name: "1170-4 Spring Lilac" }, 
      { hex: "#8E90B4", name: "1170-5 Fresh Lavender" }, 
      { hex: "#686B93", name: "1170-6 Wild Wisteria" }, 
      { hex: "#4D517F", name: "1170-7 Roman Violet" }, 
      { hex: "#E5E7E8", name: "1171-1 Silent Delight" }, 
      { hex: "#E4E6EA", name: "1171-2 Little Dipper" }, 
      { hex: "#DADEE6", name: "1171-3 Irradiant Iris" }, 
      { hex: "#B8B9CB", name: "1171-4 Cosmic" }, 
      { hex: "#9090A2", name: "1171-5 Cotton Flannel" }, 
      { hex: "#6E6F82", name: "1171-6 Old Mill Blue" }, 
      { hex: "#464960", name: "1171-7 Chinaberry" }, 
      { hex: "#EEEDEA", name: "1172-1 Snow Storm" }, 
      { hex: "#EAE8EC", name: "1172-2 Winter Morn" }, 
      { hex: "#D4CFD6", name: "1172-3 Jam Session" }, 
      { hex: "#B9B3BF", name: "1172-4 Ash Grove" }, 
      { hex: "#928A98", name: "1172-5 Tin Lizzie" }, 
      { hex: "#6A6472", name: "1172-6 Silverado" }, 
      { hex: "#4A4354", name: "1172-7 Blackberry" }, 
      { hex: "#DFDEE5", name: "1173-1 Violet Echo" }, 
      { hex: "#E0DEE3", name: "1173-2 February Frost" }, 
      { hex: "#D3D1DC", name: "1173-3 Frosted Lilac" }, 
      { hex: "#BEBBC9", name: "1173-4 Silverberry" }, 
      { hex: "#9B95A9", name: "1173-5 Purple Surf" }, 
      { hex: "#78738B", name: "1173-6 Plum Shade" }, 
      { hex: "#544F66", name: "1173-7 Magic Spell" }, 
      { hex: "#E4E1E4", name: "1174-1 Orchid Blossom" }, 
      { hex: "#DAD6DF", name: "1174-2 Violet Whimsey" }, 
      { hex: "#CDC8D2", name: "1174-3 Silver Chalice" }, 
      { hex: "#B9B3C2", name: "1174-4 Cloudberry" }, 
      { hex: "#9B8FA6", name: "1174-5 Smoky Grape" }, 
      { hex: "#736A86", name: "1174-6 Purple Rain" }, 
      { hex: "#4E4260", name: "1174-7 Royal Indigo" }, 
      { hex: "#E5E2E7", name: "1175-1 Violet Hush" }, 
      { hex: "#DEDBE5", name: "1175-2 Pale Orchid" }, 
      { hex: "#D3D0DD", name: "1175-3 Lavender Haze" }, 
      { hex: "#BEB8CD", name: "1175-4 Wild Lilac" }, 
      { hex: "#988EB4", name: "1175-5 French Violet" }, 
      { hex: "#736993", name: "1175-6 Purple Grapes" }, 
      { hex: "#534A77", name: "1175-7 Imperial Purple" }, 
      { hex: "#E6DEE6", name: "1176-1 Peekaboo" }, 
      { hex: "#E5DDE7", name: "1176-2 Orchid Lane" }, 
      { hex: "#D6CBDA", name: "1176-3 Dusky Lilac" }, 
      { hex: "#C2B1C8", name: "1176-4 Purple Essence" }, 
      { hex: "#A387AC", name: "1176-5 Violet Eclipse" }, 
      { hex: "#886793", name: "1176-6 Mirabella" }, 
      { hex: "#694878", name: "1176-7 Perfectly Purple" }, 
      { hex: "#E7E3E7", name: "1177-1 Orchid Petal" }, 
      { hex: "#E0D8DF", name: "1177-2 Little Lilac" }, 
      { hex: "#D6C7D6", name: "1177-3 Shy Violet" }, 
      { hex: "#C2AEC3", name: "1177-4 Lavish Lavender" }, 
      { hex: "#A489A3", name: "1177-5 Pale Plum" }, 
      { hex: "#7E667F", name: "1177-6 Grape Jelly" }, 
      { hex: "#5F4561", name: "1177-7 Pansy Petal" }, 
      { hex: "#E7DFE3", name: "1178-1 Lavender Twilight" }, 
      { hex: "#E5D8E1", name: "1178-2 Wine Frost" }, 
      { hex: "#DCCAD8", name: "1178-3 Pale Mauve" }, 
      { hex: "#CFB7C9", name: "1178-4 Soft Amethyst" }, 
      { hex: "#AF8EA5", name: "1178-5 Palisade Orchid" }, 
      { hex: "#87657E", name: "1178-6 Blackberry Jam" }, 
      { hex: "#654161", name: "1178-7 Royal Plum" }, 
      { hex: "#E7E1E3", name: "1179-1 Misty Morn" }, 
      { hex: "#E1D9DC", name: "1179-2 Smoky Orchid" }, 
      { hex: "#DBCCD3", name: "1179-3 Silver Mauve" }, 
      { hex: "#CEB9C4", name: "1179-4 Rose Marble" }, 
      { hex: "#B495A4", name: "1179-5 Ashberry" }, 
      { hex: "#8E6278", name: "1179-6 Victorian Plum" }, 
      { hex: "#603E53", name: "1179-7 Love Potion" }, 
      { hex: "#E5DAE1", name: "1180-1 Violet Vapor" }, 
      { hex: "#E6D9E2", name: "1180-2 Rajah Rose" }, 
      { hex: "#E5CFDE", name: "1180-3 Summer Clover" }, 
      { hex: "#D8B7CF", name: "1180-4 Light Mulberry" }, 
      { hex: "#BF91B2", name: "1180-5 Mauve Magic" }, 
      { hex: "#A16C94", name: "1180-6 Flowering Raspberry" }, 
      { hex: "#7F4774", name: "1180-7 Magic Magenta" }, 
      { hex: "#F3DFE3", name: "1181-1 Candy Mix" }, 
      { hex: "#F3D8E0", name: "1181-2 Brittany's Bow" }, 
      { hex: "#F4C8D5", name: "1181-3 Mountain Laurel" }, 
      { hex: "#EFA7BF", name: "1181-4 Tickled Pink" }, 
      { hex: "#E585A5", name: "1181-5 Rose Glory" }, 
      { hex: "#DA6D91", name: "1181-6 Paris Pink" }, 
      { hex: "#C6577C", name: "1181-7 Panama Rose" }, 
      { hex: "#EFE1E4", name: "1182-1 Pink Booties" }, 
      { hex: "#F0D6DD", name: "1182-2 Blushing Bride" }, 
      { hex: "#EEC8D3", name: "1182-3 Pale Primrose" }, 
      { hex: "#E3A4B8", name: "1182-4 Garden Party" }, 
      { hex: "#D6859F", name: "1182-5 Primrose" }, 
      { hex: "#C66787", name: "1182-6 Geranium Pink" }, 
      { hex: "#AB446B", name: "1182-7 Fuchsia Flock" }, 
      { hex: "#F0DEE0", name: "1183-1 Ballerina" }, 
      { hex: "#F1D3D9", name: "1183-2 Cradle Pink" }, 
      { hex: "#ECBFC9", name: "1183-3 Rose Melody" }, 
      { hex: "#E69DAD", name: "1183-4 Brandywine" }, 
      { hex: "#D1768C", name: "1183-5 Razzberries" }, 
      { hex: "#C7607B", name: "1183-6 Cherry Pink" }, 
      { hex: "#AC3E5F", name: "1183-7 Heart's Desire" }, 
      { hex: "#F4E4E5", name: "1184-1 Gaiety" }, 
      { hex: "#F5CDD2", name: "1184-2 Pleasing Pink" }, 
      { hex: "#F5B3BC", name: "1184-3 Powder Rose" }, 
      { hex: "#F392A0", name: "1184-4 Pink Punch" }, 
      { hex: "#E26B81", name: "1184-5 Cherry Brandy" }, 
      { hex: "#D45871", name: "1184-6 Kenny's Kiss" }, 
      { hex: "#CA4B65", name: "1184-7 California Wine" }, 
      { hex: "#F4DBD9", name: "1185-1 Fresco" }, 
      { hex: "#F7CCCD", name: "1185-2 Kendall Rose" }, 
      { hex: "#F6B5B6", name: "1185-3 Precious Pink" }, 
      { hex: "#F3949B", name: "1185-4 Primrose Garden" }, 
      { hex: "#E66A77", name: "1185-5 Bleeding Heart" }, 
      { hex: "#DA5265", name: "1185-6 Cranberry Splash" }, 
      { hex: "#C53A4B", name: "1185-7 Calypso Berry" }, 
      { hex: "#F2DBDB", name: "1186-1 Lover's Knot" }, 
      { hex: "#F3CACB", name: "1186-2 Blushing Senorita" }, 
      { hex: "#F1B3B6", name: "1186-3 Jaguar Rose" }, 
      { hex: "#E68E96", name: "1186-4 Pink Flambe" }, 
      { hex: "#D16D76", name: "1186-5 Mexican Chile" }, 
      { hex: "#BB4F5C", name: "1186-6 Salsa Diane" }, 
      { hex: "#A83E4C", name: "1186-7 Red Licorice" }, 
      { hex: "#F3D9D6", name: "1187-1 Scented Valentine" }, 
      { hex: "#F3D2CF", name: "1187-2 Lady Pink" }, 
      { hex: "#F2C1C0", name: "1187-3 Silver Strawberry" }, 
      { hex: "#EC9B9D", name: "1187-4 River Rouge" }, 
      { hex: "#D87678", name: "1187-5 Red Cedar" }, 
      { hex: "#C3585C", name: "1187-6 Bonfire" }, 
      { hex: "#AC3A3E", name: "1187-7 Red Gumball" }, 
      { hex: "#F4E4E0", name: "1188-1 Rockabye Baby" }, 
      { hex: "#F6D8D7", name: "1188-2 Frosted Tulip" }, 
      { hex: "#F7C2BF", name: "1188-3 Rosewine" }, 
      { hex: "#F6A09D", name: "1188-4 Salmon Pink" }, 
      { hex: "#EC7878", name: "1188-5 Siesta Rose" }, 
      { hex: "#E15F65", name: "1188-6 Briquette" }, 
      { hex: "#C6494C", name: "1188-7 Burnt Red" }, 
      { hex: "#F5E2DE", name: "1189-1 Floral Linen" }, 
      { hex: "#F6DBD3", name: "1189-2 Pink Sangria" }, 
      { hex: "#F7CAC1", name: "1189-3 Rose Pink" }, 
      { hex: "#F7B1A6", name: "1189-4 Riviera Rose" }, 
      { hex: "#EE867D", name: "1189-5 Smoked Salmon" }, 
      { hex: "#D1584C", name: "1189-6 Wet Coral" }, 
      { hex: "#B44940", name: "1189-7 Teaberry Blossom" }, 
      { hex: "#F3E0DB", name: "1190-1 Limoge Pink" }, 
      { hex: "#F2DBD6", name: "1190-2 Ballet Slipper" }, 
      { hex: "#F3C8C2", name: "1190-3 Sonia Rose" }, 
      { hex: "#EAAAA2", name: "1190-4 Soft Salmon" }, 
      { hex: "#DB8079", name: "1190-5 Cranapple" }, 
      { hex: "#C26157", name: "1190-6 Firecracker" }, 
      { hex: "#AA423A", name: "1190-7 Rum Punch" }, 
      { hex: "#F3ECE7", name: "1191-1 Summer Lily" }, 
      { hex: "#F2E3DC", name: "1191-2 Peach Tone" }, 
      { hex: "#EFC4BB", name: "1191-3 Peach Ash" }, 
      { hex: "#E5A090", name: "1191-4 Coral Blush" }, 
      { hex: "#D78775", name: "1191-5 Freckles" }, 
      { hex: "#C3705F", name: "1191-6 Cajun Spice" }, 
      { hex: "#AF5941", name: "1191-7 Glowing Firelight" }, 
      { hex: "#F3E5DC", name: "1192-1 Champagne Ice" }, 
      { hex: "#F3E0D8", name: "1192-2 Peachskin" }, 
      { hex: "#F0D1C8", name: "1192-3 Chic Peach" }, 
      { hex: "#EFC1B5", name: "1192-4 New Clay" }, 
      { hex: "#E49C86", name: "1192-5 Opal Fire" }, 
      { hex: "#D88167", name: "1192-6 Summer Sunset" }, 
      { hex: "#BF5B3C", name: "1192-7 Tabasco" }, 
      { hex: "#F3E9E0", name: "1193-1 Scalloped Shell" }, 
      { hex: "#F6E2D8", name: "1193-2 Flamingo Peach" }, 
      { hex: "#F7DFD7", name: "1193-3 Cameo Rose" }, 
      { hex: "#F5C8BB", name: "1193-4 Sweet Angel" }, 
      { hex: "#F9A48E", name: "1193-5 Coral Serenade" }, 
      { hex: "#DF745B", name: "1193-6 Rustic Pottery" }, 
      { hex: "#C9543A", name: "1193-7 Cinnamon Stone" }, 
      { hex: "#F4E8E1", name: "1194-1 Jasmine Flower" }, 
      { hex: "#F5E5DC", name: "1194-2 La Minuet" }, 
      { hex: "#F4DED3", name: "1194-3 Ambrosia" }, 
      { hex: "#F0B9A9", name: "1194-4 Sweet Sheba" }, 
      { hex: "#EA9073", name: "1194-5 Warm Welcome" }, 
      { hex: "#E07757", name: "1194-6 Clay Pot" }, 
      { hex: "#BC5339", name: "1194-7 Orange Vermillion" }, 
      { hex: "#F2EBE1", name: "1195-1 Pale Ecru" }, 
      { hex: "#F4E2D4", name: "1195-2 Peach Everlasting" }, 
      { hex: "#F1D4C4", name: "1195-3 Melon Pink" }, 
      { hex: "#F0B599", name: "1195-4 Crab Bisque" }, 
      { hex: "#F2A37D", name: "1195-5 Coral Silk" }, 
      { hex: "#E88A5B", name: "1195-6 Indiana Clay" }, 
      { hex: "#D86F3C", name: "1195-7 Field Poppy" }, 
      { hex: "#F3DDCD", name: "1196-1 Peachtree" }, 
      { hex: "#F4D9C8", name: "1196-2 Melon Ice" }, 
      { hex: "#F5D5C2", name: "1196-3 Dreamsicle" }, 
      { hex: "#F5BE9D", name: "1196-4 Shrimp Boat" }, 
      { hex: "#F7A270", name: "1196-5 Copper River" }, 
      { hex: "#F09056", name: "1196-6 Chinese Lantern" }, 
      { hex: "#E68750", name: "1196-7 Orange Poppy" }, 
      { hex: "#F2E9DE", name: "1197-1 Tangelo Cream" }, 
      { hex: "#F2E1D2", name: "1197-2 Light Peach" }, 
      { hex: "#F6D8BE", name: "1197-3 Bisque" }, 
      { hex: "#F7C5A0", name: "1197-4 Shrimp Toast" }, 
      { hex: "#FAAC72", name: "1197-5 Orange Marmalade" }, 
      { hex: "#F69A54", name: "1197-6 Fall Leaf" }, 
      { hex: "#EF924A", name: "1197-7 Carmelized Orange" }, 
      { hex: "#F4DECB", name: "1198-1 Pecan Sandie" }, 
      { hex: "#F3D4BF", name: "1198-2 Budding Peach" }, 
      { hex: "#F2C6A7", name: "1198-3 Citrus Sachet" }, 
      { hex: "#EDAA80", name: "1198-4 Orange Liqueur" }, 
      { hex: "#DC8C59", name: "1198-5 Carrot Cake" }, 
      { hex: "#CE7639", name: "1198-6 Tiger Tail" }, 
      { hex: "#C26A35", name: "1198-7 Sesame Crunch" }, 
      { hex: "#F4E2D6", name: "1199-1 Alyssa" }, 
      { hex: "#F3DFD4", name: "1199-2 Peach Shortcake" }, 
      { hex: "#EDC7B6", name: "1199-3 Spiced Orange" }, 
      { hex: "#E4B095", name: "1199-4 Hush Puppy" }, 
      { hex: "#CF8D6C", name: "1199-5 Cinnamon Brandy" }, 
      { hex: "#C37C59", name: "1199-6 Brown Clay" }, 
      { hex: "#AC5E3A", name: "1199-7 Fragrant Cloves" }, 
      { hex: "#F3E4D5", name: "1200-1 China Doll" }, 
      { hex: "#F4D9C5", name: "1200-2 Sourpatch Peach" }, 
      { hex: "#F0C3A7", name: "1200-3 Siesta" }, 
      { hex: "#E6A57F", name: "1200-4 Orange Clay" }, 
      { hex: "#CF875E", name: "1200-5 Georgian Leather" }, 
      { hex: "#C17444", name: "1200-6 Ginger Root" }, 
      { hex: "#B66A3C", name: "1200-7 Mincemeat" }, 
      { hex: "#F1E4D7", name: "1201-1 Uptown Taupe" }, 
      { hex: "#EFDCCA", name: "1201-2 Tea Biscuit" }, 
      { hex: "#EFCDB4", name: "1201-3 Peach Darling" }, 
      { hex: "#E8B793", name: "1201-4 Gentle Doe" }, 
      { hex: "#D59466", name: "1201-5 Pumpkin Patch" }, 
      { hex: "#CC8149", name: "1201-6 Gingerbread" }, 
      { hex: "#BC6F37", name: "1201-7 Lucky Penny" }, 
      { hex: "#F1E9DD", name: "1202-1 Vanilla Tan" }, 
      { hex: "#F3E3D1", name: "1202-2 Peach Surprise" }, 
      { hex: "#F3DCC6", name: "1202-3 Crisp Won Ton" }, 
      { hex: "#EEC9AA", name: "1202-4 Caramel Ice" }, 
      { hex: "#E2AC78", name: "1202-5 Buffalo Trail" }, 
      { hex: "#D09258", name: "1202-6 Polo Pony" }, 
      { hex: "#C27F38", name: "1202-7 Ginger Beer" }, 
      { hex: "#F3ECDC", name: "1203-1 Spun Cotton" }, 
      { hex: "#F5E9D5", name: "1203-2 Mimosa" }, 
      { hex: "#F4DEBF", name: "1203-3 Peach Dip" }, 
      { hex: "#F9D09F", name: "1203-4 Ginger Peach" }, 
      { hex: "#FBC17B", name: "1203-5 Zing" }, 
      { hex: "#F2AD62", name: "1203-6 Goldfish" }, 
      { hex: "#ED9B44", name: "1203-7 Cornucopia" }, 
      { hex: "#F4EEDC", name: "1204-1 Spice Ivory" }, 
      { hex: "#F3EAD2", name: "1204-2 Vanilla Wafer" }, 
      { hex: "#F9E7BF", name: "1204-3 Creamy Custard" }, 
      { hex: "#FBDCA8", name: "1204-4 Doodle" }, 
      { hex: "#F9C982", name: "1204-5 Chunk Of Cheddar" }, 
      { hex: "#F7C070", name: "1204-6 Golden Opportunity" }, 
      { hex: "#F7B74E", name: "1204-7 Mango Margarita" }, 
      { hex: "#F4F0DE", name: "1205-1 Combed Cotton" }, 
      { hex: "#F5EFD6", name: "1205-2 Soft Cream" }, 
      { hex: "#F8E9C2", name: "1205-3 Barely Butter" }, 
      { hex: "#FCDFA4", name: "1205-4 Honey Bee" }, 
      { hex: "#FDD792", name: "1205-5 Evening Glow" }, 
      { hex: "#FFC863", name: "1205-6 Honey Pot" }, 
      { hex: "#FFBC35", name: "1205-7 Fall Gold" }, 
      { hex: "#F4F0DA", name: "1206-1 Lotus Flower" }, 
      { hex: "#F6EECD", name: "1206-2 Silk Sails" }, 
      { hex: "#F7ECCA", name: "1206-3 Shiny Silk" }, 
      { hex: "#FBE4AF", name: "1206-4 Sawdust" }, 
      { hex: "#FFD978", name: "1206-5 Spiced Butternut" }, 
      { hex: "#FFD15C", name: "1206-6 Fuzzy Navel" }, 
      { hex: "#FFC632", name: "1206-7 Rise-n-shine" }, 
      { hex: "#F1EDE0", name: "1207-1 Candlelit Beige" }, 
      { hex: "#F4E8D1", name: "1207-2 Golden Mushroom" }, 
      { hex: "#F3E2C6", name: "1207-3 Honey Beige" }, 
      { hex: "#EFCEA0", name: "1207-4 Toffee Crunch" }, 
      { hex: "#E1B270", name: "1207-5 Lion's Mane" }, 
      { hex: "#CC974D", name: "1207-6 Allspice" }, 
      { hex: "#B98033", name: "1207-7 Cider Toddy" }, 
      { hex: "#F1EEE2", name: "1208-1 Accolade" }, 
      { hex: "#F3E9CF", name: "1208-2 Spice Delight" }, 
      { hex: "#F3DFB6", name: "1208-3 Belgian Waffle" }, 
      { hex: "#ECC481", name: "1208-4 Gold Buff" }, 
      { hex: "#DFAC59", name: "1208-5 Brown Mustard" }, 
      { hex: "#CE9844", name: "1208-6 Mayan Treasure" }, 
      { hex: "#BB852F", name: "1208-7 Gothic Gold" }, 
      { hex: "#F3EDD9", name: "1209-1 Satin Weave" }, 
      { hex: "#F4E5C5", name: "1209-2 Sausalito" }, 
      { hex: "#F5DEAE", name: "1209-3 Dusty Yellow" }, 
      { hex: "#F3C775", name: "1209-4 Yukon Gold" }, 
      { hex: "#EDB856", name: "1209-5 Yellow Coneflower" }, 
      { hex: "#E1A84B", name: "1209-6 Brass Mesh" }, 
      { hex: "#C89134", name: "1209-7 Mecca Gold" }, 
      { hex: "#F4EBD0", name: "1210-1 Crisp Candlelight" }, 
      { hex: "#F6E5B9", name: "1210-2 Gentle Glow" }, 
      { hex: "#F6E0A9", name: "1210-3 Visionary" }, 
      { hex: "#F6D48D", name: "1210-4 Maybe Maui" }, 
      { hex: "#ECBE63", name: "1210-5 Bright Idea" }, 
      { hex: "#E3B34C", name: "1210-6 Va Va Voom" }, 
      { hex: "#D6A332", name: "1210-7 Curry Sauce" }, 
      { hex: "#F3F0D6", name: "1211-1 Good Graces" }, 
      { hex: "#F3EFCD", name: "1211-2 Heavenly Haze" }, 
      { hex: "#F9ECB6", name: "1211-3 Easy On The Eyes" }, 
      { hex: "#FCE79A", name: "1211-4 Twinkle Little Star" }, 
      { hex: "#F9D97B", name: "1211-5 Firelight" }, 
      { hex: "#FBD05C", name: "1211-6 Beach Party" }, 
      { hex: "#FFC943", name: "1211-7 Be Daring" }, 
      { hex: "#F1F0D6", name: "1212-1 Capri Cream" }, 
      { hex: "#F4EFC3", name: "1212-2 Banana Pudding" }, 
      { hex: "#F5EDB2", name: "1212-3 Sunbeam" }, 
      { hex: "#F6EBA1", name: "1212-4 Lazy Daizy" }, 
      { hex: "#FDEA83", name: "1212-5 Citrus Punch" }, 
      { hex: "#FFDF38", name: "1212-6 Acorn Squash" }, 
      { hex: "#FFD637", name: "1212-7 Flirtatious" }, 
      { hex: "#F0F0E0", name: "1213-1 Sail Cloth" }, 
      { hex: "#F2EFCD", name: "1213-2 Blonde Beauty" }, 
      { hex: "#F4EEBA", name: "1213-3 Butter" }, 
      { hex: "#F5EDAE", name: "1213-4 Golden Straw" }, 
      { hex: "#F8EB97", name: "1213-5 Calabash" }, 
      { hex: "#F6DB5D", name: "1213-6 Dilly Dally" }, 
      { hex: "#EFCC44", name: "1213-7 Crushed Pineapple" }, 
      { hex: "#F0EDDB", name: "1214-1 Cake Batter" }, 
      { hex: "#F0EAD2", name: "1214-2 Golden Fleece" }, 
      { hex: "#F7EAB9", name: "1214-3 Banana Brulee" }, 
      { hex: "#F3E4A7", name: "1214-4 Butterfly Bush" }, 
      { hex: "#F6D76E", name: "1214-5 Forsythia Blossom" }, 
      { hex: "#E4C14D", name: "1214-6 Indian Maize" }, 
      { hex: "#D8AD39", name: "1214-7 Yarrow" }, 
      { hex: "#F1F1E6", name: "1215-1 Clear Yellow" }, 
      { hex: "#F0EDD1", name: "1215-2 Bright Laughter" }, 
      { hex: "#F0E7A9", name: "1215-3 Pineapple Delight" }, 
      { hex: "#EFDE75", name: "1215-4 Canary Yellow" }, 
      { hex: "#E2C74F", name: "1215-5 Golden Yarrow" }, 
      { hex: "#CEB02A", name: "1215-6 Grass Daisy" }, 
      { hex: "#B8A02A", name: "1215-7 Pollination" }, 
      { hex: "#EEF0D6", name: "1216-1 Morning Glow" }, 
      { hex: "#EAEFCE", name: "1216-2 Cool Yellow" }, 
      { hex: "#E9EDBD", name: "1216-3 Spring Blossom" }, 
      { hex: "#EBECA7", name: "1216-4 Lemon Pepper" }, 
      { hex: "#ECE678", name: "1216-5 Fresh Lemonade" }, 
      { hex: "#E6D943", name: "1216-6 Citrus Spice" }, 
      { hex: "#D9C737", name: "1216-7 Gone Giddy" }, 
      { hex: "#EFF0D3", name: "1217-1 Giggle" }, 
      { hex: "#EAECB9", name: "1217-2 Limited Lime" }, 
      { hex: "#E4E8A7", name: "1217-3 Hip Hop" }, 
      { hex: "#D9E6A6", name: "1217-4 Mermaid Tears" }, 
      { hex: "#CFDB8D", name: "1217-5 Lime Splash" }, 
      { hex: "#CDD47F", name: "1217-6 Green Gecko" }, 
      { hex: "#C9CC4A", name: "1217-7 Slap Happy" }, 
      { hex: "#EDEEC5", name: "1218-1 Oh Dahling" }, 
      { hex: "#EDEBB4", name: "1218-2 Mystic Melon" }, 
      { hex: "#E1DD8E", name: "1218-3 Lively Laugh" }, 
      { hex: "#D5CE69", name: "1218-4 Force Of Nature" }, 
      { hex: "#BEB755", name: "1218-5 Parachute" }, 
      { hex: "#A6A23F", name: "1218-6 Machine Green" }, 
      { hex: "#9B983D", name: "1218-7 Be Yourself" }, 
      { hex: "#EBF0D6", name: "1219-1 Plain And Simple" }, 
      { hex: "#E3EBAE", name: "1219-2 Daydream" }, 
      { hex: "#D9E49E", name: "1219-3 Curious" }, 
      { hex: "#CCD87A", name: "1219-4 Goody Gumdrop" }, 
      { hex: "#BECE61", name: "1219-5 Boogie Blast" }, 
      { hex: "#AFBB42", name: "1219-6 Hopscotch" }, 
      { hex: "#9AA22B", name: "1219-7 Lichen" }, 
      { hex: "#ECF0DA", name: "1220-1 Memoir" }, 
      { hex: "#EDEFCB", name: "1220-2 Passionate Pause" }, 
      { hex: "#E5ECB7", name: "1220-3 Lots Of Bubbles" }, 
      { hex: "#DEEAAA", name: "1220-4 High Hopes" }, 
      { hex: "#D0E798", name: "1220-5 Clean N Crisp" }, 
      { hex: "#BED565", name: "1220-6 Glow Worm" }, 
      { hex: "#A8C74D", name: "1220-7 Mojo" }, 
      { hex: "#ECF1E2", name: "1221-1 Aloe Essence" }, 
      { hex: "#E7EFCF", name: "1221-2 Quiet Rain" }, 
      { hex: "#DDEDBD", name: "1221-3 Mellow Mint" }, 
      { hex: "#D5EBAC", name: "1221-4 Faith" }, 
      { hex: "#C1E089", name: "1221-5 Livin' Large" }, 
      { hex: "#A5CB66", name: "1221-6 Be Spontaneous" }, 
      { hex: "#98BD3C", name: "1221-7 Funky Frog" }, 
      { hex: "#E6ECD6", name: "1222-1 Lime Meringue" }, 
      { hex: "#E6ECCC", name: "1222-2 Honeydew Melon" }, 
      { hex: "#DBE5B9", name: "1222-3 Aloe Vera" }, 
      { hex: "#CEDDA2", name: "1222-4 Lettuce Alone" }, 
      { hex: "#AEC571", name: "1222-5 Lime Green" }, 
      { hex: "#96AF54", name: "1222-6 Asparagus" }, 
      { hex: "#7A973B", name: "1222-7 Antique Moss" }, 
      { hex: "#E3EDE0", name: "1223-1 Green Tease" }, 
      { hex: "#DEEAD8", name: "1223-2 Lily Pond" }, 
      { hex: "#D2E3CC", name: "1223-3 Lime Flip" }, 
      { hex: "#BAD7AE", name: "1223-4 Bleached Spruce" }, 
      { hex: "#96BF83", name: "1223-5 Hearty Hosta" }, 
      { hex: "#76A55B", name: "1223-6 Grassy Meadow" }, 
      { hex: "#588C3A", name: "1223-7 Antique Green" }, 
      { hex: "#ECF0E5", name: "1224-1 Alaskan Mist" }, 
      { hex: "#E8F0E2", name: "1224-2 Spearmint Stick" }, 
      { hex: "#E4EFDE", name: "1224-3 Chilled Mint" }, 
      { hex: "#D7ECCD", name: "1224-4 Lantana Lime" }, 
      { hex: "#BFE5B1", name: "1224-5 Almost Aloe" }, 
      { hex: "#9ED686", name: "1224-6 Celery Sprig" }, 
      { hex: "#79BE58", name: "1224-7 Green Pear" }, 
      { hex: "#E3EFE1", name: "1225-1 Hint Of Mint" }, 
      { hex: "#DCEEDB", name: "1225-2 Dewmist Delight" }, 
      { hex: "#CDEACD", name: "1225-3 Applemint" }, 
      { hex: "#BEE5BE", name: "1225-4 Lime Sorbet" }, 
      { hex: "#92D599", name: "1225-5 May Apple" }, 
      { hex: "#6BC271", name: "1225-6 Bermuda Grass" }, 
      { hex: "#41A94F", name: "1225-7 Leap Frog" }, 
      { hex: "#DAE9DC", name: "1226-1 Tint Of Green" }, 
      { hex: "#D1E6D5", name: "1226-2 Peppermint Patty" }, 
      { hex: "#B9DCC3", name: "1226-3 Sprite Twist" }, 
      { hex: "#9ACDA9", name: "1226-4 Heath Green" }, 
      { hex: "#68B082", name: "1226-5 Elf Shoe" }, 
      { hex: "#529D6E", name: "1226-6 Basil Pesto" }, 
      { hex: "#027944", name: "1226-7 Blarney Stone" }, 
      { hex: "#DBEEE0", name: "1227-1 Sea Mist" }, 
      { hex: "#C4EAD5", name: "1227-2 Sweet Pea" }, 
      { hex: "#A7E0C2", name: "1227-3 Mountain Mint" }, 
      { hex: "#79D0A7", name: "1227-4 Crystal Gem" }, 
      { hex: "#47BA87", name: "1227-5 Aragon Green" }, 
      { hex: "#31AA74", name: "1227-6 Beanstalk" }, 
      { hex: "#00955E", name: "1227-7 Green Gloss" }, 
      { hex: "#DDEEE2", name: "1228-1 Maggie's Magic" }, 
      { hex: "#C1E5D5", name: "1228-2 Jade Spell" }, 
      { hex: "#A2D4BD", name: "1228-3 Flowering Cactus" }, 
      { hex: "#80C4A9", name: "1228-4 Green Balloon" }, 
      { hex: "#52A786", name: "1228-5 Laurel Wreath" }, 
      { hex: "#29906D", name: "1228-6 Leprechaun" }, 
      { hex: "#007958", name: "1228-7 Ivy League" }, 
      { hex: "#D4EDE3", name: "1229-1 Wintergreen" }, 
      { hex: "#BDE8D8", name: "1229-2 Wintergreen Mint" }, 
      { hex: "#98DDC5", name: "1229-3 Almost Aqua" }, 
      { hex: "#5ECAAE", name: "1229-4 Tropical Tide" }, 
      { hex: "#1DB394", name: "1229-5 Aloha" }, 
      { hex: "#00A483", name: "1229-6 Congo Green" }, 
      { hex: "#008B6D", name: "1229-7 Carolina Green" }, 
      { hex: "#D9EAE5", name: "1230-1 Tropical Dream" }, 
      { hex: "#BDE1D8", name: "1230-2 Serendipity" }, 
      { hex: "#A5D8CD", name: "1230-3 Whirlpool" }, 
      { hex: "#77C3B4", name: "1230-4 Pale Jade" }, 
      { hex: "#46A795", name: "1230-5 Jewel Weed" }, 
      { hex: "#17917F", name: "1230-6 Miami Jade" }, 
      { hex: "#007E6B", name: "1230-7 Medieval Forest" }, 
      { hex: "#E2EBE5", name: "1231-1 Hallowed Hush" }, 
      { hex: "#C5E5E2", name: "1231-2 Swan Lake" }, 
      { hex: "#B5DEDA", name: "1231-3 Minerva" }, 
      { hex: "#8FCDC7", name: "1231-4 Tropical Holiday" }, 
      { hex: "#5EB2AA", name: "1231-5 Artesian Well" }, 
      { hex: "#2B9890", name: "1231-6 Azure Tide" }, 
      { hex: "#007C75", name: "1231-7 Romantic Isle" }, 
      { hex: "#E1EDE6", name: "1232-1 Ice Blue" }, 
      { hex: "#D4EDE6", name: "1232-2 Cascade" }, 
      { hex: "#ABE3DE", name: "1232-3 Silent Ripple" }, 
      { hex: "#80D7CF", name: "1232-4 Isle Royale" }, 
      { hex: "#41BFB5", name: "1232-5 Tint Of Turquoise" }, 
      { hex: "#00A49B", name: "1232-6 Grecian Isle" }, 
      { hex: "#00938B", name: "1232-7 Torrid Turquoise" }, 
      { hex: "#DEEEED", name: "1233-1 Free Spirit" }, 
      { hex: "#D2EBEA", name: "1233-2 Seaspray" }, 
      { hex: "#C3E7E8", name: "1233-3 Pale Seafoam" }, 
      { hex: "#B5E4E4", name: "1233-4 Seascape Green" }, 
      { hex: "#70CBCE", name: "1233-5 Tropical Splash" }, 
      { hex: "#3FBABD", name: "1233-6 Montego Bay" }, 
      { hex: "#009A9E", name: "1233-7 Riviera Paradise" }, 
      { hex: "#E5F1EE", name: "1234-1 Aqua Tint" }, 
      { hex: "#D3E7E5", name: "1234-2 Plateau" }, 
      { hex: "#BFDFDF", name: "1234-3 Aqua Whisper" }, 
      { hex: "#8ECFD0", name: "1234-4 Fling Green" }, 
      { hex: "#4FB3B3", name: "1234-5 Biscay Bay" }, 
      { hex: "#1A9597", name: "1234-6 Sea Fantasy" }, 
      { hex: "#00787F", name: "1234-7 Hypnotic Sea" }, 
      { hex: "#E8EFEC", name: "1235-1 Kiss Me Kate" }, 
      { hex: "#D2E6E8", name: "1235-2 Blue Phlox" }, 
      { hex: "#C4DDE2", name: "1235-3 Galactica" }, 
      { hex: "#94C8D2", name: "1235-4 Idyllic Isle" }, 
      { hex: "#55A7B6", name: "1235-5 Blue Calypso" }, 
      { hex: "#1E8EA1", name: "1235-6 Safe Harbor" }, 
      { hex: "#007A91", name: "1235-7 Bimini Blue" }, 
      { hex: "#DEECED", name: "1236-1 Breathless" }, 
      { hex: "#D3E9EC", name: "1236-2 Enchanted Evening" }, 
      { hex: "#C6E4EB", name: "1236-3 Surf's Up" }, 
      { hex: "#9CD4E1", name: "1236-4 Ocean Cruise" }, 
      { hex: "#59B9CC", name: "1236-5 High Dive" }, 
      { hex: "#26A5BA", name: "1236-6 Jamaican Sea" }, 
      { hex: "#0090A8", name: "1236-7 Mediterranean Blue" }, 
      { hex: "#E3EDED", name: "1237-1 Bashful" }, 
      { hex: "#CFE4EE", name: "1237-2 Diamond Blue" }, 
      { hex: "#AED7EA", name: "1237-3 Ariel" }, 
      { hex: "#80C1E2", name: "1237-4 Horizon Haze" }, 
      { hex: "#48A8D0", name: "1237-5 Mystic Blue" }, 
      { hex: "#1993BE", name: "1237-6 Bellflower" }, 
      { hex: "#007DAC", name: "1237-7 Neptune" }, 
      { hex: "#DAE6E9", name: "1238-1 Airy" }, 
      { hex: "#D0E1E8", name: "1238-2 Goddess" }, 
      { hex: "#ADD0E0", name: "1238-3 Flemish Blue" }, 
      { hex: "#7EB6D0", name: "1238-4 Harbor Sky" }, 
      { hex: "#5397B7", name: "1238-5 Hush-a-bye" }, 
      { hex: "#2282A8", name: "1238-6 Blue Paisley" }, 
      { hex: "#006A93", name: "1238-7 Port Au Prince" }, 
      { hex: "#D6E1E4", name: "1239-1 Wavecrest" }, 
      { hex: "#CCDFE8", name: "1239-2 Duck's Egg Blue" }, 
      { hex: "#9FC9E4", name: "1239-3 Windsor Way" }, 
      { hex: "#66A9D3", name: "1239-4 Salem Blue" }, 
      { hex: "#3E8FBC", name: "1239-5 Quiet Night" }, 
      { hex: "#1D78AB", name: "1239-6 North Sea" }, 
      { hex: "#00619D", name: "1239-7 Rave Regatta" }, 
      { hex: "#D3E5EB", name: "1240-1 Ocean Breeze" }, 
      { hex: "#CBE3EE", name: "1240-2 Niagara Falls" }, 
      { hex: "#A3D1EB", name: "1240-3 Songbird" }, 
      { hex: "#6AB4E0", name: "1240-4 Xavier Blue" }, 
      { hex: "#3398CE", name: "1240-5 Sorcerer" }, 
      { hex: "#1C8AC9", name: "1240-6 Newport Blue" }, 
      { hex: "#0072B5", name: "1240-7 Cobalt Glaze" }, 
      { hex: "#D9E6EE", name: "1241-1 First Light" }, 
      { hex: "#C8DDEE", name: "1241-2 Blue Booties" }, 
      { hex: "#9BC7EA", name: "1241-3 Sweet Dreams" }, 
      { hex: "#62A5DF", name: "1241-4 Windjammer" }, 
      { hex: "#3D8ED0", name: "1241-5 Magical Merlin" }, 
      { hex: "#1E80C7", name: "1241-6 Electric Blue" }, 
      { hex: "#0264AE", name: "1241-7 Cobalt Stone" }, 
      { hex: "#DAE3E9", name: "1242-1 First Frost" }, 
      { hex: "#C2D7E9", name: "1242-2 Touch Of Blue" }, 
      { hex: "#97BEE2", name: "1242-3 Viva La Bleu" }, 
      { hex: "#73A3D0", name: "1242-4 Overcast" }, 
      { hex: "#3C85BE", name: "1242-5 King Triton" }, 
      { hex: "#1C70AD", name: "1242-6 Planetarium" }, 
      { hex: "#1A5897", name: "1242-7 Suddenly Sapphire" }, 
      { hex: "#E0E8EC", name: "1243-1 Sweet Illusion" }, 
      { hex: "#D3E0EC", name: "1243-2 Haunting Hue" }, 
      { hex: "#ABCAEA", name: "1243-3 Baby Bunting" }, 
      { hex: "#7DAEE1", name: "1243-4 Victoria Blue" }, 
      { hex: "#518FD1", name: "1243-5 Blue Dart" }, 
      { hex: "#3C7AC2", name: "1243-6 Royal Plume" }, 
      { hex: "#2863AD", name: "1243-7 Rainbow Bright" }, 
      { hex: "#DFE6EA", name: "1244-1 Abyss" }, 
      { hex: "#D0DCE8", name: "1244-2 Blue Silk" }, 
      { hex: "#A3BCDB", name: "1244-3 Valor" }, 
      { hex: "#7EA3D2", name: "1244-4 Boudoir Blue" }, 
      { hex: "#5488C0", name: "1244-5 Blueberry Popover" }, 
      { hex: "#356FAD", name: "1244-6 Nocturne Shade" }, 
      { hex: "#1C5798", name: "1244-7 Florentine Lapis" }, 
      { hex: "#DDE0E8", name: "1245-1 Orchid Whisper" }, 
      { hex: "#DADEE9", name: "1245-2 Pale Lilac" }, 
      { hex: "#CBD1E1", name: "1245-3 Sweet Emily" }, 
      { hex: "#ABB6D7", name: "1245-4 Lilac Sachet" }, 
      { hex: "#8394C5", name: "1245-5 Blue Hyacinth" }, 
      { hex: "#6274AB", name: "1245-6 King's Robe" }, 
      { hex: "#445397", name: "1245-7 Crushed Velvet" }, 
      { hex: "#DEE2EC", name: "1246-1 Violet Ice" }, 
      { hex: "#D7DDEC", name: "1246-2 Weeping Wisteria" }, 
      { hex: "#C9D1E9", name: "1246-3 Globe Thistle" }, 
      { hex: "#ADBAE3", name: "1246-4 French Lilac" }, 
      { hex: "#8596D2", name: "1246-5 Mystic Iris" }, 
      { hex: "#7487C6", name: "1246-6 Violets Are Blue" }, 
      { hex: "#5868AE", name: "1246-7 Blue Calico" }, 
      { hex: "#E8E6E8", name: "1247-1 Orchid Mist" }, 
      { hex: "#E4E1EA", name: "1247-2 Guardian Angel" }, 
      { hex: "#DBD7E4", name: "1247-3 Misty Violet" }, 
      { hex: "#C6BEDD", name: "1247-4 Purple Dragon" }, 
      { hex: "#A598C7", name: "1247-5 Grape Arbor" }, 
      { hex: "#8278AD", name: "1247-6 Purple Rhapsody" }, 
      { hex: "#5A4E88", name: "1247-7 Eggplant" }, 
      { hex: "#EDECEC", name: "1248-1 Coronation" }, 
      { hex: "#E8E5EC", name: "1248-2 Iris Isle" }, 
      { hex: "#E3DFEC", name: "1248-3 Velvet Scarf" }, 
      { hex: "#D0C8E6", name: "1248-4 Lilac Breeze" }, 
      { hex: "#ADA2CE", name: "1248-5 Puturple" }, 
      { hex: "#9488BE", name: "1248-6 Magic Carpet" }, 
      { hex: "#76679E", name: "1248-7 Reign Over Me " }, 
      { hex: "#E9E1E8", name: "1249-1 Violet Vogue" }, 
      { hex: "#E3D7E5", name: "1249-2 Lavender Vista" }, 
      { hex: "#DCCAE0", name: "1249-3 Grape Glimmer" }, 
      { hex: "#C9AFD0", name: "1249-4 Windsor Purple" }, 
      { hex: "#A885B5", name: "1249-5 Purple Statice" }, 
      { hex: "#9569A3", name: "1249-6 Grape Popsicle" }, 
      { hex: "#795088", name: "1249-7 Cleopatra's Gown" }, 
      { hex: "#EBDFEA", name: "1250-1 Angora Pink" }, 
      { hex: "#E8DEEA", name: "1250-2 Lilac Frost" }, 
      { hex: "#DFCAE4", name: "1250-3 Syrian Violet" }, 
      { hex: "#CFB1D8", name: "1250-4 Sea Lavender" }, 
      { hex: "#B48AC2", name: "1250-5 Plum Perfect" }, 
      { hex: "#A475B1", name: "1250-6 Bell Heather" }, 
      { hex: "#835995", name: "1250-7 Royal Lilac" }, 
      { hex: "#EBE2E8", name: "1251-1 Dream Dust" }, 
      { hex: "#EAE0E8", name: "1251-2 Tiara" }, 
      { hex: "#E8D2E3", name: "1251-3 Sonora Rose" }, 
      { hex: "#E1BED9", name: "1251-4 Pink Peony" }, 
      { hex: "#CC94BE", name: "1251-5 Moorland Heather" }, 
      { hex: "#AD6EA0", name: "1251-6 Mulberry Bush" }, 
      { hex: "#905284", name: "1251-7 Grape Juice" }, 
      { hex: "#EDE5E8", name: "1252-1 Lavender Pearl" }, 
      { hex: "#EEE1EB", name: "1252-2 Heaven Sent" }, 
      { hex: "#EDDBE8", name: "1252-3 Desert Dawn" }, 
      { hex: "#E7C2DE", name: "1252-4 Sweet Alyssum" }, 
      { hex: "#DBA3CE", name: "1252-5 Chateau Rose" }, 
      { hex: "#C37CB3", name: "1252-6 Daphne Rose" }, 
      { hex: "#9D5A8F", name: "1252-7 Bermuda Onion" }, 
      { hex: "#425A65", name: "10-01 Oceania" }, 
      { hex: "#657D85", name: "10-02 Sorcerer's Spell" }, 
      { hex: "#71898D", name: "10-03 Twilight Stroll" }, 
      { hex: "#A0AEAD", name: "10-04 Polaris" }, 
      { hex: "#E8E5DB", name: "10-05 Oyster White" }, 
      { hex: "#7C8783", name: "10-06 Thunderbolt" }, 
      { hex: "#CDD2C9", name: "10-07 Bay Of Fundy" }, 
      { hex: "#BFC8C3", name: "10-08 Gale Force" }, 
      { hex: "#48545D", name: "10-09 Soothing Sapphire" }, 
      { hex: "#5C707E", name: "10-10 Hatteras Gray" }, 
      { hex: "#8398A4", name: "10-11 Seastone" }, 
      { hex: "#C3D0D8", name: "10-12 Cool Gray" }, 
      { hex: "#A3AEB4", name: "10-13 Foretell" }, 
      { hex: "#B0BCC3", name: "10-14 Stormy" }, 
      { hex: "#BDC1C1", name: "10-15 Quest" }, 
      { hex: "#69808B", name: "10-16 Artifact" }, 
      { hex: "#BBC6D9", name: "10-17 Blue Opal" }, 
      { hex: "#CBD0DD", name: "10-18 Debonaire" }, 
      { hex: "#70777E", name: "10-19 Favorite Flannel" }, 
      { hex: "#939DA9", name: "10-20 Coast Of Maine" }, 
      { hex: "#808EA1", name: "10-21 Acceleration" }, 
      { hex: "#667486", name: "10-22 License To Dream" }, 
      { hex: "#D4DAE2", name: "10-23 Aster Petal" }, 
      { hex: "#9DAAB9", name: "10-24 Inevitable" }, 
      { hex: "#D4DDDD", name: "10-25 Winter's Breath" }, 
      { hex: "#CEDDE7", name: "10-26 Simply Elegant" }, 
      { hex: "#CFDCE0", name: "10-27 Tradewinds" }, 
      { hex: "#A2B2BD", name: "10-28 Peace" }, 
      { hex: "#A2B5AB", name: "10-29 Dusty Aqua" }, 
      { hex: "#BCC8BA", name: "10-30 Niagara Mist" }, 
      { hex: "#C4D1C6", name: "10-31 White Clover" }, 
      { hex: "#2A4B6E", name: "10-32 Blue Tang" }, 
      { hex: "#ECDA9E", name: "11-01 Demeter" }, 
      { hex: "#EAD795", name: "11-02 Tainted Gold" }, 
      { hex: "#D8C475", name: "11-03 Grassroots" }, 
      { hex: "#CCBF88", name: "11-04 Country Style" }, 
      { hex: "#B1A26A", name: "11-05 Old Times Sake" }, 
      { hex: "#9D8A50", name: "11-06 Safari Scene" }, 
      { hex: "#8E824E", name: "11-07 Gobbledygook" }, 
      { hex: "#6E6A4C", name: "11-08 Olive Orchard" }, 
      { hex: "#DAD7AD", name: "11-09 Misty Moor" }, 
      { hex: "#C8CDA0", name: "11-10 In The Dale" }, 
      { hex: "#E4EAB7", name: "11-11 Totally Tickled" }, 
      { hex: "#B7AD6E", name: "11-12 Secret Scribbles" }, 
      { hex: "#ACB17E", name: "11-13 Sparrow Song" }, 
      { hex: "#949B64", name: "11-14 Leafy Romaine" }, 
      { hex: "#848947", name: "11-15 Wistful Walk" }, 
      { hex: "#708054", name: "11-16 Spinach Salad" }, 
      { hex: "#9C9273", name: "11-17 Mossy Gold" }, 
      { hex: "#B0A584", name: "11-18 Foggy Beach" }, 
      { hex: "#C2B79A", name: "11-19 Distant Valley" }, 
      { hex: "#ADAA96", name: "11-20 Scottish Moor" }, 
      { hex: "#D6DBC0", name: "11-21 Breezeway" }, 
      { hex: "#C5C1A3", name: "11-22 Northern Landscape" }, 
      { hex: "#9CA389", name: "11-23 Edamame" }, 
      { hex: "#808677", name: "11-24 Smokey Sage" }, 
      { hex: "#656457", name: "11-25 Plunge Pool" }, 
      { hex: "#838463", name: "11-26 Wilderness" }, 
      { hex: "#D0C6A1", name: "11-27 Safari" }, 
      { hex: "#89876A", name: "11-28 Only Oregano" }, 
      { hex: "#AFA984", name: "11-29 Green Gray Mist" }, 
      { hex: "#B3AE87", name: "11-30 Lively Ivy" }, 
      { hex: "#AFA97D", name: "11-31 Thimbleberry Leaf" }, 
      { hex: "#9C9369", name: "11-32 Tapenade" }, 
      { hex: "#F9E4AE", name: "12-01 Corn Silk" }, 
      { hex: "#F0DDBB", name: "12-02 Cordon Bleu" }, 
      { hex: "#E7C26F", name: "12-03 Sun Salutation" }, 
      { hex: "#D4B57F", name: "12-04 Bulletin Board" }, 
      { hex: "#F5E4BF", name: "12-05 Winter Wheat" }, 
      { hex: "#E2C28D", name: "12-06 Lira" }, 
      { hex: "#EFD7AB", name: "12-07 Waves Of Grain" }, 
      { hex: "#E6B570", name: "12-08 Bold Butterscotch" }, 
      { hex: "#F1E7CE", name: "12-09 Rice Cake" }, 
      { hex: "#F0DEBB", name: "12-10 Millet" }, 
      { hex: "#E5CA9E", name: "12-11 Antique Cream" }, 
      { hex: "#DCC49B", name: "12-12 True Blonde" }, 
      { hex: "#E8DBC4", name: "12-13 Camel Tan" }, 
      { hex: "#D3B78B", name: "12-14 Craftsman Gold" }, 
      { hex: "#E1CCA6", name: "12-15 Hearth" }, 
      { hex: "#C2AE88", name: "12-16 Desert Camel" }, 
      { hex: "#EFD7A7", name: "12-17 Tuscan Sun" }, 
      { hex: "#E0C796", name: "12-18 Hayloft" }, 
      { hex: "#C1A87C", name: "12-19 Antiquity" }, 
      { hex: "#CCB88D", name: "12-20 Canvas Satchel" }, 
      { hex: "#E1CFA5", name: "12-21 Foothills" }, 
      { hex: "#CFB989", name: "12-22 Appalachian Trail" }, 
      { hex: "#EDE1A8", name: "12-23 Turning Oakleaf" }, 
      { hex: "#AB8F55", name: "12-24 Gathering Field" }, 
      { hex: "#F4E4C6", name: "12-25 To The Rescue" }, 
      { hex: "#E1D0B2", name: "12-26 Assateague Sand" }, 
      { hex: "#F0E5C7", name: "12-27 Soleil" }, 
      { hex: "#E7D9B9", name: "12-28 At The Beach" }, 
      { hex: "#E2D0AD", name: "12-29 Ivory Beauty" }, 
      { hex: "#CEBA97", name: "12-30 Baguette" }, 
      { hex: "#DFCCA6", name: "12-31 Neutral Beige" }, 
      { hex: "#E8D7B8", name: "12-32 Sandcastle Symphony" }, 
      { hex: "#91575D", name: "13-01 Pomegranate Punch" }, 
      { hex: "#824E4A", name: "13-02 Cherokee Red" }, 
      { hex: "#6C403E", name: "13-03 Burgundy Wine" }, 
      { hex: "#723F45", name: "13-04 Merlot" }, 
      { hex: "#89585D", name: "13-05 Old Burgundy" }, 
      { hex: "#72494A", name: "13-06 Chianti" }, 
      { hex: "#604344", name: "13-07 Enchanting Eggplant" }, 
      { hex: "#6B4D5F", name: "13-08 Positively Purple" }, 
      { hex: "#A34747", name: "13-09 Crushed Tomatoes" }, 
      { hex: "#964647", name: "13-10 Candy Apple" }, 
      { hex: "#943E4D", name: "13-11 Madeira Red" }, 
      { hex: "#8F4347", name: "13-12 Crazed Cranberry" }, 
      { hex: "#9C4D52", name: "13-13 Roasted Pepper" }, 
      { hex: "#A54F5D", name: "13-14 Heart's Afire" }, 
      { hex: "#A34A3E", name: "13-15 Rojo Colonial" }, 
      { hex: "#9D3E3F", name: "13-16 Blaze" }, 
      { hex: "#595461", name: "13-17 Purple Parlor" }, 
      { hex: "#605258", name: "13-18 Pinot Noir" }, 
      { hex: "#7C6B76", name: "13-19 Purple Dusk" }, 
      { hex: "#705C79", name: "13-20 Pageant Pansy" }, 
      { hex: "#4A4354", name: "13-21 Blackberry" }, 
      { hex: "#6A6472", name: "13-22 Silverado" }, 
      { hex: "#A0A0AA", name: "13-23 Amethyst Haze" }, 
      { hex: "#817C85", name: "13-24 Magic Dust" }, 
      { hex: "#374874", name: "13-25 Daring Indigo" }, 
      { hex: "#2E5169", name: "13-26 Blue Lava" }, 
      { hex: "#295266", name: "13-27 Plymouth Blue" }, 
      { hex: "#1C6B75", name: "13-28 Caribbean Holiday" }, 
      { hex: "#455C59", name: "13-29 Antique Slate" }, 
      { hex: "#3A5A55", name: "13-30 Sea Glass" }, 
      { hex: "#4F6450", name: "13-31 Still Searching" }, 
      { hex: "#4C6B4E", name: "13-32 Emerald City" }, 
      { hex: "#B4AAA0", name: "14-01 Shadow Taupe" }, 
      { hex: "#9C8F83", name: "14-02 Nut Shell" }, 
      { hex: "#E0DED8", name: "14-03 Seagull" }, 
      { hex: "#BAB2AB", name: "14-04 City Street" }, 
      { hex: "#3D4645", name: "14-05 Dark As Night" }, 
      { hex: "#948E82", name: "14-06 Winter Feather" }, 
      { hex: "#E0DBCD", name: "14-07 Scotch Mist" }, 
      { hex: "#EEEADD", name: "14-08 Horseradish" }, 
      { hex: "#C0AF92", name: "14-09 Rock Cliffs" }, 
      { hex: "#D9CDB5", name: "14-10 Summer Wheat" }, 
      { hex: "#D5D3C3", name: "14-11 Static" }, 
      { hex: "#EEEADA", name: "14-12 Jewel White" }, 
      { hex: "#A0917E", name: "14-13 Oyster Shell" }, 
      { hex: "#C7B8A4", name: "14-14 Summer Suede" }, 
      { hex: "#EAE3D6", name: "14-15 French Cream" }, 
      { hex: "#EFECE2", name: "14-16 Winter Mood" }, 
      { hex: "#D7C8B1", name: "14-17 Armadillo" }, 
      { hex: "#D3BC9E", name: "14-18 Gaia" }, 
      { hex: "#E4D5BC", name: "14-19 Alpaca Wool" }, 
      { hex: "#EFE9DA", name: "14-20 Purity" }, 
      { hex: "#DFD4C4", name: "14-21 Wheat Sheaf" }, 
      { hex: "#E4D9C5", name: "14-22 Bone White" }, 
      { hex: "#EEE8D9", name: "14-23 Edelweiss" }, 
      { hex: "#E9E6DD", name: "14-24 Dogwood Blossom" }, 
      { hex: "#D3D1BE", name: "14-25 Fisherman's Net" }, 
      { hex: "#C8C0AA", name: "14-26 Hideaway" }, 
      { hex: "#B8AE98", name: "14-27 True Khaki" }, 
      { hex: "#AAA492", name: "14-28 Aldabra" }, 
      { hex: "#D1C9BA", name: "14-29 Moth Gray" }, 
      { hex: "#DAD1C6", name: "14-30 Gray Beige" }, 
      { hex: "#E5E1D8", name: "14-31 Paraffin" }, 
      { hex: "#CEC7B8", name: "14-32 Ostrich Feather" }, 
      { hex: "#BB9B7D", name: "15-01 Maison De Campagne" }, 
      { hex: "#996F45", name: "15-02 Apple Butter" }, 
      { hex: "#AE8661", name: "15-03 Bronco Brown" }, 
      { hex: "#C7A98D", name: "15-04 Yosemite Trailhead" }, 
      { hex: "#EFEBDE", name: "15-05 Macaroon Cream" }, 
      { hex: "#F5F0E2", name: "15-06 White Chip" }, 
      { hex: "#E5CAA2", name: "15-07 York Ivory" }, 
      { hex: "#CCA571", name: "15-08 Burnt Ivory" }, 
      { hex: "#BAA589", name: "15-09 Antelope" }, 
      { hex: "#AE9676", name: "15-10 Petaluma Dust" }, 
      { hex: "#C8AC89", name: "15-11 Rabbit" }, 
      { hex: "#C4AD92", name: "15-12 Kangaroo" }, 
      { hex: "#6F5746", name: "15-13 Chocolate Truffle" }, 
      { hex: "#98754E", name: "15-14 Leather" }, 
      { hex: "#B19576", name: "15-15 Coffee Kiss" }, 
      { hex: "#C6B49C", name: "15-16 Best Beige" }, 
      { hex: "#8D847F", name: "15-17 Elephant Gray" }, 
      { hex: "#6D6053", name: "15-18 Introspective" }, 
      { hex: "#A39281", name: "15-19 Rapid Rock" }, 
      { hex: "#887B6E", name: "15-20 Ghost Ship" }, 
      { hex: "#766859", name: "15-21 Curlew" }, 
      { hex: "#625141", name: "15-22 Pumpernickel" }, 
      { hex: "#624E45", name: "15-23 Chestnut" }, 
      { hex: "#544642", name: "15-24 French Toast" }, 
      { hex: "#C8BCAB", name: "15-25 Stonington" }, 
      { hex: "#DACFBA", name: "15-26 Toasted Almond" }, 
      { hex: "#E5DAC8", name: "15-27 Botany Beige" }, 
      { hex: "#CBC1B4", name: "15-28 Great Gray" }, 
      { hex: "#B7A696", name: "15-29 El Capitan" }, 
      { hex: "#9D8C7C", name: "15-30 Roasted Chestnut" }, 
      { hex: "#C6B092", name: "15-31 Beige Tellin" }, 
      { hex: "#8B7867", name: "15-32 Portabella" }, 
      { hex: "#D1AC99", name: "16-01 Sombrero Tan" }, 
      { hex: "#C79C7C", name: "16-02 Summer Spice" }, 
      { hex: "#C58F68", name: "16-03 Burning Sand" }, 
      { hex: "#B78565", name: "16-04 Capuccino" }, 
      { hex: "#B88A74", name: "16-05 Caramel Sugar" }, 
      { hex: "#A27253", name: "16-06 Red Rock Falls" }, 
      { hex: "#9D6F59", name: "16-07 Southern Wood" }, 
      { hex: "#784C42", name: "16-08 Antique Mahogany" }, 
      { hex: "#F1E2C6", name: "16-09 Linen Tint" }, 
      { hex: "#D9BC86", name: "16-10 Hummus" }, 
      { hex: "#E2B46C", name: "16-11 Apollo Gold" }, 
      { hex: "#CD9647", name: "16-12 Italian Saffron" }, 
      { hex: "#AC854E", name: "16-13 Pumpkin Spice" }, 
      { hex: "#CC9859", name: "16-14 Bran Muffin" }, 
      { hex: "#AC7B44", name: "16-15 Brown Basket" }, 
      { hex: "#A9805D", name: "16-16 Treasure Hunt" }, 
      { hex: "#BC946D", name: "16-17 Tudor Beige" }, 
      { hex: "#CDA885", name: "16-18 Covered Wagon" }, 
      { hex: "#C68B5A", name: "16-19 Broomstick" }, 
      { hex: "#AE703B", name: "16-20 Bronze Eucalyptus" }, 
      { hex: "#B07447", name: "16-21 Fresh Praline" }, 
      { hex: "#A76C40", name: "16-22 Chaparral" }, 
      { hex: "#835842", name: "16-23 Tampico Brown" }, 
      { hex: "#574642", name: "16-24 Racy Raisin" }, 
      { hex: "#E8CBB4", name: "16-25 Maple Granola" }, 
      { hex: "#D8A686", name: "16-26 Clay Fire" }, 
      { hex: "#C18978", name: "16-27 Copper Trail" }, 
      { hex: "#B7735E", name: "16-28 Crushed Cinnamon" }, 
      { hex: "#9A5247", name: "16-29 Hunt Club Red" }, 
      { hex: "#9B6046", name: "16-30 Muted Copper" }, 
      { hex: "#A15C49", name: "16-31 Rich Clay" }, 
      { hex: "#89483E", name: "16-32 Red Clay" }, 
      { hex: "#96ADDC", name: "17-01 Suenos" }, 
      { hex: "#5072B1", name: "17-02 Cenote" }, 
      { hex: "#314A76", name: "17-03 Hacienda Talavera" }, 
      { hex: "#6D86B6", name: "17-04 Kimono" }, 
      { hex: "#5868AE", name: "17-05 Blue Calico" }, 
      { hex: "#7E84B5", name: "17-06 Magical Moment" }, 
      { hex: "#816D95", name: "17-07 Crowning Glory" }, 
      { hex: "#B08AAE", name: "17-08 Heather Glen" }, 
      { hex: "#C86E94", name: "17-09 Florentine Pink" }, 
      { hex: "#C25A88", name: "17-10 Tutti Frutti" }, 
      { hex: "#A54976", name: "17-11 Cerise" }, 
      { hex: "#A24041", name: "17-12 Granada" }, 
      { hex: "#C6494C", name: "17-13 Burnt Red" }, 
      { hex: "#E66A77", name: "17-14 Bleeding Heart" }, 
      { hex: "#DF745B", name: "17-15 Rustic Pottery" }, 
      { hex: "#D9624E", name: "17-16 Candy Corn" }, 
      { hex: "#FCD766", name: "17-17 Mariposa" }, 
      { hex: "#F1C96A", name: "17-18 Sol De Yucatan" }, 
      { hex: "#EBB454", name: "17-19 Oro De Maya" }, 
      { hex: "#DFB170", name: "17-20 Tesoros" }, 
      { hex: "#FDAE6F", name: "17-21 Sorbete De Melon" }, 
      { hex: "#EF913E", name: "17-22 Dynamo" }, 
      { hex: "#D07D4D", name: "17-23 Cazuela" }, 
      { hex: "#D67953", name: "17-24 Copper Penny" }, 
      { hex: "#D5D16B", name: "17-25 Got The Giggles" }, 
      { hex: "#AAAC32", name: "17-26 Willow Herb" }, 
      { hex: "#B6C876", name: "17-27 Fern Glow" }, 
      { hex: "#729167", name: "17-28 Mexican Jade" }, 
      { hex: "#97D4C0", name: "17-29 San Juan Spritz" }, 
      { hex: "#BCE7D1", name: "17-30 Dinner Mint" }, 
      { hex: "#86C7BF", name: "17-31 Caribbean Crush" }, 
      { hex: "#00908D", name: "17-32 Teal We Meet Again" }, 
      { hex: "#F2F0E6", name: "18-01 Crumb Cookie" }, 
      { hex: "#D8CDC4", name: "18-02 River Rock" }, 
      { hex: "#CAB8AB", name: "18-03 Grey Mauve" }, 
      { hex: "#C3B8B7", name: "18-04 Luxurious" }, 
      { hex: "#BB9E9B", name: "18-05 Awakening" }, 
      { hex: "#C49B9E", name: "18-06 Mexicali Rose" }, 
      { hex: "#AF8F9E", name: "18-07 Luscious Lilac" }, 
      { hex: "#A18A8D", name: "18-08 Smoky Quartz" }, 
      { hex: "#ECE9DD", name: "18-09 Garlic Clove" }, 
      { hex: "#F2E9DC", name: "18-10 Lotus Petal" }, 
      { hex: "#F3EAE3", name: "18-11 Pastel Paper" }, 
      { hex: "#F4E4D9", name: "18-12 Granddad's Girl" }, 
      { hex: "#EEDBCE", name: "18-13 Beige Llama" }, 
      { hex: "#DFC4B9", name: "18-14 Spice Beige" }, 
      { hex: "#E3B8A9", name: "18-15 Shrimp Salad" }, 
      { hex: "#C59687", name: "18-16 Salmon Eggs" }, 
      { hex: "#ECE2E3", name: "18-17 Just Blush" }, 
      { hex: "#EAD7D9", name: "18-18 Rose Blush" }, 
      { hex: "#DAB7BB", name: "18-19 Crushed Roses" }, 
      { hex: "#B68190", name: "18-20 Thornberry" }, 
      { hex: "#A37379", name: "18-21 Moody Mauve" }, 
      { hex: "#A0666B", name: "18-22 Make Mine Mauve" }, 
      { hex: "#9C6071", name: "18-23 Berries And Cream" }, 
      { hex: "#7C3F55", name: "18-24 Purple Cabbage" }, 
      { hex: "#F4E5D2", name: "18-25 Belleek" }, 
      { hex: "#E5CCBD", name: "18-26 Peach Brick" }, 
      { hex: "#E7C3AB", name: "18-27 Peach Beauty" }, 
      { hex: "#E3BEB0", name: "18-28 Adorable" }, 
      { hex: "#C67976", name: "18-29 Emberglo" }, 
      { hex: "#BE727C", name: "18-30 Lush Rose" }, 
      { hex: "#B2656C", name: "18-31 Raspberry Ripple" }, 
      { hex: "#AB5959", name: "18-32 Indian Paintbrush" }, 
      { hex: "#", name: "FLLW144 Wright Autumn Green" }, 
      { hex: "#", name: "FLLW287 Wright Tanager Red" }, 
      { hex: "#", name: "FLLW321 Wright Mustard" }, 
      { hex: "#", name: "FLLW325 Wright Ochre" }, 
      { hex: "#", name: "FLLW36 Wright Midnight" }, 
      { hex: "#", name: "FLLW370 Wright Deep Rust" }, 
      { hex: "#", name: "FLLW396 Wright Spring Green" }, 
      { hex: "#", name: "FLLW514 Wright Bluebird" }, 
      { hex: "#", name: "FLLW518 Wright Turquoise" }, 
      { hex: "#", name: "FLLW539 Wright Pottery Red" }, 
      { hex: "#", name: "FLLW568 Wright Gold" }, 
      { hex: "#", name: "FLLW570 Wright Sun Tan" }, 
      { hex: "#", name: "FLLW577 Wright Raspberry" }, 
      { hex: "#", name: "FLLW618 Wright Quiet Green" }, 
      { hex: "#", name: "FLLW620 Wright Green Olive" }, 
      { hex: "#", name: "FLLW623 Wright Oak Bark" }, 
      { hex: "#", name: "FLLW68 Wright Cherokee Red Taliesin West" }, 
      { hex: "#", name: "FLLW705 Wright Old Rose" }, 
      { hex: "#", name: "FLLW724 Wright Pale Mustard" }, 
      { hex: "#", name: "FLLW726 Wright Dark Eggshell" }, 
      { hex: "#", name: "FLLW741 Wright Echo Blue" }, 
      { hex: "#", name: "FLLW742 Wright Egyptian Blue" }, 
      { hex: "#", name: "FLLW771 Wright Murasaki" }, 
      { hex: "#", name: "FLLW785 Wright Cornfield Tan" }, 
      { hex: "#", name: "FLLW792 Wright Flesh Pink" }, 
      { hex: "#", name: "FLLW840 Wright Grey Tan" }, 
      { hex: "#", name: "FLLW858 Wright Stone Grey" }, 
      { hex: "#", name: "FLLW864 Wright Sky Blue" }, 
      { hex: "#", name: "FLLW872 Wright Soft Grey " }, 
      { hex: "#", name: "FLLW892 Wright Blue Mist" }, 
      { hex: "#", name: "FLLW917 Wright Lemon White" }, 
      { hex: "#", name: "FLLW918 Wright Pearl Gray" }, 
      { hex: "#", name: "FLLW943 Wright Shell Pink" }, 
      { hex: "#", name: "FLLW961 Wright Cloud White" }, 
      { hex: "#", name: "FLLW994 Wright Pearl White" }, 
      { hex: "#", name: "FLLW999 Wright Oyster Shell" }
    ],
      "Caparol color": [      { hex: "#925043", name: "Granat 0" }, 
      { hex: "#B67363", name: "Granat 12" }, 
      { hex: "#CE9280", name: "Granat 13" }, 
      { hex: "#DDA89A", name: "Granat 14" }, 
      { hex: "#E4BCAF", name: "Granat 15" }, 
      { hex: "#E3CEC5", name: "Granat 16" }, 
      { hex: "#F3E0D9", name: "Granat 18" }, 
      { hex: "#A55942", name: "Madeira 0" }, 
      { hex: "#D07E59", name: "Madeira 12" }, 
      { hex: "#E49B74", name: "Madeira 13" }, 
      { hex: "#F0B28E", name: "Madeira 14" }, 
      { hex: "#F5C4A6", name: "Madeira 15" }, 
      { hex: "#F7D3BA", name: "Madeira 16" }, 
      { hex: "#FAE3D2", name: "Madeira 18" }, 
      { hex: "#D77B39", name: "Aprikose 0" }, 
      { hex: "#E9964B", name: "Aprikose 12" }, 
      { hex: "#F8B567", name: "Aprikose 13" }, 
      { hex: "#FBC581", name: "Aprikose 14" }, 
      { hex: "#FDD39B", name: "Aprikose 15" }, 
      { hex: "#FBDDB2", name: "Aprikose 16" }, 
      { hex: "#F9E6C9", name: "Aprikose 18" }, 
      { hex: "#C87F3F", name: "Cognac 0" }, 
      { hex: "#E4A75F", name: "Cognac 12" }, 
      { hex: "#F1C07D", name: "Cognac 13" }, 
      { hex: "#F4CF96", name: "Cognac 14" }, 
      { hex: "#F7DAAD", name: "Cognac 15" }, 
      { hex: "#F8E3C1", name: "Cognac 16" }, 
      { hex: "#F5E9D4", name: "Cognac 18" }, 
      { hex: "#E49A37", name: "Mandarin 0" }, 
      { hex: "#F5B756", name: "Mandarin 12" }, 
      { hex: "#FBCB77", name: "Mandarin 13" }, 
      { hex: "#FCD691", name: "Mandarin 14" }, 
      { hex: "#FBDEA9", name: "Mandarin 15" }, 
      { hex: "#FAE5BD", name: "Mandarin 16" }, 
      { hex: "#F7EBD3", name: "Mandarin 18" }, 
      { hex: "#C38F3A", name: "Gobi 0" }, 
      { hex: "#E2B054", name: "Gobi 12" }, 
      { hex: "#F1C776", name: "Gobi 13" }, 
      { hex: "#F5D490", name: "Gobi 14" }, 
      { hex: "#F8DFA8", name: "Gobi 15" }, 
      { hex: "#F8E6BD", name: "Gobi 16" }, 
      { hex: "#F8EBD2", name: "Gobi 18" }, 
      { hex: "#EBAB2C", name: "Mais 0" }, 
      { hex: "#F4C75C", name: "Mais 12" }, 
      { hex: "#F8D980", name: "Mais 13" }, 
      { hex: "#F8DF9B", name: "Mais 14" }, 
      { hex: "#F9E7B4", name: "Mais 15" }, 
      { hex: "#F7E9C3", name: "Mais 16" }, 
      { hex: "#F5EDD6", name: "Mais 18" }, 
      { hex: "#BE9B3E", name: "Ingwer 0" }, 
      { hex: "#E1C56D", name: "Ingwer 12" }, 
      { hex: "#EFDA93", name: "Ingwer 13" }, 
      { hex: "#F2E2A9", name: "Ingwer 14" }, 
      { hex: "#F5EABE", name: "Ingwer 15" }, 
      { hex: "#F5EDCD", name: "Ingwer 16" }, 
      { hex: "#F4EFDD", name: "Ingwer 18" }, 
      { hex: "#626E45", name: "Amazonas 0" }, 
      { hex: "#879766", name: "Amazonas 12" }, 
      { hex: "#A3B281", name: "Amazonas 13" }, 
      { hex: "#B7C398", name: "Amazonas 14" }, 
      { hex: "#C8D2AF", name: "Amazonas 15" }, 
      { hex: "#D6DDC1", name: "Amazonas 16" }, 
      { hex: "#DBE9D6", name: "Amazonas 18" }, 
      { hex: "#455F72", name: "Iris 0" }, 
      { hex: "#648AA2", name: "Iris 12" }, 
      { hex: "#84A7BC", name: "Iris 13" }, 
      { hex: "#AABCCD", name: "Iris 14" }, 
      { hex: "#B8CEDA", name: "Iris 15" }, 
      { hex: "#C8D8E1", name: "Iris 16" }, 
      { hex: "#DDE5E8", name: "Iris 18" }, 
      { hex: "#3B4B86", name: "Lapis 0" }, 
      { hex: "#5C82C5", name: "Lapis 12" }, 
      { hex: "#81A2D9", name: "Lapis 13" }, 
      { hex: "#9DB8E0", name: "Lapis 14" }, 
      { hex: "#B5C9E6", name: "Lapis 15" }, 
      { hex: "#C9D6E7", name: "Lapis 16" }, 
      { hex: "#DCE4EC", name: "Lapis 18" }, 
      { hex: "#5F6A8E", name: "Cosmos 0" }, 
      { hex: "#8D99BB", name: "Cosmos 12" }, 
      { hex: "#ADB5D0", name: "Cosmos 13" }, 
      { hex: "#C3C7DB", name: "Cosmos 14" }, 
      { hex: "#D4D6E5", name: "Cosmos 15" }, 
      { hex: "#DEDFE8", name: "Cosmos 16" }, 
      { hex: "#EAE9EC", name: "Cosmos 18" }, 
      { hex: "#4C4845", name: "Kiesel 0" }, 
      { hex: "#807C79", name: "Kiesel 12" }, 
      { hex: "#A49F9A", name: "Kiesel 13" }, 
      { hex: "#B9B5AF", name: "Kiesel 14" }, 
      { hex: "#CDC8C4", name: "Kiesel 15" }, 
      { hex: "#DAD7D3", name: "Kiesel 16" }, 
      { hex: "#E8E5E1", name: "Kiesel 18" }, 
      { hex: "#504E48", name: "Schiefer 0" }, 
      { hex: "#6F6B63", name: "Schiefer 12" }, 
      { hex: "#8F897F", name: "Schiefer 13" }, 
      { hex: "#A6A197", name: "Schiefer 14" }, 
      { hex: "#BCB5AC", name: "Schiefer 15" }, 
      { hex: "#CBC7BE", name: "Schiefer 16" }, 
      { hex: "#E1DCD5", name: "Schiefer 18" }, 
      { hex: "#504F4E", name: "Graphit 0" }, 
      { hex: "#808282", name: "Graphit 12" }, 
      { hex: "#A2A4A3", name: "Graphit 13" }, 
      { hex: "#B9BAB8", name: "Graphit 14" }, 
      { hex: "#CCCCCB", name: "Graphit 15" }, 
      { hex: "#DADAD8", name: "Graphit 16" }, 
      { hex: "#EAE7E5", name: "Graphit 18" }, 
      { hex: "#534C4B", name: "Basalt 0" }, 
      { hex: "#867D7E", name: "Basalt 12" }, 
      { hex: "#A79E9D", name: "Basalt 13" }, 
      { hex: "#BDB6B5", name: "Basalt 14" }, 
      { hex: "#CFC8C7", name: "Basalt 15" }, 
      { hex: "#DBD5D3", name: "Basalt 16" }, 
      { hex: "#E9E4E2", name: "Basalt 18" }, 
      { hex: "#5A4641", name: "Mocca 0" }, 
      { hex: "#8A706A", name: "Mocca 12" }, 
      { hex: "#AC948D", name: "Mocca 13" }, 
      { hex: "#C2ADA6", name: "Mocca 14" }, 
      { hex: "#D3C1BB", name: "Mocca 15" }, 
      { hex: "#DED0CC", name: "Mocca 16" }, 
      { hex: "#EAE1DE", name: "Mocca 18" }, 
      { hex: "#7A5541", name: "Marone 0" }, 
      { hex: "#AA8166", name: "Marone 12" }, 
      { hex: "#C6A084", name: "Marone 13" }, 
      { hex: "#D5B59E", name: "Marone 14" }, 
      { hex: "#E2C8B4", name: "Marone 15" }, 
      { hex: "#E9D5C6", name: "Marone 16" }, 
      { hex: "#F2E5DB", name: "Marone 18" }, 
      { hex: "#705645", name: "Nutria 0" }, 
      { hex: "#9C8067", name: "Nutria 12" }, 
      { hex: "#B99E83", name: "Nutria 13" }, 
      { hex: "#CAB39B", name: "Nutria 14" }, 
      { hex: "#D9C5B1", name: "Nutria 15" }, 
      { hex: "#EED5C5", name: "Nutria 16" }, 
      { hex: "#EEE3D8", name: "Nutria 18" }, 
      { hex: "#9A6241", name: "Terra 0" }, 
      { hex: "#C08558", name: "Terra 12" }, 
      { hex: "#D7A275", name: "Terra 13" }, 
      { hex: "#E3B790", name: "Terra 14" }, 
      { hex: "#ECC7A5", name: "Terra 15" }, 
      { hex: "#F2D7BD", name: "Terra 16" }, 
      { hex: "#F6E4D3", name: "Terra 18" }, 
      { hex: "#7A6043", name: "Havanna 0" }, 
      { hex: "#B0875F", name: "Havanna 12" }, 
      { hex: "#CAA47D", name: "Havanna 13" }, 
      { hex: "#D7B692", name: "Havanna 14" }, 
      { hex: "#DBCAAD", name: "Havanna 15" }, 
      { hex: "#ECD7C0", name: "Havanna 16" }, 
      { hex: "#F3E5D6", name: "Havanna 18" }, 
      { hex: "#6E5E4C", name: "Muskat 0" }, 
      { hex: "#9F8C71", name: "Muskat 12" }, 
      { hex: "#C1AE92", name: "Muskat 13" }, 
      { hex: "#D1C2A9", name: "Muskat 14" }, 
      { hex: "#DFD3BE", name: "Muskat 15" }, 
      { hex: "#E8DECE", name: "Muskat 16" }, 
      { hex: "#F1EADF", name: "Muskat 18" }, 
      { hex: "#796345", name: "Savanne 0" }, 
      { hex: "#B09265", name: "Savanne 12" }, 
      { hex: "#CCB285", name: "Savanne 13" }, 
      { hex: "#DDC7A0", name: "Savanne 14" }, 
      { hex: "#E7D5B6", name: "Savanne 15" }, 
      { hex: "#ECDFC7", name: "Savanne 16" }, 
      { hex: "#F2EAD9", name: "Savanne 18" }, 
      { hex: "#576355", name: "Salbei 0" }, 
      { hex: "#8C978A", name: "Salbei 12" }, 
      { hex: "#AFB7AA", name: "Salbei 13" }, 
      { hex: "#C7CEC3", name: "Salbei 14" }, 
      { hex: "#D9DDD5", name: "Salbei 15" }, 
      { hex: "#DFE1D9", name: "Salbei 16" }, 
      { hex: "#EBEAE4", name: "Salbei 18" }, 
      { hex: "#666A6A", name: "Tibet 0" }, 
      { hex: "#859292", name: "Tibet 12" }, 
      { hex: "#A4AFAE", name: "Tibet 13" }, 
      { hex: "#B9C3C0", name: "Tibet 14" }, 
      { hex: "#CDD4D1", name: "Tibet 15" }, 
      { hex: "#D9DDDB", name: "Tibet 16" }, 
      { hex: "#E8E9E6", name: "Tibet 18" }, 
      { hex: "#485057", name: "Atlantis 0" }, 
      { hex: "#6B7D89", name: "Atlantis 12" }, 
      { hex: "#8C9FA9", name: "Atlantis 13" }, 
      { hex: "#A5B4BC", name: "Atlantis 14" }, 
      { hex: "#B9C6CC", name: "Atlantis 15" }, 
      { hex: "#CED7DB", name: "Atlantis 16" }, 
      { hex: "#DFE5E5", name: "Atlantis 18" }
    ],
      "Caparol fassade A1": [      { hex: "#E8E1DB", name: "3D Warm-Weiss" }, 
      { hex: "#E9E3D9", name: "3D Umbra-Weiss" }, 
      { hex: "#EEE8E0", name: "3D Natur-Weiss" }, 
      { hex: "#F3EFEA", name: "3D Hell-Weiss" }, 
      { hex: "#EEE9E4", name: "3D Grau-Weiss" }, 
      { hex: "#EAE6E4", name: "3D Kuhl-Weiss" }, 
      { hex: "#3E3D3D", name: "3D Granit 5" }, 
      { hex: "#525050", name: "3D Granit 10" }, 
      { hex: "#727070", name: "3D Granit 20" }, 
      { hex: "#8E8A8A", name: "3D Granit 30" }, 
      { hex: "#AAA4A3", name: "3D Granit 40" }, 
      { hex: "#C4C0BE", name: "3D Granit 50" }, 
      { hex: "#E0DEDB", name: "3D Granit 60" }, 
      { hex: "#443D3D", name: "3D Ferro 5" }, 
      { hex: "#696462", name: "3D Ferro 15" }, 
      { hex: "#827B7A", name: "3D Ferro 25" }, 
      { hex: "#9B9592", name: "3D Ferro 35" }, 
      { hex: "#BAB3AF", name: "3D Ferro 45" }, 
      { hex: "#D4CFCC", name: "3D Ferro 55" }, 
      { hex: "#3A3835", name: "3D Jura 5" }, 
      { hex: "#66615F", name: "3D Jura 15" }, 
      { hex: "#7F7C78", name: "3D Jura 25" }, 
      { hex: "#999490", name: "3D Jura 35" }, 
      { hex: "#B8B4AE", name: "3D Jura 45" }, 
      { hex: "#D2CFCA", name: "3D Jura 55" }, 
      { hex: "#4D5052", name: "3D Venato 10" }, 
      { hex: "#6E7272", name: "3D Venato 20" }, 
      { hex: "#8A8C8E", name: "3D Venato 30" }, 
      { hex: "#A4A7A7", name: "3D Venato 40" }, 
      { hex: "#C1C2C2", name: "3D Venato 50" }, 
      { hex: "#DEDEDE", name: "3D Venato 60" }, 
      { hex: "#7F4A42", name: "3D Bordeaux 35" }, 
      { hex: "#815354", name: "3D Barolo 40" }, 
      { hex: "#AB8D8A", name: "3D Barolo 50" }, 
      { hex: "#C4ABA9", name: "3D Barolo 55" }, 
      { hex: "#A76E6F", name: "3D Barolo 75" }, 
      { hex: "#B98F8C", name: "3D Barolo 80" }, 
      { hex: "#CFAEAC", name: "3D Barolo 85" }, 
      { hex: "#523634", name: "3D Grenadin 5" }, 
      { hex: "#6E5451", name: "3D Grenadin 10" }, 
      { hex: "#91706C", name: "3D Grenadin 15" }, 
      { hex: "#A08A88", name: "3D Grenadin 20" }, 
      { hex: "#B8AAA6", name: "3D Grenadin 25" }, 
      { hex: "#D8CDCB", name: "3D Grenadin 30" }, 
      { hex: "#683732", name: "3D Grenadin 35" }, 
      { hex: "#825752", name: "3D Grenadin 40" }, 
      { hex: "#90746E", name: "3D Grenadin 45" }, 
      { hex: "#AE8E8B", name: "3D Grenadin 50" }, 
      { hex: "#C7ADA9", name: "3D Grenadin 55" }, 
      { hex: "#E0D2CE", name: "3D Grenadin 60" }, 
      { hex: "#813630", name: "3D Grenadin 65" }, 
      { hex: "#985551", name: "3D Grenadin 70" }, 
      { hex: "#AC7870", name: "3D Grenadin 75" }, 
      { hex: "#BE918B", name: "3D Grenadin 80" }, 
      { hex: "#D1B1AC", name: "3D Grenadin 85" }, 
      { hex: "#EAD6D3", name: "3D Grenadin 90" }, 
      { hex: "#AC5652", name: "3D Grenadin 100" }, 
      { hex: "#BE7971", name: "3D Grenadin 105" }, 
      { hex: "#CE958E", name: "3D Grenadin 110" }, 
      { hex: "#A7847D", name: "3D Bordeaux 5" }, 
      { hex: "#B9928A", name: "3D Bordeaux 10" }, 
      { hex: "#BBA19C", name: "3D Bordeaux 15" }, 
      { hex: "#C6B0AC", name: "3D Bordeaux 20" }, 
      { hex: "#DDD0CD", name: "3D Bordeaux 25" }, 
      { hex: "#F0E4E0", name: "3D Bordeaux 30" }, 
      { hex: "#9C645A", name: "3D Bordeaux 40" }, 
      { hex: "#B56E64", name: "3D Bordeaux 45" }, 
      { hex: "#BA7C73", name: "3D Bordeaux 50" }, 
      { hex: "#9A4234", name: "3D Magma 95" }, 
      { hex: "#583E38", name: "3D Magma 5" }, 
      { hex: "#715853", name: "3D Magma 10" }, 
      { hex: "#8B7370", name: "3D Magma 15" }, 
      { hex: "#A18E8A", name: "3D Magma 20" }, 
      { hex: "#BAAAA6", name: "3D Magma 25" }, 
      { hex: "#D9CDC9", name: "3D Magma 30" }, 
      { hex: "#6F4237", name: "3D Magma 35" }, 
      { hex: "#875C54", name: "3D Magma 40" }, 
      { hex: "#A07A71", name: "3D Magma 45" }, 
      { hex: "#B19189", name: "3D Magma 50" }, 
      { hex: "#C9AFA9", name: "3D Magma 55" }, 
      { hex: "#E4D2CE", name: "3D Magma 60" }, 
      { hex: "#7E453A", name: "3D Magma 65" }, 
      { hex: "#B07B6F", name: "3D Magma 75" }, 
      { hex: "#C0958A", name: "3D Magma 80" }, 
      { hex: "#AF5F51", name: "3D Magma 100" }, 
      { hex: "#C17F70", name: "3D Magma 105" }, 
      { hex: "#C7998C", name: "3D Magma 110" }, 
      { hex: "#978682", name: "3D Cameo 5" }, 
      { hex: "#B4A6A3", name: "3D Cameo 10" }, 
      { hex: "#CCC3C0", name: "3D Cameo 15" }, 
      { hex: "#816C67", name: "3D Cameo 35" }, 
      { hex: "#A58D87", name: "3D Cameo 40" }, 
      { hex: "#C6AEA7", name: "3D Cameo 50" }, 
      { hex: "#986960", name: "3D Cameo 65" }, 
      { hex: "#CA9B90", name: "3D Cameo 75" }, 
      { hex: "#DBB9AF", name: "3D Cameo 80" }, 
      { hex: "#894E3F", name: "3D Cameo 95" }, 
      { hex: "#AF7667", name: "3D Cameo 100" }, 
      { hex: "#DFAA9C", name: "3D Cameo 110" }, 
      { hex: "#A34F3D", name: "3D Cameo 125" }, 
      { hex: "#AE6254", name: "3D Cameo 130" }, 
      { hex: "#C97B69", name: "3D Cameo 135" }, 
      { hex: "#B67C69", name: "3D Lachs 35" }, 
      { hex: "#CCA092", name: "3D Lachs 45" }, 
      { hex: "#EEBAAD", name: "3D Lachs 55" }, 
      { hex: "#AA6149", name: "3D Lachs 65" }, 
      { hex: "#D17B5B", name: "3D Lachs 70" }, 
      { hex: "#DB8968", name: "3D Lachs 75" }, 
      { hex: "#B0968B", name: "3D Aprico 5" }, 
      { hex: "#C8A59B", name: "3D Aprico 10" }, 
      { hex: "#CAC4BC", name: "3D Aprico 15" }, 
      { hex: "#906D60", name: "3D Aprico 35" }, 
      { hex: "#A78678", name: "3D Aprico 40" }, 
      { hex: "#D7AD9F", name: "3D Aprico 45" }, 
      { hex: "#A06C55", name: "3D Aprico 95" }, 
      { hex: "#C58D75", name: "3D Aprico 105" }, 
      { hex: "#E39977", name: "3D Aprico 110" }, 
      { hex: "#C5643A", name: "3D Aprico 125" }, 
      { hex: "#D67E54", name: "3D Aprico 130" }, 
      { hex: "#CB7B5A", name: "3D Aprico 135" }, 
      { hex: "#D4733E", name: "3D Papaya 95" }, 
      { hex: "#7E695E", name: "3D Papaya 10" }, 
      { hex: "#A9968E", name: "3D Papaya 20" }, 
      { hex: "#DECDC7", name: "3D Papaya 30" }, 
      { hex: "#AB735C", name: "3D Papaya 40" }, 
      { hex: "#BF9D8C", name: "3D Papaya 50" }, 
      { hex: "#E7D1C6", name: "3D Papaya 60" }, 
      { hex: "#B1683D", name: "3D Papaya 65" }, 
      { hex: "#CC9373", name: "3D Papaya 75" }, 
      { hex: "#E2BBA8", name: "3D Papaya 85" }, 
      { hex: "#DF8856", name: "3D Papaya 100" }, 
      { hex: "#E5996E", name: "3D Papaya 105" }, 
      { hex: "#EAAC89", name: "3D Papaya 110" }, 
      { hex: "#A58875", name: "3D Ceramic 10" }, 
      { hex: "#BBA598", name: "3D Ceramic 20" }, 
      { hex: "#D7C5BD", name: "3D Ceramic 30" }, 
      { hex: "#C6A18B", name: "3D Ceramic 35" }, 
      { hex: "#D3B09D", name: "3D Ceramic 40" }, 
      { hex: "#E0C4B3", name: "3D Ceramic 55" }, 
      { hex: "#C59575", name: "3D Ceramic 65" }, 
      { hex: "#E0AC8B", name: "3D Ceramic 70" }, 
      { hex: "#EBCCB0", name: "3D Ceramic 75" }, 
      { hex: "#AA978C", name: "3D Amber 20" }, 
      { hex: "#BFB1A7", name: "3D Amber 25" }, 
      { hex: "#DECFC8", name: "3D Amber 30" }, 
      { hex: "#9F7758", name: "3D Amber 40" }, 
      { hex: "#C19F89", name: "3D Amber 50" }, 
      { hex: "#E8D3C6", name: "3D Amber 60" }, 
      { hex: "#B06E34", name: "3D Amber 65" }, 
      { hex: "#CC946A", name: "3D Amber 75" }, 
      { hex: "#E2BEA2", name: "3D Amber 85" }, 
      { hex: "#D97D30", name: "3D Amber 95" }, 
      { hex: "#E5A366", name: "3D Amber 105" }, 
      { hex: "#F3C5A0", name: "3D Amber 115" }, 
      { hex: "#7A675A", name: "3D Siena 5" }, 
      { hex: "#8F7F73", name: "3D Siena 10" }, 
      { hex: "#A6988E", name: "3D Siena 15" }, 
      { hex: "#C1B5AF", name: "3D Siena 20" }, 
      { hex: "#E6D3CF", name: "3D Siena 25" }, 
      { hex: "#EBE4E0", name: "3D Siena 30" }, 
      { hex: "#8F7665", name: "3D Siena 35" }, 
      { hex: "#C1AC9E", name: "3D Siena 45" }, 
      { hex: "#D9C9BD", name: "3D Siena 50" }, 
      { hex: "#B29279", name: "3D Siena 80" }, 
      { hex: "#CFB4A0", name: "3D Siena 85" }, 
      { hex: "#ECCDB7", name: "3D Siena 90" }, 
      { hex: "#D1965D", name: "3D Siena 125" }, 
      { hex: "#C4946A", name: "3D Siena 130" }, 
      { hex: "#E0AD82", name: "3D Siena 135" }, 
      { hex: "#EF9A33", name: "3D Onyx 220" }, 
      { hex: "#ABA19B", name: "3D Onyx 5" }, 
      { hex: "#D1BEB9", name: "3D Onyx 15" }, 
      { hex: "#D4CBC7", name: "3D Onyx 25" }, 
      { hex: "#786D63", name: "3D Onyx 35" }, 
      { hex: "#93877C", name: "3D Onyx 40" }, 
      { hex: "#B6ABA0", name: "3D Onyx 45" }, 
      { hex: "#CEBCAB", name: "3D Onyx 70" }, 
      { hex: "#E6D2C0", name: "3D Onyx 80" }, 
      { hex: "#FAECDE", name: "3D Onyx 90" }, 
      { hex: "#B6997C", name: "3D Onyx 100" }, 
      { hex: "#D6B28E", name: "3D Onyx 105" }, 
      { hex: "#EBD2BA", name: "3D Onyx 115" }, 
      { hex: "#D2A575", name: "3D Onyx 130" }, 
      { hex: "#ECC9A4", name: "3D Onyx 140" }, 
      { hex: "#FFD8BA", name: "3D Onyx 145" }, 
      { hex: "#B98547", name: "3D Onyx 155" }, 
      { hex: "#E5AD78", name: "3D Onyx 165" }, 
      { hex: "#F2BE85", name: "3D Onyx 170" }, 
      { hex: "#928475", name: "3D Marill 15" }, 
      { hex: "#C1B4A8", name: "3D Marill 25" }, 
      { hex: "#DED4C9", name: "3D Marill 30" }, 
      { hex: "#957D5A", name: "3D Marill 40" }, 
      { hex: "#BAA48A", name: "3D Marill 50" }, 
      { hex: "#E8D9C9", name: "3D Marill 60" }, 
      { hex: "#AD813E", name: "3D Marill 65" }, 
      { hex: "#CAA472", name: "3D Marill 75" }, 
      { hex: "#E2C5A1", name: "3D Marill 85" }, 
      { hex: "#DA9F3B", name: "3D Marill 95" }, 
      { hex: "#E1AB56", name: "3D Marill 100" }, 
      { hex: "#EDBB71", name: "3D Marill 105" }, 
      { hex: "#EDC383", name: "3D Marill 110" }, 
      { hex: "#F3CE9D", name: "3D Marill 115" }, 
      { hex: "#FFE3C3", name: "3D Marill 120" }, 
      { hex: "#827C73", name: "3D Palazzo 35" }, 
      { hex: "#BCB5AC", name: "3D Palazzo 45" }, 
      { hex: "#E2D7CD", name: "3D Palazzo 55" }, 
      { hex: "#867C70", name: "3D Palazzo 95" }, 
      { hex: "#B4A99C", name: "3D Palazzo 110" }, 
      { hex: "#D8CDC1", name: "3D Palazzo 115" }, 
      { hex: "#6F6353", name: "3D Palazzo 130" }, 
      { hex: "#AC9B85", name: "3D Palazzo 140" }, 
      { hex: "#E0CEB6", name: "3D Palazzo 150" }, 
      { hex: "#CEBB9C", name: "3D Palazzo 170" }, 
      { hex: "#E9D2B2", name: "3D Palazzo 175" }, 
      { hex: "#FCEAD2", name: "3D Palazzo 180" }, 
      { hex: "#B49D75", name: "3D Palazzo 195" }, 
      { hex: "#D7C299", name: "3D Palazzo 205" }, 
      { hex: "#FAE6C6", name: "3D Palazzo 210" }, 
      { hex: "#D5B486", name: "3D Palazzo 225" }, 
      { hex: "#F5D19D", name: "3D Palazzo 230" }, 
      { hex: "#FAEEDB", name: "3D Palazzo 240" }, 
      { hex: "#D3A964", name: "3D Palazzo 255" }, 
      { hex: "#E0B97C", name: "3D Palazzo 260" }, 
      { hex: "#F9CE8C", name: "3D Palazzo 265" }, 
      { hex: "#CFA24A", name: "3D Palazzo 285" }, 
      { hex: "#DDAC57", name: "3D Palazzo 290" }, 
      { hex: "#EFBF71", name: "3D Palazzo 295" }, 
      { hex: "#BC8920", name: "3D Palazzo 335" }, 
      { hex: "#D69524", name: "3D Palazzo 340" }, 
      { hex: "#D8AF29", name: "3D Palazzo 345" }, 
      { hex: "#F9D06C", name: "3D Ginster 140" }, 
      { hex: "#9B8A73", name: "3D Curcuma 15" }, 
      { hex: "#C6BAAA", name: "3D Curcuma 25" }, 
      { hex: "#E2DACF", name: "3D Curcuma 30" }, 
      { hex: "#A78D50", name: "3D Curcuma 40" }, 
      { hex: "#C5B087", name: "3D Curcuma 50" }, 
      { hex: "#D6C6A9", name: "3D Curcuma 55" }, 
      { hex: "#CD9E1D", name: "3D Curcuma 65" }, 
      { hex: "#D6AD4C", name: "3D Curcuma 70" }, 
      { hex: "#DEB868", name: "3D Curcuma 75" }, 
      { hex: "#E4C584", name: "3D Curcuma 80" }, 
      { hex: "#E9D1A6", name: "3D Curcuma 85" }, 
      { hex: "#F0E1C8", name: "3D Curcuma 90" }, 
      { hex: "#AEA18E", name: "3D Ginster 5" }, 
      { hex: "#CBC0B2", name: "3D Ginster 15" }, 
      { hex: "#ECE4DB", name: "3D Ginster 25" }, 
      { hex: "#91775A", name: "3D Ginster 35" }, 
      { hex: "#B5A78E", name: "3D Ginster 45" }, 
      { hex: "#E3D5BE", name: "3D Ginster 55" }, 
      { hex: "#CDBC99", name: "3D Ginster 75" }, 
      { hex: "#DFCBA4", name: "3D Ginster 80" }, 
      { hex: "#F1DEB9", name: "3D Ginster 85" }, 
      { hex: "#D9BB88", name: "3D Ginster 95" }, 
      { hex: "#E6C37E", name: "3D Ginster 100" }, 
      { hex: "#F9D38D", name: "3D Ginster 105" }, 
      { hex: "#F2D492", name: "3D Ginster 110" }, 
      { hex: "#F5DCAD", name: "3D Ginster 115" }, 
      { hex: "#FFEBC3", name: "3D Ginster 120" }, 
      { hex: "#B8AC8F", name: "3D Curry 5" }, 
      { hex: "#DDD4C1", name: "3D Curry 15" }, 
      { hex: "#F3EADA", name: "3D Curry 25" }, 
      { hex: "#D8C79A", name: "3D Curry 45" }, 
      { hex: "#E8DBB9", name: "3D Curry 50" }, 
      { hex: "#F7EACF", name: "3D Curry 55" }, 
      { hex: "#BAA76D", name: "3D Curry 65" }, 
      { hex: "#DDBF7D", name: "3D Curry 70" }, 
      { hex: "#E2CE99", name: "3D Curry 75" }, 
      { hex: "#FADCAF", name: "3D Curry 80" }, 
      { hex: "#FBEABF", name: "3D Curry 85" }, 
      { hex: "#FFF1C8", name: "3D Curry 90" }, 
      { hex: "#E4C879", name: "3D Curry 105" }, 
      { hex: "#EFD591", name: "3D Curry 110" }, 
      { hex: "#FFEBB0", name: "3D Curry 120" }, 
      { hex: "#E4C32C", name: "3D Curry 130" }, 
      { hex: "#EED168", name: "3D Curry 135" }, 
      { hex: "#FADA5F", name: "3D Curry 140" }, 
      { hex: "#7C7254", name: "3D Citrus 10" }, 
      { hex: "#ADA28E", name: "3D Citrus 20" }, 
      { hex: "#C6BFAC", name: "3D Citrus 25" }, 
      { hex: "#BAAB6C", name: "3D Citrus 45" }, 
      { hex: "#C9BC88", name: "3D Citrus 50" }, 
      { hex: "#DBCFA5", name: "3D Citrus 55" }, 
      { hex: "#EBD886", name: "3D Citrus 80" }, 
      { hex: "#F3E3A0", name: "3D Citrus 85" }, 
      { hex: "#FBEEBF", name: "3D Citrus 90" }, 
      { hex: "#B1A686", name: "3D Melisse 35" }, 
      { hex: "#CCC6AA", name: "3D Melisse 40" }, 
      { hex: "#E7DFC5", name: "3D Melisse 50" }, 
      { hex: "#B6A974", name: "3D Melisse 75" }, 
      { hex: "#DACD97", name: "3D Melisse 80" }, 
      { hex: "#FAF0D3", name: "3D Melisse 90" }, 
      { hex: "#F3DF51", name: "3D Melisse 110" }, 
      { hex: "#F8E975", name: "3D Melisse 115" }, 
      { hex: "#FBEFC3", name: "3D Melisse 120" }, 
      { hex: "#C4BD47", name: "3D Tundra 130" }, 
      { hex: "#585753", name: "3D Tundra 5" }, 
      { hex: "#767266", name: "3D Tundra 10" }, 
      { hex: "#8D877C", name: "3D Tundra 15" }, 
      { hex: "#BBB6A9", name: "3D Tundra 20" }, 
      { hex: "#E4DED0", name: "3D Tundra 25" }, 
      { hex: "#F4ECE0", name: "3D Tundra 30" }, 
      { hex: "#A59F85", name: "3D Tundra 35" }, 
      { hex: "#CDC7B0", name: "3D Tundra 45" }, 
      { hex: "#F1E9D5", name: "3D Tundra 55" }, 
      { hex: "#80805C", name: "3D Tundra 75" }, 
      { hex: "#B1AA88", name: "3D Tundra 85" }, 
      { hex: "#E4DBBA", name: "3D Tundra 90" }, 
      { hex: "#9B9A3D", name: "3D Tundra 125" }, 
      { hex: "#D2CB49", name: "3D Tundra 135" }, 
      { hex: "#F3EA70", name: "3D Tundra 145" }, 
      { hex: "#A7A49A", name: "3D Mai 15" }, 
      { hex: "#C4BFB5", name: "3D Mai 20" }, 
      { hex: "#DDD8CD", name: "3D Mai 25" }, 
      { hex: "#807D66", name: "3D Mai 35" }, 
      { hex: "#B7B29B", name: "3D Mai 45" }, 
      { hex: "#E7DFC7", name: "3D Mai 55" }, 
      { hex: "#A9B350", name: "3D Mai 70" }, 
      { hex: "#C5CD5C", name: "3D Mai 80" }, 
      { hex: "#D5DE8C", name: "3D Mai 85" }, 
      { hex: "#8C8C85", name: "3D Jade 35" }, 
      { hex: "#BCBAAC", name: "3D Jade 45" }, 
      { hex: "#CFD5CD", name: "3D Jade 55" }, 
      { hex: "#7E7E61", name: "3D Jade 65" }, 
      { hex: "#9E9E89", name: "3D Jade 70" }, 
      { hex: "#B8B8A0", name: "3D Jade 75" }, 
      { hex: "#CBD0AF", name: "3D Jade 80" }, 
      { hex: "#E0DFC4", name: "3D Jade 85" }, 
      { hex: "#F1EDD8", name: "3D Jade 90" }, 
      { hex: "#697049", name: "3D Jade 95" }, 
      { hex: "#99A077", name: "3D Jade 100" }, 
      { hex: "#B4BB8B", name: "3D Jade 105" }, 
      { hex: "#D6D9A9", name: "3D Jade 110" }, 
      { hex: "#DAE1AB", name: "3D Jade 115" }, 
      { hex: "#E7EDA7", name: "3D Jade 120" }, 
      { hex: "#6D8254", name: "3D Pinie 40" }, 
      { hex: "#A5B08C", name: "3D Pinie 50" }, 
      { hex: "#E0E1CA", name: "3D Pinie 60" }, 
      { hex: "#8DB044", name: "3D Pinie 100" }, 
      { hex: "#B8CB82", name: "3D Pinie 110" }, 
      { hex: "#DAECC1", name: "3D Pinie 120" }, 
      { hex: "#565851", name: "3D Moos 5" }, 
      { hex: "#86857F", name: "3D Moos 15" }, 
      { hex: "#A2A09D", name: "3D Moos 20" }, 
      { hex: "#A3A697", name: "3D Moos 40" }, 
      { hex: "#BBBAAF", name: "3D Moos 50" }, 
      { hex: "#E0E1D3", name: "3D Moos 60" }, 
      { hex: "#798367", name: "3D Moos 65" }, 
      { hex: "#AAAE99", name: "3D Moos 75" }, 
      { hex: "#C2C8B2", name: "3D Moos 80" }, 
      { hex: "#79A467", name: "3D Oase 135" }, 
      { hex: "#7B7E65", name: "3D Oase 45" }, 
      { hex: "#ADB9A3", name: "3D Oase 50" }, 
      { hex: "#D5D7CD", name: "3D Oase 55" }, 
      { hex: "#8B9D7E", name: "3D Oase 75" }, 
      { hex: "#CBC9B6", name: "3D Oase 80" }, 
      { hex: "#F1E9DC", name: "3D Oase 90" }, 
      { hex: "#54774C", name: "3D Oase 100" }, 
      { hex: "#9FC18D", name: "3D Oase 110" }, 
      { hex: "#F1F3D7", name: "3D Oase 120" }, 
      { hex: "#8F908B", name: "3D Agave 10" }, 
      { hex: "#C5C5BF", name: "3D Agave 20" }, 
      { hex: "#D4D5CF", name: "3D Agave 25" }, 
      { hex: "#828E7E", name: "3D Agave 35" }, 
      { hex: "#9BAEA1", name: "3D Agave 40" }, 
      { hex: "#C2C7BD", name: "3D Agave 45" }, 
      { hex: "#DBDED4", name: "3D Agave 50" }, 
      { hex: "#E8EAE3", name: "3D Agave 55" }, 
      { hex: "#F4F2EB", name: "3D Agave 60" }, 
      { hex: "#899E82", name: "3D Agave 65" }, 
      { hex: "#ABBCA7", name: "3D Agave 75" }, 
      { hex: "#CFD9CA", name: "3D Agave 85" }, 
      { hex: "#415247", name: "3D Malachit 5" }, 
      { hex: "#5C6C5F", name: "3D Malachit 10" }, 
      { hex: "#768479", name: "3D Malachit 15" }, 
      { hex: "#939D94", name: "3D Malachit 20" }, 
      { hex: "#B1B8B0", name: "3D Malachit 25" }, 
      { hex: "#C8D8D1", name: "3D Malachit 30" }, 
      { hex: "#4D7059", name: "3D Malachit 40" }, 
      { hex: "#8BA793", name: "3D Malachit 50" }, 
      { hex: "#D2DFD5", name: "3D Malachit 60" }, 
      { hex: "#669579", name: "3D Malachit 75" }, 
      { hex: "#A7C6B2", name: "3D Malachit 85" }, 
      { hex: "#D2E6D7", name: "3D Malachit 90" }, 
      { hex: "#4E9B76", name: "3D Malachit 105" }, 
      { hex: "#7DB494", name: "3D Malachit 110" }, 
      { hex: "#A5CFB5", name: "3D Malachit 115" }, 
      { hex: "#858A85", name: "3D Mint 5" }, 
      { hex: "#9EA69F", name: "3D Mint 10" }, 
      { hex: "#BFC7BF", name: "3D Mint 15" }, 
      { hex: "#D1D4CE", name: "3D Mint 20" }, 
      { hex: "#E1E1DC", name: "3D Mint 25" }, 
      { hex: "#F0EDE8", name: "3D Mint 30" }, 
      { hex: "#6A8974", name: "3D Mint 40" }, 
      { hex: "#849E8E", name: "3D Mint 45" }, 
      { hex: "#B9C9BE", name: "3D Mint 55" }, 
      { hex: "#2A767C", name: "3D Verona 95" }, 
      { hex: "#718C86", name: "3D Patina 5" }, 
      { hex: "#AAB9B4", name: "3D Patina 15" }, 
      { hex: "#D0D5D2", name: "3D Patina 25" }, 
      { hex: "#83938E", name: "3D Patina 50" }, 
      { hex: "#A7BDB8", name: "3D Patina 55" }, 
      { hex: "#BAD9D3", name: "3D Patina 60" }, 
      { hex: "#56766F", name: "3D Patina 70" }, 
      { hex: "#7B9E94", name: "3D Patina 75" }, 
      { hex: "#9FBDB5", name: "3D Patina 80" }, 
      { hex: "#525B5B", name: "3D Verona 35" }, 
      { hex: "#88908F", name: "3D Verona 40" }, 
      { hex: "#ACB2B1", name: "3D Verona 45" }, 
      { hex: "#798B8B", name: "3D Verona 75" }, 
      { hex: "#A0ACAC", name: "3D Verona 80" }, 
      { hex: "#C8D6D3", name: "3D Verona 85" }, 
      { hex: "#5C9195", name: "3D Verona 105" }, 
      { hex: "#91ADB0", name: "3D Verona 110" }, 
      { hex: "#A9CCCB", name: "3D Verona 115" }, 
      { hex: "#5D6368", name: "3D Arctis 5" }, 
      { hex: "#787F84", name: "3D Arctis 10" }, 
      { hex: "#979C9F", name: "3D Arctis 15" }, 
      { hex: "#B1B7BA", name: "3D Arctis 20" }, 
      { hex: "#D2D6D7", name: "3D Arctis 25" }, 
      { hex: "#E5E5E4", name: "3D Arctis 30" }, 
      { hex: "#5B747D", name: "3D Arctis 35" }, 
      { hex: "#65737A", name: "3D Arctis 40" }, 
      { hex: "#888C91", name: "3D Arctis 45" }, 
      { hex: "#9EA9AC", name: "3D Arctis 50" }, 
      { hex: "#BFC7C8", name: "3D Arctis 55" }, 
      { hex: "#E3E8E7", name: "3D Arctis 60" }, 
      { hex: "#718E97", name: "3D Arctis 65" }, 
      { hex: "#92ACB2", name: "3D Arctis 70" }, 
      { hex: "#B6C8CD", name: "3D Arctis 80" }, 
      { hex: "#2D6A79", name: "3D Arctis 95" }, 
      { hex: "#60828F", name: "3D Arctis 100" }, 
      { hex: "#799FAA", name: "3D Arctis 105" }, 
      { hex: "#507199", name: "3D Lazur 165" }, 
      { hex: "#9DA9B2", name: "3D Coelin 35" }, 
      { hex: "#BDC7CC", name: "3D Coelin 45" }, 
      { hex: "#DFE4E7", name: "3D Coelin 55" }, 
      { hex: "#7AA1B3", name: "3D Coelin 65" }, 
      { hex: "#98BCCE", name: "3D Coelin 75" }, 
      { hex: "#B8D6E5", name: "3D Coelin 85" }, 
      { hex: "#52585F", name: "3D Pacific 10" }, 
      { hex: "#929AA0", name: "3D Pacific 15" }, 
      { hex: "#B0B4B6", name: "3D Pacific 20" }, 
      { hex: "#727E87", name: "3D Pacific 45" }, 
      { hex: "#B8BDC0", name: "3D Pacific 50" }, 
      { hex: "#E2E4E4", name: "3D Pacific 60" }, 
      { hex: "#939DA3", name: "3D Pacific 65" }, 
      { hex: "#9DAAB3", name: "3D Pacific 75" }, 
      { hex: "#B8C5CC", name: "3D Pacific 80" }, 
      { hex: "#597489", name: "3D Pacific 135" }, 
      { hex: "#738EA0", name: "3D Pacific 140" }, 
      { hex: "#90A9BA", name: "3D Pacific 145" }, 
      { hex: "#6E767D", name: "3D Lago 15" }, 
      { hex: "#A9ADB1", name: "3D Lago 25" }, 
      { hex: "#CDCFD1", name: "3D Lago 30" }, 
      { hex: "#6C7D8C", name: "3D Lago 45" }, 
      { hex: "#ACB7C0", name: "3D Lago 55" }, 
      { hex: "#C7D8DF", name: "3D Lago 60" }, 
      { hex: "#6A849B", name: "3D Lago 75" }, 
      { hex: "#879FB1", name: "3D Lago 80" }, 
      { hex: "#AABDCC", name: "3D Lago 85" }, 
      { hex: "#3D7097", name: "3D Lago 100" }, 
      { hex: "#568BAD", name: "3D Lago 105" }, 
      { hex: "#86A7C2", name: "3D Lago 110" }, 
      { hex: "#6C7281", name: "3D Lazur 75" }, 
      { hex: "#9EA7B4", name: "3D Lazur 85" }, 
      { hex: "#C2C9D6", name: "3D Lazur 90" }, 
      { hex: "#62728C", name: "3D Lazur 105" }, 
      { hex: "#818EA2", name: "3D Lazur 110" }, 
      { hex: "#A6B5C8", name: "3D Lazur 115" }, 
      { hex: "#43648B", name: "3D Lazur 160" }, 
      { hex: "#6C8DB5", name: "3D Lazur 170" }, 
      { hex: "#9FB5D2", name: "3D Lazur 180" }, 
      { hex: "#61647E", name: "3D Lavendel 70" }, 
      { hex: "#3A414C", name: "3D Saphir 5" }, 
      { hex: "#4B5B67", name: "3D Saphir 10" }, 
      { hex: "#72767F", name: "3D Saphir 15" }, 
      { hex: "#8E9199", name: "3D Saphir 20" }, 
      { hex: "#ACADB4", name: "3D Saphir 25" }, 
      { hex: "#D0D1D4", name: "3D Saphir 30" }, 
      { hex: "#747C8E", name: "3D Saphir 45" }, 
      { hex: "#9195A4", name: "3D Saphir 50" }, 
      { hex: "#B0B3C0", name: "3D Saphir 55" }, 
      { hex: "#6A7088", name: "3D Aquarell 65" }, 
      { hex: "#848BA3", name: "3D Aquarell 70" }, 
      { hex: "#9FA7BD", name: "3D Aquarell 75" }, 
      { hex: "#8E8D95", name: "3D Lavendel 5" }, 
      { hex: "#B7B5BF", name: "3D Lavendel 15" }, 
      { hex: "#D7D4D8", name: "3D Lavendel 25" }, 
      { hex: "#72717B", name: "3D Lavendel 45" }, 
      { hex: "#9C9BA7", name: "3D Lavendel 50" }, 
      { hex: "#C7C6D2", name: "3D Lavendel 55" }, 
      { hex: "#958C98", name: "3D Velvet 20" }, 
      { hex: "#B2AEB4", name: "3D Velvet 25" }, 
      { hex: "#D3CFD3", name: "3D Velvet 30" }, 
      { hex: "#867985", name: "3D Viola 5" }, 
      { hex: "#A3989F", name: "3D Viola 10" }, 
      { hex: "#BCB4B9", name: "3D Viola 15" }, 
      { hex: "#816B70", name: "3D Flamenco 35" }, 
      { hex: "#9B888D", name: "3D Flamenco 40" }, 
      { hex: "#BAA7AC", name: "3D Flamenco 50" }
    ],
      "Caparol Alpinacolor": [      { hex: "#647038", name: "Palma 1" }, 
      { hex: "#fce4bc", name: "Rodeo 7" }, 
      { hex: "#e8f07c", name: "Schilf 3" }, 
      { hex: "#dc8070", name: "Tommy 4" }, 
      { hex: "#005460", name: "Alaska 2" }, 
      { hex: "#006874", name: "Alaska 3" }, 
      { hex: "#007884", name: "Alaska 4" }, 
      { hex: "#2c9ca4", name: "Alaska 5" }, 
      { hex: "#60b0c4", name: "Alaska 6" }, 
      { hex: "#84c4d0", name: "Alaska 7" }, 
      { hex: "#b4dce0", name: "Alaska 8" }, 
      { hex: "#c4e4e8", name: "Alaska 9" }, 
      { hex: "#00383c", name: "Alaska 0 Kg" }, 
      { hex: "#0E781C", name: "Amazonas 1" }, 
      { hex: "#288c30", name: "Amazonas 2" }, 
      { hex: "#40a448", name: "Amazonas 3" }, 
      { hex: "#5cbc60", name: "Amazonas 4" }, 
      { hex: "#84d08c", name: "Amazonas 5" }, 
      { hex: "#a0e0a8", name: "Amazonas 6" }, 
      { hex: "#b8e8c0", name: "Amazonas 7" }, 
      { hex: "#c4eccc", name: "Amazonas 8" }, 
      { hex: "#d8f0dc", name: "Amazonas 9" }, 
      { hex: "#106010", name: "Amazonas 0 Kg" }, 
      { hex: "#fca828", name: "Aprikose 1" }, 
      { hex: "#FFB438", name: "Aprikose 2" }, 
      { hex: "#fcd054", name: "Aprikose 3" }, 
      { hex: "#fce87c", name: "Aprikose 4" }, 
      { hex: "#fcf098", name: "Aprikose 5" }, 
      { hex: "#fcf8b4", name: "Aprikose 6" }, 
      { hex: "#fcfcc8", name: "Aprikose 7" }, 
      { hex: "#fcf8d8", name: "Aprikose 8" }, 
      { hex: "#fcfce4", name: "Aprikose 9" }, 
      { hex: "#fc8c14", name: "Aprikose 0 Kg" }, 
      { hex: "#00007c", name: "Atlantic 1" }, 
      { hex: "#001c90", name: "Atlantic 2" }, 
      { hex: "#003ca8", name: "Atlantic 3" }, 
      { hex: "#0868bc", name: "Atlantic 4" }, 
      { hex: "#348ccc", name: "Atlantic 5" }, 
      { hex: "#68acdc", name: "Atlantic 6" }, 
      { hex: "#8cc4e0", name: "Atlantic 7" }, 
      { hex: "#a4d0e8", name: "Atlantic 8" }, 
      { hex: "#c8e4ec", name: "Atlantic 9" }, 
      { hex: "#000050", name: "Atlantic 0 Kg" }, 
      { hex: "#e4c43c", name: "Bali 1" }, 
      { hex: "#f0d450", name: "Bali 2" }, 
      { hex: "#fce868", name: "Bali 3" }, 
      { hex: "#fcf884", name: "Bali 4" }, 
      { hex: "#fcfca0", name: "Bali 5" }, 
      { hex: "#fcfcb4", name: "Bali 6" }, 
      { hex: "#fcfcc8", name: "Bali 7" }, 
      { hex: "#f8fcd8", name: "Bali 8" }, 
      { hex: "#f8fce0", name: "Bali 9" }, 
      { hex: "#d4b030", name: "Bali 0 Kg" }, 
      { hex: "#fcfc5c", name: "Bambus 1" }, 
      { hex: "#fcfc6c", name: "Bambus 2" }, 
      { hex: "#fcfc84", name: "Bambus 3" }, 
      { hex: "#fcfc9c", name: "Bambus 4" }, 
      { hex: "#fcfcb4", name: "Bambus 5" }, 
      { hex: "#fcfcc8", name: "Bambus 6" }, 
      { hex: "#f4fcd4", name: "Bambus 7" }, 
      { hex: "#f0fce0", name: "Bambus 8" }, 
      { hex: "#f4fce4", name: "Bambus 9" }, 
      { hex: "#fcfc40", name: "Bambus 0 Kg" }, 
      { hex: "#544430", name: "Bison 1" }, 
      { hex: "#685840", name: "Bison 2" }, 
      { hex: "#8c7c64", name: "Bison 3" }, 
      { hex: "#a4987c", name: "Bison 4" }, 
      { hex: "#bcb098", name: "Bison 5" }, 
      { hex: "#d0c4b0", name: "Bison 6" }, 
      { hex: "#e0d8cc", name: "Bison 7" }, 
      { hex: "#e8e4d8", name: "Bison 8" }, 
      { hex: "#f0ece4", name: "Bison 9" }, 
      { hex: "#3c2c18", name: "Bison 0 Kg" }, 
      { hex: "#fcfc58", name: "Canari 1" }, 
      { hex: "#fcfc68", name: "Canari 2" }, 
      { hex: "#fcfc80", name: "Canari 3" }, 
      { hex: "#fcfc9c", name: "Canari 4" }, 
      { hex: "#fcfcac", name: "Canari 5" }, 
      { hex: "#f4fcb8", name: "Canari 6" }, 
      { hex: "#f0fccc", name: "Canari 7" }, 
      { hex: "#f4fcdc", name: "Canari 8" }, 
      { hex: "#f4fce4", name: "Canari 9" }, 
      { hex: "#fcfc4c", name: "Canari 0 Kg" }, 
      { hex: "#fca83c", name: "Cognac 1" }, 
      { hex: "#fcb450", name: "Cognac 2" }, 
      { hex: "#fcc864", name: "Cognac 3" }, 
      { hex: "#fcd888", name: "Cognac 4" }, 
      { hex: "#fce8a4", name: "Cognac 5" }, 
      { hex: "#fcf4c4", name: "Cognac 6" }, 
      { hex: "#fcf4d0", name: "Cognac 7" }, 
      { hex: "#fcf4d8", name: "Cognac 8" }, 
      { hex: "#fcf8e8", name: "Cognac 9" }, 
      { hex: "#ec9028", name: "Cognac 0 Kg" }, 
      { hex: "#445440", name: "Elefant 1" }, 
      { hex: "#5c6854", name: "Elefant 2" }, 
      { hex: "#7c8470", name: "Elefant 3" }, 
      { hex: "#9EA08C", name: "Elefant 4" }, 
      { hex: "#acb4a4", name: "Elefant 5" }, 
      { hex: "#c4ccbc", name: "Elefant 6" }, 
      { hex: "#CEDCD4", name: "Elefant 7" }, 
      { hex: "#dce0d8", name: "Elefant 8" }, 
      { hex: "#ececec", name: "Elefant 9" }, 
      { hex: "#34402c", name: "Elefant 0 Kg" }, 
      { hex: "#fcc83c", name: "Gobi 1" }, 
      { hex: "#fcd440", name: "Gobi 2" }, 
      { hex: "#fcec60", name: "Gobi 3" }, 
      { hex: "#fcfc80", name: "Gobi 4" }, 
      { hex: "#fcfca0", name: "Gobi 5" }, 
      { hex: "#fcfcbc", name: "Gobi 6" }, 
      { hex: "#fcfccc", name: "Gobi 7" }, 
      { hex: "#fcfcdc", name: "Gobi 8" }, 
      { hex: "#f8fce0", name: "Gobi 9" }, 
      { hex: "#f4b828", name: "Gobi 0 Kg" }, 
      { hex: "#886030", name: "Havanna 1" }, 
      { hex: "#947048", name: "Havanna 2" }, 
      { hex: "#ac8858", name: "Havanna 3" }, 
      { hex: "#c8a474", name: "Havanna 4" }, 
      { hex: "#CABC94", name: "Havanna 5" }, 
      { hex: "#e0ccb0", name: "Havanna 6" }, 
      { hex: "#ecdcc0", name: "Havanna 7" }, 
      { hex: "#f0e4d4", name: "Havanna 8" }, 
      { hex: "#f4ece4", name: "Havanna 9" }, 
      { hex: "#704418", name: "Havanna 0 Kg" }, 
      { hex: "#b45420", name: "India 1" }, 
      { hex: "#c0602c", name: "India 2" }, 
      { hex: "#d87c48", name: "India 3" }, 
      { hex: "#e89868", name: "India 4" }, 
      { hex: "#f8b888", name: "India 5" }, 
      { hex: "#fcc8a0", name: "India 6" }, 
      { hex: "#fcd8bc", name: "India 7" }, 
      { hex: "#fce4d4", name: "India 8" }, 
      { hex: "#fcf0e0", name: "India 9" }, 
      { hex: "#a44414", name: "India 0 Kg" }, 
      { hex: "#002470", name: "Iris 1" }, 
      { hex: "#00347c", name: "Iris 2" }, 
      { hex: "#085098", name: "Iris 3" }, 
      { hex: "#3474b8", name: "Iris 4" }, 
      { hex: "#5490c4", name: "Iris 5" }, 
      { hex: "#7EACD0", name: "Iris 6" }, 
      { hex: "#a4cce0", name: "Iris 7" }, 
      { hex: "#b4d4e0", name: "Iris 8" }, 
      { hex: "#c8e4ec", name: "Iris 9" }, 
      { hex: "#001050", name: "Iris 0 Kg" }, 
      { hex: "#58503c", name: "Lava 1" }, 
      { hex: "#68644c", name: "Lava 2" }, 
      { hex: "#8c8470", name: "Lava 3" }, 
      { hex: "#a49c8c", name: "Lava 4" }, 
      { hex: "#c0c0ac", name: "Lava 5" }, 
      { hex: "#ccccc0", name: "Lava 6" }, 
      { hex: "#dcdcd4", name: "Lava 7" }, 
      { hex: "#ecece4", name: "Lava 8" }, 
      { hex: "#ecece4", name: "Lava 9" }, 
      { hex: "#443c28", name: "Lava 0 Kg" }, 
      { hex: "#b89c3c", name: "Limba 1" }, 
      { hex: "#bca048", name: "Limba 2" }, 
      { hex: "#d8c064", name: "Limba 3" }, 
      { hex: "#e8d480", name: "Limba 4" }, 
      { hex: "#f4e8a4", name: "Limba 5" }, 
      { hex: "#f8ecb8", name: "Limba 6" }, 
      { hex: "#fcf4d4", name: "Limba 7" }, 
      { hex: "#F2F8DC", name: "Limba 8" }, 
      { hex: "#FFF8E4", name: "Limba 9" }, 
      { hex: "#987c24", name: "Limba 0 Kg" }, 
      { hex: "#CEA880", name: "Malaga 4" }, 
      { hex: "#fcfc54", name: "Mais 1" }, 
      { hex: "#fcfc60", name: "Mais 2" }, 
      { hex: "#fcfc80", name: "Mais 3" }, 
      { hex: "#fcfca0", name: "Mais 4" }, 
      { hex: "#fcfcb4", name: "Mais 5" }, 
      { hex: "#fcfcc8", name: "Mais 6" }, 
      { hex: "#f8fcd4", name: "Mais 7" }, 
      { hex: "#f8fce0", name: "Mais 8" }, 
      { hex: "#f4fce8", name: "Mais 9" }, 
      { hex: "#fcec34", name: "Mais 0 Kg" }, 
      { hex: "#a06038", name: "Malaga 1" }, 
      { hex: "#b07040", name: "Malaga 2" }, 
      { hex: "#c48860", name: "Malaga 3" }, 
      { hex: "#e0bca0", name: "Malaga 5" }, 
      { hex: "#ecd4c0", name: "Malaga 6" }, 
      { hex: "#ecd8c8", name: "Malaga 7" }, 
      { hex: "#f8ecdc", name: "Malaga 8" }, 
      { hex: "#f4ece8", name: "Malaga 9" }, 
      { hex: "#944c20", name: "Malaga 0 Kg" }, 
      { hex: "#fcdc38", name: "Mandarin 1" }, 
      { hex: "#fcec50", name: "Mandarin 2" }, 
      { hex: "#fcfc64", name: "Mandarin 3" }, 
      { hex: "#fcfc80", name: "Mandarin 4" }, 
      { hex: "#fcfca4", name: "Mandarin 5" }, 
      { hex: "#fcfcbc", name: "Mandarin 6" }, 
      { hex: "#fcfccc", name: "Mandarin 7" }, 
      { hex: "#fcfcdc", name: "Mandarin 8" }, 
      { hex: "#f8fce4", name: "Mandarin 9" }, 
      { hex: "#F2D024", name: "Mandarin 0 Kg" }, 
      { hex: "#ac7028", name: "Maroc 1" }, 
      { hex: "#c08840", name: "Maroc 2" }, 
      { hex: "#d8a85c", name: "Maroc 3" }, 
      { hex: "#ecc484", name: "Maroc 4" }, 
      { hex: "#ecd09c", name: "Maroc 5" }, 
      { hex: "#f4e0b8", name: "Maroc 6" }, 
      { hex: "#f8e8cc", name: "Maroc 7" }, 
      { hex: "#fcf0d8", name: "Maroc 8" }, 
      { hex: "#fcf4e8", name: "Maroc 9" }, 
      { hex: "#945818", name: "Maroc 0 Kg" }, 
      { hex: "#7c4c24", name: "Marone 1" }, 
      { hex: "#8c5c34", name: "Marone 2" }, 
      { hex: "#ac7c54", name: "Marone 3" }, 
      { hex: "#cca47c", name: "Marone 4" }, 
      { hex: "#d4b89c", name: "Marone 5" }, 
      { hex: "#DACCB4", name: "Marone 6" }, 
      { hex: "#f0e0cc", name: "Marone 7" }, 
      { hex: "#f4e8d8", name: "Marone 8" }, 
      { hex: "#f4ece8", name: "Marone 9" }, 
      { hex: "#64340c", name: "Marone 0 Kg" }, 
      { hex: "#c09434", name: "Mistral 1" }, 
      { hex: "#d4a848", name: "Mistral 2" }, 
      { hex: "#f4cc68", name: "Mistral 3" }, 
      { hex: "#f8dc84", name: "Mistral 4" }, 
      { hex: "#fce8a8", name: "Mistral 5" }, 
      { hex: "#fcf4c0", name: "Mistral 6" }, 
      { hex: "#fcf4d0", name: "Mistral 7" }, 
      { hex: "#fcfce0", name: "Mistral 8" }, 
      { hex: "#fcf8e4", name: "Mistral 9" }, 
      { hex: "#AA8420", name: "Mistral 0 Kg" }, 
      { hex: "#ecb03c", name: "Monsun 1" }, 
      { hex: "#f8c04c", name: "Monsun 2" }, 
      { hex: "#fcd860", name: "Monsun 3" }, 
      { hex: "#F2E884", name: "Monsun 4" }, 
      { hex: "#fcf8a0", name: "Monsun 5" }, 
      { hex: "#fcf4b8", name: "Monsun 6" }, 
      { hex: "#fcf8cc", name: "Monsun 7" }, 
      { hex: "#fcfcd8", name: "Monsun 8" }, 
      { hex: "#f8f8e4", name: "Monsun 9" }, 
      { hex: "#dc9c24", name: "Monsun 0 Kg" }, 
      { hex: "#b88430", name: "Montana 1" }, 
      { hex: "#c89840", name: "Montana 2" }, 
      { hex: "#e0b464", name: "Montana 3" }, 
      { hex: "#f0cc88", name: "Montana 4" }, 
      { hex: "#e4d8c8", name: "Nutria 7" }, 
      { hex: "#fce0a4", name: "Montana 5" }, 
      { hex: "#fce8c0", name: "Montana 6" }, 
      { hex: "#fcf4d0", name: "Montana 7" }, 
      { hex: "#fcf8e0", name: "Montana 8" }, 
      { hex: "#fcfcec", name: "Montana 9" }, 
      { hex: "#a46c1c", name: "Montana 0 Kg" }, 
      { hex: "#684c30", name: "Nutria 1" }, 
      { hex: "#785c40", name: "Nutria 2" }, 
      { hex: "#94785c", name: "Nutria 3" }, 
      { hex: "#b09880", name: "Nutria 4" }, 
      { hex: "#c8b09c", name: "Nutria 5" }, 
      { hex: "#dcccb8", name: "Nutria 6" }, 
      { hex: "#ece4d8", name: "Nutria 8" }, 
      { hex: "#f0e8dc", name: "Nutria 9" }, 
      { hex: "#503418", name: "Nutria 0 Kg" }, 
      { hex: "#8c9844", name: "Olive 1" }, 
      { hex: "#9ca854", name: "Olive 2" }, 
      { hex: "#b4c06c", name: "Olive 3" }, 
      { hex: "#d0d48c", name: "Olive 4" }, 
      { hex: "#d8e4a4", name: "Olive 5" }, 
      { hex: "#e0ecb8", name: "Olive 6" }, 
      { hex: "#ecf4cc", name: "Olive 7" }, 
      { hex: "#f4f8e0", name: "Olive 8" }, 
      { hex: "#f4f8e8", name: "Olive 9" }, 
      { hex: "#7c8030", name: "Olive 0 Kg" }, 
      { hex: "#541858", name: "Orchidee 1" }, 
      { hex: "#602464", name: "Orchidee 2" }, 
      { hex: "#7c4484", name: "Orchidee 3" }, 
      { hex: "#9c68a4", name: "Orchidee 4" }, 
      { hex: "#b088bc", name: "Orchidee 5" }, 
      { hex: "#c0a4cc", name: "Orchidee 6" }, 
      { hex: "#dcc4e0", name: "Orchidee 7" }, 
      { hex: "#e4d8e8", name: "Orchidee 8" }, 
      { hex: "#ece0e8", name: "Orchidee 9" }, 
      { hex: "#480c3c", name: "Orchidee 0 Kg" }, 
      { hex: "#7c8848", name: "Palma 2" }, 
      { hex: "#94a060", name: "Palma 3" }, 
      { hex: "#b4bc80", name: "Palma 4" }, 
      { hex: "#c4d0a0", name: "Palma 5" }, 
      { hex: "#d8e4bc", name: "Palma 6" }, 
      { hex: "#e0ecd0", name: "Palma 7" }, 
      { hex: "#e8f0d8", name: "Palma 8" }, 
      { hex: "#f4fce8", name: "Palma 9" }, 
      { hex: "#4c5424", name: "Palma 0 Kg" }, 
      { hex: "#f8500c", name: "Paprika 1" }, 
      { hex: "#F2581C", name: "Paprika 2" }, 
      { hex: "#fc7c3c", name: "Paprika 3" }, 
      { hex: "#fc9860", name: "Paprika 4" }, 
      { hex: "#fcb088", name: "Paprika 5" }, 
      { hex: "#fcc4a0", name: "Paprika 6" }, 
      { hex: "#FFD4BC", name: "Paprika 7" }, 
      { hex: "#fcdccc", name: "Paprika 8" }, 
      { hex: "#fce4dc", name: "Paprika 9" }, 
      { hex: "#DE3800", name: "Paprika 0 Kg" }, 
      { hex: "#e46c20", name: "Rodeo 1" }, 
      { hex: "#f8802c", name: "Rodeo 2" }, 
      { hex: "#fc9844", name: "Rodeo 3" }, 
      { hex: "#fcb060", name: "Rodeo 4" }, 
      { hex: "#fcc484", name: "Rodeo 5" }, 
      { hex: "#fcd8a0", name: "Rodeo 6" }, 
      { hex: "#fcecd0", name: "Rodeo 8" }, 
      { hex: "#fcf4dc", name: "Rodeo 9" }, 
      { hex: "#d45c10", name: "Rodeo 0 Kg" }, 
      { hex: "#d83c2c", name: "Rubin 1" }, 
      { hex: "#e44438", name: "Rubin 2" }, 
      { hex: "#f06060", name: "Rubin 3" }, 
      { hex: "#fc7c80", name: "Rubin 4" }, 
      { hex: "#fc989c", name: "Rubin 5" }, 
      { hex: "#f4acb4", name: "Rubin 6" }, 
      { hex: "#f0c0cc", name: "Rubin 7" }, 
      { hex: "#f8d4d8", name: "Rubin 8" }, 
      { hex: "#f8e0e4", name: "Rubin 9" }, 
      { hex: "#c42804", name: "Rubin 0 Kg" }, 
      { hex: "#2c3030", name: "Schiefer 1" }, 
      { hex: "#343838", name: "Schiefer 2" }, 
      { hex: "#585c58", name: "Schiefer 3" }, 
      { hex: "#7c7c74", name: "Schiefer 4" }, 
      { hex: "#949898", name: "Schiefer 5" }, 
      { hex: "#b0b0b0", name: "Schiefer 6" }, 
      { hex: "#c8c8c8", name: "Schiefer 7" }, 
      { hex: "#d4d4d4", name: "Schiefer 8" }, 
      { hex: "#e4e4e4", name: "Schiefer 9" }, 
      { hex: "#1c1c1c", name: "Schiefer 0 Kg" }, 
      { hex: "#ccd060", name: "Schilf 1" }, 
      { hex: "#d8dc68", name: "Schilf 2" }, 
      { hex: "#e8f894", name: "Schilf 4" }, 
      { hex: "#f0fca8", name: "Schilf 5" }, 
      { hex: "#f4fcc0", name: "Schilf 6" }, 
      { hex: "#f4fcd0", name: "Schilf 7" }, 
      { hex: "#f4fcdc", name: "Schilf 8" }, 
      { hex: "#f4fce4", name: "Schilf 9" }, 
      { hex: "#c0c044", name: "Schilf 0 Kg" }, 
      { hex: "#6c5c34", name: "Sepia 1" }, 
      { hex: "#7c6840", name: "Sepia 2" }, 
      { hex: "#a08c64", name: "Sepia 3" }, 
      { hex: "#bcac80", name: "Sepia 4" }, 
      { hex: "#d0c4a0", name: "Sepia 5" }, 
      { hex: "#e0d4b8", name: "Sepia 6" }, 
      { hex: "#e8e4d4", name: "Sepia 7" }, 
      { hex: "#ece8dc", name: "Sepia 8" }, 
      { hex: "#f4f4e8", name: "Sepia 9" }, 
      { hex: "#503c20", name: "Sepia 0 Kg" }, 
      { hex: "#00a008", name: "Smaragd 1" }, 
      { hex: "#00b424", name: "Smaragd 2" }, 
      { hex: "#08d444", name: "Smaragd 3" }, 
      { hex: "#3ce470", name: "Smaragd 4" }, 
      { hex: "#68ec90", name: "Smaragd 5" }, 
      { hex: "#8AF4B4", name: "Smaragd 6" }, 
      { hex: "#b8f4cc", name: "Smaragd 7" }, 
      { hex: "#ccf8d8", name: "Smaragd 8" }, 
      { hex: "#d0f4e0", name: "Smaragd 9" }, 
      { hex: "#0A7000", name: "Smaragd 0 Kg" }, 
      { hex: "#807440", name: "Taiga 1" }, 
      { hex: "#8c804c", name: "Taiga 2" }, 
      { hex: "#a49864", name: "Taiga 3" }, 
      { hex: "#c4b884", name: "Taiga 4" }, 
      { hex: "#d4cca4", name: "Taiga 5" }, 
      { hex: "#e0dcc0", name: "Taiga 6" }, 
      { hex: "#f0ecd0", name: "Taiga 7" }, 
      { hex: "#f0f0e0", name: "Taiga 8" }, 
      { hex: "#f0f0e4", name: "Taiga 9" }, 
      { hex: "#5c501c", name: "Taiga 0 Kg" }, 
      { hex: "#bc6c28", name: "Terra 1" }, 
      { hex: "#cc8038", name: "Terra 2" }, 
      { hex: "#dc9850", name: "Terra 3" }, 
      { hex: "#ecb074", name: "Terra 4" }, 
      { hex: "#f4c894", name: "Terra 5" }, 
      { hex: "#fcd8ac", name: "Terra 6" }, 
      { hex: "#fce4c4", name: "Terra 7" }, 
      { hex: "#fcf0d8", name: "Terra 8" }, 
      { hex: "#f8f0e4", name: "Terra 9" }, 
      { hex: "#ac5c1c", name: "Terra 0 Kg" }, 
      { hex: "#a44024", name: "Tommy 1" }, 
      { hex: "#b04830", name: "Tommy 2" }, 
      { hex: "#c86854", name: "Tommy 3" }, 
      { hex: "#f0a494", name: "Tommy 5" }, 
      { hex: "#f0bcb0", name: "Tommy 6" }, 
      { hex: "#f0c8c4", name: "Tommy 7" }, 
      { hex: "#f4dcd8", name: "Tommy 8" }, 
      { hex: "#f4e4e0", name: "Tommy 9" }, 
      { hex: "#9c3008", name: "Tommy 0 Kg" }, 
      { hex: "#00642c", name: "Turmalin 1" }, 
      { hex: "#00743c", name: "Turmalin 2" }, 
      { hex: "#089058", name: "Turmalin 3" }, 
      { hex: "#28ac74", name: "Turmalin 4" }, 
      { hex: "#50c094", name: "Turmalin 5" }, 
      { hex: "#7cd4b4", name: "Turmalin 6" }, 
      { hex: "#a0dcc8", name: "Turmalin 7" }, 
      { hex: "#bce8d8", name: "Turmalin 8" }, 
      { hex: "#ccece0", name: "Turmalin 9" }, 
      { hex: "#004c0c", name: "Turmalin 0 Kg" }, 
      { hex: "#008800", name: "Viktoria 1" }, 
      { hex: "#009c10", name: "Viktoria 2" }, 
      { hex: "#00bc34", name: "Viktoria 3" }, 
      { hex: "#00cc5c", name: "Viktoria 4" }, 
      { hex: "#2cdc84", name: "Viktoria 5" }, 
      { hex: "#58e4a0", name: "Viktoria 6" }, 
      { hex: "#8cf0bc", name: "Viktoria 7" }, 
      { hex: "#b4ecd0", name: "Viktoria 8" }, 
      { hex: "#ccf4e0", name: "Viktoria 9" }, 
      { hex: "#006000", name: "Viktoria 0 Kg" }, 
      { hex: "#DFE1D4", name: "lava18" }
    ],
      "Caparol 3D": [      { hex: "#AE958A", name: "Aprico 5" }, 
      { hex: "#2A638A", name: "Blu 30" }, 
      { hex: "#3A507E", name: "Diva 10" }, 
      { hex: "#453B73", name: "Diva 15" }, 
      { hex: "#524E5F", name: "Diva 20" }, 
      { hex: "#663971", name: "Diva 25" }, 
      { hex: "#823066", name: "Diva 30" }, 
      { hex: "#E4E4DF", name: "Grau 60" }, 
      { hex: "#8D8F89", name: "Agave 10" }, 
      { hex: "#7FA372", name: "Agave 100" }, 
      { hex: "#9FD9A6", name: "Agave 105" }, 
      { hex: "#CAE4BD", name: "Agave 110" }, 
      { hex: "#DCEBD2", name: "Agave 115" }, 
      { hex: "#E3EDDD", name: "Agave 120" }, 
      { hex: "#53A349", name: "Agave 125" }, 
      { hex: "#75B169", name: "Agave 130" }, 
      { hex: "#79BB67", name: "Agave 135" }, 
      { hex: "#95C584", name: "Agave 140" }, 
      { hex: "#A8A9A2", name: "Agave 15" }, 
      { hex: "#CCC5BE", name: "Agave 20" }, 
      { hex: "#D3D4CC", name: "Agave 25" }, 
      { hex: "#E9EAE0", name: "Agave 30" }, 
      { hex: "#848C7C", name: "Agave 35" }, 
      { hex: "#B2B0A3", name: "Agave 40" }, 
      { hex: "#C1C6BB", name: "Agave 45" }, 
      { hex: "#70716C", name: "Agave 5" }, 
      { hex: "#DADED3", name: "Agave 50" }, 
      { hex: "#E3E8DE", name: "Agave 55" }, 
      { hex: "#F0F0E7", name: "Agave 60" }, 
      { hex: "#8C9D80", name: "Agave 65" }, 
      { hex: "#A1BB93", name: "Agave 70" }, 
      { hex: "#ACBBA4", name: "Agave 75" }, 
      { hex: "#C3D8BE", name: "Agave 80" }, 
      { hex: "#CDD6C6", name: "Agave 85" }, 
      { hex: "#DBE2D9", name: "Agave 90" }, 
      { hex: "#568847", name: "Agave 95" }, 
      { hex: "#535355", name: "Amethyst 10" }, 
      { hex: "#56516B", name: "Amethyst 100" }, 
      { hex: "#746C8C", name: "Amethyst 105" }, 
      { hex: "#8D899D", name: "Amethyst 110" }, 
      { hex: "#C8C2D4", name: "Amethyst 115" }, 
      { hex: "#E2DDE5", name: "Amethyst 120" }, 
      { hex: "#8F8D91", name: "Amethyst 15" }, 
      { hex: "#BDBBBE", name: "Amethyst 20" }, 
      { hex: "#DBDAD8", name: "Amethyst 25" }, 
      { hex: "#D9E2DE", name: "Amethyst 30" }, 
      { hex: "#58565F", name: "Amethyst 35" }, 
      { hex: "#8D8C95", name: "Amethyst 40" }, 
      { hex: "#AAA7B1", name: "Amethyst 45" }, 
      { hex: "#3B3B3D", name: "Amethyst 5" }, 
      { hex: "#B6B4BC", name: "Amethyst 50" }, 
      { hex: "#D4D1D7", name: "Amethyst 55" }, 
      { hex: "#E6E2E2", name: "Amethyst 60" }, 
      { hex: "#3B384A", name: "Amethyst 65" }, 
      { hex: "#565264", name: "Amethyst 70" }, 
      { hex: "#646077", name: "Amethyst 75" }, 
      { hex: "#ABA7B6", name: "Amethyst 80" }, 
      { hex: "#C8C4CE", name: "Amethyst 85" }, 
      { hex: "#E4E2E5", name: "Amethyst 90" }, 
      { hex: "#3C355A", name: "Amethyst 95" }, 
      { hex: "#BBA499", name: "Aprico 10" }, 
      { hex: "#CE8766", name: "Aprico 100" }, 
      { hex: "#C08A71", name: "Aprico 105" }, 
      { hex: "#DF9774", name: "Aprico 110" }, 
      { hex: "#EDA482", name: "Aprico 115" }, 
      { hex: "#E4A588", name: "Aprico 120" }, 
      { hex: "#C26133", name: "Aprico 125" }, 
      { hex: "#DB794D", name: "Aprico 130" }, 
      { hex: "#C57653", name: "Aprico 135" }, 
      { hex: "#EF763F", name: "Aprico 140" }, 
      { hex: "#FC8045", name: "Aprico 145" }, 
      { hex: "#D1C2BA", name: "Aprico 15" }, 
      { hex: "#FFAE8A", name: "Aprico 150" }, 
      { hex: "#FDD8C6", name: "Aprico 175" }, 
      { hex: "#F7E2D5", name: "Aprico 180" }, 
      { hex: "#DAD0C9", name: "Aprico 20" }, 
      { hex: "#E7E1DA", name: "Aprico 25" }, 
      { hex: "#E7E4DD", name: "Aprico 30" }, 
      { hex: "#8E6C5D", name: "Aprico 35" }, 
      { hex: "#A38375", name: "Aprico 40" }, 
      { hex: "#D4AD9E", name: "Aprico 45" }, 
      { hex: "#DDC0B2", name: "Aprico 50" }, 
      { hex: "#EDCFC0", name: "Aprico 55" }, 
      { hex: "#F8DFD1", name: "Aprico 60" }, 
      { hex: "#AD826F", name: "Aprico 65" }, 
      { hex: "#B8917F", name: "Aprico 70" }, 
      { hex: "#E2AA90", name: "Aprico 75" }, 
      { hex: "#F0B8A5", name: "Aprico 80" }, 
      { hex: "#E3BAA9", name: "Aprico 85" }, 
      { hex: "#F3CBBA", name: "Aprico 90" }, 
      { hex: "#9D6950", name: "Aprico 95" }, 
      { hex: "#B5B8BD", name: "Aquarell 10" }, 
      { hex: "#6599CF", name: "Aquarell 100" }, 
      { hex: "#95B7DE", name: "Aquarell 105" }, 
      { hex: "#AEC5E0", name: "Aquarell 110" }, 
      { hex: "#DFE5E9", name: "Aquarell 115" }, 
      { hex: "#E8EBEC", name: "Aquarell 120" }, 
      { hex: "#C8C9CD", name: "Aquarell 15" }, 
      { hex: "#D4D5D5", name: "Aquarell 20" }, 
      { hex: "#E6E5E2", name: "Aquarell 25" }, 
      { hex: "#EBE9E4", name: "Aquarell 30" }, 
      { hex: "#9EA8B8", name: "Aquarell 35" }, 
      { hex: "#A8AFB8", name: "Aquarell 40" }, 
      { hex: "#C3C8CF", name: "Aquarell 45" }, 
      { hex: "#949AA4", name: "Aquarell 5" }, 
      { hex: "#D3D5D9", name: "Aquarell 50" }, 
      { hex: "#E1E4E5", name: "Aquarell 55" }, 
      { hex: "#E7E9E7", name: "Aquarell 60" }, 
      { hex: "#70738A", name: "Aquarell 65" }, 
      { hex: "#7F8DA4", name: "Aquarell 70" }, 
      { hex: "#9BAABE", name: "Aquarell 75" }, 
      { hex: "#C3C5D6", name: "Aquarell 80" }, 
      { hex: "#C9D3E2", name: "Aquarell 85" }, 
      { hex: "#E0E7EA", name: "Aquarell 90" }, 
      { hex: "#497EB4", name: "Aquarell 95" }, 
      { hex: "#757E81", name: "Arctis 10" }, 
      { hex: "#5A838D", name: "Arctis 100" }, 
      { hex: "#77A1A9", name: "Arctis 105" }, 
      { hex: "#72BECC", name: "Arctis 110" }, 
      { hex: "#A3CDD4", name: "Arctis 115" }, 
      { hex: "#B8DEE6", name: "Arctis 120" }, 
      { hex: "#939C9D", name: "Arctis 15" }, 
      { hex: "#AFB8B8", name: "Arctis 20" }, 
      { hex: "#CDD4D2", name: "Arctis 25" }, 
      { hex: "#DFE1DD", name: "Arctis 30" }, 
      { hex: "#57757C", name: "Arctis 35" }, 
      { hex: "#627277", name: "Arctis 40" }, 
      { hex: "#7C8C90", name: "Arctis 45" }, 
      { hex: "#596265", name: "Arctis 5" }, 
      { hex: "#9DAAAB", name: "Arctis 50" }, 
      { hex: "#BDC6C6", name: "Arctis 55" }, 
      { hex: "#DDE3DF", name: "Arctis 60" }, 
      { hex: "#669097", name: "Arctis 65" }, 
      { hex: "#91ACB1", name: "Arctis 70" }, 
      { hex: "#98BCC2", name: "Arctis 75" }, 
      { hex: "#B4C8CA", name: "Arctis 80" }, 
      { hex: "#B8D7DA", name: "Arctis 85" }, 
      { hex: "#C4D6D6", name: "Arctis 90" }, 
      { hex: "#306B77", name: "Arctis 95" }, 
      { hex: "#B1B7BC", name: "Astra 10" }, 
      { hex: "#BFC7CE", name: "Astra 15" }, 
      { hex: "#D4D7DA", name: "Astra 20" }, 
      { hex: "#D8DCDF", name: "Astra 25" }, 
      { hex: "#E2E3E3", name: "Astra 30" }, 
      { hex: "#9BA9B7", name: "Astra 35" }, 
      { hex: "#ADB7C2", name: "Astra 40" }, 
      { hex: "#CFD6DD", name: "Astra 45" }, 
      { hex: "#929AA3", name: "Astra 5" }, 
      { hex: "#D4E0E8", name: "Astra 50" }, 
      { hex: "#E4E8E9", name: "Astra 55" }, 
      { hex: "#E1E7EA", name: "Astra 60" }, 
      { hex: "#5C7087", name: "Astra 65" }, 
      { hex: "#7B8EA4", name: "Astra 70" }, 
      { hex: "#98A9BD", name: "Astra 75" }, 
      { hex: "#B9C9D9", name: "Astra 80" }, 
      { hex: "#BAB6BF", name: "Atmo 10" }, 
      { hex: "#C9C6CC", name: "Atmo 15" }, 
      { hex: "#E6E1E2", name: "Atmo 20" }, 
      { hex: "#EAE7E5", name: "Atmo 25" }, 
      { hex: "#ABA8B1", name: "Atmo 5" }, 
      { hex: "#82434C", name: "Baccara 10" }, 
      { hex: "#C1606F", name: "Baccara 15" }, 
      { hex: "#DF7D8B", name: "Baccara 20" }, 
      { hex: "#ECA3AB", name: "Baccara 25" }, 
      { hex: "#F3CFCF", name: "Baccara 30" }, 
      { hex: "#613437", name: "Baccara 5" }, 
      { hex: "#2396A5", name: "Blu 10" }, 
      { hex: "#00364B", name: "Blu 15" }, 
      { hex: "#005C7B", name: "Blu 20" }, 
      { hex: "#1C445C", name: "Blu 25" }, 
      { hex: "#004755", name: "Blu 5" }, 
      { hex: "#B5928A", name: "Bordeaux 10" }, 
      { hex: "#B8A19B", name: "Bordeaux 15" }, 
      { hex: "#C3B1AC", name: "Bordeaux 20" }, 
      { hex: "#DBD1CD", name: "Bordeaux 25" }, 
      { hex: "#E9E1DB", name: "Bordeaux 30" }, 
      { hex: "#7A463E", name: "Bordeaux 35" }, 
      { hex: "#986157", name: "Bordeaux 40" }, 
      { hex: "#AE6A5F", name: "Bordeaux 45" }, 
      { hex: "#A3847D", name: "Bordeaux 5" }, 
      { hex: "#B57C72", name: "Bordeaux 50" }, 
      { hex: "#CD9D96", name: "Bordeaux 55" }, 
      { hex: "#DABEB7", name: "Bordeaux 60" }, 
      { hex: "#A1322A", name: "Bordeaux 65" }, 
      { hex: "#A85248", name: "Bordeaux 70" }, 
      { hex: "#A8564C", name: "Bordeaux 75" }, 
      { hex: "#CD7061", name: "Bordeaux 80" }, 
      { hex: "#FA998D", name: "Bordeaux 85" }, 
      { hex: "#FED8D0", name: "Bordeaux 90" }, 
      { hex: "#F77800", name: "Brasil 10" }, 
      { hex: "#5F3D25", name: "Brasil 15" }, 
      { hex: "#BE742D", name: "Brasil 20" }, 
      { hex: "#4E4230", name: "Brasil 25" }, 
      { hex: "#FFB200", name: "Brasil 30" }, 
      { hex: "#51302B", name: "Brasil 5" }, 
      { hex: "#A6A5A2", name: "Cameo 10" }, 
      { hex: "#A97364", name: "Cameo 100" }, 
      { hex: "#DB9687", name: "Cameo 105" }, 
      { hex: "#DAA99C", name: "Cameo 110" }, 
      { hex: "#EAC3B9", name: "Cameo 115" }, 
      { hex: "#F9DBD0", name: "Cameo 120" }, 
      { hex: "#9B4732", name: "Cameo 125" }, 
      { hex: "#9E5E4F", name: "Cameo 130" }, 
      { hex: "#C17764", name: "Cameo 135" }, 
      { hex: "#F1A18F", name: "Cameo 140" }, 
      { hex: "#F1B4A4", name: "Cameo 145" }, 
      { hex: "#C8C3BF", name: "Cameo 15" }, 
      { hex: "#F6DED5", name: "Cameo 150" }, 
      { hex: "#CC523B", name: "Cameo 155" }, 
      { hex: "#DF4D34", name: "Cameo 160" }, 
      { hex: "#DE5234", name: "Cameo 165" }, 
      { hex: "#E8775D", name: "Cameo 170" }, 
      { hex: "#FE9C88", name: "Cameo 175" }, 
      { hex: "#FFC3B4", name: "Cameo 180" }, 
      { hex: "#D9CDC7", name: "Cameo 20" }, 
      { hex: "#E6E3DD", name: "Cameo 25" }, 
      { hex: "#E8E5DE", name: "Cameo 30" }, 
      { hex: "#7F6B65", name: "Cameo 35" }, 
      { hex: "#A18C85", name: "Cameo 40" }, 
      { hex: "#B89E96", name: "Cameo 45" }, 
      { hex: "#958681", name: "Cameo 5" }, 
      { hex: "#C4AFA7", name: "Cameo 50" }, 
      { hex: "#D7D0CB", name: "Cameo 55" }, 
      { hex: "#F5EBE4", name: "Cameo 60" }, 
      { hex: "#81675E", name: "Cameo 65" }, 
      { hex: "#A48278", name: "Cameo 70" }, 
      { hex: "#C59A8F", name: "Cameo 75" }, 
      { hex: "#D8B9AE", name: "Cameo 80" }, 
      { hex: "#E7CEC7", name: "Cameo 85" }, 
      { hex: "#F6DED6", name: "Cameo 90" }, 
      { hex: "#844939", name: "Cameo 95" }, 
      { hex: "#C1B5A7", name: "Caramel 10" }, 
      { hex: "#E5A85E", name: "Caramel 100" }, 
      { hex: "#FAAC30", name: "Caramel 105" }, 
      { hex: "#F6CA96", name: "Caramel 110" }, 
      { hex: "#FED29C", name: "Caramel 115" }, 
      { hex: "#FEDAB1", name: "Caramel 120" }, 
      { hex: "#CEC4B8", name: "Caramel 15" }, 
      { hex: "#D9D2C9", name: "Caramel 20" }, 
      { hex: "#E5E1D9", name: "Caramel 25" }, 
      { hex: "#E9E6E0", name: "Caramel 30" }, 
      { hex: "#897257", name: "Caramel 35" }, 
      { hex: "#9B8671", name: "Caramel 40" }, 
      { hex: "#B8A48E", name: "Caramel 45" }, 
      { hex: "#B3A493", name: "Caramel 5" }, 
      { hex: "#D3C1AC", name: "Caramel 50" }, 
      { hex: "#E1D0BD", name: "Caramel 55" }, 
      { hex: "#F3E7D7", name: "Caramel 60" }, 
      { hex: "#CDAE8A", name: "Caramel 65" }, 
      { hex: "#DAC5AB", name: "Caramel 70" }, 
      { hex: "#DFD1B7", name: "Caramel 75" }, 
      { hex: "#F7DDC2", name: "Caramel 80" }, 
      { hex: "#FCE0CA", name: "Caramel 85" }, 
      { hex: "#F6ECDF", name: "Caramel 90" }, 
      { hex: "#CD9C62", name: "Caramel 95" }, 
      { hex: "#A28673", name: "Ceramic 10" }, 
      { hex: "#FCA05E", name: "Ceramic 100" }, 
      { hex: "#FFC29B", name: "Ceramic 105" }, 
      { hex: "#BCA18E", name: "Ceramic 15" }, 
      { hex: "#B9A598", name: "Ceramic 20" }, 
      { hex: "#C5B4A8", name: "Ceramic 25" }, 
      { hex: "#D0C1B8", name: "Ceramic 30" }, 
      { hex: "#C39F89", name: "Ceramic 35" }, 
      { hex: "#CFAE9A", name: "Ceramic 40" }, 
      { hex: "#DDB7A0", name: "Ceramic 45" }, 
      { hex: "#8C6E5B", name: "Ceramic 5" }, 
      { hex: "#DFBBA4", name: "Ceramic 50" }, 
      { hex: "#DCC1B0", name: "Ceramic 55" }, 
      { hex: "#F3DBCA", name: "Ceramic 60" }, 
      { hex: "#C29272", name: "Ceramic 65" }, 
      { hex: "#DCA989", name: "Ceramic 70" }, 
      { hex: "#F1C7AD", name: "Ceramic 75" }, 
      { hex: "#FFD6BD", name: "Ceramic 80" }, 
      { hex: "#F8DECC", name: "Ceramic 85" }, 
      { hex: "#F4E8DE", name: "Ceramic 90" }, 
      { hex: "#FA7E0A", name: "Ceramic 95" }, 
      { hex: "#867881", name: "Clematis 10" }, 
      { hex: "#98979C", name: "Clematis 15" }, 
      { hex: "#BBB4B5", name: "Clematis 20" }, 
      { hex: "#D8D2D1", name: "Clematis 25" }, 
      { hex: "#E2DFDB", name: "Clematis 30" }, 
      { hex: "#634F62", name: "Clematis 35" }, 
      { hex: "#7F6777", name: "Clematis 40" }, 
      { hex: "#9B848F", name: "Clematis 45" }, 
      { hex: "#6E5D68", name: "Clematis 5" }, 
      { hex: "#B7A4AC", name: "Clematis 50" }, 
      { hex: "#D1C1C5", name: "Clematis 55" }, 
      { hex: "#EFE2E0", name: "Clematis 60" }, 
      { hex: "#5E3453", name: "Clematis 65" }, 
      { hex: "#78436D", name: "Clematis 70" }, 
      { hex: "#73586F", name: "Clematis 75" }, 
      { hex: "#8E667D", name: "Clematis 80" }, 
      { hex: "#B092A3", name: "Clematis 85" }, 
      { hex: "#E9CFD7", name: "Clematis 90" }, 
      { hex: "#BBC0C1", name: "Coelin 10" }, 
      { hex: "#158CA5", name: "Coelin 100" }, 
      { hex: "#55A8BF", name: "Coelin 105" }, 
      { hex: "#79C5DB", name: "Coelin 110" }, 
      { hex: "#8BCFE3", name: "Coelin 115" }, 
      { hex: "#C9CDCC", name: "Coelin 15" }, 
      { hex: "#DCDDDA", name: "Coelin 20" }, 
      { hex: "#E7EBE7", name: "Coelin 25" }, 
      { hex: "#9BACB1", name: "Coelin 35" }, 
      { hex: "#ADBABE", name: "Coelin 40" }, 
      { hex: "#BFCBCE", name: "Coelin 45" }, 
      { hex: "#ABB2B4", name: "Coelin 5" }, 
      { hex: "#CDD6D8", name: "Coelin 50" }, 
      { hex: "#DCE4E3", name: "Coelin 55" }, 
      { hex: "#77A4B2", name: "Coelin 65" }, 
      { hex: "#82B0BF", name: "Coelin 70" }, 
      { hex: "#95BFCC", name: "Coelin 75" }, 
      { hex: "#A6CDD8", name: "Coelin 80" }, 
      { hex: "#B4D7E1", name: "Coelin 85" }, 
      { hex: "#D0E7EA", name: "Coelin 90" }, 
      { hex: "#0A6E8B", name: "Coelin 95" }, 
      { hex: "#C0BFA6", name: "Curry 10" }, 
      { hex: "#C1A45A", name: "Curry 100" }, 
      { hex: "#E3C072", name: "Curry 105" }, 
      { hex: "#EED08D", name: "Curry 110" }, 
      { hex: "#F7D98E", name: "Curry 115" }, 
      { hex: "#F8DFA7", name: "Curry 120" }, 
      { hex: "#D4AB18", name: "Curry 125" }, 
      { hex: "#E6BA1C", name: "Curry 130" }, 
      { hex: "#EDC861", name: "Curry 135" }, 
      { hex: "#FBD35A", name: "Curry 140" }, 
      { hex: "#FBDA84", name: "Curry 145" }, 
      { hex: "#DBD3C1", name: "Curry 15" }, 
      { hex: "#E3DBCB", name: "Curry 20" }, 
      { hex: "#F1EAD9", name: "Curry 25" }, 
      { hex: "#F5EDDA", name: "Curry 30" }, 
      { hex: "#A18A59", name: "Curry 35" }, 
      { hex: "#C8A978", name: "Curry 40" }, 
      { hex: "#E1C296", name: "Curry 45" }, 
      { hex: "#B7A98E", name: "Curry 5" }, 
      { hex: "#E7D7B5", name: "Curry 50" }, 
      { hex: "#F6E8CD", name: "Curry 55" }, 
      { hex: "#BBA36A", name: "Curry 65" }, 
      { hex: "#D2B879", name: "Curry 70" }, 
      { hex: "#DFC794", name: "Curry 75" }, 
      { hex: "#ECD6A9", name: "Curry 80" }, 
      { hex: "#FAE6BE", name: "Curry 85" }, 
      { hex: "#FAE9C2", name: "Curry 90" }, 
      { hex: "#B0902C", name: "Curry 95" }, 
      { hex: "#08386C", name: "Diva 5" }, 
      { hex: "#C3B4A7", name: "Falb 10" }, 
      { hex: "#CDC2B8", name: "Falb 15" }, 
      { hex: "#D7CFC5", name: "Falb 20" }, 
      { hex: "#DCE2DA", name: "Falb 25" }, 
      { hex: "#E9E6DF", name: "Falb 30" }, 
      { hex: "#8A6F58", name: "Falb 35" }, 
      { hex: "#978974", name: "Falb 40" }, 
      { hex: "#BFA38D", name: "Falb 45" }, 
      { hex: "#B7A596", name: "Falb 5" }, 
      { hex: "#BBA491", name: "Falb 50" }, 
      { hex: "#D5BFAD", name: "Falb 55" }, 
      { hex: "#F1DDCA", name: "Falb 60" }, 
      { hex: "#A68569", name: "Falb 65" }, 
      { hex: "#D3B298", name: "Falb 70" }, 
      { hex: "#E0BEA3", name: "Falb 75" }, 
      { hex: "#F2CDAE", name: "Falb 80" }, 
      { hex: "#B0A6A8", name: "Flamenco 10" }, 
      { hex: "#845765", name: "Flamenco 100" }, 
      { hex: "#A8818D", name: "Flamenco 105" }, 
      { hex: "#C29FA7", name: "Flamenco 110" }, 
      { hex: "#DDBEC3", name: "Flamenco 115" }, 
      { hex: "#F4DEDF", name: "Flamenco 120" }, 
      { hex: "#823D55", name: "Flamenco 125" }, 
      { hex: "#955067", name: "Flamenco 130" }, 
      { hex: "#AD6A7D", name: "Flamenco 135" }, 
      { hex: "#C5889B", name: "Flamenco 140" }, 
      { hex: "#E4A7BA", name: "Flamenco 145" }, 
      { hex: "#CBC2C2", name: "Flamenco 15" }, 
      { hex: "#F1CCD5", name: "Flamenco 150" }, 
      { hex: "#DAD2D0", name: "Flamenco 20" }, 
      { hex: "#DFDBD9", name: "Flamenco 25" }, 
      { hex: "#E0E6E0", name: "Flamenco 30" }, 
      { hex: "#7E6B70", name: "Flamenco 35" }, 
      { hex: "#95878C", name: "Flamenco 40" }, 
      { hex: "#B4969A", name: "Flamenco 45" }, 
      { hex: "#797273", name: "Flamenco 5" }, 
      { hex: "#B5A8AB", name: "Flamenco 50" }, 
      { hex: "#D0C4C6", name: "Flamenco 55" }, 
      { hex: "#E9E2DD", name: "Flamenco 60" }, 
      { hex: "#695259", name: "Flamenco 65" }, 
      { hex: "#85676F", name: "Flamenco 70" }, 
      { hex: "#9F848B", name: "Flamenco 75" }, 
      { hex: "#BBA3A7", name: "Flamenco 80" }, 
      { hex: "#687668", name: "Mint 35" }, 
      { hex: "#D4C0C2", name: "Flamenco 85" }, 
      { hex: "#F0E5E0", name: "Flamenco 90" }, 
      { hex: "#744F5A", name: "Flamenco 95" }, 
      { hex: "#BCB0A0", name: "Ginster 10" }, 
      { hex: "#E3BD78", name: "Ginster 100" }, 
      { hex: "#F5CB86", name: "Ginster 105" }, 
      { hex: "#EFCC8C", name: "Ginster 110" }, 
      { hex: "#F2D7A8", name: "Ginster 115" }, 
      { hex: "#F8E1BA", name: "Ginster 120" }, 
      { hex: "#E9A900", name: "Ginster 125" }, 
      { hex: "#F1B300", name: "Ginster 130" }, 
      { hex: "#FDC641", name: "Ginster 135" }, 
      { hex: "#F7C765", name: "Ginster 140" }, 
      { hex: "#FFCE58", name: "Ginster 145" }, 
      { hex: "#C9C0B2", name: "Ginster 15" }, 
      { hex: "#FCD791", name: "Ginster 150" }, 
      { hex: "#DAD4C9", name: "Ginster 20" }, 
      { hex: "#E9E4DA", name: "Ginster 25" }, 
      { hex: "#E2E8E0", name: "Ginster 30" }, 
      { hex: "#867356", name: "Ginster 35" }, 
      { hex: "#95866D", name: "Ginster 40" }, 
      { hex: "#B2A38A", name: "Ginster 45" }, 
      { hex: "#AEA28E", name: "Ginster 5" }, 
      { hex: "#D0C1A9", name: "Ginster 50" }, 
      { hex: "#E1D3BB", name: "Ginster 55" }, 
      { hex: "#FBE2CA", name: "Ginster 60" }, 
      { hex: "#A2885B", name: "Ginster 65" }, 
      { hex: "#B6A479", name: "Ginster 70" }, 
      { hex: "#D6B795", name: "Ginster 75" }, 
      { hex: "#DDC6A0", name: "Ginster 80" }, 
      { hex: "#EED9B5", name: "Ginster 85" }, 
      { hex: "#F8E9CC", name: "Ginster 90" }, 
      { hex: "#D7B885", name: "Ginster 95" }, 
      { hex: "#8B8988", name: "Grau 10" }, 
      { hex: "#A9A7A5", name: "Grau 15" }, 
      { hex: "#C4C4C1", name: "Grau 20" }, 
      { hex: "#DAD9D5", name: "Grau 25" }, 
      { hex: "#E9E5DF", name: "Grau 30" }, 
      { hex: "#646262", name: "Grau 35" }, 
      { hex: "#7B7A7A", name: "Grau 40" }, 
      { hex: "#9B9998", name: "Grau 45" }, 
      { hex: "#6E6E6D", name: "Grau 5" }, 
      { hex: "#B6B5B2", name: "Grau 50" }, 
      { hex: "#D2D1CE", name: "Grau 55" }, 
      { hex: "#EBE9E0", name: "Grau-Weiss" }, 
      { hex: "#F3F2E9", name: "Hell-Weiss" }, 
      { hex: "#9A9C83", name: "Herba 10" }, 
      { hex: "#AAAC95", name: "Herba 15" }, 
      { hex: "#C2C4AC", name: "Herba 20" }, 
      { hex: "#DBDDCC", name: "Herba 25" }, 
      { hex: "#F0F1E3", name: "Herba 30" }, 
      { hex: "#98B63F", name: "Herba 40" }, 
      { hex: "#B7C656", name: "Herba 45" }, 
      { hex: "#8B9075", name: "Herba 5" }, 
      { hex: "#D7E195", name: "Herba 50" }, 
      { hex: "#DDE6A6", name: "Herba 55" }, 
      { hex: "#F0F1DB", name: "Herba 60" }, 
      { hex: "#B8B6AF", name: "Jade 10" }, 
      { hex: "#9B9C76", name: "Jade 100" }, 
      { hex: "#B6B886", name: "Jade 105" }, 
      { hex: "#D6D5A4", name: "Jade 110" }, 
      { hex: "#DADCA5", name: "Jade 115" }, 
      { hex: "#E2E39F", name: "Jade 120" }, 
      { hex: "#CFCDC6", name: "Jade 15" }, 
      { hex: "#D3D2CB", name: "Jade 20" }, 
      { hex: "#DEDCD5", name: "Jade 25" }, 
      { hex: "#EAE9E1", name: "Jade 30" }, 
      { hex: "#8A8B84", name: "Jade 35" }, 
      { hex: "#AAAA9E", name: "Jade 40" }, 
      { hex: "#B9B8AA", name: "Jade 45" }, 
      { hex: "#A8A9A2", name: "Jade 5" }, 
      { hex: "#C6C5BB", name: "Jade 50" }, 
      { hex: "#D5D3CA", name: "Jade 55" }, 
      { hex: "#F4E9DC", name: "Jade 60" }, 
      { hex: "#7C7B5C", name: "Jade 65" }, 
      { hex: "#9D9C86", name: "Jade 70" }, 
      { hex: "#B8B79F", name: "Jade 75" }, 
      { hex: "#C3CDAB", name: "Jade 80" }, 
      { hex: "#DEDDC2", name: "Jade 85" }, 
      { hex: "#EBE9D3", name: "Jade 90" }, 
      { hex: "#AFA3A1", name: "Korall 10" }, 
      { hex: "#694541", name: "Korall 100" }, 
      { hex: "#784C47", name: "Korall 105" }, 
      { hex: "#6C514F", name: "Korall 110" }, 
      { hex: "#875751", name: "Korall 115" }, 
      { hex: "#78615E", name: "Korall 120" }, 
      { hex: "#78312D", name: "Korall 125" }, 
      { hex: "#693C39", name: "Korall 130" }, 
      { hex: "#97504A", name: "Korall 135" }, 
      { hex: "#B9655D", name: "Korall 140" }, 
      { hex: "#C2756E", name: "Korall 145" }, 
      { hex: "#D6CAC6", name: "Korall 15" }, 
      { hex: "#DA938D", name: "Korall 150" }, 
      { hex: "#A74A45", name: "Korall 155" }, 
      { hex: "#AE504D", name: "Korall 160" }, 
      { hex: "#C55F59", name: "Korall 165" }, 
      { hex: "#E16964", name: "Korall 170" }, 
      { hex: "#F08B84", name: "Korall 175" }, 
      { hex: "#E8A098", name: "Korall 180" }, 
      { hex: "#E2D5D1", name: "Korall 20" }, 
      { hex: "#DED9D3", name: "Korall 25" }, 
      { hex: "#E4DED8", name: "Korall 30" }, 
      { hex: "#B19F9C", name: "Korall 35" }, 
      { hex: "#BBA39F", name: "Korall 40" }, 
      { hex: "#C9B9B5", name: "Korall 45" }, 
      { hex: "#988885", name: "Korall 5" }, 
      { hex: "#D0BCB7", name: "Korall 50" }, 
      { hex: "#F5D3CB", name: "Korall 55" }, 
      { hex: "#F3DCD4", name: "Korall 60" }, 
      { hex: "#99706C", name: "Korall 65" }, 
      { hex: "#9D706B", name: "Korall 70" }, 
      { hex: "#CA8983", name: "Korall 75" }, 
      { hex: "#B58C87", name: "Korall 80" }, 
      { hex: "#D2ACA6", name: "Korall 85" }, 
      { hex: "#DFBBB5", name: "Korall 90" }, 
      { hex: "#4D3533", name: "Korall 95" }, 
      { hex: "#C8BDB3", name: "Kreide 10" }, 
      { hex: "#D4CBC3", name: "Kreide 15" }, 
      { hex: "#E0D9D2", name: "Kreide 20" }, 
      { hex: "#E5E1D9", name: "Kreide 25" }, 
      { hex: "#E9E5DF", name: "Kreide 30" }, 
      { hex: "#ACA6A1", name: "Kreide 5" }, 
      { hex: "#E4E4DE", name: "Kuehl-Weiss" }, 
      { hex: "#B75939", name: "Lachs 100" }, 
      { hex: "#C96C49", name: "Lachs 105" }, 
      { hex: "#DA5A2F", name: "Lachs 110" }, 
      { hex: "#F07C59", name: "Lachs 115" }, 
      { hex: "#FC9D80", name: "Lachs 120" }, 
      { hex: "#DEBCAE", name: "Lachs 15" }, 
      { hex: "#ECCEC1", name: "Lachs 20" }, 
      { hex: "#F8E0D4", name: "Lachs 25" }, 
      { hex: "#F8E4DA", name: "Lachs 30" }, 
      { hex: "#B27966", name: "Lachs 35" }, 
      { hex: "#BC8D7E", name: "Lachs 40" }, 
      { hex: "#C89F90", name: "Lachs 45" }, 
      { hex: "#D99F8C", name: "Lachs 50" }, 
      { hex: "#E8BAAB", name: "Lachs 55" }, 
      { hex: "#A65E44", name: "Lachs 65" }, 
      { hex: "#CB7757", name: "Lachs 70" }, 
      { hex: "#D68766", name: "Lachs 75" }, 
      { hex: "#E39279", name: "Lachs 80" }, 
      { hex: "#FFBFA9", name: "Lachs 85" }, 
      { hex: "#B84B23", name: "Lachs 95" }, 
      { hex: "#78396B", name: "Laser 10" }, 
      { hex: "#A32E57", name: "Laser 15" }, 
      { hex: "#B7283E", name: "Laser 20" }, 
      { hex: "#C93236", name: "Laser 25" }, 
      { hex: "#EF5603", name: "Laser 30" }, 
      { hex: "#FD8504", name: "Laser 35" }, 
      { hex: "#FB9D00", name: "Laser 40" }, 
      { hex: "#FFB900", name: "Laser 45" }, 
      { hex: "#543D71", name: "Laser 5" }, 
      { hex: "#F9D910", name: "Laser 50" }, 
      { hex: "#C5C100", name: "Laser 55" }, 
      { hex: "#7EAC11", name: "Laser 60" }, 
      { hex: "#2E8B29", name: "Laser 65" }, 
      { hex: "#00805D", name: "Laser 70" }, 
      { hex: "#006774", name: "Laser 75" }, 
      { hex: "#005988", name: "Laser 80" }, 
      { hex: "#004C84", name: "Laser 85" }, 
      { hex: "#2B447B", name: "Laser 90" }, 
      { hex: "#B2AAB4", name: "Lavendel 10" }, 
      { hex: "#6E7C9E", name: "Lavendel 100" }, 
      { hex: "#ABB4CE", name: "Lavendel 105" }, 
      { hex: "#B0B5C5", name: "Lavendel 110" }, 
      { hex: "#CFD3DF", name: "Lavendel 115" }, 
      { hex: "#DCDFE7", name: "Lavendel 120" }, 
      { hex: "#8B99BA", name: "Lavendel 125" }, 
      { hex: "#A0ACC9", name: "Lavendel 130" }, 
      { hex: "#A6B4D4", name: "Lavendel 135" }, 
      { hex: "#BAC5E1", name: "Lavendel 140" }, 
      { hex: "#C6CDE1", name: "Lavendel 145" }, 
      { hex: "#B4B6C0", name: "Lavendel 15" }, 
      { hex: "#C8D0E6", name: "Lavendel 150" }, 
      { hex: "#28385A", name: "Lavendel 155" }, 
      { hex: "#294875", name: "Lavendel 160" }, 
      { hex: "#355383", name: "Lavendel 165" }, 
      { hex: "#3D547D", name: "Lavendel 170" }, 
      { hex: "#5872A4", name: "Lavendel 175" }, 
      { hex: "#7C8FBA", name: "Lavendel 180" }, 
      { hex: "#C4C6CA", name: "Lavendel 20" }, 
      { hex: "#D6D6D8", name: "Lavendel 25" }, 
      { hex: "#E1E1E2", name: "Lavendel 30" }, 
      { hex: "#433C45", name: "Lavendel 35" }, 
      { hex: "#52555F", name: "Lavendel 40" }, 
      { hex: "#6C6F79", name: "Lavendel 45" }, 
      { hex: "#8C8E96", name: "Lavendel 5" }, 
      { hex: "#999DA8", name: "Lavendel 50" }, 
      { hex: "#C7CBD4", name: "Lavendel 55" }, 
      { hex: "#E2E4E8", name: "Lavendel 60" }, 
      { hex: "#3E4861", name: "Lavendel 65" }, 
      { hex: "#5A657E", name: "Lavendel 70" }, 
      { hex: "#717B95", name: "Lavendel 75" }, 
      { hex: "#8F99B3", name: "Lavendel 80" }, 
      { hex: "#9F9CB3", name: "Lavendel 85" }, 
      { hex: "#A1A8BE", name: "Lavendel 90" }, 
      { hex: "#4C5979", name: "Lavendel 95" }, 
      { hex: "#8C939B", name: "Lazur 10" }, 
      { hex: "#4C647A", name: "Lazur 100" }, 
      { hex: "#5B748C", name: "Lazur 105" }, 
      { hex: "#7E91A3", name: "Lazur 110" }, 
      { hex: "#A4B8C9", name: "Lazur 115" }, 
      { hex: "#B6C9D8", name: "Lazur 120" }, 
      { hex: "#1F516F", name: "Lazur 125" }, 
      { hex: "#456783", name: "Lazur 130" }, 
      { hex: "#6C90B0", name: "Lazur 135" }, 
      { hex: "#778FA6", name: "Lazur 140" }, 
      { hex: "#92ACC5", name: "Lazur 145" }, 
      { hex: "#A3A9AF", name: "Lazur 15" }, 
      { hex: "#97ABBE", name: "Lazur 150" }, 
      { hex: "#005378", name: "Lazur 155" }, 
      { hex: "#34678C", name: "Lazur 160" }, 
      { hex: "#48769A", name: "Lazur 165" }, 
      { hex: "#6692B6", name: "Lazur 170" }, 
      { hex: "#82AFD4", name: "Lazur 175" }, 
      { hex: "#005787", name: "Lazur 185" }, 
      { hex: "#005D87", name: "Lazur 190" }, 
      { hex: "#3979A3", name: "Lazur 195" }, 
      { hex: "#B8C5C6", name: "Lazur 20" }, 
      { hex: "#E9EAE2", name: "Mint 30" }, 
      { hex: "#4793C5", name: "Lazur 200" }, 
      { hex: "#5C93BC", name: "Lazur 205" }, 
      { hex: "#DFD6D4", name: "Lazur 25" }, 
      { hex: "#E4E4E0", name: "Lazur 30" }, 
      { hex: "#C7C7CF", name: "Lazur 35" }, 
      { hex: "#CFD7DC", name: "Lazur 40" }, 
      { hex: "#DEE3E4", name: "Lazur 45" }, 
      { hex: "#747E88", name: "Lazur 5" }, 
      { hex: "#E2E4E3", name: "Lazur 50" }, 
      { hex: "#EAEBE8", name: "Lazur 55" }, 
      { hex: "#ECEEEA", name: "Lazur 60" }, 
      { hex: "#3D4E5D", name: "Lazur 65" }, 
      { hex: "#485766", name: "Lazur 70" }, 
      { hex: "#687480", name: "Lazur 75" }, 
      { hex: "#7C8C9D", name: "Lazur 80" }, 
      { hex: "#9DAAB6", name: "Lazur 85" }, 
      { hex: "#BDC9D4", name: "Lazur 90" }, 
      { hex: "#304C61", name: "Lazur 95" }, 
      { hex: "#7F8093", name: "Litho 10" }, 
      { hex: "#9FA0AB", name: "Litho 15" }, 
      { hex: "#B6B8BD", name: "Litho 20" }, 
      { hex: "#DBDADB", name: "Litho 25" }, 
      { hex: "#E6E5E2", name: "Litho 30" }, 
      { hex: "#5D5F78", name: "Litho 5" }, 
      { hex: "#7F7C75", name: "Mai 10" }, 
      { hex: "#A5A298", name: "Mai 15" }, 
      { hex: "#C2BFB3", name: "Mai 20" }, 
      { hex: "#D9D6CA", name: "Mai 25" }, 
      { hex: "#E6ECDF", name: "Mai 30" }, 
      { hex: "#807B62", name: "Mai 35" }, 
      { hex: "#959079", name: "Mai 40" }, 
      { hex: "#B5B098", name: "Mai 45" }, 
      { hex: "#696760", name: "Mai 5" }, 
      { hex: "#C9C4AC", name: "Mai 50" }, 
      { hex: "#E4DDC3", name: "Mai 55" }, 
      { hex: "#F4EED4", name: "Mai 60" }, 
      { hex: "#ABA872", name: "Mai 65" }, 
      { hex: "#B0AD46", name: "Mai 70" }, 
      { hex: "#BEBE38", name: "Mai 75" }, 
      { hex: "#CBC652", name: "Mai 80" }, 
      { hex: "#D9D785", name: "Mai 85" }, 
      { hex: "#E8DD78", name: "Mai 90" }, 
      { hex: "#AEBEC7", name: "Marin 10" }, 
      { hex: "#C0CAD0", name: "Marin 15" }, 
      { hex: "#D3D9DA", name: "Marin 20" }, 
      { hex: "#E7E7E3", name: "Marin 25" }, 
      { hex: "#E9E9E5", name: "Marin 30" }, 
      { hex: "#547285", name: "Marin 35" }, 
      { hex: "#7690A2", name: "Marin 40" }, 
      { hex: "#94ADBE", name: "Marin 45" }, 
      { hex: "#99ACB9", name: "Marin 5" }, 
      { hex: "#A7C9D8", name: "Marin 50" }, 
      { hex: "#C7D9E2", name: "Marin 55" }, 
      { hex: "#DDE8EA", name: "Marin 60" }, 
      { hex: "#0076A1", name: "Marin 65" }, 
      { hex: "#0089B7", name: "Marin 70" }, 
      { hex: "#5FAED6", name: "Marin 75" }, 
      { hex: "#98BED6", name: "Marin 80" }, 
      { hex: "#B0CBDC", name: "Marin 85" }, 
      { hex: "#C7E3E9", name: "Marin 90" }, 
      { hex: "#D8D4C9", name: "Melisse 10" }, 
      { hex: "#CFB423", name: "Melisse 100" }, 
      { hex: "#E9CB3F", name: "Melisse 105" }, 
      { hex: "#F4D645", name: "Melisse 110" }, 
      { hex: "#F8E06C", name: "Melisse 115" }, 
      { hex: "#F7EBBF", name: "Melisse 120" }, 
      { hex: "#E8E4D9", name: "Melisse 15" }, 
      { hex: "#EAE8DE", name: "Melisse 20" }, 
      { hex: "#F0E9D8", name: "Melisse 25" }, 
      { hex: "#EBEED8", name: "Melisse 30" }, 
      { hex: "#B1A585", name: "Melisse 35" }, 
      { hex: "#CBC3A8", name: "Melisse 40" }, 
      { hex: "#DED5BC", name: "Melisse 45" }, 
      { hex: "#C9C5BA", name: "Melisse 5" }, 
      { hex: "#E7DEC5", name: "Melisse 50" }, 
      { hex: "#F1E9D3", name: "Melisse 55" }, 
      { hex: "#F3EFE0", name: "Melisse 60" }, 
      { hex: "#7A6E44", name: "Melisse 65" }, 
      { hex: "#968C6B", name: "Melisse 70" }, 
      { hex: "#B8A56F", name: "Melisse 75" }, 
      { hex: "#DAC993", name: "Melisse 80" }, 
      { hex: "#F8E6B0", name: "Melisse 85" }, 
      { hex: "#F6EDCF", name: "Melisse 90" }, 
      { hex: "#BCA920", name: "Melisse 95" }, 
      { hex: "#9DA59E", name: "Mint 10" }, 
      { hex: "#C0C8C0", name: "Mint 15" }, 
      { hex: "#D0D6CE", name: "Mint 20" }, 
      { hex: "#E0E3DC", name: "Mint 25" }, 
      { hex: "#688770", name: "Mint 40" }, 
      { hex: "#858C85", name: "Mint 5" }, 
      { hex: "#9DAFA5", name: "Mint 50" }, 
      { hex: "#BACABD", name: "Mint 55" }, 
      { hex: "#DCE3D8", name: "Mint 60" }, 
      { hex: "#238155", name: "Mint 65" }, 
      { hex: "#427E5D", name: "Mint 70" }, 
      { hex: "#51986F", name: "Mint 75" }, 
      { hex: "#75B591", name: "Mint 80" }, 
      { hex: "#85B095", name: "Mint 85" }, 
      { hex: "#C9E3CF", name: "Mint 90" }, 
      { hex: "#6B6C64", name: "Moos 10" }, 
      { hex: "#9BAB69", name: "Moos 100" }, 
      { hex: "#A0A97B", name: "Moos 105" }, 
      { hex: "#C0C998", name: "Moos 110" }, 
      { hex: "#DDE3BE", name: "Moos 115" }, 
      { hex: "#E5EACB", name: "Moos 120" }, 
      { hex: "#83847D", name: "Moos 15" }, 
      { hex: "#9F9F9B", name: "Moos 20" }, 
      { hex: "#D0D1CA", name: "Moos 25" }, 
      { hex: "#E3E1DA", name: "Moos 30" }, 
      { hex: "#8F937E", name: "Moos 35" }, 
      { hex: "#A2A495", name: "Moos 40" }, 
      { hex: "#A9B4AD", name: "Moos 45" }, 
      { hex: "#54554E", name: "Moos 5" }, 
      { hex: "#B8B9AD", name: "Moos 50" }, 
      { hex: "#CBCCC3", name: "Moos 55" }, 
      { hex: "#D8DACB", name: "Moos 60" }, 
      { hex: "#959E73", name: "Moos 70" }, 
      { hex: "#AAAD97", name: "Moos 75" }, 
      { hex: "#C2C6AF", name: "Moos 80" }, 
      { hex: "#D0D4BA", name: "Moos 85" }, 
      { hex: "#E7E7D4", name: "Moos 90" }, 
      { hex: "#849740", name: "Moos 95" }, 
      { hex: "#ECE8DD", name: "Natur-Weiss" }, 
      { hex: "#969D8E", name: "Oase 10" }, 
      { hex: "#577345", name: "Oase 100" }, 
      { hex: "#7C8862", name: "Oase 105" }, 
      { hex: "#A3BF89", name: "Oase 110" }, 
      { hex: "#ADBD98", name: "Oase 115" }, 
      { hex: "#E1ECD0", name: "Oase 120" }, 
      { hex: "#4E7536", name: "Oase 125" }, 
      { hex: "#63933F", name: "Oase 130" }, 
      { hex: "#81A161", name: "Oase 135" }, 
      { hex: "#869E8B", name: "Mint 45" }, 
      { hex: "#80B148", name: "Oase 140" }, 
      { hex: "#8FC162", name: "Oase 145" }, 
      { hex: "#99A99B", name: "Oase 15" }, 
      { hex: "#AED08A", name: "Oase 150" }, 
      { hex: "#C0C6BB", name: "Oase 20" }, 
      { hex: "#D2D5CA", name: "Oase 25" }, 
      { hex: "#E2E3D9", name: "Oase 30" }, 
      { hex: "#424A3C", name: "Oase 35" }, 
      { hex: "#535B4A", name: "Oase 40" }, 
      { hex: "#707B5E", name: "Oase 45" }, 
      { hex: "#808877", name: "Oase 5" }, 
      { hex: "#ADB8A1", name: "Oase 50" }, 
      { hex: "#D0D5C9", name: "Oase 55" }, 
      { hex: "#E5E8DE", name: "Oase 60" }, 
      { hex: "#345033", name: "Oase 65" }, 
      { hex: "#536448", name: "Oase 70" }, 
      { hex: "#849B7D", name: "Oase 75" }, 
      { hex: "#C0C8B3", name: "Oase 80" }, 
      { hex: "#C8D8C6", name: "Oase 85" }, 
      { hex: "#E1E4D6", name: "Oase 90" }, 
      { hex: "#365D30", name: "Oase 95" }, 
      { hex: "#F5ECE4", name: "Off White 10" }, 
      { hex: "#F5ECE2", name: "Off White 15" }, 
      { hex: "#F5EEDC", name: "Off White 20" }, 
      { hex: "#F5F0DE", name: "Off White 25" }, 
      { hex: "#F0F1E0", name: "Off White 30" }, 
      { hex: "#EAF1E9", name: "Off White 35" }, 
      { hex: "#E8F0E7", name: "Off White 40" }, 
      { hex: "#E7EDE8", name: "Off White 45" }, 
      { hex: "#F2EBE5", name: "Off White 5" }, 
      { hex: "#E9EBE7", name: "Off White 50" }, 
      { hex: "#EDEDE9", name: "Off White 55" }, 
      { hex: "#EDE8E7", name: "Off White 60" }, 
      { hex: "#E39600", name: "Oliv 10" }, 
      { hex: "#5C5535", name: "Oliv 15" }, 
      { hex: "#D3A900", name: "Oliv 20" }, 
      { hex: "#948011", name: "Oliv 25" }, 
      { hex: "#CFC30C", name: "Oliv 30" }, 
      { hex: "#242525", name: "Oliv 5" }, 
      { hex: "#BEB6AE", name: "Onyx 10" }, 
      { hex: "#B39578", name: "Onyx 100" }, 
      { hex: "#D4AE8A", name: "Onyx 105" }, 
      { hex: "#DEBFA2", name: "Onyx 110" }, 
      { hex: "#E7CEB7", name: "Onyx 115" }, 
      { hex: "#F6E5D2", name: "Onyx 120" }, 
      { hex: "#BA906C", name: "Onyx 125" }, 
      { hex: "#D2A272", name: "Onyx 130" }, 
      { hex: "#DFB389", name: "Onyx 135" }, 
      { hex: "#EAC5A1", name: "Onyx 140" }, 
      { hex: "#F4D4B7", name: "Onyx 145" }, 
      { hex: "#BABEB7", name: "Onyx 15" }, 
      { hex: "#F9DEC8", name: "Onyx 150" }, 
      { hex: "#B98042", name: "Onyx 155" }, 
      { hex: "#C08E59", name: "Onyx 160" }, 
      { hex: "#E4A974", name: "Onyx 165" }, 
      { hex: "#F0B981", name: "Onyx 170" }, 
      { hex: "#F9C99C", name: "Onyx 175" }, 
      { hex: "#FDDABA", name: "Onyx 180" }, 
      { hex: "#DC9853", name: "Onyx 185" }, 
      { hex: "#E59C51", name: "Onyx 190" }, 
      { hex: "#F2AD66", name: "Onyx 195" }, 
      { hex: "#D3CAC2", name: "Onyx 20" }, 
      { hex: "#FDBD80", name: "Onyx 200" }, 
      { hex: "#FFCE9C", name: "Onyx 205" }, 
      { hex: "#F5EBDF", name: "Onyx 210" }, 
      { hex: "#EC9324", name: "Onyx 220" }, 
      { hex: "#FFB14D", name: "Onyx 225" }, 
      { hex: "#FFB357", name: "Onyx 230" }, 
      { hex: "#DBCBC5", name: "Onyx 25" }, 
      { hex: "#DCD9D4", name: "Onyx 30" }, 
      { hex: "#766C62", name: "Onyx 35" }, 
      { hex: "#90867B", name: "Onyx 40" }, 
      { hex: "#B5AAA0", name: "Onyx 45" }, 
      { hex: "#A9A29C", name: "Onyx 5" }, 
      { hex: "#DCD1C7", name: "Onyx 50" }, 
      { hex: "#E1D9CE", name: "Onyx 55" }, 
      { hex: "#EFE8DE", name: "Onyx 60" }, 
      { hex: "#AD937B", name: "Onyx 65" }, 
      { hex: "#CCBAA9", name: "Onyx 70" }, 
      { hex: "#DDC8B3", name: "Onyx 75" }, 
      { hex: "#E4D1C0", name: "Onyx 80" }, 
      { hex: "#EBDFD1", name: "Onyx 85" }, 
      { hex: "#F3E5D6", name: "Onyx 90" }, 
      { hex: "#957C63", name: "Onyx 95" }, 
      { hex: "#4C565C", name: "Pacific 10" }, 
      { hex: "#345969", name: "Pacific 100" }, 
      { hex: "#7894A2", name: "Pacific 105" }, 
      { hex: "#788F9A", name: "Pacific 110" }, 
      { hex: "#AECAD5", name: "Pacific 115" }, 
      { hex: "#B3C8D1", name: "Pacific 120" }, 
      { hex: "#0B4C61", name: "Pacific 125" }, 
      { hex: "#1C5F74", name: "Pacific 130" }, 
      { hex: "#527688", name: "Pacific 135" }, 
      { hex: "#7091A1", name: "Pacific 140" }, 
      { hex: "#8FADBA", name: "Pacific 145" }, 
      { hex: "#8F9B9F", name: "Pacific 15" }, 
      { hex: "#A7CAD9", name: "Pacific 150" }, 
      { hex: "#006C8C", name: "Pacific 155" }, 
      { hex: "#45788F", name: "Pacific 160" }, 
      { hex: "#2989A9", name: "Pacific 165" }, 
      { hex: "#6093A9", name: "Pacific 170" }, 
      { hex: "#5FA4BF", name: "Pacific 175" }, 
      { hex: "#93CBE0", name: "Pacific 180" }, 
      { hex: "#AFB5B5", name: "Pacific 20" }, 
      { hex: "#C4C7C6", name: "Pacific 25" }, 
      { hex: "#D7DAD8", name: "Pacific 30" }, 
      { hex: "#435863", name: "Pacific 35" }, 
      { hex: "#596770", name: "Pacific 40" }, 
      { hex: "#6E7E85", name: "Pacific 45" }, 
      { hex: "#333E44", name: "Pacific 5" }, 
      { hex: "#B8C0C1", name: "Pacific 50" }, 
      { hex: "#CED2D2", name: "Pacific 55" }, 
      { hex: "#DDE2DE", name: "Pacific 60" }, 
      { hex: "#909EA4", name: "Pacific 65" }, 
      { hex: "#8EABB4", name: "Pacific 70" }, 
      { hex: "#9CACB4", name: "Pacific 75" }, 
      { hex: "#B7C7CC", name: "Pacific 80" }, 
      { hex: "#DBE4E3", name: "Pacific 85" }, 
      { hex: "#E1E9E6", name: "Pacific 90" }, 
      { hex: "#194150", name: "Pacific 95" }, 
      { hex: "#ABA8A2", name: "Palazzo 10" }, 
      { hex: "#918574", name: "Palazzo 100" }, 
      { hex: "#A4998A", name: "Palazzo 105" }, 
      { hex: "#B2A89A", name: "Palazzo 110" }, 
      { hex: "#D5CBBE", name: "Palazzo 115" }, 
      { hex: "#E7D9C7", name: "Palazzo 120" }, 
      { hex: "#524635", name: "Palazzo 125" }, 
      { hex: "#6C5F4E", name: "Palazzo 130" }, 
      { hex: "#877661", name: "Palazzo 135" }, 
      { hex: "#AB9A83", name: "Palazzo 140" }, 
      { hex: "#C3B39D", name: "Palazzo 145" }, 
      { hex: "#B8B5AF", name: "Palazzo 15" }, 
      { hex: "#D9C8B0", name: "Palazzo 150" }, 
      { hex: "#65533B", name: "Palazzo 155" }, 
      { hex: "#776850", name: "Palazzo 160" }, 
      { hex: "#96846A", name: "Palazzo 165" }, 
      { hex: "#CDB89A", name: "Palazzo 170" }, 
      { hex: "#E7CEAE", name: "Palazzo 175" }, 
      { hex: "#F5E4CB", name: "Palazzo 180" }, 
      { hex: "#725730", name: "Palazzo 185" }, 
      { hex: "#93764C", name: "Palazzo 190" }, 
      { hex: "#AB9970", name: "Palazzo 195" }, 
      { hex: "#C5C2BD", name: "Palazzo 20" }, 
      { hex: "#C2A782", name: "Palazzo 200" }, 
      { hex: "#DFBE96", name: "Palazzo 205" }, 
      { hex: "#F4DEBE", name: "Palazzo 210" }, 
      { hex: "#AC864A", name: "Palazzo 215" }, 
      { hex: "#C6A676", name: "Palazzo 220" }, 
      { hex: "#D3B082", name: "Palazzo 225" }, 
      { hex: "#F2CC99", name: "Palazzo 230" }, 
      { hex: "#FBDAAE", name: "Palazzo 235" }, 
      { hex: "#F6EAD6", name: "Palazzo 240" }, 
      { hex: "#987339", name: "Palazzo 245" }, 
      { hex: "#D5D2CC", name: "Palazzo 25" }, 
      { hex: "#B0843C", name: "Palazzo 250" }, 
      { hex: "#D5A45E", name: "Palazzo 255" }, 
      { hex: "#E1B578", name: "Palazzo 260" }, 
      { hex: "#F7C987", name: "Palazzo 265" }, 
      { hex: "#FED699", name: "Palazzo 270" }, 
      { hex: "#986D26", name: "Palazzo 280" }, 
      { hex: "#D19C41", name: "Palazzo 285" }, 
      { hex: "#DEA752", name: "Palazzo 290" }, 
      { hex: "#EEB96C", name: "Palazzo 295" }, 
      { hex: "#E3E0D9", name: "Palazzo 30" }, 
      { hex: "#FFD18A", name: "Palazzo 300" }, 
      { hex: "#B27E2B", name: "Palazzo 305" }, 
      { hex: "#C18924", name: "Palazzo 310" }, 
      { hex: "#C69033", name: "Palazzo 315" }, 
      { hex: "#E5A938", name: "Palazzo 320" }, 
      { hex: "#FEC671", name: "Palazzo 325" }, 
      { hex: "#FECD73", name: "Palazzo 330" }, 
      { hex: "#CE9015", name: "Palazzo 340" }, 
      { hex: "#E6A713", name: "Palazzo 345" }, 
      { hex: "#7F7972", name: "Palazzo 35" }, 
      { hex: "#E9A700", name: "Palazzo 350" }, 
      { hex: "#FCB625", name: "Palazzo 355" }, 
      { hex: "#FFC958", name: "Palazzo 360" }, 
      { hex: "#A9A39B", name: "Palazzo 40" }, 
      { hex: "#BBB5AC", name: "Palazzo 45" }, 
      { hex: "#9D9A95", name: "Palazzo 5" }, 
      { hex: "#CDC7BB", name: "Palazzo 50" }, 
      { hex: "#DDD5CA", name: "Palazzo 55" }, 
      { hex: "#E7E0D6", name: "Palazzo 60" }, 
      { hex: "#413B31", name: "Palazzo 65" }, 
      { hex: "#5D574E", name: "Palazzo 70" }, 
      { hex: "#79736A", name: "Palazzo 75" }, 
      { hex: "#94968A", name: "Palazzo 80" }, 
      { hex: "#C2B7AA", name: "Palazzo 85" }, 
      { hex: "#F0E7D8", name: "Palazzo 90" }, 
      { hex: "#837A6D", name: "Palazzo 95" }, 
      { hex: "#505851", name: "Palm 10" }, 
      { hex: "#556456", name: "Palm 15" }, 
      { hex: "#6A716A", name: "Palm 20" }, 
      { hex: "#7D947D", name: "Palm 25" }, 
      { hex: "#97B19D", name: "Palm 30" }, 
      { hex: "#274B36", name: "Palm 35" }, 
      { hex: "#265C39", name: "Palm 40" }, 
      { hex: "#395A44", name: "Palm 45" }, 
      { hex: "#48574E", name: "Palm 5" }, 
      { hex: "#336947", name: "Palm 50" }, 
      { hex: "#3F7754", name: "Palm 55" }, 
      { hex: "#53755F", name: "Palm 60" }, 
      { hex: "#006533", name: "Palm 65" }, 
      { hex: "#196D3C", name: "Palm 70" }, 
      { hex: "#31794B", name: "Palm 75" }, 
      { hex: "#96ABA4", name: "Patina 10" }, 
      { hex: "#137C6A", name: "Patina 100" }, 
      { hex: "#1C9783", name: "Patina 105" }, 
      { hex: "#4C9483", name: "Patina 110" }, 
      { hex: "#59B5A0", name: "Patina 115" }, 
      { hex: "#75B1A1", name: "Patina 120" }, 
      { hex: "#A9B9B3", name: "Patina 15" }, 
      { hex: "#B9C7C0", name: "Patina 20" }, 
      { hex: "#CFD4CF", name: "Patina 25" }, 
      { hex: "#E7E8E2", name: "Patina 30" }, 
      { hex: "#3E4946", name: "Patina 35" }, 
      { hex: "#324B44", name: "Patina 40" }, 
      { hex: "#4E6660", name: "Patina 45" }, 
      { hex: "#708C85", name: "Patina 5" }, 
      { hex: "#82938D", name: "Patina 50" }, 
      { hex: "#A5BDB6", name: "Patina 55" }, 
      { hex: "#BFD4CC", name: "Patina 60" }, 
      { hex: "#054E43", name: "Patina 65" }, 
      { hex: "#53756B", name: "Patina 70" }, 
      { hex: "#7C9E94", name: "Patina 75" }, 
      { hex: "#9FBDB3", name: "Patina 80" }, 
      { hex: "#9ECFC1", name: "Patina 85" }, 
      { hex: "#E4EBE2", name: "Patina 90" }, 
      { hex: "#006D5C", name: "Patina 95" }, 
      { hex: "#BA927C", name: "Perl 10" }, 
      { hex: "#D3A58C", name: "Perl 15" }, 
      { hex: "#DCAC93", name: "Perl 20" }, 
      { hex: "#E2BBA6", name: "Perl 25" }, 
      { hex: "#F4DBCE", name: "Perl 30" }, 
      { hex: "#D09E86", name: "Perl 40" }, 
      { hex: "#E3AE92", name: "Perl 45" }, 
      { hex: "#A98671", name: "Perl 5" }, 
      { hex: "#F6CAB4", name: "Perl 50" }, 
      { hex: "#F3D6C1", name: "Perl 55" }, 
      { hex: "#F9DFD1", name: "Perl 60" }, 
      { hex: "#005A4A", name: "Peru 10" }, 
      { hex: "#00413C", name: "Peru 15" }, 
      { hex: "#007C71", name: "Peru 20" }, 
      { hex: "#00494F", name: "Peru 25" }, 
      { hex: "#006C75", name: "Peru 30" }, 
      { hex: "#00483D", name: "Peru 5" }, 
      { hex: "#A59D9D", name: "Quarz 10" }, 
      { hex: "#BCB3B1", name: "Quarz 15" }, 
      { hex: "#CCC3C1", name: "Quarz 20" }, 
      { hex: "#C9C9C7", name: "Quarz 25" }, 
      { hex: "#E5DCD8", name: "Quarz 30" }, 
      { hex: "#C9AEAD", name: "Quarz 45" }, 
      { hex: "#CDB6B5", name: "Quarz 50" }, 
      { hex: "#D7C8C6", name: "Quarz 55" }, 
      { hex: "#E4D7D5", name: "Quarz 60" }, 
      { hex: "#D2CDC9", name: "Rose 10" }, 
      { hex: "#A84660", name: "Rose 100" }, 
      { hex: "#88555E", name: "Rose 105" }, 
      { hex: "#A86872", name: "Rose 110" }, 
      { hex: "#D3808E", name: "Rose 115" }, 
      { hex: "#D8AAAF", name: "Rose 120" }, 
      { hex: "#E9DCDA", name: "Rose 15" }, 
      { hex: "#E9E1DC", name: "Rose 20" }, 
      { hex: "#E8E3DD", name: "Rose 25" }, 
      { hex: "#EBE8E2", name: "Rose 30" }, 
      { hex: "#998587", name: "Rose 35" }, 
      { hex: "#B9A0A1", name: "Rose 40" }, 
      { hex: "#B5A6A7", name: "Rose 45" }, 
      { hex: "#BDB5B3", name: "Rose 5" }, 
      { hex: "#C5B3B5", name: "Rose 50" }, 
      { hex: "#E7CAC8", name: "Rose 55" }, 
      { hex: "#F4E4E1", name: "Rose 60" }, 
      { hex: "#694F53", name: "Rose 65" }, 
      { hex: "#80696C", name: "Rose 70" }, 
      { hex: "#9F7479", name: "Rose 75" }, 
      { hex: "#B88E93", name: "Rose 80" }, 
      { hex: "#D1ADB2", name: "Rose 85" }, 
      { hex: "#F4DAD9", name: "Rose 90" }, 
      { hex: "#A93757", name: "Rose 95" }, 
      { hex: "#B22C33", name: "Rubin 10" }, 
      { hex: "#833026", name: "Rubin 15" }, 
      { hex: "#B02C19", name: "Rubin 20" }, 
      { hex: "#633724", name: "Rubin 25" }, 
      { hex: "#C04213", name: "Rubin 30" }, 
      { hex: "#50252E", name: "RUBIN 5" }, 
      { hex: "#8C7D71", name: "Siena 10" }, 
      { hex: "#D9B297", name: "Siena 100" }, 
      { hex: "#D8B69B", name: "Siena 105" }, 
      { hex: "#ECC5AA", name: "Siena 110" }, 
      { hex: "#F5D8C1", name: "Siena 115" }, 
      { hex: "#F2DCC9", name: "Siena 120" }, 
      { hex: "#D09156", name: "Siena 125" }, 
      { hex: "#C39165", name: "Siena 130" }, 
      { hex: "#DDA87C", name: "Siena 135" }, 
      { hex: "#FCC79D", name: "Siena 140" }, 
      { hex: "#FBD7BB", name: "Siena 145" }, 
      { hex: "#A3978D", name: "Siena 15" }, 
      { hex: "#FAE1CF", name: "Siena 150" }, 
      { hex: "#C47930", name: "Siena 155" }, 
      { hex: "#E69551", name: "Siena 160" }, 
      { hex: "#EAA774", name: "Siena 165" }, 
      { hex: "#FFB16C", name: "Siena 170" }, 
      { hex: "#FFBF8C", name: "Siena 175" }, 
      { hex: "#BFB5AD", name: "Siena 20" }, 
      { hex: "#D8D2CC", name: "Siena 25" }, 
      { hex: "#E4E0D9", name: "Siena 30" }, 
      { hex: "#8C7462", name: "Siena 35" }, 
      { hex: "#A48E7D", name: "Siena 40" }, 
      { hex: "#BEAB9C", name: "Siena 45" }, 
      { hex: "#796556", name: "Siena 5" }, 
      { hex: "#D8C8BB", name: "Siena 50" }, 
      { hex: "#E4D1C0", name: "Siena 55" }, 
      { hex: "#F1E5D8", name: "Siena 60" }, 
      { hex: "#816144", name: "Siena 65" }, 
      { hex: "#9C7555", name: "Siena 70" }, 
      { hex: "#A18362", name: "Siena 75" }, 
      { hex: "#B19077", name: "Siena 80" }, 
      { hex: "#CCB29D", name: "Siena 85" }, 
      { hex: "#E5C7AF", name: "Siena 90" }, 
      { hex: "#CA9C80", name: "Siena 95" }, 
      { hex: "#CBC6B6", name: "Soja 10" }, 
      { hex: "#E0E2CB", name: "Soja 15" }, 
      { hex: "#F4EBCC", name: "Soja 20" }, 
      { hex: "#F4EED6", name: "Soja 25" }, 
      { hex: "#F3EEDA", name: "Soja 30" }, 
      { hex: "#B9B39C", name: "Soja 5" }, 
      { hex: "#726E61", name: "Tundra 10" }, 
      { hex: "#847943", name: "Tundra 100" }, 
      { hex: "#968B4E", name: "Tundra 105" }, 
      { hex: "#A5995A", name: "Tundra 110" }, 
      { hex: "#C2B687", name: "Tundra 115" }, 
      { hex: "#DCC58A", name: "Tundra 120" }, 
      { hex: "#A29437", name: "Tundra 125" }, 
      { hex: "#C6B73A", name: "Tundra 130" }, 
      { hex: "#D7C639", name: "Tundra 135" }, 
      { hex: "#F3D843", name: "Tundra 140" }, 
      { hex: "#F4E366", name: "Tundra 145" }, 
      { hex: "#8A8679", name: "Tundra 15" }, 
      { hex: "#F5EBB4", name: "Tundra 150" }, 
      { hex: "#B9B5A7", name: "Tundra 20" }, 
      { hex: "#E1DDCD", name: "Tundra 25" }, 
      { hex: "#EDE9DA", name: "Tundra 30" }, 
      { hex: "#A69D83", name: "Tundra 35" }, 
      { hex: "#BDB597", name: "Tundra 40" }, 
      { hex: "#CFC8B0", name: "Tundra 45" }, 
      { hex: "#555550", name: "Tundra 5" }, 
      { hex: "#D9D5C3", name: "Tundra 50" }, 
      { hex: "#EEE8D3", name: "Tundra 55" }, 
      { hex: "#F2F0E1", name: "Tundra 60" }, 
      { hex: "#5C553F", name: "Tundra 65" }, 
      { hex: "#747155", name: "Tundra 70" }, 
      { hex: "#837D57", name: "Tundra 75" }, 
      { hex: "#968B5E", name: "Tundra 80" }, 
      { hex: "#A8A885", name: "Tundra 85" }, 
      { hex: "#DDD5B3", name: "Tundra 90" }, 
      { hex: "#797242", name: "Tundra 95" }, 
      { hex: "#E8E4D7", name: "Umbra-Weiss" }, 
      { hex: "#DA7778", name: "Venezia 10" }, 
      { hex: "#E78686", name: "Venezia 15" }, 
      { hex: "#F6B0B0", name: "Venezia 20" }, 
      { hex: "#F9DBD7", name: "Venezia 25" }, 
      { hex: "#F5DBD6", name: "Venezia 30" }, 
      { hex: "#CC5158", name: "Venezia 5" }, 
      { hex: "#4C8121", name: "Verdo 10" }, 
      { hex: "#14442B", name: "Verdo 15" }, 
      { hex: "#00642E", name: "Verdo 20" }, 
      { hex: "#2A4B43", name: "Verdo 25" }, 
      { hex: "#00835C", name: "Verdo 30" }, 
      { hex: "#3B5028", name: "Verdo 5" }, 
      { hex: "#C4C5C1", name: "Verona 10" }, 
      { hex: "#4D7575", name: "Verona 100" }, 
      { hex: "#589393", name: "Verona 105" }, 
      { hex: "#92B1B0", name: "Verona 110" }, 
      { hex: "#ADD1CC", name: "Verona 115" }, 
      { hex: "#CCE5E1", name: "Verona 120" }, 
      { hex: "#006969", name: "Verona 125" }, 
      { hex: "#008B8F", name: "Verona 135" }, 
      { hex: "#76C2BF", name: "Verona 145" }, 
      { hex: "#CACECA", name: "Verona 15" }, 
      { hex: "#D6D7D2", name: "Verona 20" }, 
      { hex: "#E1E2DB", name: "Verona 25" }, 
      { hex: "#E6E7E0", name: "Verona 30" }, 
      { hex: "#4F5959", name: "Verona 35" }, 
      { hex: "#86908E", name: "Verona 40" }, 
      { hex: "#AAB2B0", name: "Verona 45" }, 
      { hex: "#A5A9A7", name: "Verona 5" }, 
      { hex: "#BABFBC", name: "Verona 50" }, 
      { hex: "#CDD5D3", name: "Verona 55" }, 
      { hex: "#D8DFD9", name: "Verona 60" }, 
      { hex: "#205757", name: "Verona 65" }, 
      { hex: "#597371", name: "Verona 70" }, 
      { hex: "#788B89", name: "Verona 75" }, 
      { hex: "#9DACAA", name: "Verona 80" }, 
      { hex: "#C7D5D0", name: "Verona 85" }, 
      { hex: "#DAE9E3", name: "Verona 90" }, 
      { hex: "#23797B", name: "Verona 95" }, 
      { hex: "#9F98A0", name: "Viola 10" }, 
      { hex: "#6A4972", name: "Viola 100" }, 
      { hex: "#8A6393", name: "Viola 105" }, 
      { hex: "#806385", name: "Viola 110" }, 
      { hex: "#9C84A5", name: "Viola 115" }, 
      { hex: "#B8A0BB", name: "Viola 120" }, 
      { hex: "#B9B5B8", name: "Viola 15" }, 
      { hex: "#D4D2D2", name: "Viola 20" }, 
      { hex: "#E3E0DC", name: "Viola 25" }, 
      { hex: "#EBE8E2", name: "Viola 30" }, 
      { hex: "#5E5262", name: "Viola 35" }, 
      { hex: "#837684", name: "Viola 40" }, 
      { hex: "#A395A4", name: "Viola 45" }, 
      { hex: "#807984", name: "Viola 5" }, 
      { hex: "#BEB3BD", name: "Viola 50" }, 
      { hex: "#DAD1D5", name: "Viola 55" }, 
      { hex: "#EFE8E7", name: "Viola 60" }, 
      { hex: "#645168", name: "Viola 65" }, 
      { hex: "#715A77", name: "Viola 70" }, 
      { hex: "#79697E", name: "Viola 75" }, 
      { hex: "#A693AA", name: "Viola 80" }, 
      { hex: "#C3B0C7", name: "Viola 85" }, 
      { hex: "#DECEDA", name: "Viola 90" }, 
      { hex: "#4B3354", name: "Viola 95" }, 
      { hex: "#E7E2D9", name: "Warm-Weiss" }
    ],
      "Caparol 3D plus": [      { hex: "#E8E1DB", name: "3D Warm-Weiss" }, 
      { hex: "#F3E3D9", name: "3D Umbra-Weiss" }, 
      { hex: "#EEE8E0", name: "3D Natur-Weiss" }, 
      { hex: "#F3EFEA", name: "3D Hell-Weiss" }, 
      { hex: "#EEE9E4", name: "3D Grau-Weiss" }, 
      { hex: "#EAE6E4", name: "3D Kuhl-Weiss" }, 
      { hex: "#F6EAE3", name: "3D Off White 15" }, 
      { hex: "#E9ECDC", name: "3D Off White 20" }, 
      { hex: "#F5EFDF", name: "3D Off White 25" }, 
      { hex: "#F2F1E4", name: "3D Off White 30" }, 
      { hex: "#E5EEE8", name: "3D Off White 40" }, 
      { hex: "#ECEBE9", name: "3D Off White 50" }, 
      { hex: "#3E3D3D", name: "3D Granit 5" }, 
      { hex: "#5C5050", name: "3D Granit 10" }, 
      { hex: "#656263", name: "3D Granit 15" }, 
      { hex: "#727070", name: "3D Granit 20" }, 
      { hex: "#7D7B7A", name: "3D Granit 25" }, 
      { hex: "#8E8A8A", name: "3D Granit 30" }, 
      { hex: "#989795", name: "3D Granit 35" }, 
      { hex: "#AAA4A3", name: "3D Granit 40" }, 
      { hex: "#BAB5B5", name: "3D Granit 45" }, 
      { hex: "#C4C0BE", name: "3D Granit 50" }, 
      { hex: "#D1CDCB", name: "3D Granit 55" }, 
      { hex: "#E0DEDB", name: "3D Granit 60" }, 
      { hex: "#443D3D", name: "3D Ferro 5" }, 
      { hex: "#56504E", name: "3D Ferro 10" }, 
      { hex: "#696462", name: "3D Ferro 15" }, 
      { hex: "#756F6D", name: "3D Ferro 20" }, 
      { hex: "#827B7A", name: "3D Ferro 25" }, 
      { hex: "#918A87", name: "3D Ferro 30" }, 
      { hex: "#9B9592", name: "3D Ferro 35" }, 
      { hex: "#ACA5A2", name: "3D Ferro 40" }, 
      { hex: "#BAB3AF", name: "3D Ferro 45" }, 
      { hex: "#C9C2BF", name: "3D Ferro 50" }, 
      { hex: "#D4CFCC", name: "3D Ferro 55" }, 
      { hex: "#E1DCD9", name: "3D Ferro 60" }, 
      { hex: "#3A3835", name: "3D Jura 5" }, 
      { hex: "#514F4B", name: "3D Jura 10" }, 
      { hex: "#66615F", name: "3D Jura 15" }, 
      { hex: "#72706C", name: "3D Jura 20" }, 
      { hex: "#7F7C78", name: "3D Jura 25" }, 
      { hex: "#8F8C86", name: "3D Jura 30" }, 
      { hex: "#999490", name: "3D Jura 35" }, 
      { hex: "#A9A5A0", name: "3D Jura 40" }, 
      { hex: "#B8B4AE", name: "3D Jura 45" }, 
      { hex: "#C5C3BE", name: "3D Jura 50" }, 
      { hex: "#D2CFCA", name: "3D Jura 55" }, 
      { hex: "#E0DCD8", name: "3D Jura 60" }, 
      { hex: "#3A3D3D", name: "3D Venato 5" }, 
      { hex: "#4D5052", name: "3D Venato 10" }, 
      { hex: "#646667", name: "3D Venato 15" }, 
      { hex: "#6E7272", name: "3D Venato 20" }, 
      { hex: "#7B7D7F", name: "3D Venato 25" }, 
      { hex: "#948C8E", name: "3D Venato 30" }, 
      { hex: "#959798", name: "3D Venato 35" }, 
      { hex: "#A4A7A7", name: "3D Venato 40" }, 
      { hex: "#B2B4B3", name: "3D Venato 45" }, 
      { hex: "#C1C2C2", name: "3D Venato 50" }, 
      { hex: "#CFCFCE", name: "3D Venato 55" }, 
      { hex: "#DEDEDE", name: "3D Venato 60" }, 
      { hex: "#C0B5B3", name: "3D Rose 5" }, 
      { hex: "#D6CECB", name: "3D Rose 10" }, 
      { hex: "#EDDCDA", name: "3D Rose 15" }, 
      { hex: "#EBE0DD", name: "3D Rose 20" }, 
      { hex: "#EAE1DD", name: "3D Rose 25" }, 
      { hex: "#EFE9E5", name: "3D Rose 30" }, 
      { hex: "#9E8788", name: "3D Rose 35" }, 
      { hex: "#BDA0A0", name: "3D Rose 40" }, 
      { hex: "#B8A6A7", name: "3D Rose 45" }, 
      { hex: "#C8B2B4", name: "3D Rose 50" }, 
      { hex: "#DFC8C7", name: "3D Rose 55" }, 
      { hex: "#F0E5E4", name: "3D Rose 60" }, 
      { hex: "#6D5256", name: "3D Rose 65" }, 
      { hex: "#876C6E", name: "3D Rose 70" }, 
      { hex: "#A6757A", name: "3D Rose 75" }, 
      { hex: "#BC8E93", name: "3D Rose 80" }, 
      { hex: "#D6ACB1", name: "3D Rose 85" }, 
      { hex: "#FCDEDF", name: "3D Rose 90" }, 
      { hex: "#B23557", name: "3D Rose 95" }, 
      { hex: "#B34862", name: "3D Rose 100" }, 
      { hex: "#905961", name: "3D Rose 105" }, 
      { hex: "#AF6772", name: "3D Rose 110" }, 
      { hex: "#DC7E8D", name: "3D Rose 115" }, 
      { hex: "#E3ABB2", name: "3D Rose 120" }, 
      { hex: "#673B3C", name: "3D Baccara 5" }, 
      { hex: "#804750", name: "3D Baccara 10" }, 
      { hex: "#D46170", name: "3D Baccara 15" }, 
      { hex: "#E67C88", name: "3D Baccara 20" }, 
      { hex: "#F4A1A9", name: "3D Baccara 25" }, 
      { hex: "#FDD3D4", name: "3D Baccara 30" }, 
      { hex: "#4F3131", name: "3D Barolo 5" }, 
      { hex: "#6B5451", name: "3D Barolo 10" }, 
      { hex: "#86706E", name: "3D Barolo 15" }, 
      { hex: "#9F8B89", name: "3D Barolo 20" }, 
      { hex: "#B8A7A6", name: "3D Barolo 25" }, 
      { hex: "#CCCCC9", name: "3D Barolo 30" }, 
      { hex: "#6E3132", name: "3D Barolo 35" }, 
      { hex: "#8B5354", name: "3D Barolo 40" }, 
      { hex: "#96716E", name: "3D Barolo 45" }, 
      { hex: "#AB8D8A", name: "3D Barolo 50" }, 
      { hex: "#C4ABA9", name: "3D Barolo 55" }, 
      { hex: "#E1D1CF", name: "3D Barolo 60" }, 
      { hex: "#772C32", name: "3D Barolo 65" }, 
      { hex: "#934E4F", name: "3D Barolo 70" }, 
      { hex: "#A76E6F", name: "3D Barolo 75" }, 
      { hex: "#B98F8C", name: "3D Barolo 80" }, 
      { hex: "#CFAEAC", name: "3D Barolo 85" }, 
      { hex: "#E8D6D4", name: "3D Barolo 90" }, 
      { hex: "#8A2530", name: "3D Barolo 95" }, 
      { hex: "#A45054", name: "3D Barolo 100" }, 
      { hex: "#B07274", name: "3D Barolo 105" }, 
      { hex: "#C98D8E", name: "3D Barolo 110" }, 
      { hex: "#DCB4B1", name: "3D Barolo 115" }, 
      { hex: "#F0D9D6", name: "3D Barolo 120" }, 
      { hex: "#A72036", name: "3D Barolo 125" }, 
      { hex: "#B44D52", name: "3D Barolo 130" }, 
      { hex: "#C97072", name: "3D Barolo 135" }, 
      { hex: "#D79293", name: "3D Barolo 140" }, 
      { hex: "#E7B5B3", name: "3D Barolo 145" }, 
      { hex: "#FADFDD", name: "3D Barolo 150" }, 
      { hex: "#D55058", name: "3D Venezia 5" }, 
      { hex: "#E47678", name: "3D Venezia 10" }, 
      { hex: "#EF8585", name: "3D Venezia 15" }, 
      { hex: "#FBB0AF", name: "3D Venezia 20" }, 
      { hex: "#FBDAD6", name: "3D Venezia 25" }, 
      { hex: "#FEE1DD", name: "3D Venezia 30" }, 
      { hex: "#523634", name: "3D Grenadin 5" }, 
      { hex: "#785451", name: "3D Grenadin 10" }, 
      { hex: "#87706C", name: "3D Grenadin 15" }, 
      { hex: "#AA8A88", name: "3D Grenadin 20" }, 
      { hex: "#B8AAA6", name: "3D Grenadin 25" }, 
      { hex: "#CECDCB", name: "3D Grenadin 30" }, 
      { hex: "#683732", name: "3D Grenadin 35" }, 
      { hex: "#825752", name: "3D Grenadin 40" }, 
      { hex: "#9A746E", name: "3D Grenadin 45" }, 
      { hex: "#AE8E8B", name: "3D Grenadin 50" }, 
      { hex: "#C7ADA9", name: "3D Grenadin 55" }, 
      { hex: "#E0D2CE", name: "3D Grenadin 60" }, 
      { hex: "#8B3630", name: "3D Grenadin 65" }, 
      { hex: "#985551", name: "3D Grenadin 70" }, 
      { hex: "#AC7870", name: "3D Grenadin 75" }, 
      { hex: "#BE918B", name: "3D Grenadin 80" }, 
      { hex: "#D1B1AC", name: "3D Grenadin 85" }, 
      { hex: "#F4D6D3", name: "3D Grenadin 90" }, 
      { hex: "#973A38", name: "3D Grenadin 95" }, 
      { hex: "#AC5652", name: "3D Grenadin 100" }, 
      { hex: "#BE7971", name: "3D Grenadin 105" }, 
      { hex: "#CE958E", name: "3D Grenadin 110" }, 
      { hex: "#DFB4AE", name: "3D Grenadin 115" }, 
      { hex: "#F0D9D5", name: "3D Grenadin 120" }, 
      { hex: "#AE3637", name: "3D Grenadin 125" }, 
      { hex: "#C05853", name: "3D Grenadin 130" }, 
      { hex: "#C77871", name: "3D Grenadin 135" }, 
      { hex: "#E5958E", name: "3D Grenadin 140" }, 
      { hex: "#E9B8B2", name: "3D Grenadin 145" }, 
      { hex: "#EDDEDA", name: "3D Grenadin 150" }, 
      { hex: "#A7847D", name: "3D Bordeaux 5" }, 
      { hex: "#B9928A", name: "3D Bordeaux 10" }, 
      { hex: "#BBA19C", name: "3D Bordeaux 15" }, 
      { hex: "#C6B0AC", name: "3D Bordeaux 20" }, 
      { hex: "#DDD0CD", name: "3D Bordeaux 25" }, 
      { hex: "#F0E4E0", name: "3D Bordeaux 30" }, 
      { hex: "#7F4A42", name: "3D Bordeaux 35" }, 
      { hex: "#9C645A", name: "3D Bordeaux 40" }, 
      { hex: "#B56E64", name: "3D Bordeaux 45" }, 
      { hex: "#BA7C73", name: "3D Bordeaux 50" }, 
      { hex: "#D39D96", name: "3D Bordeaux 55" }, 
      { hex: "#EDC1BA", name: "3D Bordeaux 60" }, 
      { hex: "#A63630", name: "3D Bordeaux 65" }, 
      { hex: "#AF564B", name: "3D Bordeaux 70" }, 
      { hex: "#B05B51", name: "3D Bordeaux 75" }, 
      { hex: "#D37262", name: "3D Bordeaux 80" }, 
      { hex: "#FF9B8D", name: "3D Bordeaux 85" }, 
      { hex: "#FFDAD2", name: "3D Bordeaux 90" }, 
      { hex: "#583E38", name: "3D Magma 5" }, 
      { hex: "#7B5853", name: "3D Magma 10" }, 
      { hex: "#8B7370", name: "3D Magma 15" }, 
      { hex: "#A18E8A", name: "3D Magma 20" }, 
      { hex: "#BAAAA6", name: "3D Magma 25" }, 
      { hex: "#D9CDC9", name: "3D Magma 30" }, 
      { hex: "#6F4237", name: "3D Magma 35" }, 
      { hex: "#875C54", name: "3D Magma 40" }, 
      { hex: "#A07A71", name: "3D Magma 45" }, 
      { hex: "#B19189", name: "3D Magma 50" }, 
      { hex: "#D3AFA9", name: "3D Magma 55" }, 
      { hex: "#E4D2CE", name: "3D Magma 60" }, 
      { hex: "#88453A", name: "3D Magma 65" }, 
      { hex: "#9C6155", name: "3D Magma 70" }, 
      { hex: "#B07B6F", name: "3D Magma 75" }, 
      { hex: "#C0958A", name: "3D Magma 80" }, 
      { hex: "#D6B2AB", name: "3D Magma 85" }, 
      { hex: "#ECD5CF", name: "3D Magma 90" }, 
      { hex: "#9A4234", name: "3D Magma 95" }, 
      { hex: "#A55F51", name: "3D Magma 100" }, 
      { hex: "#C17F70", name: "3D Magma 105" }, 
      { hex: "#D1998C", name: "3D Magma 110" }, 
      { hex: "#E2B5AD", name: "3D Magma 115" }, 
      { hex: "#F6DAD3", name: "3D Magma 120" }, 
      { hex: "#AB3C30", name: "3D Magma 125" }, 
      { hex: "#C4634E", name: "3D Magma 130" }, 
      { hex: "#D78070", name: "3D Magma 135" }, 
      { hex: "#E49E90", name: "3D Magma 140" }, 
      { hex: "#F3BBB1", name: "3D Magma 145" }, 
      { hex: "#FEDDD5", name: "3D Magma 150" }, 
      { hex: "#978682", name: "3D Cameo 5" }, 
      { hex: "#B4A6A3", name: "3D Cameo 10" }, 
      { hex: "#CCC3C0", name: "3D Cameo 15" }, 
      { hex: "#DDCDC8", name: "3D Cameo 20" }, 
      { hex: "#EAE2E0", name: "3D Cameo 25" }, 
      { hex: "#F1EAE7", name: "3D Cameo 30" }, 
      { hex: "#816C67", name: "3D Cameo 35" }, 
      { hex: "#A58D87", name: "3D Cameo 40" }, 
      { hex: "#BCA098", name: "3D Cameo 45" }, 
      { hex: "#C6AEA7", name: "3D Cameo 50" }, 
      { hex: "#E5D1CE", name: "3D Cameo 55" }, 
      { hex: "#FAECE9", name: "3D Cameo 60" }, 
      { hex: "#8E6960", name: "3D Cameo 65" }, 
      { hex: "#A98379", name: "3D Cameo 70" }, 
      { hex: "#CA9B90", name: "3D Cameo 75" }, 
      { hex: "#DBB9AF", name: "3D Cameo 80" }, 
      { hex: "#EDCFC9", name: "3D Cameo 85" }, 
      { hex: "#FCE2DB", name: "3D Cameo 90" }, 
      { hex: "#894E3F", name: "3D Cameo 95" }, 
      { hex: "#AF7667", name: "3D Cameo 100" }, 
      { hex: "#E29A89", name: "3D Cameo 105" }, 
      { hex: "#DFAA9C", name: "3D Cameo 110" }, 
      { hex: "#F0C4BB", name: "3D Cameo 115" }, 
      { hex: "#FFDFD5", name: "3D Cameo 120" }, 
      { hex: "#A34F3D", name: "3D Cameo 125" }, 
      { hex: "#AE6254", name: "3D Cameo 130" }, 
      { hex: "#C97B69", name: "3D Cameo 135" }, 
      { hex: "#F7A48F", name: "3D Cameo 140" }, 
      { hex: "#F7B6A5", name: "3D Cameo 145" }, 
      { hex: "#FFE4DC", name: "3D Cameo 150" }, 
      { hex: "#D35540", name: "3D Cameo 155" }, 
      { hex: "#DD4F39", name: "3D Cameo 160" }, 
      { hex: "#E85539", name: "3D Cameo 165" }, 
      { hex: "#EE785C", name: "3D Cameo 170" }, 
      { hex: "#F59F88", name: "3D Cameo 175" }, 
      { hex: "#FFC7B6", name: "3D Cameo 180" }, 
      { hex: "#BE988C", name: "3D Lachs 5" }, 
      { hex: "#D4ADA0", name: "3D Lachs 10" }, 
      { hex: "#E2BEB1", name: "3D Lachs 15" }, 
      { hex: "#F9CDC1", name: "3D Lachs 20" }, 
      { hex: "#FADED5", name: "3D Lachs 25" }, 
      { hex: "#FEE7DE", name: "3D Lachs 30" }, 
      { hex: "#B67C69", name: "3D Lachs 35" }, 
      { hex: "#C09080", name: "3D Lachs 40" }, 
      { hex: "#CCA092", name: "3D Lachs 45" }, 
      { hex: "#DEA18E", name: "3D Lachs 50" }, 
      { hex: "#EEBAAD", name: "3D Lachs 55" }, 
      { hex: "#FFD9CB", name: "3D Lachs 60" }, 
      { hex: "#AA6149", name: "3D Lachs 65" }, 
      { hex: "#D17B5B", name: "3D Lachs 70" }, 
      { hex: "#DB8968", name: "3D Lachs 75" }, 
      { hex: "#E7947A", name: "3D Lachs 80" }, 
      { hex: "#FFC2AA", name: "3D Lachs 85" }, 
      { hex: "#FFD2BE", name: "3D Lachs 90" }, 
      { hex: "#BC512D", name: "3D Lachs 95" }, 
      { hex: "#BC5D3E", name: "3D Lachs 100" }, 
      { hex: "#CF6E4B", name: "3D Lachs 105" }, 
      { hex: "#E05D36", name: "3D Lachs 110" }, 
      { hex: "#EA7D59", name: "3D Lachs 115" }, 
      { hex: "#FFA082", name: "3D Lachs 120" }, 
      { hex: "#A6968B", name: "3D Aprico 5" }, 
      { hex: "#BEA59B", name: "3D Aprico 10" }, 
      { hex: "#D4C4BC", name: "3D Aprico 15" }, 
      { hex: "#DDD1CB", name: "3D Aprico 20" }, 
      { hex: "#ECE3E0", name: "3D Aprico 25" }, 
      { hex: "#F0E8E5", name: "3D Aprico 30" }, 
      { hex: "#906D60", name: "3D Aprico 35" }, 
      { hex: "#A78678", name: "3D Aprico 40" }, 
      { hex: "#D7AD9F", name: "3D Aprico 45" }, 
      { hex: "#EAC0B3", name: "3D Aprico 50" }, 
      { hex: "#F1CFC2", name: "3D Aprico 55" }, 
      { hex: "#FEE2D4", name: "3D Aprico 60" }, 
      { hex: "#B18472", name: "3D Aprico 65" }, 
      { hex: "#BD9382", name: "3D Aprico 70" }, 
      { hex: "#E7AE94", name: "3D Aprico 75" }, 
      { hex: "#EABAA6", name: "3D Aprico 80" }, 
      { hex: "#E7BCAB", name: "3D Aprico 85" }, 
      { hex: "#F9CDBD", name: "3D Aprico 90" }, 
      { hex: "#A06C55", name: "3D Aprico 95" }, 
      { hex: "#D48B6B", name: "3D Aprico 100" }, 
      { hex: "#C58D75", name: "3D Aprico 105" }, 
      { hex: "#E39977", name: "3D Aprico 110" }, 
      { hex: "#F1A785", name: "3D Aprico 115" }, 
      { hex: "#F8AA8E", name: "3D Aprico 120" }, 
      { hex: "#C5643A", name: "3D Aprico 125" }, 
      { hex: "#D67E54", name: "3D Aprico 130" }, 
      { hex: "#CB7B5A", name: "3D Aprico 135" }, 
      { hex: "#F47A44", name: "3D Aprico 140" }, 
      { hex: "#FF8449", name: "3D Aprico 145" }, 
      { hex: "#FFB490", name: "3D Aprico 150" }, 
      { hex: "#D96D3A", name: "3D Aprico 155" }, 
      { hex: "#EB8F5F", name: "3D Aprico 160" }, 
      { hex: "#FCA980", name: "3D Aprico 165" }, 
      { hex: "#FFBF9E", name: "3D Aprico 170" }, 
      { hex: "#FFD8C6", name: "3D Aprico 175" }, 
      { hex: "#FDE4D8", name: "3D Aprico 180" }, 
      { hex: "#574B42", name: "3D Papaya 5" }, 
      { hex: "#7E695E", name: "3D Papaya 10" }, 
      { hex: "#937E74", name: "3D Papaya 15" }, 
      { hex: "#A9968E", name: "3D Papaya 20" }, 
      { hex: "#C1AFA8", name: "3D Papaya 25" }, 
      { hex: "#DECDC7", name: "3D Papaya 30" }, 
      { hex: "#875840", name: "3D Papaya 35" }, 
      { hex: "#A1735C", name: "3D Papaya 40" }, 
      { hex: "#B18A76", name: "3D Papaya 45" }, 
      { hex: "#BF9D8C", name: "3D Papaya 50" }, 
      { hex: "#D2B4A6", name: "3D Papaya 55" }, 
      { hex: "#E7D1C6", name: "3D Papaya 60" }, 
      { hex: "#B1683D", name: "3D Papaya 65" }, 
      { hex: "#BC7B59", name: "3D Papaya 70" }, 
      { hex: "#CC9373", name: "3D Papaya 75" }, 
      { hex: "#D8A78C", name: "3D Papaya 80" }, 
      { hex: "#E2BBA8", name: "3D Papaya 85" }, 
      { hex: "#F2D7C9", name: "3D Papaya 90" }, 
      { hex: "#D4733E", name: "3D Papaya 95" }, 
      { hex: "#DF8856", name: "3D Papaya 100" }, 
      { hex: "#E5996E", name: "3D Papaya 105" }, 
      { hex: "#F4AC89", name: "3D Papaya 110" }, 
      { hex: "#F4C2A6", name: "3D Papaya 115" }, 
      { hex: "#FCDAC9", name: "3D Papaya 120" }, 
      { hex: "#F37D2F", name: "3D Papaya 125" }, 
      { hex: "#FD914F", name: "3D Papaya 130" }, 
      { hex: "#FFA46C", name: "3D Papaya 135" }, 
      { hex: "#FFB487", name: "3D Papaya 140" }, 
      { hex: "#FFC9A9", name: "3D Papaya 145" }, 
      { hex: "#FFDDC9", name: "3D Papaya 150" }, 
      { hex: "#8C705D", name: "3D Ceramic 5" }, 
      { hex: "#A58875", name: "3D Ceramic 10" }, 
      { hex: "#BFA291", name: "3D Ceramic 15" }, 
      { hex: "#BBA598", name: "3D Ceramic 20" }, 
      { hex: "#C7B4A9", name: "3D Ceramic 25" }, 
      { hex: "#D7C5BD", name: "3D Ceramic 30" }, 
      { hex: "#C6A18B", name: "3D Ceramic 35" }, 
      { hex: "#D3B09D", name: "3D Ceramic 40" }, 
      { hex: "#E1B9A3", name: "3D Ceramic 45" }, 
      { hex: "#E1BCA5", name: "3D Ceramic 50" }, 
      { hex: "#E0C4B3", name: "3D Ceramic 55" }, 
      { hex: "#FBE0D1", name: "3D Ceramic 60" }, 
      { hex: "#CF9575", name: "3D Ceramic 65" }, 
      { hex: "#E0AC8B", name: "3D Ceramic 70" }, 
      { hex: "#FFCCB0", name: "3D Ceramic 75" }, 
      { hex: "#FED6BB", name: "3D Ceramic 80" }, 
      { hex: "#FBDFCF", name: "3D Ceramic 85" }, 
      { hex: "#F9EBE5", name: "3D Ceramic 90" }, 
      { hex: "#634D3D", name: "3D Amber 5" }, 
      { hex: "#806B5D", name: "3D Amber 10" }, 
      { hex: "#958174", name: "3D Amber 15" }, 
      { hex: "#AA978C", name: "3D Amber 20" }, 
      { hex: "#BFB1A7", name: "3D Amber 25" }, 
      { hex: "#DECFC8", name: "3D Amber 30" }, 
      { hex: "#895B38", name: "3D Amber 35" }, 
      { hex: "#9F7758", name: "3D Amber 40" }, 
      { hex: "#B18B70", name: "3D Amber 45" }, 
      { hex: "#C19F89", name: "3D Amber 50" }, 
      { hex: "#D2B7A6", name: "3D Amber 55" }, 
      { hex: "#E8D3C6", name: "3D Amber 60" }, 
      { hex: "#B06E34", name: "3D Amber 65" }, 
      { hex: "#BF8350", name: "3D Amber 70" }, 
      { hex: "#CC946A", name: "3D Amber 75" }, 
      { hex: "#D7A885", name: "3D Amber 80" }, 
      { hex: "#E2BEA2", name: "3D Amber 85" }, 
      { hex: "#F2D7C5", name: "3D Amber 90" }, 
      { hex: "#D97D30", name: "3D Amber 95" }, 
      { hex: "#DD914A", name: "3D Amber 100" }, 
      { hex: "#E5A366", name: "3D Amber 105" }, 
      { hex: "#ECB283", name: "3D Amber 110" }, 
      { hex: "#F3C5A0", name: "3D Amber 115" }, 
      { hex: "#FDDBC3", name: "3D Amber 120" }, 
      { hex: "#FB8B22", name: "3D Amber 125" }, 
      { hex: "#FF9E3F", name: "3D Amber 130" }, 
      { hex: "#FFAD60", name: "3D Amber 135" }, 
      { hex: "#FFBD80", name: "3D Amber 140" }, 
      { hex: "#FFCB9E", name: "3D Amber 145" }, 
      { hex: "#FFDFC2", name: "3D Amber 150" }, 
      { hex: "#7A675A", name: "3D Siena 5" }, 
      { hex: "#8F7F73", name: "3D Siena 10" }, 
      { hex: "#A6988E", name: "3D Siena 15" }, 
      { hex: "#C1B5AF", name: "3D Siena 20" }, 
      { hex: "#DCD3CF", name: "3D Siena 25" }, 
      { hex: "#E1E4E0", name: "3D Siena 30" }, 
      { hex: "#8F7665", name: "3D Siena 35" }, 
      { hex: "#A79080", name: "3D Siena 40" }, 
      { hex: "#C1AC9E", name: "3D Siena 45" }, 
      { hex: "#D9C9BD", name: "3D Siena 50" }, 
      { hex: "#E6D2C3", name: "3D Siena 55" }, 
      { hex: "#FAEADE", name: "3D Siena 60" }, 
      { hex: "#82644B", name: "3D Siena 65" }, 
      { hex: "#9D795A", name: "3D Siena 70" }, 
      { hex: "#AD8767", name: "3D Siena 75" }, 
      { hex: "#B29279", name: "3D Siena 80" }, 
      { hex: "#CFB4A0", name: "3D Siena 85" }, 
      { hex: "#ECCDB7", name: "3D Siena 90" }, 
      { hex: "#C19E82", name: "3D Siena 95" }, 
      { hex: "#DCB499", name: "3D Siena 100" }, 
      { hex: "#DDB89E", name: "3D Siena 105" }, 
      { hex: "#F0C6AB", name: "3D Siena 110" }, 
      { hex: "#F6D8C1", name: "3D Siena 115" }, 
      { hex: "#F9E2D0", name: "3D Siena 120" }, 
      { hex: "#D1965D", name: "3D Siena 125" }, 
      { hex: "#C4946A", name: "3D Siena 130" }, 
      { hex: "#E0AD82", name: "3D Siena 135" }, 
      { hex: "#FFCBA0", name: "3D Siena 140" }, 
      { hex: "#FEDBBF", name: "3D Siena 145" }, 
      { hex: "#FFE5D5", name: "3D Siena 150" }, 
      { hex: "#C47E3C", name: "3D Siena 155" }, 
      { hex: "#E89A57", name: "3D Siena 160" }, 
      { hex: "#ECAB78", name: "3D Siena 165" }, 
      { hex: "#FFB670", name: "3D Siena 170" }, 
      { hex: "#FFC38D", name: "3D Siena 175" }, 
      { hex: "#FFD09A", name: "3D Siena 180" }, 
      { hex: "#ABA19B", name: "3D Onyx 5" }, 
      { hex: "#C1B7B0", name: "3D Onyx 10" }, 
      { hex: "#D1BEB9", name: "3D Onyx 15" }, 
      { hex: "#D5CAC4", name: "3D Onyx 20" }, 
      { hex: "#D4CBC7", name: "3D Onyx 25" }, 
      { hex: "#E3DDDB", name: "3D Onyx 30" }, 
      { hex: "#786D63", name: "3D Onyx 35" }, 
      { hex: "#93877C", name: "3D Onyx 40" }, 
      { hex: "#B6ABA0", name: "3D Onyx 45" }, 
      { hex: "#E8D2C8", name: "3D Onyx 50" }, 
      { hex: "#E3DAD1", name: "3D Onyx 55" }, 
      { hex: "#F3EBE3", name: "3D Onyx 60" }, 
      { hex: "#AD947C", name: "3D Onyx 65" }, 
      { hex: "#CEBCAB", name: "3D Onyx 70" }, 
      { hex: "#E3CAB6", name: "3D Onyx 75" }, 
      { hex: "#E6D2C0", name: "3D Onyx 80" }, 
      { hex: "#EEE1D5", name: "3D Onyx 85" }, 
      { hex: "#FAECDE", name: "3D Onyx 90" }, 
      { hex: "#967E66", name: "3D Onyx 95" }, 
      { hex: "#B6997C", name: "3D Onyx 100" }, 
      { hex: "#D6B28E", name: "3D Onyx 105" }, 
      { hex: "#DFC2A4", name: "3D Onyx 110" }, 
      { hex: "#EBD2BA", name: "3D Onyx 115" }, 
      { hex: "#FBE9D8", name: "3D Onyx 120" }, 
      { hex: "#BA936E", name: "3D Onyx 125" }, 
      { hex: "#D2A575", name: "3D Onyx 130" }, 
      { hex: "#E2B88D", name: "3D Onyx 135" }, 
      { hex: "#ECC9A4", name: "3D Onyx 140" }, 
      { hex: "#F6D8BA", name: "3D Onyx 145" }, 
      { hex: "#FFE4CE", name: "3D Onyx 150" }, 
      { hex: "#B98547", name: "3D Onyx 155" }, 
      { hex: "#C0935E", name: "3D Onyx 160" }, 
      { hex: "#E5AD78", name: "3D Onyx 165" }, 
      { hex: "#F2BE85", name: "3D Onyx 170" }, 
      { hex: "#FBCD9D", name: "3D Onyx 175" }, 
      { hex: "#FFDFBE", name: "3D Onyx 180" }, 
      { hex: "#DB9B56", name: "3D Onyx 185" }, 
      { hex: "#E7A358", name: "3D Onyx 190" }, 
      { hex: "#EBB46D", name: "3D Onyx 195" }, 
      { hex: "#FFC383", name: "3D Onyx 200" }, 
      { hex: "#FFD39E", name: "3D Onyx 205" }, 
      { hex: "#F9EEE5", name: "3D Onyx 210" }, 
      { hex: "#DF8C25", name: "3D Onyx 215" }, 
      { hex: "#EF9A33", name: "3D Onyx 220" }, 
      { hex: "#FFB857", name: "3D Onyx 225" }, 
      { hex: "#FFB85D", name: "3D Onyx 230" }, 
      { hex: "#FFC574", name: "3D Onyx 235" }, 
      { hex: "#FFD093", name: "3D Onyx 240" }, 
      { hex: "#665643", name: "3D Marill 5" }, 
      { hex: "#7D6D5C", name: "3D Marill 10" }, 
      { hex: "#928475", name: "3D Marill 15" }, 
      { hex: "#A99B8E", name: "3D Marill 20" }, 
      { hex: "#C1B4A8", name: "3D Marill 25" }, 
      { hex: "#DED4C9", name: "3D Marill 30" }, 
      { hex: "#856A43", name: "3D Marill 35" }, 
      { hex: "#957D5A", name: "3D Marill 40" }, 
      { hex: "#AA9172", name: "3D Marill 45" }, 
      { hex: "#BAA48A", name: "3D Marill 50" }, 
      { hex: "#CDB9A2", name: "3D Marill 55" }, 
      { hex: "#E8D9C9", name: "3D Marill 60" }, 
      { hex: "#AD813E", name: "3D Marill 65" }, 
      { hex: "#BD9157", name: "3D Marill 70" }, 
      { hex: "#CAA472", name: "3D Marill 75" }, 
      { hex: "#D5B388", name: "3D Marill 80" }, 
      { hex: "#E2C5A1", name: "3D Marill 85" }, 
      { hex: "#F1DEC7", name: "3D Marill 90" }, 
      { hex: "#DA9F3B", name: "3D Marill 95" }, 
      { hex: "#E1AB56", name: "3D Marill 100" }, 
      { hex: "#EDBB71", name: "3D Marill 105" }, 
      { hex: "#EDC383", name: "3D Marill 110" }, 
      { hex: "#FDCE9D", name: "3D Marill 115" }, 
      { hex: "#FFE3C3", name: "3D Marill 120" }, 
      { hex: "#FFBB30", name: "3D Marill 125" }, 
      { hex: "#FFC350", name: "3D Marill 130" }, 
      { hex: "#FFCC6B", name: "3D Marill 135" }, 
      { hex: "#FFD387", name: "3D Marill 140" }, 
      { hex: "#FFD99A", name: "3D Marill 145" }, 
      { hex: "#FFE4B8", name: "3D Marill 150" }, 
      { hex: "#A99A95", name: "3D Palazzo 5" }, 
      { hex: "#AEA9A2", name: "3D Palazzo 10" }, 
      { hex: "#BBB7B1", name: "3D Palazzo 15" }, 
      { hex: "#C8C3BE", name: "3D Palazzo 20" }, 
      { hex: "#DAD4CE", name: "3D Palazzo 25" }, 
      { hex: "#F5E5E0", name: "3D Palazzo 30" }, 
      { hex: "#827C73", name: "3D Palazzo 35" }, 
      { hex: "#ADA59D", name: "3D Palazzo 40" }, 
      { hex: "#BCB5AC", name: "3D Palazzo 45" }, 
      { hex: "#D1C8BD", name: "3D Palazzo 50" }, 
      { hex: "#E2D7CD", name: "3D Palazzo 55" }, 
      { hex: "#F0E6DE", name: "3D Palazzo 60" }, 
      { hex: "#463F37", name: "3D Palazzo 65" }, 
      { hex: "#615B53", name: "3D Palazzo 70" }, 
      { hex: "#7D766E", name: "3D Palazzo 75" }, 
      { hex: "#9F968A", name: "3D Palazzo 80" }, 
      { hex: "#C3B8AB", name: "3D Palazzo 85" }, 
      { hex: "#F6ECDF", name: "3D Palazzo 90" }, 
      { hex: "#867C70", name: "3D Palazzo 95" }, 
      { hex: "#958878", name: "3D Palazzo 100" }, 
      { hex: "#A79B8B", name: "3D Palazzo 105" }, 
      { hex: "#B4A99C", name: "3D Palazzo 110" }, 
      { hex: "#D8CDC1", name: "3D Palazzo 115" }, 
      { hex: "#EDDFCE", name: "3D Palazzo 120" }, 
      { hex: "#564B3B", name: "3D Palazzo 125" }, 
      { hex: "#6F6353", name: "3D Palazzo 130" }, 
      { hex: "#897A65", name: "3D Palazzo 135" }, 
      { hex: "#AC9B85", name: "3D Palazzo 140" }, 
      { hex: "#C5B49F", name: "3D Palazzo 145" }, 
      { hex: "#E0CEB6", name: "3D Palazzo 150" }, 
      { hex: "#66553F", name: "3D Palazzo 155" }, 
      { hex: "#846D55", name: "3D Palazzo 160" }, 
      { hex: "#97866E", name: "3D Palazzo 165" }, 
      { hex: "#CEBB9C", name: "3D Palazzo 170" }, 
      { hex: "#E9D2B2", name: "3D Palazzo 175" }, 
      { hex: "#FCEAD2", name: "3D Palazzo 180" }, 
      { hex: "#715934", name: "3D Palazzo 185" }, 
      { hex: "#927A52", name: "3D Palazzo 190" }, 
      { hex: "#B49D75", name: "3D Palazzo 195" }, 
      { hex: "#C4AA85", name: "3D Palazzo 200" }, 
      { hex: "#E1C299", name: "3D Palazzo 205" }, 
      { hex: "#F0E6C6", name: "3D Palazzo 210" }, 
      { hex: "#AD894F", name: "3D Palazzo 215" }, 
      { hex: "#C8AB7B", name: "3D Palazzo 220" }, 
      { hex: "#D5B486", name: "3D Palazzo 225" }, 
      { hex: "#F5D19D", name: "3D Palazzo 230" }, 
      { hex: "#FDDEB2", name: "3D Palazzo 235" }, 
      { hex: "#FAEEDB", name: "3D Palazzo 240" }, 
      { hex: "#96753D", name: "3D Palazzo 245" }, 
      { hex: "#A68742", name: "3D Palazzo 250" }, 
      { hex: "#D3A964", name: "3D Palazzo 255" }, 
      { hex: "#E0B97C", name: "3D Palazzo 260" }, 
      { hex: "#F9CE8C", name: "3D Palazzo 265" }, 
      { hex: "#FFDE9F", name: "3D Palazzo 270" }, 
      { hex: "#8C682B", name: "3D Palazzo 275" }, 
      { hex: "#987638", name: "3D Palazzo 280" }, 
      { hex: "#CFA24A", name: "3D Palazzo 285" }, 
      { hex: "#DDAC57", name: "3D Palazzo 290" }, 
      { hex: "#EFBF71", name: "3D Palazzo 295" }, 
      { hex: "#FFDC91", name: "3D Palazzo 300" }, 
      { hex: "#AF8538", name: "3D Palazzo 305" }, 
      { hex: "#C09032", name: "3D Palazzo 310" }, 
      { hex: "#C59841", name: "3D Palazzo 315" }, 
      { hex: "#E3B041", name: "3D Palazzo 320" }, 
      { hex: "#FFCF77", name: "3D Palazzo 325" }, 
      { hex: "#FFD97C", name: "3D Palazzo 330" }, 
      { hex: "#BC8920", name: "3D Palazzo 335" }, 
      { hex: "#CC9524", name: "3D Palazzo 340" }, 
      { hex: "#D8AF29", name: "3D Palazzo 345" }, 
      { hex: "#FFBC0", name: "3D Palazzo 350" }, 
      { hex: "#FCBF32", name: "3D Palazzo 355" }, 
      { hex: "#FFD462", name: "3D Palazzo 360" }, 
      { hex: "#715F3F", name: "3D Curcuma 5" }, 
      { hex: "#797356", name: "3D Curcuma 10" }, 
      { hex: "#9B8A73", name: "3D Curcuma 15" }, 
      { hex: "#ADA18C", name: "3D Curcuma 20" }, 
      { hex: "#C6BAAA", name: "3D Curcuma 25" }, 
      { hex: "#E2DACF", name: "3D Curcuma 30" }, 
      { hex: "#92772D", name: "3D Curcuma 35" }, 
      { hex: "#A78D50", name: "3D Curcuma 40" }, 
      { hex: "#B79C6C", name: "3D Curcuma 45" }, 
      { hex: "#BBB087", name: "3D Curcuma 50" }, 
      { hex: "#D6C6A9", name: "3D Curcuma 55" }, 
      { hex: "#DFDECC", name: "3D Curcuma 60" }, 
      { hex: "#CD9E1D", name: "3D Curcuma 65" }, 
      { hex: "#D6AD4C", name: "3D Curcuma 70" }, 
      { hex: "#DEB868", name: "3D Curcuma 75" }, 
      { hex: "#E4C584", name: "3D Curcuma 80" }, 
      { hex: "#E9D1A6", name: "3D Curcuma 85" }, 
      { hex: "#E6E1C8", name: "3D Curcuma 90" }, 
      { hex: "#FCBC0", name: "3D Curcuma 95" }, 
      { hex: "#FAC631", name: "3D Curcuma 100" }, 
      { hex: "#FFD05F", name: "3D Curcuma 105" }, 
      { hex: "#FED881", name: "3D Curcuma 110" }, 
      { hex: "#FFDFA0", name: "3D Curcuma 115" }, 
      { hex: "#FFE9C2", name: "3D Curcuma 120" }, 
      { hex: "#AEA18E", name: "3D Ginster 5" }, 
      { hex: "#BEB1A1", name: "3D Ginster 10" }, 
      { hex: "#CBC0B2", name: "3D Ginster 15" }, 
      { hex: "#DCD3C8", name: "3D Ginster 20" }, 
      { hex: "#ECE4DB", name: "3D Ginster 25" }, 
      { hex: "#E8EBE4", name: "3D Ginster 30" }, 
      { hex: "#87775A", name: "3D Ginster 35" }, 
      { hex: "#978970", name: "3D Ginster 40" }, 
      { hex: "#B5A78E", name: "3D Ginster 45" }, 
      { hex: "#D3C5AD", name: "3D Ginster 50" }, 
      { hex: "#E3D5BE", name: "3D Ginster 55" }, 
      { hex: "#ECE6CF", name: "3D Ginster 60" }, 
      { hex: "#A38A5D", name: "3D Ginster 65" }, 
      { hex: "#B5A97D", name: "3D Ginster 70" }, 
      { hex: "#CDBC99", name: "3D Ginster 75" }, 
      { hex: "#DFCBA4", name: "3D Ginster 80" }, 
      { hex: "#F1DEB9", name: "3D Ginster 85" }, 
      { hex: "#FDEED2", name: "3D Ginster 90" }, 
      { hex: "#CFBB88", name: "3D Ginster 95" }, 
      { hex: "#DCC37E", name: "3D Ginster 100" }, 
      { hex: "#F9D38D", name: "3D Ginster 105" }, 
      { hex: "#F2D492", name: "3D Ginster 110" }, 
      { hex: "#F5DCAD", name: "3D Ginster 115" }, 
      { hex: "#FFEBC3", name: "3D Ginster 120" }, 
      { hex: "#E8B20", name: "3D Ginster 125" }, 
      { hex: "#F3C00", name: "3D Ginster 130" }, 
      { hex: "#FCCF4A", name: "3D Ginster 135" }, 
      { hex: "#F9D06C", name: "3D Ginster 140" }, 
      { hex: "#FFD75F", name: "3D Ginster 145" }, 
      { hex: "#FFE399", name: "3D Ginster 150" }, 
      { hex: "#B8AC8F", name: "3D Curry 5" }, 
      { hex: "#CBC1A8", name: "3D Curry 10" }, 
      { hex: "#DDD4C1", name: "3D Curry 15" }, 
      { hex: "#E6DDCE", name: "3D Curry 20" }, 
      { hex: "#F3EADA", name: "3D Curry 25" }, 
      { hex: "#FBF3E1", name: "3D Curry 30" }, 
      { hex: "#9F905E", name: "3D Curry 35" }, 
      { hex: "#BFAB7A", name: "3D Curry 40" }, 
      { hex: "#E2C79A", name: "3D Curry 45" }, 
      { hex: "#E8DBB9", name: "3D Curry 50" }, 
      { hex: "#F7EACF", name: "3D Curry 55" }, 
      { hex: "#FCF3DC", name: "3D Curry 60" }, 
      { hex: "#BAA76D", name: "3D Curry 65" }, 
      { hex: "#D3BF7D", name: "3D Curry 70" }, 
      { hex: "#E2CE99", name: "3D Curry 75" }, 
      { hex: "#F0DCAF", name: "3D Curry 80" }, 
      { hex: "#FFEABF", name: "3D Curry 85" }, 
      { hex: "#FFF1C8", name: "3D Curry 90" }, 
      { hex: "#AF9631", name: "3D Curry 95" }, 
      { hex: "#C0A960", name: "3D Curry 100" }, 
      { hex: "#E4C879", name: "3D Curry 105" }, 
      { hex: "#EFD591", name: "3D Curry 110" }, 
      { hex: "#F7DE90", name: "3D Curry 115" }, 
      { hex: "#FFEBB0", name: "3D Curry 120" }, 
      { hex: "#D0B121", name: "3D Curry 125" }, 
      { hex: "#DAC32C", name: "3D Curry 130" }, 
      { hex: "#EED168", name: "3D Curry 135" }, 
      { hex: "#FADA5F", name: "3D Curry 140" }, 
      { hex: "#FDE289", name: "3D Curry 145" }, 
      { hex: "#FFEC9B", name: "3D Curry 150" }, 
      { hex: "#605834", name: "3D Citrus 5" }, 
      { hex: "#7C7254", name: "3D Citrus 10" }, 
      { hex: "#958C70", name: "3D Citrus 15" }, 
      { hex: "#ADA28E", name: "3D Citrus 20" }, 
      { hex: "#C6BFAC", name: "3D Citrus 25" }, 
      { hex: "#E6E0D1", name: "3D Citrus 30" }, 
      { hex: "#90822C", name: "3D Citrus 35" }, 
      { hex: "#A7984F", name: "3D Citrus 40" }, 
      { hex: "#BAAB6C", name: "3D Citrus 45" }, 
      { hex: "#C9BC88", name: "3D Citrus 50" }, 
      { hex: "#DBCFA5", name: "3D Citrus 55" }, 
      { hex: "#F0E5C7", name: "3D Citrus 60" }, 
      { hex: "#D5BB27", name: "3D Citrus 65" }, 
      { hex: "#DBC74C", name: "3D Citrus 70" }, 
      { hex: "#E5CF6A", name: "3D Citrus 75" }, 
      { hex: "#EBD886", name: "3D Citrus 80" }, 
      { hex: "#F3E3A0", name: "3D Citrus 85" }, 
      { hex: "#FBEEBF", name: "3D Citrus 90" }, 
      { hex: "#F0DF14", name: "3D Citrus 95" }, 
      { hex: "#FCE342", name: "3D Citrus 100" }, 
      { hex: "#FDE55B", name: "3D Citrus 105" }, 
      { hex: "#FBE778", name: "3D Citrus 110" }, 
      { hex: "#FBE894", name: "3D Citrus 115" }, 
      { hex: "#FFEFAF", name: "3D Citrus 120" }, 
      { hex: "#CAC4BA", name: "3D Melisse 5" }, 
      { hex: "#DAD4CB", name: "3D Melisse 10" }, 
      { hex: "#EAE4DB", name: "3D Melisse 15" }, 
      { hex: "#EDE7E2", name: "3D Melisse 20" }, 
      { hex: "#F2E9D9", name: "3D Melisse 25" }, 
      { hex: "#F9F1DD", name: "3D Melisse 30" }, 
      { hex: "#B1A686", name: "3D Melisse 35" }, 
      { hex: "#CCC6AA", name: "3D Melisse 40" }, 
      { hex: "#DED6BC", name: "3D Melisse 45" }, 
      { hex: "#E7DFC5", name: "3D Melisse 50" }, 
      { hex: "#F2E9D4", name: "3D Melisse 55" }, 
      { hex: "#F7F2E5", name: "3D Melisse 60" }, 
      { hex: "#7A734A", name: "3D Melisse 65" }, 
      { hex: "#988F70", name: "3D Melisse 70" }, 
      { hex: "#B6A974", name: "3D Melisse 75" }, 
      { hex: "#DACD97", name: "3D Melisse 80" }, 
      { hex: "#F9E9B2", name: "3D Melisse 85" }, 
      { hex: "#FAF0D3", name: "3D Melisse 90" }, 
      { hex: "#C3B02E", name: "3D Melisse 95" }, 
      { hex: "#CDBC34", name: "3D Melisse 100" }, 
      { hex: "#E7D44D", name: "3D Melisse 105" }, 
      { hex: "#E9DF51", name: "3D Melisse 110" }, 
      { hex: "#F8E975", name: "3D Melisse 115" }, 
      { hex: "#FBEFC3", name: "3D Melisse 120" }, 
      { hex: "#BBB39D", name: "3D Soja 5" }, 
      { hex: "#CCC6B6", name: "3D Soja 10" }, 
      { hex: "#EAE3CC", name: "3D Soja 15" }, 
      { hex: "#F5EED1", name: "3D Soja 20" }, 
      { hex: "#F5EFD9", name: "3D Soja 25" }, 
      { hex: "#FAF1DF", name: "3D Soja 30" }, 
      { hex: "#585753", name: "3D Tundra 5" }, 
      { hex: "#767266", name: "3D Tundra 10" }, 
      { hex: "#8D877C", name: "3D Tundra 15" }, 
      { hex: "#BBB6A9", name: "3D Tundra 20" }, 
      { hex: "#E4DED0", name: "3D Tundra 25" }, 
      { hex: "#F4ECE0", name: "3D Tundra 30" }, 
      { hex: "#A59F85", name: "3D Tundra 35" }, 
      { hex: "#BDB799", name: "3D Tundra 40" }, 
      { hex: "#CDC7B0", name: "3D Tundra 45" }, 
      { hex: "#DBD6C5", name: "3D Tundra 50" }, 
      { hex: "#F1E9D5", name: "3D Tundra 55" }, 
      { hex: "#F9F4E7", name: "3D Tundra 60" }, 
      { hex: "#525641", name: "3D Tundra 65" }, 
      { hex: "#737359", name: "3D Tundra 70" }, 
      { hex: "#80805C", name: "3D Tundra 75" }, 
      { hex: "#948F62", name: "3D Tundra 80" }, 
      { hex: "#B1AA88", name: "3D Tundra 85" }, 
      { hex: "#DADBBA", name: "3D Tundra 90" }, 
      { hex: "#7A7549", name: "3D Tundra 95" }, 
      { hex: "#847E4B", name: "3D Tundra 100" }, 
      { hex: "#948D54", name: "3D Tundra 105" }, 
      { hex: "#A49D60", name: "3D Tundra 110" }, 
      { hex: "#C0B98A", name: "3D Tundra 115" }, 
      { hex: "#D6CD91", name: "3D Tundra 120" }, 
      { hex: "#9B9A3D", name: "3D Tundra 125" }, 
      { hex: "#C4BD47", name: "3D Tundra 130" }, 
      { hex: "#D2CB49", name: "3D Tundra 135" }, 
      { hex: "#E6DF51", name: "3D Tundra 140" }, 
      { hex: "#F3EA70", name: "3D Tundra 145" }, 
      { hex: "#EDF0B9", name: "3D Tundra 150" }, 
      { hex: "#6B6963", name: "3D Mai 5" }, 
      { hex: "#817C77", name: "3D Mai 10" }, 
      { hex: "#A7A49A", name: "3D Mai 15" }, 
      { hex: "#C4BFB5", name: "3D Mai 20" }, 
      { hex: "#DDD8CD", name: "3D Mai 25" }, 
      { hex: "#F6EFE5", name: "3D Mai 30" }, 
      { hex: "#807D66", name: "3D Mai 35" }, 
      { hex: "#95927D", name: "3D Mai 40" }, 
      { hex: "#B7B29B", name: "3D Mai 45" }, 
      { hex: "#CBC7B0", name: "3D Mai 50" }, 
      { hex: "#E7DFC7", name: "3D Mai 55" }, 
      { hex: "#F8F1DA", name: "3D Mai 60" }, 
      { hex: "#A6AB75", name: "3D Mai 65" }, 
      { hex: "#A9B350", name: "3D Mai 70" }, 
      { hex: "#B5C545", name: "3D Mai 75" }, 
      { hex: "#C5CD5C", name: "3D Mai 80" }, 
      { hex: "#D5DE8C", name: "3D Mai 85" }, 
      { hex: "#F3E782", name: "3D Mai 90" }, 
      { hex: "#AAA9A3", name: "3D Jade 5" }, 
      { hex: "#BAB8B1", name: "3D Jade 10" }, 
      { hex: "#D0CDC6", name: "3D Jade 15" }, 
      { hex: "#D8D4CE", name: "3D Jade 20" }, 
      { hex: "#E1DCD7", name: "3D Jade 25" }, 
      { hex: "#F2ECE8", name: "3D Jade 30" }, 
      { hex: "#8C8C85", name: "3D Jade 35" }, 
      { hex: "#AEACA0", name: "3D Jade 40" }, 
      { hex: "#BCBAAC", name: "3D Jade 45" }, 
      { hex: "#C9C6BD", name: "3D Jade 50" }, 
      { hex: "#D9D5CD", name: "3D Jade 55" }, 
      { hex: "#F1ECE1", name: "3D Jade 60" }, 
      { hex: "#7E7E61", name: "3D Jade 65" }, 
      { hex: "#9E9E89", name: "3D Jade 70" }, 
      { hex: "#B8B8A0", name: "3D Jade 75" }, 
      { hex: "#CBD0AF", name: "3D Jade 80" }, 
      { hex: "#E0DFC4", name: "3D Jade 85" }, 
      { hex: "#F1EDD8", name: "3D Jade 90" }, 
      { hex: "#697049", name: "3D Jade 95" }, 
      { hex: "#99A077", name: "3D Jade 100" }, 
      { hex: "#B4BB8B", name: "3D Jade 105" }, 
      { hex: "#D6D9A9", name: "3D Jade 110" }, 
      { hex: "#DAE1AB", name: "3D Jade 115" }, 
      { hex: "#E7EDA7", name: "3D Jade 120" }, 
      { hex: "#51553D", name: "3D Pinie 5" }, 
      { hex: "#6C6F5B", name: "3D Pinie 10" }, 
      { hex: "#858875", name: "3D Pinie 15" }, 
      { hex: "#A0A191", name: "3D Pinie 20" }, 
      { hex: "#BDBDAF", name: "3D Pinie 25" }, 
      { hex: "#DCDBD0", name: "3D Pinie 30" }, 
      { hex: "#5C6D34", name: "3D Pinie 35" }, 
      { hex: "#778254", name: "3D Pinie 40" }, 
      { hex: "#84986E", name: "3D Pinie 45" }, 
      { hex: "#A5B08C", name: "3D Pinie 50" }, 
      { hex: "#C2C7AA", name: "3D Pinie 55" }, 
      { hex: "#E0E1CA", name: "3D Pinie 60" }, 
      { hex: "#75862D", name: "3D Pinie 65" }, 
      { hex: "#829A4E", name: "3D Pinie 70" }, 
      { hex: "#8DAB69", name: "3D Pinie 75" }, 
      { hex: "#ADBF87", name: "3D Pinie 80" }, 
      { hex: "#C6D0A5", name: "3D Pinie 85" }, 
      { hex: "#DFE6C8", name: "3D Pinie 90" }, 
      { hex: "#70A016", name: "3D Pinie 95" }, 
      { hex: "#8DB044", name: "3D Pinie 100" }, 
      { hex: "#A2BF65", name: "3D Pinie 105" }, 
      { hex: "#B8CB82", name: "3D Pinie 110" }, 
      { hex: "#CEDEA2", name: "3D Pinie 115" }, 
      { hex: "#E4ECC1", name: "3D Pinie 120" }, 
      { hex: "#565851", name: "3D Moos 5" }, 
      { hex: "#71716A", name: "3D Moos 10" }, 
      { hex: "#86857F", name: "3D Moos 15" }, 
      { hex: "#A2A09D", name: "3D Moos 20" }, 
      { hex: "#D4D3CD", name: "3D Moos 25" }, 
      { hex: "#ECE7E1", name: "3D Moos 30" }, 
      { hex: "#8F9381", name: "3D Moos 35" }, 
      { hex: "#A3A697", name: "3D Moos 40" }, 
      { hex: "#B5B4AD", name: "3D Moos 45" }, 
      { hex: "#BBBAAF", name: "3D Moos 50" }, 
      { hex: "#CFCEC6", name: "3D Moos 55" }, 
      { hex: "#E0E1D3", name: "3D Moos 60" }, 
      { hex: "#798367", name: "3D Moos 65" }, 
      { hex: "#95A178", name: "3D Moos 70" }, 
      { hex: "#AAAE99", name: "3D Moos 75" }, 
      { hex: "#C2C8B2", name: "3D Moos 80" }, 
      { hex: "#D2D7BE", name: "3D Moos 85" }, 
      { hex: "#EFEEDD", name: "3D Moos 90" }, 
      { hex: "#82897A", name: "3D Oase 5" }, 
      { hex: "#979E8F", name: "3D Oase 10" }, 
      { hex: "#A5A89D", name: "3D Oase 15" }, 
      { hex: "#C3C7BD", name: "3D Oase 20" }, 
      { hex: "#D7D7CD", name: "3D Oase 25" }, 
      { hex: "#E7E6DF", name: "3D Oase 30" }, 
      { hex: "#474E42", name: "3D Oase 35" }, 
      { hex: "#566051", name: "3D Oase 40" }, 
      { hex: "#717E65", name: "3D Oase 45" }, 
      { hex: "#ADB9A3", name: "3D Oase 50" }, 
      { hex: "#D5D7CD", name: "3D Oase 55" }, 
      { hex: "#EDEEE6", name: "3D Oase 60" }, 
      { hex: "#3F533A", name: "3D Oase 65" }, 
      { hex: "#54684E", name: "3D Oase 70" }, 
      { hex: "#8B9D7E", name: "3D Oase 75" }, 
      { hex: "#C1C9B6", name: "3D Oase 80" }, 
      { hex: "#D1D8C7", name: "3D Oase 85" }, 
      { hex: "#E7E9DC", name: "3D Oase 90" }, 
      { hex: "#3D6037", name: "3D Oase 95" }, 
      { hex: "#54774C", name: "3D Oase 100" }, 
      { hex: "#798A66", name: "3D Oase 105" }, 
      { hex: "#9FC18D", name: "3D Oase 110" }, 
      { hex: "#B5C09B", name: "3D Oase 115" }, 
      { hex: "#E7F3D7", name: "3D Oase 120" }, 
      { hex: "#47783C", name: "3D Oase 125" }, 
      { hex: "#579849", name: "3D Oase 130" }, 
      { hex: "#79A467", name: "3D Oase 135" }, 
      { hex: "#71B552", name: "3D Oase 140" }, 
      { hex: "#8CC468", name: "3D Oase 145" }, 
      { hex: "#ABD891", name: "3D Oase 150" }, 
      { hex: "#72716D", name: "3D Agave 5" }, 
      { hex: "#8F908B", name: "3D Agave 10" }, 
      { hex: "#ABAAA5", name: "3D Agave 15" }, 
      { hex: "#C5C5BF", name: "3D Agave 20" }, 
      { hex: "#D4D5CF", name: "3D Agave 25" }, 
      { hex: "#F0EEE6", name: "3D Agave 30" }, 
      { hex: "#828E7E", name: "3D Agave 35" }, 
      { hex: "#A5AEA1", name: "3D Agave 40" }, 
      { hex: "#C2C7BD", name: "3D Agave 45" }, 
      { hex: "#DBDED4", name: "3D Agave 50" }, 
      { hex: "#F2EAE3", name: "3D Agave 55" }, 
      { hex: "#F4F2EB", name: "3D Agave 60" }, 
      { hex: "#899E82", name: "3D Agave 65" }, 
      { hex: "#9DBE97", name: "3D Agave 70" }, 
      { hex: "#ABBCA7", name: "3D Agave 75" }, 
      { hex: "#C2DBC1", name: "3D Agave 80" }, 
      { hex: "#CFD9CA", name: "3D Agave 85" }, 
      { hex: "#E5E9E1", name: "3D Agave 90" }, 
      { hex: "#508B4E", name: "3D Agave 95" }, 
      { hex: "#78A676", name: "3D Agave 100" }, 
      { hex: "#A2DBAB", name: "3D Agave 105" }, 
      { hex: "#C6E7C1", name: "3D Agave 110" }, 
      { hex: "#DDEDD6", name: "3D Agave 115" }, 
      { hex: "#E8F2E4", name: "3D Agave 120" }, 
      { hex: "#45A454", name: "3D Agave 125" }, 
      { hex: "#69B46E", name: "3D Agave 130" }, 
      { hex: "#6DBD6E", name: "3D Agave 135" }, 
      { hex: "#8CC888", name: "3D Agave 140" }, 
      { hex: "#99D497", name: "3D Agave 145" }, 
      { hex: "#C0ECBC", name: "3D Agave 150" }, 
      { hex: "#4B5247", name: "3D Malachit 5" }, 
      { hex: "#5C6C5F", name: "3D Malachit 10" }, 
      { hex: "#768479", name: "3D Malachit 15" }, 
      { hex: "#939D94", name: "3D Malachit 20" }, 
      { hex: "#B1B8B0", name: "3D Malachit 25" }, 
      { hex: "#D2D8D1", name: "3D Malachit 30" }, 
      { hex: "#2E5941", name: "3D Malachit 35" }, 
      { hex: "#4D7059", name: "3D Malachit 40" }, 
      { hex: "#6C8C76", name: "3D Malachit 45" }, 
      { hex: "#8BA793", name: "3D Malachit 50" }, 
      { hex: "#ABC0B2", name: "3D Malachit 55" }, 
      { hex: "#D2DFD5", name: "3D Malachit 60" }, 
      { hex: "#0D603D", name: "3D Malachit 65" }, 
      { hex: "#467D5D", name: "3D Malachit 70" }, 
      { hex: "#669579", name: "3D Malachit 75" }, 
      { hex: "#86AD95", name: "3D Malachit 80" }, 
      { hex: "#A7C6B2", name: "3D Malachit 85" }, 
      { hex: "#D2E6D7", name: "3D Malachit 90" }, 
      { hex: "#0663C", name: "3D Malachit 95" }, 
      { hex: "#2F8159", name: "3D Malachit 100" }, 
      { hex: "#589B76", name: "3D Malachit 105" }, 
      { hex: "#7DB494", name: "3D Malachit 110" }, 
      { hex: "#A5CFB5", name: "3D Malachit 115" }, 
      { hex: "#D3EEDB", name: "3D Malachit 120" }, 
      { hex: "#858A85", name: "3D Mint 5" }, 
      { hex: "#9EA69F", name: "3D Mint 10" }, 
      { hex: "#BFC7BF", name: "3D Mint 15" }, 
      { hex: "#DBD4CE", name: "3D Mint 20" }, 
      { hex: "#E1E1DC", name: "3D Mint 25" }, 
      { hex: "#F0EDE8", name: "3D Mint 30" }, 
      { hex: "#6A796C", name: "3D Mint 35" }, 
      { hex: "#6A8974", name: "3D Mint 40" }, 
      { hex: "#849E8E", name: "3D Mint 45" }, 
      { hex: "#9CAFA6", name: "3D Mint 50" }, 
      { hex: "#B9C9BE", name: "3D Mint 55" }, 
      { hex: "#E2E8DE", name: "3D Mint 60" }, 
      { hex: "#718C86", name: "3D Patina 5" }, 
      { hex: "#97ABA5", name: "3D Patina 10" }, 
      { hex: "#AAB9B4", name: "3D Patina 15" }, 
      { hex: "#BAC7C2", name: "3D Patina 20" }, 
      { hex: "#D0D5D2", name: "3D Patina 25" }, 
      { hex: "#EFEDEA", name: "3D Patina 30" }, 
      { hex: "#434D4A", name: "3D Patina 35" }, 
      { hex: "#384E4A", name: "3D Patina 40" }, 
      { hex: "#576A66", name: "3D Patina 45" }, 
      { hex: "#83938E", name: "3D Patina 50" }, 
      { hex: "#A7BDB8", name: "3D Patina 55" }, 
      { hex: "#C4D9D3", name: "3D Patina 60" }, 
      { hex: "#1B5048", name: "3D Patina 65" }, 
      { hex: "#56766F", name: "3D Patina 70" }, 
      { hex: "#7B9E94", name: "3D Patina 75" }, 
      { hex: "#9FBDB5", name: "3D Patina 80" }, 
      { hex: "#9CCCC2", name: "3D Patina 85" }, 
      { hex: "#E7EDE8", name: "3D Patina 90" }, 
      { hex: "#56B60", name: "3D Patina 95" }, 
      { hex: "#1F7A6E", name: "3D Patina 100" }, 
      { hex: "#289387", name: "3D Patina 105" }, 
      { hex: "#4F9186", name: "3D Patina 110" }, 
      { hex: "#62B2A3", name: "3D Patina 115" }, 
      { hex: "#6DB3A5", name: "3D Patina 120" }, 
      { hex: "#A7A9A8", name: "3D Verona 5" }, 
      { hex: "#C5C5C2", name: "3D Verona 10" }, 
      { hex: "#CED0CC", name: "3D Verona 15" }, 
      { hex: "#D5D5D3", name: "3D Verona 20" }, 
      { hex: "#E5E4DF", name: "3D Verona 25" }, 
      { hex: "#EEEDE8", name: "3D Verona 30" }, 
      { hex: "#525B5B", name: "3D Verona 35" }, 
      { hex: "#88908F", name: "3D Verona 40" }, 
      { hex: "#ACB2B1", name: "3D Verona 45" }, 
      { hex: "#BCBFBD", name: "3D Verona 50" }, 
      { hex: "#D0D6D5", name: "3D Verona 55" }, 
      { hex: "#E1E6E2", name: "3D Verona 60" }, 
      { hex: "#36575A", name: "3D Verona 65" }, 
      { hex: "#5B7374", name: "3D Verona 70" }, 
      { hex: "#798B8B", name: "3D Verona 75" }, 
      { hex: "#A0ACAC", name: "3D Verona 80" }, 
      { hex: "#C8D6D3", name: "3D Verona 85" }, 
      { hex: "#E0EDE9", name: "3D Verona 90" }, 
      { hex: "#2A767C", name: "3D Verona 95" }, 
      { hex: "#517678", name: "3D Verona 100" }, 
      { hex: "#5C9195", name: "3D Verona 105" }, 
      { hex: "#91ADB0", name: "3D Verona 110" }, 
      { hex: "#A9CCCB", name: "3D Verona 115" }, 
      { hex: "#D1EAE8", name: "3D Verona 120" }, 
      { hex: "#0676E", name: "3D Verona 125" }, 
      { hex: "#07079", name: "3D Verona 130" }, 
      { hex: "#08491", name: "3D Verona 135" }, 
      { hex: "#53A3A8", name: "3D Verona 140" }, 
      { hex: "#81BEC2", name: "3D Verona 145" }, 
      { hex: "#AADDDF", name: "3D Verona 150" }, 
      { hex: "#5D6368", name: "3D Arctis 5" }, 
      { hex: "#787F84", name: "3D Arctis 10" }, 
      { hex: "#979C9F", name: "3D Arctis 15" }, 
      { hex: "#A7B7BA", name: "3D Arctis 20" }, 
      { hex: "#D2D6D7", name: "3D Arctis 25" }, 
      { hex: "#E5E5E4", name: "3D Arctis 30" }, 
      { hex: "#5B747D", name: "3D Arctis 35" }, 
      { hex: "#65737A", name: "3D Arctis 40" }, 
      { hex: "#7E8C91", name: "3D Arctis 45" }, 
      { hex: "#9EA9AC", name: "3D Arctis 50" }, 
      { hex: "#BFC7C8", name: "3D Arctis 55" }, 
      { hex: "#E3E8E7", name: "3D Arctis 60" }, 
      { hex: "#718E97", name: "3D Arctis 65" }, 
      { hex: "#92ACB2", name: "3D Arctis 70" }, 
      { hex: "#9ABAC5", name: "3D Arctis 75" }, 
      { hex: "#C0C8CD", name: "3D Arctis 80" }, 
      { hex: "#BBD6DE", name: "3D Arctis 85" }, 
      { hex: "#CADADE", name: "3D Arctis 90" }, 
      { hex: "#376A79", name: "3D Arctis 95" }, 
      { hex: "#60828F", name: "3D Arctis 100" }, 
      { hex: "#799FAA", name: "3D Arctis 105" }, 
      { hex: "#73B8CD", name: "3D Arctis 110" }, 
      { hex: "#A2C9D5", name: "3D Arctis 115" }, 
      { hex: "#BBDFEC", name: "3D Arctis 120" }, 
      { hex: "#ADB0B4", name: "3D Coelin 5" }, 
      { hex: "#BDC0C3", name: "3D Coelin 10" }, 
      { hex: "#CDCDCF", name: "3D Coelin 15" }, 
      { hex: "#DEDDDC", name: "3D Coelin 20" }, 
      { hex: "#E8E8EA", name: "3D Coelin 25" }, 
      { hex: "#F1F1F2", name: "3D Coelin 30" }, 
      { hex: "#9DA9B2", name: "3D Coelin 35" }, 
      { hex: "#AFB9BF", name: "3D Coelin 40" }, 
      { hex: "#BDC7CC", name: "3D Coelin 45" }, 
      { hex: "#CED4D9", name: "3D Coelin 50" }, 
      { hex: "#DFE4E7", name: "3D Coelin 55" }, 
      { hex: "#E7EEF2", name: "3D Coelin 60" }, 
      { hex: "#7AA1B3", name: "3D Coelin 65" }, 
      { hex: "#85AEC1", name: "3D Coelin 70" }, 
      { hex: "#98BCCE", name: "3D Coelin 75" }, 
      { hex: "#A7C9D9", name: "3D Coelin 80" }, 
      { hex: "#B8D6E5", name: "3D Coelin 85" }, 
      { hex: "#D3E8EF", name: "3D Coelin 90" }, 
      { hex: "#0678B", name: "3D Coelin 95" }, 
      { hex: "#3087A7", name: "3D Coelin 100" }, 
      { hex: "#5BA1C0", name: "3D Coelin 105" }, 
      { hex: "#77BBDB", name: "3D Coelin 110" }, 
      { hex: "#8CCAE6", name: "3D Coelin 115" }, 
      { hex: "#B1D3E2", name: "3D Coelin 120" }, 
      { hex: "#3B4247", name: "3D Pacific 5" }, 
      { hex: "#52585F", name: "3D Pacific 10" }, 
      { hex: "#929AA0", name: "3D Pacific 15" }, 
      { hex: "#B0B4B6", name: "3D Pacific 20" }, 
      { hex: "#C5C4C5", name: "3D Pacific 25" }, 
      { hex: "#DADCDC", name: "3D Pacific 30" }, 
      { hex: "#525765", name: "3D Pacific 35" }, 
      { hex: "#546872", name: "3D Pacific 40" }, 
      { hex: "#727E87", name: "3D Pacific 45" }, 
      { hex: "#B8BDC0", name: "3D Pacific 50" }, 
      { hex: "#CBCED0", name: "3D Pacific 55" }, 
      { hex: "#E2E4E4", name: "3D Pacific 60" }, 
      { hex: "#939DA3", name: "3D Pacific 65" }, 
      { hex: "#9BA9B5", name: "3D Pacific 70" }, 
      { hex: "#9DAAB3", name: "3D Pacific 75" }, 
      { hex: "#B8C5CC", name: "3D Pacific 80" }, 
      { hex: "#DBE3E4", name: "3D Pacific 85" }, 
      { hex: "#E7EDED", name: "3D Pacific 90" }, 
      { hex: "#213A52", name: "3D Pacific 95" }, 
      { hex: "#3E596A", name: "3D Pacific 100" }, 
      { hex: "#7C91A2", name: "3D Pacific 105" }, 
      { hex: "#7B8C9A", name: "3D Pacific 110" }, 
      { hex: "#A5C7D5", name: "3D Pacific 115" }, 
      { hex: "#B8CAD5", name: "3D Pacific 120" }, 
      { hex: "#134A61", name: "3D Pacific 125" }, 
      { hex: "#2E5D75", name: "3D Pacific 130" }, 
      { hex: "#597489", name: "3D Pacific 135" }, 
      { hex: "#7D8EA0", name: "3D Pacific 140" }, 
      { hex: "#90A9BA", name: "3D Pacific 145" }, 
      { hex: "#ABCADC", name: "3D Pacific 150" }, 
      { hex: "#0668C", name: "3D Pacific 155" }, 
      { hex: "#4E7790", name: "3D Pacific 160" }, 
      { hex: "#3D83A9", name: "3D Pacific 165" }, 
      { hex: "#658FA8", name: "3D Pacific 170" }, 
      { hex: "#649EBF", name: "3D Pacific 175" }, 
      { hex: "#9ACCE7", name: "3D Pacific 180" }, 
      { hex: "#323E48", name: "3D Lago 5" }, 
      { hex: "#515C64", name: "3D Lago 10" }, 
      { hex: "#6E767D", name: "3D Lago 15" }, 
      { hex: "#8B9297", name: "3D Lago 20" }, 
      { hex: "#A9ADB1", name: "3D Lago 25" }, 
      { hex: "#CDCFD1", name: "3D Lago 30" }, 
      { hex: "#2C455C", name: "3D Lago 35" }, 
      { hex: "#4D6273", name: "3D Lago 40" }, 
      { hex: "#627D8C", name: "3D Lago 45" }, 
      { hex: "#8C99A5", name: "3D Lago 50" }, 
      { hex: "#ACB7C0", name: "3D Lago 55" }, 
      { hex: "#D1D8DF", name: "3D Lago 60" }, 
      { hex: "#184C6C", name: "3D Lago 65" }, 
      { hex: "#496C85", name: "3D Lago 70" }, 
      { hex: "#6A849B", name: "3D Lago 75" }, 
      { hex: "#879FB1", name: "3D Lago 80" }, 
      { hex: "#AABDCC", name: "3D Lago 85" }, 
      { hex: "#D1DEE8", name: "3D Lago 90" }, 
      { hex: "#D5682", name: "3D Lago 95" }, 
      { hex: "#3D7097", name: "3D Lago 100" }, 
      { hex: "#608BAD", name: "3D Lago 105" }, 
      { hex: "#86A7C2", name: "3D Lago 110" }, 
      { hex: "#A9C4D9", name: "3D Lago 115" }, 
      { hex: "#D5E6F4", name: "3D Lago 120" }, 
      { hex: "#817C87", name: "3D Lazur 5" }, 
      { hex: "#8E939A", name: "3D Lazur 10" }, 
      { hex: "#A6A9AF", name: "3D Lazur 15" }, 
      { hex: "#C3C3C5", name: "3D Lazur 20" }, 
      { hex: "#D4D3D3", name: "3D Lazur 25" }, 
      { hex: "#E9E7E5", name: "3D Lazur 30" }, 
      { hex: "#BFC5CF", name: "3D Lazur 35" }, 
      { hex: "#D0D4DB", name: "3D Lazur 40" }, 
      { hex: "#DFE1E5", name: "3D Lazur 45" }, 
      { hex: "#E6E4E4", name: "3D Lazur 50" }, 
      { hex: "#EBEAEA", name: "3D Lazur 55" }, 
      { hex: "#F1EFEE", name: "3D Lazur 60" }, 
      { hex: "#404C5C", name: "3D Lazur 65" }, 
      { hex: "#4F5867", name: "3D Lazur 70" }, 
      { hex: "#6C7281", name: "3D Lazur 75" }, 
      { hex: "#7F8A9C", name: "3D Lazur 80" }, 
      { hex: "#9EA7B4", name: "3D Lazur 85" }, 
      { hex: "#C2C9D6", name: "3D Lazur 90" }, 
      { hex: "#374A60", name: "3D Lazur 95" }, 
      { hex: "#52627A", name: "3D Lazur 100" }, 
      { hex: "#62728C", name: "3D Lazur 105" }, 
      { hex: "#818EA2", name: "3D Lazur 110" }, 
      { hex: "#A6B5C8", name: "3D Lazur 115" }, 
      { hex: "#BAC8DA", name: "3D Lazur 120" }, 
      { hex: "#2D4F6E", name: "3D Lazur 125" }, 
      { hex: "#4E6584", name: "3D Lazur 130" }, 
      { hex: "#688BAF", name: "3D Lazur 135" }, 
      { hex: "#7B8CA5", name: "3D Lazur 140" }, 
      { hex: "#95A8C5", name: "3D Lazur 145" }, 
      { hex: "#9CAAC0", name: "3D Lazur 150" }, 
      { hex: "#174C76", name: "3D Lazur 155" }, 
      { hex: "#43648B", name: "3D Lazur 160" }, 
      { hex: "#507199", name: "3D Lazur 165" }, 
      { hex: "#6C8DB5", name: "3D Lazur 170" }, 
      { hex: "#90A9D2", name: "3D Lazur 175" }, 
      { hex: "#9FB5D2", name: "3D Lazur 180" }, 
      { hex: "#E5187", name: "3D Lazur 185" }, 
      { hex: "#1C5788", name: "3D Lazur 190" }, 
      { hex: "#5173A2", name: "3D Lazur 195" }, 
      { hex: "#538AC4", name: "3D Lazur 200" }, 
      { hex: "#638CBB", name: "3D Lazur 205" }, 
      { hex: "#759AC3", name: "3D Lazur 210" }, 
      { hex: "#3A414C", name: "3D Saphir 5" }, 
      { hex: "#555B67", name: "3D Saphir 10" }, 
      { hex: "#72767F", name: "3D Saphir 15" }, 
      { hex: "#989199", name: "3D Saphir 20" }, 
      { hex: "#ACADB4", name: "3D Saphir 25" }, 
      { hex: "#DAD1D4", name: "3D Saphir 30" }, 
      { hex: "#34455D", name: "3D Saphir 35" }, 
      { hex: "#565E74", name: "3D Saphir 40" }, 
      { hex: "#747C8E", name: "3D Saphir 45" }, 
      { hex: "#9195A4", name: "3D Saphir 50" }, 
      { hex: "#B0B3C0", name: "3D Saphir 55" }, 
      { hex: "#D4D7DD", name: "3D Saphir 60" }, 
      { hex: "#2E4C71", name: "3D Saphir 65" }, 
      { hex: "#556989", name: "3D Saphir 70" }, 
      { hex: "#75829E", name: "3D Saphir 75" }, 
      { hex: "#959FB6", name: "3D Saphir 80" }, 
      { hex: "#B4BBCC", name: "3D Saphir 85" }, 
      { hex: "#D9DDE7", name: "3D Saphir 90" }, 
      { hex: "#275182", name: "3D Saphir 95" }, 
      { hex: "#556E9A", name: "3D Saphir 100" }, 
      { hex: "#778BB0", name: "3D Saphir 105" }, 
      { hex: "#93A3C0", name: "3D Saphir 110" }, 
      { hex: "#B5C0D7", name: "3D Saphir 115" }, 
      { hex: "#DCE1F0", name: "3D Saphir 120" }, 
      { hex: "#979AA4", name: "3D Aquarell 5" }, 
      { hex: "#B8B8BD", name: "3D Aquarell 10" }, 
      { hex: "#C7C5CB", name: "3D Aquarell 15" }, 
      { hex: "#D6D4D5", name: "3D Aquarell 20" }, 
      { hex: "#E7E4E3", name: "3D Aquarell 25" }, 
      { hex: "#EFEAE8", name: "3D Aquarell 30" }, 
      { hex: "#A2A5B7", name: "3D Aquarell 35" }, 
      { hex: "#ACAEB9", name: "3D Aquarell 40" }, 
      { hex: "#C3C5CE", name: "3D Aquarell 45" }, 
      { hex: "#D4D4D9", name: "3D Aquarell 50" }, 
      { hex: "#EDE2E6", name: "3D Aquarell 55" }, 
      { hex: "#ECEAEB", name: "3D Aquarell 60" }, 
      { hex: "#6A7088", name: "3D Aquarell 65" }, 
      { hex: "#848BA3", name: "3D Aquarell 70" }, 
      { hex: "#9FA7BD", name: "3D Aquarell 75" }, 
      { hex: "#BCC2D6", name: "3D Aquarell 80" }, 
      { hex: "#CDD0E3", name: "3D Aquarell 85" }, 
      { hex: "#E4E8EF", name: "3D Aquarell 90" }, 
      { hex: "#5377B2", name: "3D Aquarell 95" }, 
      { hex: "#6F92CD", name: "3D Aquarell 100" }, 
      { hex: "#9AB1DD", name: "3D Aquarell 105" }, 
      { hex: "#B3C1E1", name: "3D Aquarell 110" }, 
      { hex: "#E1E2EA", name: "3D Aquarell 115" }, 
      { hex: "#EEECEE", name: "3D Aquarell 120" }, 
      { hex: "#8E8D95", name: "3D Lavendel 5" }, 
      { hex: "#A9A7B2", name: "3D Lavendel 10" }, 
      { hex: "#B7B5BF", name: "3D Lavendel 15" }, 
      { hex: "#C7C4CA", name: "3D Lavendel 20" }, 
      { hex: "#D7D4D8", name: "3D Lavendel 25" }, 
      { hex: "#E8E4E7", name: "3D Lavendel 30" }, 
      { hex: "#404047", name: "3D Lavendel 35" }, 
      { hex: "#585760", name: "3D Lavendel 40" }, 
      { hex: "#72717B", name: "3D Lavendel 45" }, 
      { hex: "#9C9BA7", name: "3D Lavendel 50" }, 
      { hex: "#D1C6D2", name: "3D Lavendel 55" }, 
      { hex: "#E8E5EC", name: "3D Lavendel 60" }, 
      { hex: "#454961", name: "3D Lavendel 65" }, 
      { hex: "#61647E", name: "3D Lavendel 70" }, 
      { hex: "#777893", name: "3D Lavendel 75" }, 
      { hex: "#9295B0", name: "3D Lavendel 80" }, 
      { hex: "#9899B1", name: "3D Lavendel 85" }, 
      { hex: "#AFA7C0", name: "3D Lavendel 90" }, 
      { hex: "#535779", name: "3D Lavendel 95" }, 
      { hex: "#75799D", name: "3D Lavendel 100" }, 
      { hex: "#AFB1CC", name: "3D Lavendel 105" }, 
      { hex: "#B4B3C5", name: "3D Lavendel 110" }, 
      { hex: "#D3D0DF", name: "3D Lavendel 115" }, 
      { hex: "#E3E1ED", name: "3D Lavendel 120" }, 
      { hex: "#9095B9", name: "3D Lavendel 125" }, 
      { hex: "#A5A8C8", name: "3D Lavendel 130" }, 
      { hex: "#ABB0D3", name: "3D Lavendel 135" }, 
      { hex: "#BFC0E2", name: "3D Lavendel 140" }, 
      { hex: "#CACBE2", name: "3D Lavendel 145" }, 
      { hex: "#CFD0EB", name: "3D Lavendel 150" }, 
      { hex: "#2D3657", name: "3D Lavendel 155" }, 
      { hex: "#354473", name: "3D Lavendel 160" }, 
      { hex: "#415181", name: "3D Lavendel 165" }, 
      { hex: "#48527D", name: "3D Lavendel 170" }, 
      { hex: "#616CA2", name: "3D Lavendel 175" }, 
      { hex: "#838CBC", name: "3D Lavendel 180" }, 
      { hex: "#393446", name: "3D Velvet 5" }, 
      { hex: "#5D5564", name: "3D Velvet 10" }, 
      { hex: "#78717D", name: "3D Velvet 15" }, 
      { hex: "#958C98", name: "3D Velvet 20" }, 
      { hex: "#B2AEB4", name: "3D Velvet 25" }, 
      { hex: "#D3CFD3", name: "3D Velvet 30" }, 
      { hex: "#403857", name: "3D Velvet 35" }, 
      { hex: "#655A73", name: "3D Velvet 40" }, 
      { hex: "#81778C", name: "3D Velvet 45" }, 
      { hex: "#9A93A3", name: "3D Velvet 50" }, 
      { hex: "#B9B3BD", name: "3D Velvet 55" }, 
      { hex: "#DAD4DB", name: "3D Velvet 60" }, 
      { hex: "#463C65", name: "3D Velvet 65" }, 
      { hex: "#6D6184", name: "3D Velvet 70" }, 
      { hex: "#897D9B", name: "3D Velvet 75" }, 
      { hex: "#A098AF", name: "3D Velvet 80" }, 
      { hex: "#BEB8C7", name: "3D Velvet 85" }, 
      { hex: "#E0D9E3", name: "3D Velvet 90" }, 
      { hex: "#4F457B", name: "3D Velvet 95" }, 
      { hex: "#716592", name: "3D Velvet 100" }, 
      { hex: "#9283A7", name: "3D Velvet 105" }, 
      { hex: "#AA9EBB", name: "3D Velvet 110" }, 
      { hex: "#C7BCD1", name: "3D Velvet 115" }, 
      { hex: "#E7DFEA", name: "3D Velvet 120" }, 
      { hex: "#867985", name: "3D Viola 5" }, 
      { hex: "#A3989F", name: "3D Viola 10" }, 
      { hex: "#BCB4B9", name: "3D Viola 15" }, 
      { hex: "#D9D2D4", name: "3D Viola 20" }, 
      { hex: "#E8E3E0", name: "3D Viola 25" }, 
      { hex: "#F0EBE7", name: "3D Viola 30" }, 
      { hex: "#5A5363", name: "3D Viola 35" }, 
      { hex: "#8A7785", name: "3D Viola 40" }, 
      { hex: "#A794A4", name: "3D Viola 45" }, 
      { hex: "#C3B2BD", name: "3D Viola 50" }, 
      { hex: "#DFD0D7", name: "3D Viola 55" }, 
      { hex: "#F5E9EB", name: "3D Viola 60" }, 
      { hex: "#695067", name: "3D Viola 65" }, 
      { hex: "#785A77", name: "3D Viola 70" }, 
      { hex: "#806A7F", name: "3D Viola 75" }, 
      { hex: "#AA90A8", name: "3D Viola 80" }, 
      { hex: "#C8ADC6", name: "3D Viola 85" }, 
      { hex: "#E7D0DF", name: "3D Viola 90" }, 
      { hex: "#4F3151", name: "3D Viola 95" }, 
      { hex: "#724770", name: "3D Viola 100" }, 
      { hex: "#946092", name: "3D Viola 105" }, 
      { hex: "#886185", name: "3D Viola 110" }, 
      { hex: "#A381A4", name: "3D Viola 115" }, 
      { hex: "#C09EBC", name: "3D Viola 120" }, 
      { hex: "#7E7474", name: "3D Flamenco 5" }, 
      { hex: "#B4A6A9", name: "3D Flamenco 10" }, 
      { hex: "#CFC3C3", name: "3D Flamenco 15" }, 
      { hex: "#DDD3D1", name: "3D Flamenco 20" }, 
      { hex: "#E3DCDB", name: "3D Flamenco 25" }, 
      { hex: "#F2EAE6", name: "3D Flamenco 30" }, 
      { hex: "#816B70", name: "3D Flamenco 35" }, 
      { hex: "#9B888D", name: "3D Flamenco 40" }, 
      { hex: "#AD969B", name: "3D Flamenco 45" }, 
      { hex: "#BAA7AC", name: "3D Flamenco 50" }, 
      { hex: "#D6C5C8", name: "3D Flamenco 55" }, 
      { hex: "#F0E5E2", name: "3D Flamenco 60" }, 
      { hex: "#6B5259", name: "3D Flamenco 65" }, 
      { hex: "#8A6870", name: "3D Flamenco 70" }, 
      { hex: "#A5858D", name: "3D Flamenco 75" }, 
      { hex: "#C0A4A8", name: "3D Flamenco 80" }, 
      { hex: "#D9C0C2", name: "3D Flamenco 85" }, 
      { hex: "#F9E9E7", name: "3D Flamenco 90" }, 
      { hex: "#774F59", name: "3D Flamenco 95" }, 
      { hex: "#955865", name: "3D Flamenco 100" }, 
      { hex: "#AF808D", name: "3D Flamenco 105" }, 
      { hex: "#C89FA7", name: "3D Flamenco 110" }, 
      { hex: "#E4BEC4", name: "3D Flamenco 115" }, 
      { hex: "#FADFE2", name: "3D Flamenco 120" }, 
      { hex: "#893D55", name: "3D Flamenco 125" }, 
      { hex: "#9C4E66", name: "3D Flamenco 130" }, 
      { hex: "#B4687C", name: "3D Flamenco 135" }, 
      { hex: "#D58698", name: "3D Flamenco 140" }, 
      { hex: "#EEA4B9", name: "3D Flamenco 145" }, 
      { hex: "#FBCDD9", name: "3D Flamenco 150" }, 
      { hex: "#122D64", name: "3D Diva 5" }, 
      { hex: "#3A4679", name: "3D Diva 10" }, 
      { hex: "#443466", name: "3D Diva 15" }, 
      { hex: "#51475A", name: "3D Diva 20" }, 
      { hex: "#663065", name: "3D Diva 25" }, 
      { hex: "#85235C", name: "3D Diva 30" }, 
      { hex: "#03C4F", name: "3D Blu 5" }, 
      { hex: "#1D8CA0", name: "3D Blu 10" }, 
      { hex: "#F324A", name: "3D Blu 15" }, 
      { hex: "#04E75", name: "3D Blu 20" }, 
      { hex: "#223D56", name: "3D Blu 25" }, 
      { hex: "#2C5A83", name: "3D Blu 30" }, 
      { hex: "#0453C", name: "3D Peru 5" }, 
      { hex: "#05249", name: "3D Peru 10" }, 
      { hex: "#03C3A", name: "3D Peru 15" }, 
      { hex: "#07170", name: "3D Peru 20" }, 
      { hex: "#0404B", name: "3D Peru 25" }, 
      { hex: "#05F71", name: "3D Peru 30" }, 
      { hex: "#2E4E26", name: "3D Verdo 5" }, 
      { hex: "#378028", name: "3D Verdo 10" }, 
      { hex: "#1D442D", name: "3D Verdo 15" }, 
      { hex: "#06030", name: "3D Verdo 20" }, 
      { hex: "#274841", name: "3D Verdo 25" }, 
      { hex: "#07B5E", name: "3D Verdo 30" }, 
      { hex: "#242121", name: "3D Oliv 5" }, 
      { hex: "#D19A0", name: "3D Oliv 10" }, 
      { hex: "#575534", name: "3D Oliv 15" }, 
      { hex: "#C2AB0", name: "3D Oliv 20" }, 
      { hex: "#878412", name: "3D Oliv 25" }, 
      { hex: "#C7C9B", name: "3D Oliv 30" }, 
      { hex: "#522A26", name: "3D Brasil 5" }, 
      { hex: "#F0770", name: "3D Brasil 10" }, 
      { hex: "#5C3B25", name: "3D Brasil 15" }, 
      { hex: "#B67329", name: "3D Brasil 20" }, 
      { hex: "#4A4030", name: "3D Brasil 25" }, 
      { hex: "#FFBC0", name: "3D Brasil 30" }, 
      { hex: "#52202B", name: "3D Rubin 5" }, 
      { hex: "#B2192D", name: "3D Rubin 10" }, 
      { hex: "#7E2C21", name: "3D Rubin 15" }, 
      { hex: "#AD2419", name: "3D Rubin 20" }, 
      { hex: "#633422", name: "3D Rubin 25" }, 
      { hex: "#CB3E10", name: "3D Rubin 30" }, 
      { hex: "#83163D", name: "3D Pink 5" }, 
      { hex: "#C2416D", name: "3D Pink 10" }, 
      { hex: "#58223C", name: "3D Pink 15" }, 
      { hex: "#B7447C", name: "3D Pink 20" }, 
      { hex: "#623050", name: "3D Pink 25" }, 
      { hex: "#A85491", name: "3D Pink 30" }, 
      { hex: "#583468", name: "3D Laser 5" }, 
      { hex: "#7B2F61", name: "3D Laser 10" }, 
      { hex: "#A42551", name: "3D Laser 15" }, 
      { hex: "#AF1134", name: "3D Laser 20" }, 
      { hex: "#CD2532", name: "3D Laser 25" }, 
      { hex: "#F6510", name: "3D Laser 30" }, 
      { hex: "#FC880", name: "3D Laser 35" }, 
      { hex: "#FAA30", name: "3D Laser 40" }, 
      { hex: "#FDBF0", name: "3D Laser 45" }, 
      { hex: "#EFDC29", name: "3D Laser 50" }, 
      { hex: "#B8C80", name: "3D Laser 55" }, 
      { hex: "#67B21F", name: "3D Laser 60" }, 
      { hex: "#08A33", name: "3D Laser 65" }, 
      { hex: "#0775E", name: "3D Laser 70" }, 
      { hex: "#05C71", name: "3D Laser 75" }, 
      { hex: "#04A80", name: "3D Laser 80" }, 
      { hex: "#03E79", name: "3D Laser 85" }, 
      { hex: "#2E3A76", name: "3D Laser 90" }
    ],
      "Painting the past": [      { hex: "#F4F1E1", name: "NN 21 Muslin" }, 
      { hex: "#C1D9EB", name: "K71 Ice-Blue" }, 
      { hex: "#C0BFB3", name: "NN 02 Monument Grey" }, 
      { hex: "#E9EFEA", name: "NN 16 Pearl Grey" }, 
      { hex: "#92B9B4", name: "SC 71 Mint" }, 
      { hex: "#DFDCCA", name: "SC 06 French Linen" }, 
      { hex: "#DFDFCD", name: "NN 01 Old White" }, 
      { hex: "#FFFAE1", name: "01 Regency White" }, 
      { hex: "#E5F2F7", name: "P80 Something Blue" }, 
      { hex: "#F3E8C4", name: "11 Aubusson Cream" }, 
      { hex: "#FBFCEE", name: "00 Historical White" }, 
      { hex: "#F1E3C1", name: "02 Wheat" }, 
      { hex: "#FAFBEB", name: "NN 10 Paper" }, 
      { hex: "#C9B595", name: "04 Sand" }, 
      { hex: "#B39A73", name: "05 Buff" }, 
      { hex: "#CDBA92", name: "12 Biscuit" }, 
      { hex: "#C0B29C", name: "21 Linen" }, 
      { hex: "#B1A48C", name: "22 Pebble" }, 
      { hex: "#A19179", name: "23 Mud" }, 
      { hex: "#D8D2BB", name: "31 Stone" }, 
      { hex: "#C0B49A", name: "32 Clay" }, 
      { hex: "#DBD9CA", name: "41 Chalk" }, 
      { hex: "#86867A", name: "43 Mauve" }, 
      { hex: "#9E9A88", name: "53 Moss" }, 
      { hex: "#8D7E62", name: "59 Drab" }, 
      { hex: "#B1B5AC", name: "61 Scandinavian Green" }, 
      { hex: "#E1D3B7", name: "03 Dune" }, 
      { hex: "#82887C", name: "62 Bayleaf" }, 
      { hex: "#CFD9D2", name: "71 Dawn" }, 
      { hex: "#99AFAD", name: "72 Eucalyptus" }, 
      { hex: "#798A88", name: "73 Petrol" }, 
      { hex: "#BFCECD", name: "81 Blue-Grey" }, 
      { hex: "#768689", name: "82 Steel" }, 
      { hex: "#B4ACA3", name: "90 Heather" }, 
      { hex: "#8F7165", name: "91 Brick" }, 
      { hex: "#856F6C", name: "92 Aubergine" }, 
      { hex: "#A57A65", name: "93 Red Clay" }, 
      { hex: "#8A5F50", name: "94 Autumn" }, 
      { hex: "#884D48", name: "95 Dining Room Red" }, 
      { hex: "#BCA38B", name: "96 Nutmeg" }, 
      { hex: "#B4B8B3", name: "98 Dutch Grey" }, 
      { hex: "#515555", name: "99 Persian Grey" }, 
      { hex: "#AB9A84", name: "NN 06 Mocha" }, 
      { hex: "#817262", name: "NN 07 Chocolate" }, 
      { hex: "#C5BAA5", name: "NN 11 Calico" }, 
      { hex: "#A6A193", name: "NN 12 Putty" }, 
      { hex: "#6B695D", name: "NN 13 Grime" }, 
      { hex: "#2E3432", name: "NN 14 Soft Black" }, 
      { hex: "#978C7D", name: "NN 15 Truffle" }, 
      { hex: "#E9E4D4", name: "NN 19 Clotted Cream" }, 
      { hex: "#D5CAB7", name: "NN 20 Iced Coffee" }, 
      { hex: "#F6E9DD", name: "NN 91 Rose White" }, 
      { hex: "#BEA599", name: "NN 92 Afternoon Tea" }, 
      { hex: "#818788", name: "NN 99 Hampton Grey" }, 
      { hex: "#E4E9E0", name: "P12 Something Old" }, 
      { hex: "#F6F4E8", name: "SC 01 Cotton White" }, 
      { hex: "#BEAFAD", name: "SC 93 Lily" }, 
      { hex: "#DEE3D4", name: "NN 51 Lime White" }, 
      { hex: "#CBCFB6", name: "NN 52 Green Tea" }, 
      { hex: "#F8F0E3", name: "P14 Something Borrowed" }, 
      { hex: "#9D545F", name: "K34 Ruby Red" }, 
      { hex: "#9FA38A", name: "NN Cottage Green" }, 
      { hex: "#A9A38A", name: "NN 53 Cottage Green" }, 
      { hex: "#BBB6A9", name: "42 Mouse" }, 
      { hex: "#BEB699", name: "52 Gooseberry" }, 
      { hex: "#6B8B87", name: "SC 72 Sapphire" }, 
      { hex: "#4C4948", name: "SC 08 Ebony" }, 
      { hex: "#CCC9BC", name: "NN 22 Canvas" }, 
      { hex: "#9C9E98", name: "NN 18 Loft" }, 
      { hex: "#D1CDBE", name: "P19 Greige" }, 
      { hex: "#A48F97", name: "SC 94 Velvet Plum" }, 
      { hex: "#D0C8B6", name: "20 Soft Linen" }, 
      { hex: "#DDD2C6", name: "P16 Morning Tea" }, 
      { hex: "#AAA592", name: "33 Taupe" }, 
      { hex: "#C5CAC7", name: "NN 17 Cape Cod Grey" }, 
      { hex: "#636662", name: "103 Pewter" }, 
      { hex: "#F4FAF2", name: "S00 Chalk White" }, 
      { hex: "#DFC67D", name: "S09 Mustard" }, 
      { hex: "#B8BEB4", name: "S64 Salix" }, 
      { hex: "#AEB3A3", name: "S65 Verdigris" }, 
      { hex: "#C07E5A", name: "S94 Flower Pot" }
    ],
      "Sikkens 4041": [      { hex: "#988444", name: "F8.41.46" }, 
      { hex: "#A7989C", name: "A0.05.55" }, 
      { hex: "#C8B8BB", name: "A0.05.65" }, 
      { hex: "#E6D4D8", name: "A0.05.75" }, 
      { hex: "#FBEAEB", name: "A0.05.85" }, 
      { hex: "#F6D8DF", name: "A0.07.77" }, 
      { hex: "#C6A3AE", name: "A0.10.60" }, 
      { hex: "#E8BFCC", name: "A0.10.70" }, 
      { hex: "#F9CBD6", name: "A0.10.75" }, 
      { hex: "#DCABBA", name: "A0.15.65" }, 
      { hex: "#E099A3", name: "A8.20.60" }, 
      { hex: "#E7E7E6", name: "AN.01.80" }, 
      { hex: "#E6DEDF", name: "AN.02.77" }, 
      { hex: "#F0EBEC", name: "AN.02.82" }, 
      { hex: "#A99B99", name: "B2.05.55" }, 
      { hex: "#CBB6B7", name: "B2.05.65" }, 
      { hex: "#D5C2C1", name: "B2.05.70" }, 
      { hex: "#F7F4EC", name: "F2.03.84" }, 
      { hex: "#FCFEF7", name: "F2.03.88" }, 
      { hex: "#A3A299", name: "F2.05.55" }, 
      { hex: "#FBF7E7", name: "F2.05.85" }, 
      { hex: "#FEFEEF", name: "F2.05.87" }, 
      { hex: "#FFF1DE", name: "F2.06.84" }, 
      { hex: "#E9D3D2", name: "B2.05.75" }, 
      { hex: "#FCF6DF", name: "F2.08.86" }, 
      { hex: "#B2AA97", name: "F2.10.60" }, 
      { hex: "#F2E3C9", name: "F2.10.80" }, 
      { hex: "#CBA8A7", name: "B2.10.60" }, 
      { hex: "#FFEFC9", name: "F2.15.85" }, 
      { hex: "#E7BEBF", name: "B2.10.70" }, 
      { hex: "#FEDAD9", name: "B2.10.80" }, 
      { hex: "#DA9798", name: "B2.20.60" }, 
      { hex: "#FDEFEC", name: "B6.05.85" }, 
      { hex: "#FCFDF5", name: "F6.03.87" }, 
      { hex: "#EEC4C0", name: "B6.10.70" }, 
      { hex: "#EDEAD7", name: "F6.05.80" }, 
      { hex: "#DD9894", name: "B6.20.60" }, 
      { hex: "#FAFAEB", name: "F6.05.85" }, 
      { hex: "#DDD9C9", name: "F6.06.74" }, 
      { hex: "#F7EFD8", name: "F6.07.82" }, 
      { hex: "#FEF8DC", name: "F6.09.86" }, 
      { hex: "#FDF7F2", name: "C0.03.86" }, 
      { hex: "#EEDEDB", name: "C0.04.78" }, 
      { hex: "#FCEDE9", name: "C0.04.83" }, 
      { hex: "#F7E4B9", name: "F6.15.80" }, 
      { hex: "#FFF2C7", name: "F6.15.85" }, 
      { hex: "#A99A96", name: "C0.05.55" }, 
      { hex: "#C7B5B2", name: "C0.05.65" }, 
      { hex: "#E3D1CD", name: "C0.05.75" }, 
      { hex: "#F3D7D2", name: "C0.07.77" }, 
      { hex: "#FDE6DE", name: "C0.07.82" }, 
      { hex: "#C8A7A1", name: "C0.10.60" }, 
      { hex: "#E7BFB8", name: "C0.10.70" }, 
      { hex: "#FCD5CC", name: "C0.10.80" }, 
      { hex: "#E2ABA2", name: "C0.15.65" }, 
      { hex: "#FAC4BC", name: "C0.15.75" }, 
      { hex: "#DB9A90", name: "C0.20.60" }, 
      { hex: "#FFF2B9", name: "F6.20.83" }, 
      { hex: "#C8BAB3", name: "C4.05.65" }, 
      { hex: "#F9E9B8", name: "F8.15.80" }, 
      { hex: "#FAE9B2", name: "F8.20.80" }, 
      { hex: "#BFBFB8", name: "FN.02.67" }, 
      { hex: "#DCDDD4", name: "FN.02.77" }, 
      { hex: "#F6F6F0", name: "FN.02.85" }, 
      { hex: "#F8F9EF", name: "FN.02.88" }, 
      { hex: "#F8F9EB", name: "G0.03.86" }, 
      { hex: "#F4F2E5", name: "G0.04.84" }, 
      { hex: "#E9E5D6", name: "G0.05.80" }, 
      { hex: "#F8F6E1", name: "G0.05.85" }, 
      { hex: "#FDFDEA", name: "G0.05.88" }, 
      { hex: "#F4EED5", name: "G0.08.84" }, 
      { hex: "#FFFCE2", name: "G0.08.88" }, 
      { hex: "#FAF5D8", name: "G0.09.85" }, 
      { hex: "#E5DDD8", name: "C8.03.78" }, 
      { hex: "#F9EDE6", name: "C8.04.83" }, 
      { hex: "#A89C95", name: "C8.05.55" }, 
      { hex: "#CDB6B0", name: "C8.05.65" }, 
      { hex: "#E1D0C9", name: "C8.05.75" }, 
      { hex: "#FCE8DD", name: "C8.07.82" }, 
      { hex: "#B6A69A", name: "C8.10.60" }, 
      { hex: "#D7C2B5", name: "C8.10.70" }, 
      { hex: "#FFE1D2", name: "C8.10.80" }, 
      { hex: "#ECE3C5", name: "G0.10.80" }, 
      { hex: "#FBF2C2", name: "G0.15.85" }, 
      { hex: "#DEAF9D", name: "C8.15.65" }, 
      { hex: "#F9C8B3", name: "C8.15.75" }, 
      { hex: "#EDE6C0", name: "G1.13.79" }, 
      { hex: "#FAFCF3", name: "G4.03.88" }, 
      { hex: "#FFF6E6", name: "G4.04.84" }, 
      { hex: "#FDFDEC", name: "G4.04.88" }, 
      { hex: "#EBEAD8", name: "G4.05.81" }, 
      { hex: "#EBE8D2", name: "G4.07.80" }, 
      { hex: "#F7F5DA", name: "G4.08.83" }, 
      { hex: "#FEFFE6", name: "G4.08.88" }, 
      { hex: "#F0EED0", name: "G4.10.80" }, 
      { hex: "#FBFBD2", name: "G4.13.85" }, 
      { hex: "#FCF7C5", name: "G4.15.85" }, 
      { hex: "#FFFEFA", name: "CN.01.90" }, 
      { hex: "#FDFEC3", name: "G7.18.87" }, 
      { hex: "#A4A29F", name: "CN.02.57" }, 
      { hex: "#C5BEBB", name: "CN.02.67" }, 
      { hex: "#E5DED9", name: "CN.02.77" }, 
      { hex: "#F5F6E1", name: "G8.06.85" }, 
      { hex: "#FEFEFA", name: "CN.02.88" }, 
      { hex: "#FDFFEF", name: "G8.06.90" }, 
      { hex: "#EEEDC8", name: "G8.10.80" }, 
      { hex: "#F8F6D7", name: "G8.10.85" }, 
      { hex: "#FFF6EC", name: "D2.03.86" }, 
      { hex: "#FFE7DC", name: "D2.05.80" }, 
      { hex: "#F2F5CA", name: "G9.13.85" }, 
      { hex: "#FCFFFC", name: "GN.00.88" }, 
      { hex: "#FBFFFF", name: "GN.01.88" }, 
      { hex: "#FDFFF3", name: "GN.02.90" }, 
      { hex: "#C4AA99", name: "D2.10.60" }, 
      { hex: "#E1C2B0", name: "D2.10.70" }, 
      { hex: "#FCDECE", name: "D2.10.80" }, 
      { hex: "#EDF0E5", name: "H2.03.82" }, 
      { hex: "#FCFFFE", name: "H2.03.90" }, 
      { hex: "#FBFFF2", name: "H2.04.88" }, 
      { hex: "#ECEFD5", name: "H2.08.80" }, 
      { hex: "#FBFFEB", name: "H2.08.90" }, 
      { hex: "#D8B09A", name: "D2.15.65" }, 
      { hex: "#E7EACC", name: "H2.10.80" }, 
      { hex: "#F8FDC9", name: "H2.15.85" }, 
      { hex: "#FACBB1", name: "D2.15.75" }, 
      { hex: "#FFD9C0", name: "D2.15.80" }, 
      { hex: "#DCE3BE", name: "H3.12.78" }, 
      { hex: "#F6FBE5", name: "H4.06.85" }, 
      { hex: "#E6EDD3", name: "H6.06.80" }, 
      { hex: "#F6F9EF", name: "HN.02.85" }, 
      { hex: "#FAFDF7", name: "HN.02.88" }, 
      { hex: "#F8FFF1", name: "J0.04.88" }, 
      { hex: "#FCF8E4", name: "J0.05.85" }, 
      { hex: "#EAF4DC", name: "J0.07.82" }, 
      { hex: "#DEEBCC", name: "J0.10.80" }, 
      { hex: "#E4FDCD", name: "J0.15.85" }, 
      { hex: "#EBE1D8", name: "D6.04.78" }, 
      { hex: "#A49C93", name: "D6.05.55" }, 
      { hex: "#C6BBB1", name: "D6.05.65" }, 
      { hex: "#E4D6CB", name: "D6.05.75" }, 
      { hex: "#FBEEE2", name: "D6.05.85" }, 
      { hex: "#EAF2EA", name: "JN.02.82" }, 
      { hex: "#EED8C8", name: "D6.07.77" }, 
      { hex: "#FBEADB", name: "D6.07.82" }, 
      { hex: "#C0A998", name: "D6.10.60" }, 
      { hex: "#E7C2B0", name: "D6.10.70" }, 
      { hex: "#FDE5D0", name: "D6.10.80" }, 
      { hex: "#EDFAEC", name: "K2.05.85" }, 
      { hex: "#D6B39B", name: "D6.15.65" }, 
      { hex: "#F8D2B8", name: "D6.15.75" }, 
      { hex: "#EEBB9B", name: "D6.20.70" }, 
      { hex: "#BCD2B6", name: "K2.10.70" }, 
      { hex: "#FFEED1", name: "E4.10.85" }, 
      { hex: "#F8FFF9", name: "KN.02.87" }, 
      { hex: "#F3FFF8", name: "L0.03.88" }, 
      { hex: "#E9FBED", name: "L0.05.85" }, 
      { hex: "#CDE7D2", name: "L0.07.77" }, 
      { hex: "#DEF6E2", name: "L0.07.82" }, 
      { hex: "#E4FBEF", name: "L8.05.85" }, 
      { hex: "#F3EDE7", name: "DN.02.82" }, 
      { hex: "#FAF5ED", name: "E0.03.84" }, 
      { hex: "#FEFBF2", name: "E0.03.88" }, 
      { hex: "#BCC5BE", name: "LN.02.67" }, 
      { hex: "#F0FEF9", name: "LN.02.86" }, 
      { hex: "#F5FFFA", name: "LN.02.88" }, 
      { hex: "#BBA897", name: "E0.10.60" }, 
      { hex: "#E0C9B4", name: "E0.10.70" }, 
      { hex: "#FAE4D0", name: "E0.10.80" }, 
      { hex: "#E8FCF8", name: "N0.05.85" }, 
      { hex: "#C6EEE4", name: "N0.10.80" }, 
      { hex: "#D4B69B", name: "E0.15.65" }, 
      { hex: "#F8D2B3", name: "E0.15.75" }, 
      { hex: "#B2C9C4", name: "N1.06.68" }, 
      { hex: "#B2D0CD", name: "N6.08.70" }, 
      { hex: "#F1DECA", name: "E1.09.78" }, 
      { hex: "#FDDEBE", name: "E1.14.79" }, 
      { hex: "#C6D9D7", name: "N7.04.73" }, 
      { hex: "#DECEBA", name: "E3.09.72" }, 
      { hex: "#E8E5DC", name: "E4.03.80" }, 
      { hex: "#CFF6F4", name: "N8.09.81" }, 
      { hex: "#FFF1E3", name: "E4.04.83" }, 
      { hex: "#A29D93", name: "E4.05.55" }, 
      { hex: "#C2B9AD", name: "E4.05.65" }, 
      { hex: "#E0D9CD", name: "E4.05.75" }, 
      { hex: "#FDF6E8", name: "E4.05.85" }, 
      { hex: "#EDF5F3", name: "NN.01.84" }, 
      { hex: "#EBDDCB", name: "E4.07.77" }, 
      { hex: "#F8E9D5", name: "E4.07.82" }, 
      { hex: "#FFE8CE", name: "E4.10.80" }, 
      { hex: "#CECBBD", name: "G0.05.70" }, 
      { hex: "#FFDAAE", name: "E4.20.80" }, 
      { hex: "#FEF0DB", name: "E5.08.84" }, 
      { hex: "#FCF3E0", name: "E6.07.84" }, 
      { hex: "#B7BAB8", name: "ON.00.64" }, 
      { hex: "#D1CACA", name: "ON.00.69" }, 
      { hex: "#D4DADA", name: "ON.00.76" }, 
      { hex: "#DFE3E2", name: "ON.00.78" }, 
      { hex: "#DCEAE9", name: "ON.00.81" }, 
      { hex: "#F0F4F0", name: "ON.00.83" }, 
      { hex: "#F5F7F3", name: "ON.00.86" }, 
      { hex: "#F9FCFA", name: "ON.00.90" }, 
      { hex: "#D0E7E5", name: "P0.04.78" }, 
      { hex: "#ADC1C0", name: "P0.05.65" }, 
      { hex: "#C7DFDC", name: "P0.05.75" }, 
      { hex: "#DEF6F6", name: "P0.05.83" }, 
      { hex: "#C1DCDB", name: "P0.06.74" }, 
      { hex: "#DFF9F8", name: "P0.07.85" }, 
      { hex: "#A9D2CF", name: "P0.10.70" }, 
      { hex: "#C9F3F2", name: "P0.10.80" }, 
      { hex: "#EFE7D9", name: "E8.05.80" }, 
      { hex: "#E8DECC", name: "E8.07.77" }, 
      { hex: "#8FC3C1", name: "P0.15.65" }, 
      { hex: "#A8E4E1", name: "P0.15.75" }, 
      { hex: "#FFE6CF", name: "E8.10.80" }, 
      { hex: "#FFFBE7", name: "F2.07.88" }, 
      { hex: "#8DD8D5", name: "P0.20.70" }, 
      { hex: "#DBEBEA", name: "P1.03.79" }, 
      { hex: "#E9D0AF", name: "E8.15.75" }, 
      { hex: "#FBE3BE", name: "E8.15.80" }, 
      { hex: "#BBDEDD", name: "P4.10.75" }, 
      { hex: "#B6ECF4", name: "P9.14.77" }, 
      { hex: "#F5EDCA", name: "E8.15.85" }, 
      { hex: "#E2F0F0", name: "PN.02.82" }, 
      { hex: "#E3FAFC", name: "Q0.05.84" }, 
      { hex: "#C6F3F7", name: "Q0.09.81" }, 
      { hex: "#ADD0D4", name: "Q0.10.70" }, 
      { hex: "#CAEFF3", name: "Q0.10.80" }, 
      { hex: "#7FBAC2", name: "Q0.20.60" }, 
      { hex: "#99E3EE", name: "Q0.20.73" }, 
      { hex: "#FFDDAD", name: "E8.20.80" }, 
      { hex: "#D5EDF2", name: "Q5.06.80" }, 
      { hex: "#C1E5EE", name: "Q5.10.76" }, 
      { hex: "#D2F3FC", name: "Q6.09.81" }, 
      { hex: "#CCF1FA", name: "Q6.10.80" }, 
      { hex: "#B3E7F6", name: "Q7.15.76" }, 
      { hex: "#B8DFEB", name: "Q9.12.74" }, 
      { hex: "#FFFFFF", name: "QN.02.88" }, 
      { hex: "#E3F6FB", name: "R0.05.85" }, 
      { hex: "#CBEAF4", name: "R0.10.80" }, 
      { hex: "#86B2CB", name: "R0.13.77" }, 
      { hex: "#8ED3E8", name: "R0.20.70" }, 
      { hex: "#B3DCED", name: "R1.17.73" }, 
      { hex: "#94D9F1", name: "R1.23.72" }, 
      { hex: "#A2DEF5", name: "R2.20.73" }, 
      { hex: "#8BC8DF", name: "R2.22.66" }, 
      { hex: "#7ED2F2", name: "R2.29.68" }, 
      { hex: "#98D2EF", name: "R7.22.69" }, 
      { hex: "#F8F7F1", name: "EN.02.85" }, 
      { hex: "#FCFCF4", name: "EN.02.87" }, 
      { hex: "#FBFBF0", name: "EN.02.88" }, 
      { hex: "#FEFDF7", name: "EN.02.90" }, 
      { hex: "#ACBBC1", name: "S0.05.65" }, 
      { hex: "#CADBE0", name: "S0.05.75" }, 
      { hex: "#E4F6FE", name: "S0.05.85" }, 
      { hex: "#FFF2D8", name: "F0.10.85" }, 
      { hex: "#CCE4EE", name: "S0.07.77" }, 
      { hex: "#9BB2BE", name: "S0.10.60" }, 
      { hex: "#BAD3DF", name: "S0.10.70" }, 
      { hex: "#D8EEFD", name: "S0.10.80" }, 
      { hex: "#E5D2AF", name: "F0.15.75" }, 
      { hex: "#FBE4B6", name: "F0.17.80" }, 
      { hex: "#83A3B4", name: "S0.15.55" }, 
      { hex: "#9CC0D3", name: "S0.15.65" }, 
      { hex: "#BDEAFC", name: "S0.15.80" }, 
      { hex: "#FCE1B1", name: "F0.20.80" }, 
      { hex: "#BADBEE", name: "S1.13.73" }, 
      { hex: "#D4EBF8", name: "S2.07.80" }, 
      { hex: "#B6D1E0", name: "S2.10.71" }, 
      { hex: "#CCE2F3", name: "S6.09.77" }, 
      { hex: "#BEDFF7", name: "S6.14.75" }, 
      { hex: "#99C6E9", name: "S6.21.66" }, 
      { hex: "#B0D6F5", name: "S7.17.72" }, 
      { hex: "#8CB1CE", name: "S7.19.60" }, 
      { hex: "#A4BBCC", name: "S8.10.65" }, 
      { hex: "#8BA1B2", name: "S8.12.55" }, 
      { hex: "#AFC8DD", name: "S8.12.68" }, 
      { hex: "#BAC3C5", name: "SN.02.67" }, 
      { hex: "#D5E0E3", name: "SN.02.77" }, 
      { hex: "#E5EFF1", name: "SN.02.82" }, 
      { hex: "#F0FBFE", name: "SN.02.85" }, 
      { hex: "#D8EBFD", name: "T0.10.80" }, 
      { hex: "#89B0D1", name: "T0.20.60" }, 
      { hex: "#A4CCEF", name: "T0.20.70" }, 
      { hex: "#D5E5F4", name: "T3.06.78" }, 
      { hex: "#C5D6EF", name: "T8.10.73" }, 
      { hex: "#E6F1F6", name: "TN.02.82" }, 
      { hex: "#ECF4F8", name: "U0.04.84" }, 
      { hex: "#B2BCC9", name: "U0.05.65" }, 
      { hex: "#D3DDE8", name: "U0.05.75" }, 
      { hex: "#BDCDE6", name: "U0.10.70" }, 
      { hex: "#A2B9DC", name: "U0.15.65" }, 
      { hex: "#AAC4ED", name: "U0.20.70" }, 
      { hex: "#A1B9EB", name: "U3.19.64" }, 
      { hex: "#B4C9ED", name: "U3.20.64" }, 
      { hex: "#DAE1E8", name: "UN.02.77" }, 
      { hex: "#ECF3FB", name: "UN.02.82" }, 
      { hex: "#F1F9FE", name: "UN.02.85" }, 
      { hex: "#E3E9FC", name: "V0.07.80" }, 
      { hex: "#B2BEE1", name: "V0.15.65" }, 
      { hex: "#C8CDE7", name: "V2.08.71" }, 
      { hex: "#E6F6FE", name: "VN.02.85" }, 
      { hex: "#F4F3FA", name: "W0.03.84" }, 
      { hex: "#DFE0EE", name: "W0.04.78" }, 
      { hex: "#9B9BAA", name: "W0.05.55" }, 
      { hex: "#B8B8C8", name: "W0.05.65" }, 
      { hex: "#E2D7EC", name: "W0.05.75" }, 
      { hex: "#E5D8F2", name: "W0.07.77" }, 
      { hex: "#CBC9E3", name: "W0.08.71" }, 
      { hex: "#B8B2DF", name: "W0.15.65" }, 
      { hex: "#F3EAF7", name: "W1.03.81" }, 
      { hex: "#EEF0F8", name: "WN.02.82" }, 
      { hex: "#B5A7C3", name: "X0.10.60" }, 
      { hex: "#D1C0DF", name: "X0.10.70" }, 
      { hex: "#E1D9E6", name: "X6.04.76" }, 
      { hex: "#D0C1D5", name: "X7.07.69" }, 
      { hex: "#B99FBE", name: "X7.13.58" }, 
      { hex: "#D5AFDA", name: "X7.16.66" }, 
      { hex: "#ECE4F0", name: "X9.04.79" }, 
      { hex: "#EFE0F1", name: "X9.06.79" }, 
      { hex: "#E8CDE8", name: "X9.11.74" }, 
      { hex: "#F4F3F6", name: "YN.01.83" }, 
      { hex: "#E0DDDF", name: "YN.02.77" }, 
      { hex: "#F1EBF2", name: "YN.02.82" }, 
      { hex: "#C0BBDF", name: "V9.11.69" }, 
      { hex: "#F2F2F3", name: "ZN.01.83" }, 
      { hex: "#B6D9F6", name: "S8.16.73" }, 
      { hex: "#BDD7EF", name: "T0.12.73" }, 
      { hex: "#D5E5F5", name: "T3.06.80" }, 
      { hex: "#D2E2F4", name: "T7.07.77" }, 
      { hex: "#C4D4EE", name: "U2.09.75" }, 
      { hex: "#B6C2D3", name: "T9.07.67" }, 
      { hex: "#C3D0ED", name: "U4.10.72" }, 
      { hex: "#C9D1E5", name: "U6.06.73" }, 
      { hex: "#DCE4F2", name: "U7.03.81" }, 
      { hex: "#D5DBEB", name: "U9.05.75" }, 
      { hex: "#EAECF4", name: "V7.03.81" }, 
      { hex: "#CEDCE5", name: "S7.05.75" }, 
      { hex: "#D0CFEA", name: "V9.08.73" }, 
      { hex: "#C1E3F5", name: "S0.11.78" }, 
      { hex: "#D3CEE0", name: "W6.05.72" }, 
      { hex: "#B9B3C4", name: "W8.05.63" }, 
      { hex: "#E7E2EF", name: "X0.04.80" }, 
      { hex: "#F3F3F8", name: "XN.01.83" }, 
      { hex: "#F2F2F4", name: "XN.01.84" }, 
      { hex: "#E2CBE1", name: "Y1.08.73" }, 
      { hex: "#E1BFD2", name: "Z1.10.70" }, 
      { hex: "#EEBCD7", name: "Z1.14.71" }, 
      { hex: "#F7DFEA", name: "Z2.06.81" }, 
      { hex: "#F2CAD9", name: "Z4.09.76" }, 
      { hex: "#EFDBDF", name: "Z8.05.81" }, 
      { hex: "#F8CCDB", name: "Z8.11.75" }, 
      { hex: "#F8CCD5", name: "Z9.10.77" }, 
      { hex: "#E1E3F1", name: "V8.04.79" }, 
      { hex: "#CBF1BE", name: "K0.19.78" }, 
      { hex: "#C0B9B9", name: "AN.02.65" }, 
      { hex: "#EFE8E7", name: "AN.02.80" }, 
      { hex: "#F9D8D7", name: "B3.07.78" }, 
      { hex: "#FED9D5", name: "B5.08.80" }, 
      { hex: "#E4ACA8", name: "B6.15.65" }, 
      { hex: "#FFE4DF", name: "B7.06.83" }, 
      { hex: "#FDDED5", name: "C0.08.80" }, 
      { hex: "#FCD4C8", name: "C1.10.79" }, 
      { hex: "#FFE5CF", name: "D7.10.82" }, 
      { hex: "#E0D5C5", name: "E5.05.77" }, 
      { hex: "#FBE6AD", name: "F5.20.80" }, 
      { hex: "#CCCAAF", name: "G4.10.70" }, 
      { hex: "#AEBCC5", name: "S8.05.65" }, 
      { hex: "#E9FDDF", name: "K0.09.85" }, 
      { hex: "#D7DCF3", name: "U3.07.78" }, 
      { hex: "#D3E9CF", name: "K2.09.79" }, 
      { hex: "#D3FBE1", name: "L3.10.82" }, 
      { hex: "#A6E1BE", name: "L3.17.75" }, 
      { hex: "#BEF0D6", name: "L9.13.79" }, 
      { hex: "#B8F4D7", name: "L9.17.79" }, 
      { hex: "#D7FCEC", name: "M5.09.83" }, 
      { hex: "#E1FDF4", name: "M8.06.85" }, 
      { hex: "#C9F5E9", name: "M8.11.81" }, 
      { hex: "#BBECDE", name: "N0.12.78" }, 
      { hex: "#D0F3F2", name: "P2.11.80" }, 
      { hex: "#96E2E2", name: "P2.20.73" }, 
      { hex: "#C9DEE0", name: "P9.05.75" }, 
      { hex: "#B7E5F5", name: "R4.14.80" }, 
      { hex: "#DAF3CE", name: "J6.11.83" }, 
      { hex: "#E0EEFF", name: "T9.07.82" }, 
      { hex: "#EBFAFF", name: "S7.04.85" }, 
      { hex: "#AACCEE", name: "T2.17.69" }, 
      { hex: "#FED8EE", name: "Z1.10.80" }, 
      { hex: "#D2CFE0", name: "W0.05.70" }, 
      { hex: "#CCD1C4", name: "H3.04.72" }, 
      { hex: "#A4C8E8", name: "S9.18.69" }, 
      { hex: "#A0E3BC", name: "L5.21.73" }, 
      { hex: "#95ADAE", name: "P5.08.58" }, 
      { hex: "#99E4C8", name: "M2.20.75" }, 
      { hex: "#B1BEB1", name: "K1.05.65" }, 
      { hex: "#9ADFCF", name: "M8.19.72" }, 
      { hex: "#ADBFE1", name: "U3.14.67" }, 
      { hex: "#83CAE6", name: "R5.23.70" }, 
      { hex: "#A29D9D", name: "AN.02.55" }, 
      { hex: "#8FC1EE", name: "S9.25.65" }, 
      { hex: "#C2C8E5", name: "V0.10.70" }, 
      { hex: "#96C1ED", name: "T3.23.65" }, 
      { hex: "#E3A2B7", name: "Z8.18.63" }, 
      { hex: "#C7AAC7", name: "Y0.12.63" }, 
      { hex: "#E2B2C4", name: "Z9.16.68" }, 
      { hex: "#A1A7A5", name: "ON.00.58" }, 
      { hex: "#444140", name: "A0.05.15" }, 
      { hex: "#574F50", name: "A0.05.25" }, 
      { hex: "#514448", name: "A0.10.20" }, 
      { hex: "#4C3439", name: "A0.20.12" }, 
      { hex: "#653E47", name: "A0.20.20" }, 
      { hex: "#794C5D", name: "A0.20.30" }, 
      { hex: "#693546", name: "A0.30.20" }, 
      { hex: "#85485E", name: "A0.30.30" }, 
      { hex: "#463536", name: "A6.25.05" }, 
      { hex: "#764C4D", name: "B1.16.12" }, 
      { hex: "#534443", name: "B2.10.20" }, 
      { hex: "#5F4C4C", name: "B2.10.25" }, 
      { hex: "#615D4F", name: "F2.10.30" }, 
      { hex: "#8B7F67", name: "F2.15.45" }, 
      { hex: "#655A43", name: "F2.20.30" }, 
      { hex: "#5F4041", name: "B2.20.20" }, 
      { hex: "#897348", name: "F2.30.40" }, 
      { hex: "#754B4D", name: "B2.20.30" }, 
      { hex: "#AE8B44", name: "F2.40.50" }, 
      { hex: "#AF8738", name: "F2.50.50" }, 
      { hex: "#C3983C", name: "F2.50.55" }, 
      { hex: "#C7A23E", name: "F2.50.60" }, 
      { hex: "#E3B045", name: "F2.50.65" }, 
      { hex: "#67373A", name: "B2.30.20" }, 
      { hex: "#B84D5B", name: "B2.40.40" }, 
      { hex: "#AB3C47", name: "B3.49.33" }, 
      { hex: "#764C4A", name: "B6.20.30" }, 
      { hex: "#894E4F", name: "B6.30.30" }, 
      { hex: "#C0454D", name: "B6.50.40" }, 
      { hex: "#57524F", name: "C0.05.25" }, 
      { hex: "#534945", name: "C0.10.20" }, 
      { hex: "#5E573F", name: "F6.20.30" }, 
      { hex: "#77524B", name: "C0.20.30" }, 
      { hex: "#643933", name: "C0.30.20" }, 
      { hex: "#7D4740", name: "C0.30.30" }, 
      { hex: "#713731", name: "C0.40.20" }, 
      { hex: "#914542", name: "C0.40.30" }, 
      { hex: "#72342F", name: "C0.45.20" }, 
      { hex: "#78312E", name: "C0.48.20" }, 
      { hex: "#9B3C39", name: "C0.50.30" }, 
      { hex: "#C14741", name: "C0.50.40" }, 
      { hex: "#A33032", name: "C0.60.30" }, 
      { hex: "#81362F", name: "C2.50.25" }, 
      { hex: "#C44D42", name: "C2.53.40" }, 
      { hex: "#685C3B", name: "F6.30.30" }, 
      { hex: "#8F3430", name: "C2.60.25" }, 
      { hex: "#A53F35", name: "C3.57.31" }, 
      { hex: "#4C4845", name: "C4.05.20" }, 
      { hex: "#86733E", name: "F6.40.40" }, 
      { hex: "#A08840", name: "F6.40.50" }, 
      { hex: "#7D5348", name: "C4.20.30" }, 
      { hex: "#EEC544", name: "F6.50.70" }, 
      { hex: "#FFCE3F", name: "F6.55.75" }, 
      { hex: "#855247", name: "C4.30.30" }, 
      { hex: "#BDA042", name: "F8.45.55" }, 
      { hex: "#63372C", name: "C4.35.15" }, 
      { hex: "#733B30", name: "C4.40.20" }, 
      { hex: "#964638", name: "C4.40.30" }, 
      { hex: "#B15948", name: "C4.40.40" }, 
      { hex: "#CD6C55", name: "C4.40.50" }, 
      { hex: "#ED7860", name: "C4.43.54" }, 
      { hex: "#DE6C54", name: "C4.46.50" }, 
      { hex: "#A44B3D", name: "C4.49.33" }, 
      { hex: "#9E3F34", name: "C4.50.30" }, 
      { hex: "#BB5241", name: "C4.50.40" }, 
      { hex: "#E06251", name: "C4.50.50" }, 
      { hex: "#93382B", name: "C4.55.30" }, 
      { hex: "#C1462E", name: "C4.55.40" }, 
      { hex: "#9F382E", name: "C4.60.30" }, 
      { hex: "#C94437", name: "C4.60.40" }, 
      { hex: "#AF392E", name: "C4.75.30" }, 
      { hex: "#FA8566", name: "C5.43.58" }, 
      { hex: "#D65E3E", name: "C6.49.48" }, 
      { hex: "#534841", name: "C8.10.20" }, 
      { hex: "#64564E", name: "C8.10.30" }, 
      { hex: "#5F5A42", name: "G0.20.30" }, 
      { hex: "#62443B", name: "C8.20.20" }, 
      { hex: "#6F5043", name: "C8.20.30" }, 
      { hex: "#938F45", name: "G0.40.50" }, 
      { hex: "#634336", name: "C8.30.20" }, 
      { hex: "#815444", name: "C8.30.30" }, 
      { hex: "#74714B", name: "G4.25.35" }, 
      { hex: "#6C3D30", name: "C8.40.20" }, 
      { hex: "#864C39", name: "C8.40.30" }, 
      { hex: "#9C9344", name: "G4.40.50" }, 
      { hex: "#AC6046", name: "C8.40.40" }, 
      { hex: "#D4724F", name: "C8.40.50" }, 
      { hex: "#F28865", name: "C8.40.60" }, 
      { hex: "#D5CB49", name: "G4.50.70" }, 
      { hex: "#F07B56", name: "C8.45.55" }, 
      { hex: "#914732", name: "C8.50.30" }, 
      { hex: "#BE583B", name: "C8.50.40" }, 
      { hex: "#F7E652", name: "G4.50.80" }, 
      { hex: "#DF6E4C", name: "C8.50.50" }, 
      { hex: "#9E3F2C", name: "C8.60.30" }, 
      { hex: "#5D5F4F", name: "G8.10.30" }, 
      { hex: "#5C5E44", name: "G8.20.30" }, 
      { hex: "#B95530", name: "D1.58.40" }, 
      { hex: "#B3B383", name: "G8.20.60" }, 
      { hex: "#787A4B", name: "G8.30.40" }, 
      { hex: "#7A7C3D", name: "G8.40.40" }, 
      { hex: "#8A944C", name: "G8.40.50" }, 
      { hex: "#8C9536", name: "G8.50.50" }, 
      { hex: "#ACB043", name: "G8.50.60" }, 
      { hex: "#CDCE49", name: "G8.50.70" }, 
      { hex: "#584C42", name: "D2.10.25" }, 
      { hex: "#4B3D34", name: "D2.15.15" }, 
      { hex: "#59483D", name: "D2.15.25" }, 
      { hex: "#515648", name: "H2.12.25" }, 
      { hex: "#5A6043", name: "H2.25.30" }, 
      { hex: "#745645", name: "D2.20.30" }, 
      { hex: "#91994D", name: "H2.40.50" }, 
      { hex: "#7F893D", name: "H2.45.45" }, 
      { hex: "#CEDF66", name: "H2.45.75" }, 
      { hex: "#8B9538", name: "H2.50.50" }, 
      { hex: "#A5B242", name: "H2.50.60" }, 
      { hex: "#C1D24C", name: "H2.50.70" }, 
      { hex: "#B2C53D", name: "H2.55.65" }, 
      { hex: "#6E5541", name: "D2.25.30" }, 
      { hex: "#7D5540", name: "D2.30.30" }, 
      { hex: "#A06B4E", name: "D2.30.40" }, 
      { hex: "#B07150", name: "D2.35.45" }, 
      { hex: "#A26344", name: "D2.40.40" }, 
      { hex: "#434D3A", name: "J0.20.20" }, 
      { hex: "#556046", name: "J0.20.30" }, 
      { hex: "#F09465", name: "D2.40.60" }, 
      { hex: "#8F4D32", name: "D2.50.30" }, 
      { hex: "#56643F", name: "J0.30.30" }, 
      { hex: "#F3844F", name: "D2.50.55" }, 
      { hex: "#E35D20", name: "D3.71.48" }, 
      { hex: "#687B4E", name: "J0.30.40" }, 
      { hex: "#667D41", name: "J0.40.40" }, 
      { hex: "#779348", name: "J0.40.50" }, 
      { hex: "#644635", name: "D4.30.20" }, 
      { hex: "#EF742F", name: "D5.63.53" }, 
      { hex: "#54514B", name: "D6.05.25" }, 
      { hex: "#85CE63", name: "J8.48.64" }, 
      { hex: "#544C43", name: "D6.10.20" }, 
      { hex: "#5D4F42", name: "D6.15.25" }, 
      { hex: "#434D43", name: "K2.10.20" }, 
      { hex: "#566255", name: "K2.10.30" }, 
      { hex: "#554537", name: "D6.20.20" }, 
      { hex: "#6D5542", name: "D6.20.30" }, 
      { hex: "#765742", name: "D6.25.30" }, 
      { hex: "#4E644C", name: "K2.20.30" }, 
      { hex: "#5D4535", name: "D6.30.20" }, 
      { hex: "#4C6948", name: "K2.30.30" }, 
      { hex: "#7C573F", name: "D6.30.30" }, 
      { hex: "#8B6746", name: "D6.30.40" }, 
      { hex: "#7F5136", name: "D6.40.30" }, 
      { hex: "#9E6139", name: "D6.40.40" }, 
      { hex: "#54814C", name: "K2.40.40" }, 
      { hex: "#4D8846", name: "K2.50.40" }, 
      { hex: "#F89654", name: "D6.47.61" }, 
      { hex: "#8C5130", name: "D6.50.30" }, 
      { hex: "#A55F34", name: "D6.50.40" }, 
      { hex: "#CC7640", name: "D6.50.50" }, 
      { hex: "#396C3D", name: "K6.50.30" }, 
      { hex: "#F58E49", name: "D6.50.60" }, 
      { hex: "#55645A", name: "L0.10.30" }, 
      { hex: "#354137", name: "L0.15.15" }, 
      { hex: "#484E42", name: "L0.15.20" }, 
      { hex: "#F88539", name: "D6.58.58" }, 
      { hex: "#AE5E2C", name: "D6.60.40" }, 
      { hex: "#D46F2E", name: "D6.60.50" }, 
      { hex: "#324539", name: "L0.20.15" }, 
      { hex: "#3B5040", name: "L0.20.20" }, 
      { hex: "#3D6546", name: "L0.30.30" }, 
      { hex: "#304F3A", name: "L0.35.20" }, 
      { hex: "#447A53", name: "L0.40.35" }, 
      { hex: "#448255", name: "L0.40.40" }, 
      { hex: "#317142", name: "L0.50.30" }, 
      { hex: "#3B8951", name: "L0.50.40" }, 
      { hex: "#3F6954", name: "L8.30.30" }, 
      { hex: "#316C50", name: "L8.40.30" }, 
      { hex: "#337A5A", name: "L8.40.35" }, 
      { hex: "#545149", name: "E0.05.25" }, 
      { hex: "#226B4B", name: "L8.50.30" }, 
      { hex: "#2F895D", name: "L8.50.40" }, 
      { hex: "#3E4C47", name: "N0.10.20" }, 
      { hex: "#2E3C37", name: "N0.15.10" }, 
      { hex: "#294F47", name: "N0.20.20" }, 
      { hex: "#1F5549", name: "N0.40.20" }, 
      { hex: "#236C5F", name: "N0.40.30" }, 
      { hex: "#6C5540", name: "E0.20.30" }, 
      { hex: "#806448", name: "E0.25.35" }, 
      { hex: "#08873", name: "N0.50.40" }, 
      { hex: "#614731", name: "E0.30.20" }, 
      { hex: "#78593D", name: "E0.30.30" }, 
      { hex: "#946B46", name: "E0.30.40" }, 
      { hex: "#7B5736", name: "E0.40.30" }, 
      { hex: "#A16D3D", name: "E0.40.40" }, 
      { hex: "#BE7E4A", name: "E0.40.50" }, 
      { hex: "#885B33", name: "E0.45.30" }, 
      { hex: "#CA8747", name: "E0.45.55" }, 
      { hex: "#83542F", name: "E0.48.30" }, 
      { hex: "#A46434", name: "E0.50.40" }, 
      { hex: "#EF9249", name: "E0.50.60" }, 
      { hex: "#D2792F", name: "E0.60.50" }, 
      { hex: "#4B4B45", name: "E4.05.20" }, 
      { hex: "#54534E", name: "E4.05.25" }, 
      { hex: "#6C6962", name: "E4.05.35" }, 
      { hex: "#625A4E", name: "E4.10.30" }, 
      { hex: "#393D39", name: "ON.00.10" }, 
      { hex: "#3C3E3D", name: "ON.00.15" }, 
      { hex: "#515452", name: "ON.00.26" }, 
      { hex: "#5B5041", name: "E4.15.25" }, 
      { hex: "#5E615E", name: "ON.00.31" }, 
      { hex: "#67543E", name: "E4.20.30" }, 
      { hex: "#725C42", name: "E4.25.30" }, 
      { hex: "#7B6548", name: "E4.25.35" }, 
      { hex: "#574833", name: "E4.30.20" }, 
      { hex: "#715A3E", name: "E4.30.30" }, 
      { hex: "#926F46", name: "E4.30.40" }, 
      { hex: "#B88659", name: "E4.30.50" }, 
      { hex: "#785835", name: "E4.40.30" }, 
      { hex: "#926A3F", name: "E4.40.40" }, 
      { hex: "#BD8749", name: "E4.40.50" }, 
      { hex: "#9D6933", name: "E4.50.40" }, 
      { hex: "#BF813A", name: "E4.50.50" }, 
      { hex: "#E59740", name: "E4.50.60" }, 
      { hex: "#C47A2C", name: "E4.60.50" }, 
      { hex: "#4B5553", name: "P0.05.25" }, 
      { hex: "#484D4B", name: "P0.10.20" }, 
      { hex: "#534C3F", name: "E8.10.25" }, 
      { hex: "#344F4C", name: "P0.20.20" }, 
      { hex: "#2B5C59", name: "P0.30.25" }, 
      { hex: "#316865", name: "P0.30.30" }, 
      { hex: "#1B6F6D", name: "P0.40.30" }, 
      { hex: "#06C6A", name: "P0.50.30" }, 
      { hex: "#08B88", name: "P0.50.40" }, 
      { hex: "#3B4848", name: "Q0.10.20" }, 
      { hex: "#354F51", name: "Q0.20.20" }, 
      { hex: "#295155", name: "Q0.30.20" }, 
      { hex: "#33686E", name: "Q0.30.30" }, 
      { hex: "#7C6849", name: "E8.25.35" }, 
      { hex: "#1D5257", name: "Q0.40.20" }, 
      { hex: "#19535A", name: "Q0.50.20" }, 
      { hex: "#0707B", name: "Q0.50.30" }, 
      { hex: "#705D3E", name: "E8.30.30" }, 
      { hex: "#8D724B", name: "E8.30.40" }, 
      { hex: "#2A4146", name: "R0.20.15" }, 
      { hex: "#376875", name: "R0.30.30" }, 
      { hex: "#206678", name: "R0.40.30" }, 
      { hex: "#C59A5D", name: "E8.35.55" }, 
      { hex: "#06B82", name: "R0.50.30" }, 
      { hex: "#906E3C", name: "E8.40.40" }, 
      { hex: "#0799C", name: "R6.56.36" }, 
      { hex: "#AB873C", name: "E8.50.50" }, 
      { hex: "#D89B3B", name: "E8.50.60" }, 
      { hex: "#AF782E", name: "E8.55.45" }, 
      { hex: "#E6972B", name: "E8.60.60" }, 
      { hex: "#3C494D", name: "S0.10.20" }, 
      { hex: "#384E57", name: "S0.20.20" }, 
      { hex: "#1E4F65", name: "S0.40.20" }, 
      { hex: "#883AF", name: "S0.50.40" }, 
      { hex: "#2C5B73", name: "S1.37.25" }, 
      { hex: "#3A474F", name: "S8.14.17" }, 
      { hex: "#116291", name: "S8.48.28" }, 
      { hex: "#3E494F", name: "T0.10.20" }, 
      { hex: "#2B4E5E", name: "S0.30.20" }, 
      { hex: "#394D5E", name: "T0.20.20" }, 
      { hex: "#3B556B", name: "T0.25.25" }, 
      { hex: "#2A4D66", name: "T0.30.20" }, 
      { hex: "#3D627F", name: "T0.30.30" }, 
      { hex: "#29638B", name: "T0.40.30" }, 
      { hex: "#225476", name: "T0.45.20" }, 
      { hex: "#2770A2", name: "T0.45.35" }, 
      { hex: "#C6498", name: "T0.50.30" }, 
      { hex: "#135686", name: "T2.47.24" }, 
      { hex: "#275C85", name: "T4.40.30" }, 
      { hex: "#3F4851", name: "U0.10.20" }, 
      { hex: "#3A4A5E", name: "U0.20.20" }, 
      { hex: "#2D435E", name: "U0.30.16" }, 
      { hex: "#2F4869", name: "U0.30.20" }, 
      { hex: "#244B76", name: "U0.40.20" }, 
      { hex: "#315E90", name: "U0.40.30" }, 
      { hex: "#2E3947", name: "U2.21.09" }, 
      { hex: "#323A45", name: "U4.15.10" }, 
      { hex: "#48547B", name: "V0.25.25" }, 
      { hex: "#4C5D8D", name: "V0.30.30" }, 
      { hex: "#333D65", name: "V3.35.14" }, 
      { hex: "#3E4045", name: "W0.05.15" }, 
      { hex: "#54555E", name: "W0.05.25" }, 
      { hex: "#3D3F4C", name: "W0.10.20" }, 
      { hex: "#5B587A", name: "W0.20.30" }, 
      { hex: "#5F5A90", name: "W0.30.30" }, 
      { hex: "#474351", name: "X0.10.20" }, 
      { hex: "#625273", name: "X0.20.30" }, 
      { hex: "#4E474F", name: "Y0.10.20" }, 
      { hex: "#58435A", name: "Y0.20.20" }, 
      { hex: "#765066", name: "Z0.20.30" }, 
      { hex: "#AE3A2A", name: "C6.65.35" }, 
      { hex: "#B3563A", name: "C8.51.39" }, 
      { hex: "#794D38", name: "D2.35.25" }, 
      { hex: "#86533C", name: "D2.40.30" }, 
      { hex: "#C76E43", name: "D2.50.50" }, 
      { hex: "#E8752C", name: "D8.65.50" }, 
      { hex: "#C07A3D", name: "E0.50.50" }, 
      { hex: "#1B5938", name: "L6.59.23" }, 
      { hex: "#1C4E6F", name: "T0.40.20" }, 
      { hex: "#CB5B25", name: "D3.65.43" }, 
      { hex: "#5D5352", name: "AN.02.25" }, 
      { hex: "#A24F58", name: "B0.35.35" }, 
      { hex: "#9B536B", name: "Z9.30.35" }, 
      { hex: "#924D6F", name: "Z2.32.33" }, 
      { hex: "#DA725E", name: "C2.38.50" }, 
      { hex: "#78594A", name: "C9.21.31" }, 
      { hex: "#65493F", name: "C6.22.23" }, 
      { hex: "#595E8D", name: "V9.26.33" }, 
      { hex: "#257374", name: "P2.46.33" }, 
      { hex: "#53505B", name: "W7.08.24" }, 
      { hex: "#425172", name: "U6.25.25" }, 
      { hex: "#75A651", name: "J6.45.53" }, 
      { hex: "#678D6C", name: "K8.23.45" }, 
      { hex: "#7C567B", name: "X9.24.33" }, 
      { hex: "#D08827", name: "E6.63.53" }, 
      { hex: "#598940", name: "J6.51.43" }, 
      { hex: "#435A33", name: "J4.44.25" }, 
      { hex: "#394E38", name: "K2.29.20" }, 
      { hex: "#B59536", name: "F6.55.54" }, 
      { hex: "#E69311", name: "E7.72.58" }, 
      { hex: "#623C37", name: "B9.28.19" }, 
      { hex: "#804047", name: "B0.35.25" }, 
      { hex: "#303F3F", name: "Q1.19.10" }, 
      { hex: "#304D56", name: "R0.28.19" }, 
      { hex: "#73474A", name: "B0.25.25" }, 
      { hex: "#764C5A", name: "Z8.23.27" }, 
      { hex: "#2B5765", name: "R1.35.23" }, 
      { hex: "#603F3B", name: "B7.28.19" }, 
      { hex: "#119259", name: "L5.60.43" }, 
      { hex: "#235E76", name: "R7.43.26" }, 
      { hex: "#573F35", name: "C8.25.18" }, 
      { hex: "#5C4250", name: "Z0.19.20" }, 
      { hex: "#734739", name: "C7.34.24" }, 
      { hex: "#2B5466", name: "R9.35.22" }, 
      { hex: "#6B4455", name: "Z3.23.24" }, 
      { hex: "#5A3B5A", name: "Y0.30.18" }, 
      { hex: "#97434E", name: "B0.39.30" }, 
      { hex: "#73494A", name: "B2.24.25" }, 
      { hex: "#403F47", name: "X0.08.15" }, 
      { hex: "#3B4A71", name: "U9.30.20" }, 
      { hex: "#324462", name: "U5.19.25" }, 
      { hex: "#903B58", name: "A0.41.28" }, 
      { hex: "#FEFEE5", name: "G4.07.87" }, 
      { hex: "#A2BEAB", name: "L0.10.63" }, 
      { hex: "#F666A", name: "P4.48.27" }, 
      { hex: "#837456", name: "F2.20.40" }, 
      { hex: "#927D56", name: "F2.25.45" }, 
      { hex: "#6B5C3D", name: "F2.30.30" }, 
      { hex: "#8E723B", name: "F2.40.40" }, 
      { hex: "#917133", name: "F2.50.40" }, 
      { hex: "#F2BA43", name: "F2.50.70" }, 
      { hex: "#D89E2C", name: "F2.60.60" }, 
      { hex: "#F9BA36", name: "F2.60.70" }, 
      { hex: "#DD666F", name: "B2.40.50" }, 
      { hex: "#4A4D48", name: "F6.03.20" }, 
      { hex: "#615F54", name: "F6.10.30" }, 
      { hex: "#DA6668", name: "B6.40.50" }, 
      { hex: "#B85953", name: "C0.40.40" }, 
      { hex: "#D76B5F", name: "C0.40.50" }, 
      { hex: "#837346", name: "F6.30.40" }, 
      { hex: "#695C32", name: "F6.40.30" }, 
      { hex: "#C9A951", name: "F6.40.60" }, 
      { hex: "#AA8833", name: "F6.50.50" }, 
      { hex: "#C7A63D", name: "F6.50.60" }, 
      { hex: "#C7A72A", name: "F6.60.60" }, 
      { hex: "#F1C22C", name: "F6.60.70" }, 
      { hex: "#F8C00", name: "F6.70.70" }, 
      { hex: "#C6AB52", name: "F8.40.60" }, 
      { hex: "#9E604F", name: "C4.30.40" }, 
      { hex: "#585A55", name: "FN.02.27" }, 
      { hex: "#4F5049", name: "G0.05.25" }, 
      { hex: "#5F5F50", name: "G0.10.30" }, 
      { hex: "#4B4937", name: "G0.20.20" }, 
      { hex: "#827337", name: "G0.40.40" }, 
      { hex: "#BCA856", name: "G0.40.60" }, 
      { hex: "#9E9038", name: "G0.50.50" }, 
      { hex: "#BEA738", name: "G0.50.60" }, 
      { hex: "#E1C349", name: "G0.50.70" }, 
      { hex: "#C3A72B", name: "G0.60.60" }, 
      { hex: "#E4C52C", name: "G0.60.70" }, 
      { hex: "#F2D72B", name: "G0.60.75" }, 
      { hex: "#B8AC52", name: "G4.40.60" }, 
      { hex: "#9D9438", name: "G4.50.50" }, 
      { hex: "#B8AC41", name: "G4.50.60" }, 
      { hex: "#D3CA2E", name: "G4.60.70" }, 
      { hex: "#747654", name: "G8.20.40" }, 
      { hex: "#4B4E33", name: "G8.30.20" }, 
      { hex: "#5F613C", name: "G8.30.30" }, 
      { hex: "#A0965B", name: "G8.30.50" }, 
      { hex: "#5F6337", name: "G8.40.30" }, 
      { hex: "#B2B22D", name: "G8.60.60" }, 
      { hex: "#CACF36", name: "G8.60.70" }, 
      { hex: "#8F955B", name: "H2.30.50" }, 
      { hex: "#5A5F34", name: "H2.35.30" }, 
      { hex: "#A9B256", name: "H2.40.60" }, 
      { hex: "#A0B62B", name: "H2.60.60" }, 
      { hex: "#50564E", name: "J0.05.25" }, 
      { hex: "#596050", name: "J0.10.30" }, 
      { hex: "#445035", name: "J0.30.20" }, 
      { hex: "#4F6334", name: "J0.40.30" }, 
      { hex: "#657F36", name: "J0.50.40" }, 
      { hex: "#789C41", name: "J0.50.50" }, 
      { hex: "#759E32", name: "J0.60.50" }, 
      { hex: "#51743F", name: "J7.41.35" }, 
      { hex: "#4B534C", name: "K2.05.25" }, 
      { hex: "#647C5E", name: "K2.20.40" }, 
      { hex: "#577E52", name: "K2.30.40" }, 
      { hex: "#456A40", name: "K2.40.30" }, 
      { hex: "#669F5B", name: "K2.40.50" }, 
      { hex: "#438C3D", name: "K2.60.40" }, 
      { hex: "#4F5851", name: "L0.05.25" }, 
      { hex: "#4D6653", name: "L0.20.30" }, 
      { hex: "#637F69", name: "L0.20.40" }, 
      { hex: "#4C815B", name: "L0.30.40" }, 
      { hex: "#6F9E72", name: "L0.30.50" }, 
      { hex: "#386644", name: "L0.40.30" }, 
      { hex: "#539A65", name: "L0.40.50" }, 
      { hex: "#467F62", name: "L8.30.40" }, 
      { hex: "#4E5652", name: "LN.02.27" }, 
      { hex: "#4E615C", name: "N0.10.30" }, 
      { hex: "#42675F", name: "N0.20.30" }, 
      { hex: "#298774", name: "N0.40.40" }, 
      { hex: "#8A88C", name: "N0.50.50" }, 
      { hex: "#AD8159", name: "E0.30.50" }, 
      { hex: "#AA632C", name: "E0.60.40" }, 
      { hex: "#494D4A", name: "ON.00.21" }, 
      { hex: "#EE9430", name: "E4.60.60" }, 
      { hex: "#664F33", name: "E5.35.25" }, 
      { hex: "#665F52", name: "E8.10.30" }, 
      { hex: "#416663", name: "P0.20.30" }, 
      { hex: "#218683", name: "P0.40.40" }, 
      { hex: "#6B5D48", name: "E8.20.30" }, 
      { hex: "#1C6C73", name: "Q0.40.30" }, 
      { hex: "#218391", name: "Q0.40.40" }, 
      { hex: "#086A2", name: "R0.50.40" }, 
      { hex: "#236380", name: "S0.40.30" }, 
      { hex: "#36F9D", name: "S4.50.35" }, 
      { hex: "#1F658A", name: "S5.44.30" }, 
      { hex: "#545B5A", name: "SN.02.27" }, 
      { hex: "#38647A", name: "S0.30.30" }, 
      { hex: "#326087", name: "T4.36.27" }, 
      { hex: "#475C78", name: "U0.20.30" }, 
      { hex: "#42618B", name: "U0.30.30" }, 
      { hex: "#6A506A", name: "Y0.20.30" }, 
      { hex: "#41484B", name: "Z0.05.20" }, 
      { hex: "#645F3B", name: "G0.30.30" }, 
      { hex: "#DBC736", name: "G0.55.70" }, 
      { hex: "#4D5744", name: "J0.15.25" }, 
      { hex: "#B28545", name: "E8.40.50" }, 
      { hex: "#BDAE2A", name: "G4.60.60" }, 
      { hex: "#AA5271", name: "Z9.35.38" }, 
      { hex: "#C56660", name: "B8.35.45" }, 
      { hex: "#A678C", name: "S0.50.30" }, 
      { hex: "#BEBAAE", name: "F2.05.65" }, 
      { hex: "#D0D6C9", name: "F2.05.75" }, 
      { hex: "#D4C9B1", name: "F2.10.70" }, 
      { hex: "#EBD7B2", name: "F2.15.75" }, 
      { hex: "#F9E3BA", name: "F2.15.80" }, 
      { hex: "#FFE69D", name: "F5.26.81" }, 
      { hex: "#D2D1C7", name: "F6.03.72" }, 
      { hex: "#ACAA9E", name: "F6.05.60" }, 
      { hex: "#CCC9BC", name: "F6.05.70" }, 
      { hex: "#B4AC95", name: "F6.10.60" }, 
      { hex: "#D1C7AF", name: "F6.10.70" }, 
      { hex: "#F0E4C7", name: "F6.10.80" }, 
      { hex: "#E3D4AE", name: "F6.15.75" }, 
      { hex: "#F7E1AB", name: "F6.20.80" }, 
      { hex: "#FFDC9C", name: "F6.25.75" }, 
      { hex: "#FDE49E", name: "F6.25.80" }, 
      { hex: "#EBDCA8", name: "F8.20.75" }, 
      { hex: "#FEEBA4", name: "F8.25.81" }, 
      { hex: "#A3A59E", name: "FN.02.57" }, 
      { hex: "#9F9F93", name: "G0.05.55" }, 
      { hex: "#BDBDAF", name: "G0.05.65" }, 
      { hex: "#B0AC95", name: "G0.10.60" }, 
      { hex: "#C4BFA7", name: "G0.10.65" }, 
      { hex: "#D2CDB1", name: "G0.10.70" }, 
      { hex: "#E1D9B8", name: "G0.10.75" }, 
      { hex: "#E1D6AC", name: "G0.15.75" }, 
      { hex: "#F9E9AD", name: "G0.20.80" }, 
      { hex: "#FFEEA4", name: "G0.25.85" }, 
      { hex: "#FFF6A2", name: "G3.26.85" }, 
      { hex: "#A1A398", name: "G4.05.55" }, 
      { hex: "#DFDFCF", name: "G4.05.77" }, 
      { hex: "#B1B099", name: "G4.10.60" }, 
      { hex: "#E0DAAF", name: "G4.15.75" }, 
      { hex: "#FFFCA6", name: "G5.27.85" }, 
      { hex: "#ABAE95", name: "G8.10.60" }, 
      { hex: "#CACBB2", name: "G8.10.70" }, 
      { hex: "#ECEBB0", name: "G8.20.80" }, 
      { hex: "#FAF9B9", name: "G8.20.85" }, 
      { hex: "#FDFFC4", name: "G8.20.90" }, 
      { hex: "#BABDB1", name: "H2.05.65" }, 
      { hex: "#C7CCAE", name: "H2.10.70" }, 
      { hex: "#DFEAA1", name: "H3.24.78" }, 
      { hex: "#CFCEA2", name: "H4.16.70" }, 
      { hex: "#E8FCB5", name: "H7.22.83" }, 
      { hex: "#B5BDAE", name: "J0.05.65" }, 
      { hex: "#D3DDCB", name: "J0.05.75" }, 
      { hex: "#D9E3CA", name: "J0.07.77" }, 
      { hex: "#C1CBB1", name: "J0.10.70" }, 
      { hex: "#CEDFB2", name: "J0.15.75" }, 
      { hex: "#DCF2B3", name: "J0.20.80" }, 
      { hex: "#CEF3BE", name: "J9.19.80" }, 
      { hex: "#C9DED0", name: "K2.05.75" }, 
      { hex: "#D5ECD0", name: "K2.10.80" }, 
      { hex: "#C6F2BB", name: "K2.20.80" }, 
      { hex: "#B2EAB3", name: "K5.21.77" }, 
      { hex: "#D6E7DC", name: "L0.04.78" }, 
      { hex: "#AEBCB3", name: "L0.05.65" }, 
      { hex: "#CDDED0", name: "L0.05.75" }, 
      { hex: "#BDD8C1", name: "L0.10.70" }, 
      { hex: "#CEEED2", name: "L0.10.80" }, 
      { hex: "#B6E1BB", name: "L0.15.75" }, 
      { hex: "#C8DCD2", name: "L8.05.75" }, 
      { hex: "#99B6A8", name: "L8.10.60" }, 
      { hex: "#C5EDD8", name: "L8.10.80" }, 
      { hex: "#99D6B6", name: "L8.20.70" }, 
      { hex: "#E0D4C8", name: "E0.05.75" }, 
      { hex: "#A7A7A1", name: "LN.02.57" }, 
      { hex: "#D5E0DA", name: "LN.02.77" }, 
      { hex: "#B0C2BE", name: "N0.05.65" }, 
      { hex: "#98B8B0", name: "N0.10.60" }, 
      { hex: "#ADD3CA", name: "N0.10.70" }, 
      { hex: "#93D5C5", name: "N0.20.70" }, 
      { hex: "#BBAB97", name: "E4.10.60" }, 
      { hex: "#DBCAB6", name: "E4.10.70" }, 
      { hex: "#A9ADAB", name: "ON.00.60" }, 
      { hex: "#B4B8B5", name: "ON.00.63" }, 
      { hex: "#F9D9AE", name: "E6.18.76" }, 
      { hex: "#A4B1AF", name: "P0.03.60" }, 
      { hex: "#B0AFA8", name: "E8.03.60" }, 
      { hex: "#C9E7E4", name: "P0.07.77" }, 
      { hex: "#D0CBC0", name: "E8.05.70" }, 
      { hex: "#B5A996", name: "E8.10.60" }, 
      { hex: "#DCCAB2", name: "E8.10.70" }, 
      { hex: "#E9D6BA", name: "E8.10.75" }, 
      { hex: "#ACCECE", name: "P1.09.69" }, 
      { hex: "#97BDBC", name: "P1.11.63" }, 
      { hex: "#CEB899", name: "E8.15.65" }, 
      { hex: "#D6E3E1", name: "PN.02.77" }, 
      { hex: "#96A4A5", name: "Q0.05.55" }, 
      { hex: "#AABFC3", name: "Q0.05.65" }, 
      { hex: "#99B6B9", name: "Q0.10.60" }, 
      { hex: "#8FD2DD", name: "Q0.20.70" }, 
      { hex: "#DFE7E6", name: "QN.02.78" }, 
      { hex: "#CBE0E5", name: "R0.05.75" }, 
      { hex: "#99B3BA", name: "R0.10.60" }, 
      { hex: "#D5E4E8", name: "S0.04.78" }, 
      { hex: "#95A1A4", name: "S0.05.55" }, 
      { hex: "#BFD9EA", name: "S3.10.73" }, 
      { hex: "#A1C1DA", name: "S6.15.65" }, 
      { hex: "#9EA7A9", name: "SN.02.57" }, 
      { hex: "#A4D3ED", name: "S0.20.70" }, 
      { hex: "#98ADBE", name: "T0.10.60" }, 
      { hex: "#B5CCDE", name: "T0.10.70" }, 
      { hex: "#A3BCD2", name: "T0.13.64" }, 
      { hex: "#8CA3B9", name: "T3.14.55" }, 
      { hex: "#98AFC2", name: "U0.10.60" }, 
      { hex: "#A9ABD3", name: "V5.14.60" }, 
      { hex: "#B0ABC8", name: "W0.10.60" }, 
      { hex: "#C8C4E1", name: "W0.10.70" }, 
      { hex: "#DBDBE1", name: "WN.02.77" }, 
      { hex: "#DBCFD8", name: "Y0.05.72" }, 
      { hex: "#BDA4BB", name: "Y0.10.60" }, 
      { hex: "#D8BDD8", name: "Y0.10.70" }, 
      { hex: "#C9A4B2", name: "Z0.10.60" }, 
      { hex: "#FEF1D8", name: "E8.10.85" }, 
      { hex: "#DEFBB9", name: "J1.21.83" }, 
      { hex: "#E4FCB7", name: "H9.21.83" }, 
      { hex: "#B1DEA9", name: "K2.21.72" }, 
      { hex: "#9A94A7", name: "W6.07.53" }, 
      { hex: "#71686A", name: "A0.05.35" }, 
      { hex: "#887F81", name: "A0.05.45" }, 
      { hex: "#69545A", name: "A0.10.30" }, 
      { hex: "#887077", name: "A0.10.40" }, 
      { hex: "#A48992", name: "A0.10.50" }, 
      { hex: "#986473", name: "A0.20.40" }, 
      { hex: "#BE8093", name: "A0.20.50" }, 
      { hex: "#D892A8", name: "A0.20.60" }, 
      { hex: "#A55A72", name: "A0.30.40" }, 
      { hex: "#CD6F8E", name: "A0.30.50" }, 
      { hex: "#CA7081", name: "A6.30.50" }, 
      { hex: "#B5576E", name: "A6.35.40" }, 
      { hex: "#6A685E", name: "F2.05.35" }, 
      { hex: "#85837A", name: "F2.05.45" }, 
      { hex: "#6B5958", name: "B2.10.30" }, 
      { hex: "#876E6F", name: "B2.10.40" }, 
      { hex: "#7B7566", name: "F2.10.40" }, 
      { hex: "#B2AA97", name: "F2.10.50" }, 
      { hex: "#706856", name: "F2.15.35" }, 
      { hex: "#A89A7D", name: "F2.15.55" }, 
      { hex: "#CCBB9B", name: "F2.15.65" }, 
      { hex: "#A58788", name: "B2.10.50" }, 
      { hex: "#9D8C6C", name: "F2.20.50" }, 
      { hex: "#C0AB84", name: "F2.20.60" }, 
      { hex: "#E0C697", name: "F2.20.70" }, 
      { hex: "#B69B69", name: "F2.25.55" }, 
      { hex: "#D2B67E", name: "F2.25.65" }, 
      { hex: "#F5D699", name: "F2.25.75" }, 
      { hex: "#A78F5D", name: "F2.30.50" }, 
      { hex: "#C9A96C", name: "F2.30.60" }, 
      { hex: "#E5C47F", name: "F2.30.70" }, 
      { hex: "#DAB269", name: "F2.35.65" }, 
      { hex: "#956668", name: "B2.20.40" }, 
      { hex: "#C37F82", name: "B2.20.50" }, 
      { hex: "#F9AEAE", name: "B2.20.70" }, 
      { hex: "#FACF77", name: "F2.35.75" }, 
      { hex: "#FFD478", name: "F2.35.80" }, 
      { hex: "#D5A458", name: "F2.40.60" }, 
      { hex: "#E5BE61", name: "F2.40.70" }, 
      { hex: "#A55A60", name: "B2.30.40" }, 
      { hex: "#D67379", name: "B2.30.50" }, 
      { hex: "#EA888C", name: "B2.30.60" }, 
      { hex: "#5F6058", name: "F6.05.30" }, 
      { hex: "#78776E", name: "F6.05.40" }, 
      { hex: "#949388", name: "F6.05.50" }, 
      { hex: "#966966", name: "B6.20.40" }, 
      { hex: "#B9817B", name: "B6.20.50" }, 
      { hex: "#F9B2AC", name: "B6.20.70" }, 
      { hex: "#A65F5B", name: "B6.30.40" }, 
      { hex: "#CD7271", name: "B6.30.50" }, 
      { hex: "#787464", name: "F6.10.40" }, 
      { hex: "#A59582", name: "F6.10.50" }, 
      { hex: "#EC8D88", name: "B6.30.60" }, 
      { hex: "#746E59", name: "F6.15.35" }, 
      { hex: "#8F856B", name: "F6.15.45" }, 
      { hex: "#ACA183", name: "F6.15.55" }, 
      { hex: "#C8BB99", name: "F6.15.65" }, 
      { hex: "#736965", name: "C0.05.35" }, 
      { hex: "#8A7F7C", name: "C0.05.45" }, 
      { hex: "#6B5B57", name: "C0.10.30" }, 
      { hex: "#8A726D", name: "C0.10.40" }, 
      { hex: "#988B87", name: "C0.10.50" }, 
      { hex: "#BF8F88", name: "C0.15.55" }, 
      { hex: "#9C8F6B", name: "F6.20.50" }, 
      { hex: "#B9A87E", name: "F6.20.60" }, 
      { hex: "#DAC89A", name: "F6.20.70" }, 
      { hex: "#9A6A62", name: "C0.20.40" }, 
      { hex: "#C58075", name: "C0.20.50" }, 
      { hex: "#FDB7A9", name: "C0.20.70" }, 
      { hex: "#AD6E66", name: "C0.25.45" }, 
      { hex: "#CC847D", name: "C0.25.55" }, 
      { hex: "#F09D93", name: "C0.25.65" }, 
      { hex: "#A85F56", name: "C0.30.40" }, 
      { hex: "#D17C71", name: "C0.30.50" }, 
      { hex: "#F28C83", name: "C0.30.60" }, 
      { hex: "#D0B77D", name: "F6.25.65" }, 
      { hex: "#DDC789", name: "F6.25.70" }, 
      { hex: "#FFE9A6", name: "F6.25.85" }, 
      { hex: "#9E8B56", name: "F6.30.50" }, 
      { hex: "#C1AA6E", name: "F6.30.60" }, 
      { hex: "#E7C777", name: "F6.30.70" }, 
      { hex: "#FFE08A", name: "F6.30.80" }, 
      { hex: "#D3B76B", name: "F6.35.65" }, 
      { hex: "#F6D37A", name: "F6.35.75" }, 
      { hex: "#EAC662", name: "F6.40.70" }, 
      { hex: "#FACF57", name: "F6.45.75" }, 
      { hex: "#90685C", name: "C4.20.40" }, 
      { hex: "#B48275", name: "C4.20.50" }, 
      { hex: "#948C70", name: "F8.16.48" }, 
      { hex: "#DDC57A", name: "F8.30.70" }, 
      { hex: "#FFE691", name: "F8.30.80" }, 
      { hex: "#DD9989", name: "C4.20.60" }, 
      { hex: "#E5C867", name: "F8.40.70" }, 
      { hex: "#F6B2A0", name: "C4.20.70" }, 
      { hex: "#C57967", name: "C4.30.50" }, 
      { hex: "#EA937C", name: "C4.30.60" }, 
      { hex: "#F19179", name: "C4.32.60" }, 
      { hex: "#F5E26E", name: "F8.40.80" }, 
      { hex: "#FFDA4D", name: "F8.50.80" }, 
      { hex: "#70726C", name: "FN.02.37" }, 
      { hex: "#6C6D65", name: "G0.05.35" }, 
      { hex: "#838379", name: "G0.05.45" }, 
      { hex: "#807465", name: "G0.10.40" }, 
      { hex: "#95907B", name: "G0.10.50" }, 
      { hex: "#85726A", name: "C8.10.40" }, 
      { hex: "#A08C82", name: "C8.10.50" }, 
      { hex: "#BA9687", name: "C8.15.55" }, 
      { hex: "#C1B895", name: "G0.15.65" }, 
      { hex: "#7E7858", name: "G0.20.40" }, 
      { hex: "#BCAE80", name: "G0.20.60" }, 
      { hex: "#CDBC7E", name: "G0.25.65" }, 
      { hex: "#E9D898", name: "G0.25.75" }, 
      { hex: "#998E56", name: "G0.30.50" }, 
      { hex: "#B9AA68", name: "G0.30.60" }, 
      { hex: "#D9C57B", name: "G0.30.70" }, 
      { hex: "#F9E58F", name: "G0.30.80" }, 
      { hex: "#EFDA79", name: "G0.35.75" }, 
      { hex: "#FFF08E", name: "G0.35.85" }, 
      { hex: "#9C6B5A", name: "C8.20.40" }, 
      { hex: "#B18673", name: "C8.20.50" }, 
      { hex: "#DE9F89", name: "C8.20.60" }, 
      { hex: "#FFE759", name: "G0.50.80" }, 
      { hex: "#FBE43D", name: "G1.57.79" }, 
      { hex: "#FBBAA1", name: "C8.20.70" }, 
      { hex: "#FFF58A", name: "G3.34.84" }, 
      { hex: "#AA7561", name: "C8.25.45" }, 
      { hex: "#C38D76", name: "C8.25.55" }, 
      { hex: "#F1A68B", name: "C8.25.65" }, 
      { hex: "#C3BE9C", name: "G4.15.65" }, 
      { hex: "#958F68", name: "G4.20.50" }, 
      { hex: "#D7D29D", name: "G4.20.70" }, 
      { hex: "#A16751", name: "C8.30.40" }, 
      { hex: "#C37960", name: "C8.30.50" }, 
      { hex: "#E69474", name: "C8.30.60" }, 
      { hex: "#9B945A", name: "G4.30.50" }, 
      { hex: "#B6B06A", name: "G4.30.60" }, 
      { hex: "#D3C879", name: "G4.30.70" }, 
      { hex: "#F9EE94", name: "G4.30.80" }, 
      { hex: "#D8CB61", name: "G4.40.70" }, 
      { hex: "#F7E873", name: "G4.40.80" }, 
      { hex: "#585855", name: "CN.02.27" }, 
      { hex: "#FBF684", name: "G5.36.83" }, 
      { hex: "#706E6C", name: "CN.02.37" }, 
      { hex: "#8A8684", name: "CN.02.47" }, 
      { hex: "#767866", name: "G8.10.40" }, 
      { hex: "#929380", name: "G8.10.50" }, 
      { hex: "#92936B", name: "G8.20.50" }, 
      { hex: "#CFD19C", name: "G8.20.70" }, 
      { hex: "#B1B06C", name: "G8.30.60" }, 
      { hex: "#D0CE7F", name: "G8.30.70" }, 
      { hex: "#F0F196", name: "G8.30.80" }, 
      { hex: "#FCFEA0", name: "G8.30.85" }, 
      { hex: "#AEAE55", name: "G8.40.60" }, 
      { hex: "#D0CF5F", name: "G8.40.70" }, 
      { hex: "#E7F278", name: "G8.40.80" }, 
      { hex: "#665B52", name: "D2.10.30" }, 
      { hex: "#827268", name: "D2.10.40" }, 
      { hex: "#C4AA99", name: "D2.10.50" }, 
      { hex: "#84887E", name: "H2.05.45" }, 
      { hex: "#9A9D8F", name: "H2.05.55" }, 
      { hex: "#B89684", name: "D2.15.55" }, 
      { hex: "#ACB298", name: "H2.10.60" }, 
      { hex: "#8F946A", name: "H2.20.50" }, 
      { hex: "#C7CD95", name: "H2.20.70" }, 
      { hex: "#A8B36D", name: "H2.30.60" }, 
      { hex: "#C8D181", name: "H2.30.70" }, 
      { hex: "#E1EC91", name: "H2.30.80" }, 
      { hex: "#C7D267", name: "H2.40.70" }, 
      { hex: "#E5EF74", name: "H2.40.80" }, 
      { hex: "#906B57", name: "D2.20.40" }, 
      { hex: "#A8866E", name: "D2.20.50" }, 
      { hex: "#D29F83", name: "D2.20.60" }, 
      { hex: "#F6BFA3", name: "D2.20.70" }, 
      { hex: "#676E65", name: "J0.05.35" }, 
      { hex: "#81867B", name: "J0.05.45" }, 
      { hex: "#9AA295", name: "J0.05.55" }, 
      { hex: "#B67C5E", name: "D2.30.50" }, 
      { hex: "#E09872", name: "D2.30.60" }, 
      { hex: "#FBAF88", name: "D2.30.70" }, 
      { hex: "#747B6C", name: "J0.10.40" }, 
      { hex: "#8A947F", name: "J0.10.50" }, 
      { hex: "#D4895F", name: "D2.35.55" }, 
      { hex: "#B1C199", name: "J0.15.65" }, 
      { hex: "#637A59", name: "J0.20.40" }, 
      { hex: "#A9B39C", name: "J0.10.60" }, 
      { hex: "#82916A", name: "J0.20.50" }, 
      { hex: "#AAB282", name: "J0.20.60" }, 
      { hex: "#BBCF9B", name: "J0.20.70" }, 
      { hex: "#C87852", name: "D2.40.50" }, 
      { hex: "#869960", name: "J0.30.50" }, 
      { hex: "#9BB370", name: "J0.30.60" }, 
      { hex: "#B7D080", name: "J0.30.70" }, 
      { hex: "#D1F196", name: "J0.30.80" }, 
      { hex: "#95B85C", name: "J0.40.60" }, 
      { hex: "#6F6A64", name: "D6.05.35" }, 
      { hex: "#878079", name: "D6.05.45" }, 
      { hex: "#B8ECA7", name: "K0.26.76" }, 
      { hex: "#879187", name: "K2.05.50" }, 
      { hex: "#665B52", name: "D6.10.30" }, 
      { hex: "#827367", name: "D6.10.40" }, 
      { hex: "#9E8D80", name: "D6.10.50" }, 
      { hex: "#B3947E", name: "D6.15.55" }, 
      { hex: "#6B7968", name: "K2.10.40" }, 
      { hex: "#859580", name: "K2.10.50" }, 
      { hex: "#8D6D57", name: "D6.20.40" }, 
      { hex: "#A5886C", name: "D6.20.50" }, 
      { hex: "#CFA183", name: "D6.20.60" }, 
      { hex: "#FFD0AF", name: "D6.20.80" }, 
      { hex: "#A1B39F", name: "K2.10.60" }, 
      { hex: "#A9C4A3", name: "K2.15.65" }, 
      { hex: "#C59070", name: "D6.25.55" }, 
      { hex: "#E3A882", name: "D6.25.65" }, 
      { hex: "#7D9A77", name: "K2.20.50" }, 
      { hex: "#FDBE93", name: "D6.25.70" }, 
      { hex: "#93B589", name: "K2.20.60" }, 
      { hex: "#ACD3A5", name: "K2.20.70" }, 
      { hex: "#B5835E", name: "D6.30.50" }, 
      { hex: "#DF9A6F", name: "D6.30.60" }, 
      { hex: "#739E6B", name: "K2.30.50" }, 
      { hex: "#F9B283", name: "D6.30.70" }, 
      { hex: "#AE754D", name: "D6.35.45" }, 
      { hex: "#C97B4C", name: "D6.35.55" }, 
      { hex: "#FBAE7A", name: "D6.35.70" }, 
      { hex: "#83B779", name: "K2.30.60" }, 
      { hex: "#CA7C4C", name: "D6.40.50" }, 
      { hex: "#A0DB93", name: "K2.30.70" }, 
      { hex: "#7DBC6D", name: "K2.40.60" }, 
      { hex: "#E8945D", name: "D6.40.60" }, 
      { hex: "#80D68E", name: "K6.34.67" }, 
      { hex: "#636E67", name: "L0.05.35" }, 
      { hex: "#77837C", name: "L0.05.45" }, 
      { hex: "#92A096", name: "L0.05.55" }, 
      { hex: "#6A7D6F", name: "L0.10.40" }, 
      { hex: "#8E998A", name: "L0.10.50" }, 
      { hex: "#97AE9D", name: "L0.10.60" }, 
      { hex: "#91A88B", name: "L0.15.55" }, 
      { hex: "#9CC2A4", name: "L0.15.65" }, 
      { hex: "#749E7E", name: "L0.20.50" }, 
      { hex: "#8BB693", name: "L0.20.60" }, 
      { hex: "#A0D2AB", name: "L0.20.70" }, 
      { hex: "#EA985A", name: "D7.41.60" }, 
      { hex: "#F8AA6C", name: "D8.37.65" }, 
      { hex: "#76B886", name: "L0.30.60" }, 
      { hex: "#8EDE9F", name: "L0.30.70" }, 
      { hex: "#6CC481", name: "L0.40.60" }, 
      { hex: "#6D9A83", name: "L8.20.50" }, 
      { hex: "#59A07B", name: "L8.30.50" }, 
      { hex: "#72BF98", name: "L8.30.60" }, 
      { hex: "#7EDBAD", name: "L8.30.70" }, 
      { hex: "#55C38E", name: "L8.40.60" }, 
      { hex: "#8B847C", name: "E0.05.45" }, 
      { hex: "#716F6B", name: "LN.02.37" }, 
      { hex: "#665E54", name: "E0.10.30" }, 
      { hex: "#818884", name: "LN.02.47" }, 
      { hex: "#807568", name: "E0.10.40" }, 
      { hex: "#9C8C7D", name: "E0.10.50" }, 
      { hex: "#59A083", name: "M2.30.50" }, 
      { hex: "#6ABD9A", name: "M2.30.60" }, 
      { hex: "#53C599", name: "M2.40.60" }, 
      { hex: "#D4BEA9", name: "E0.11.67" }, 
      { hex: "#607872", name: "N0.10.40" }, 
      { hex: "#7A968F", name: "N0.10.50" }, 
      { hex: "#786655", name: "E0.15.35" }, 
      { hex: "#94806C", name: "E0.15.45" }, 
      { hex: "#B39A82", name: "E0.15.55" }, 
      { hex: "#558076", name: "N0.20.40" }, 
      { hex: "#689F93", name: "N0.20.50" }, 
      { hex: "#82BDAE", name: "N0.20.60" }, 
      { hex: "#79D9C2", name: "N0.28.70" }, 
      { hex: "#3D7F70", name: "N0.30.40" }, 
      { hex: "#51A390", name: "N0.30.50" }, 
      { hex: "#65BEAB", name: "N0.30.60" }, 
      { hex: "#896D53", name: "E0.20.40" }, 
      { hex: "#A8896D", name: "E0.20.50" }, 
      { hex: "#C5A180", name: "E0.20.60" }, 
      { hex: "#ECBF99", name: "E0.20.70" }, 
      { hex: "#FFD3AA", name: "E0.20.80" }, 
      { hex: "#A37D5D", name: "E0.25.45" }, 
      { hex: "#C09671", name: "E0.25.55" }, 
      { hex: "#E2B189", name: "E0.25.65" }, 
      { hex: "#2E9E89", name: "N0.40.50" }, 
      { hex: "#FFCB99", name: "E0.25.75" }, 
      { hex: "#D4A174", name: "E0.30.60" }, 
      { hex: "#CE9360", name: "E0.35.55" }, 
      { hex: "#F1AD71", name: "E0.35.65" }, 
      { hex: "#DE975A", name: "E0.40.60" }, 
      { hex: "#FDAE68", name: "E0.40.70" }, 
      { hex: "#E6BC93", name: "E1.21.69" }, 
      { hex: "#FFD6A8", name: "E3.20.77" }, 
      { hex: "#7C8279", name: "E4.05.45" }, 
      { hex: "#7A7164", name: "E4.10.40" }, 
      { hex: "#9D8F7D", name: "E4.10.50" }, 
      { hex: "#746654", name: "E4.15.35" }, 
      { hex: "#686C6B", name: "ON.00.36" }, 
      { hex: "#707473", name: "ON.00.40" }, 
      { hex: "#808482", name: "ON.00.45" }, 
      { hex: "#907E67", name: "E4.15.45" }, 
      { hex: "#8B8F8E", name: "ON.00.50" }, 
      { hex: "#9B9F9D", name: "ON.00.55" }, 
      { hex: "#B29D81", name: "E4.15.55" }, 
      { hex: "#D2B697", name: "E4.15.65" }, 
      { hex: "#8B7356", name: "E4.20.40" }, 
      { hex: "#A78B6A", name: "E4.20.50" }, 
      { hex: "#CAA985", name: "E4.20.60" }, 
      { hex: "#FCD1A2", name: "E4.20.75" }, 
      { hex: "#BE966D", name: "E4.25.55" }, 
      { hex: "#DAAF81", name: "E4.25.65" }, 
      { hex: "#FDCB93", name: "E4.25.75" }, 
      { hex: "#D6A872", name: "E4.30.60" }, 
      { hex: "#F5BD80", name: "E4.30.70" }, 
      { hex: "#FFC988", name: "E4.30.75" }, 
      { hex: "#DD9E58", name: "E4.40.60" }, 
      { hex: "#FFB968", name: "E4.40.70" }, 
      { hex: "#485757", name: "ON.01.26" }, 
      { hex: "#5F6C6B", name: "P0.05.35" }, 
      { hex: "#798786", name: "P0.05.45" }, 
      { hex: "#91A3A1", name: "P0.05.55" }, 
      { hex: "#4F6362", name: "P0.10.30" }, 
      { hex: "#657C7D", name: "P0.10.40" }, 
      { hex: "#7A9696", name: "P0.10.50" }, 
      { hex: "#93B4B0", name: "P0.10.60" }, 
      { hex: "#5D726F", name: "P0.15.35" }, 
      { hex: "#688A88", name: "P0.15.45" }, 
      { hex: "#7CA6A4", name: "P0.15.55" }, 
      { hex: "#7A7164", name: "E8.10.40" }, 
      { hex: "#988D7B", name: "E8.10.50" }, 
      { hex: "#E6C39B", name: "E4.20.70" }, 
      { hex: "#716552", name: "E8.15.35" }, 
      { hex: "#54807F", name: "P0.20.40" }, 
      { hex: "#649D9A", name: "P0.20.50" }, 
      { hex: "#78B9B6", name: "P0.20.60" }, 
      { hex: "#498583", name: "P0.30.40" }, 
      { hex: "#499F9B", name: "P0.30.50" }, 
      { hex: "#5FC0BF", name: "P0.30.60" }, 
      { hex: "#8D7E68", name: "E8.15.45" }, 
      { hex: "#B19F83", name: "E8.15.55" }, 
      { hex: "#21A5A0", name: "P0.40.50" }, 
      { hex: "#32A0AE", name: "P9.38.49" }, 
      { hex: "#867459", name: "E8.20.40" }, 
      { hex: "#A69071", name: "E8.20.50" }, 
      { hex: "#466264", name: "Q0.10.30" }, 
      { hex: "#C1A57E", name: "E8.20.60" }, 
      { hex: "#DEBE90", name: "E8.20.70" }, 
      { hex: "#6F7B7E", name: "Q0.10.40" }, 
      { hex: "#7D979B", name: "Q0.10.50" }, 
      { hex: "#F8D7A5", name: "E8.20.75" }, 
      { hex: "#356367", name: "Q0.20.30" }, 
      { hex: "#557F84", name: "Q0.20.40" }, 
      { hex: "#669AA2", name: "Q0.20.50" }, 
      { hex: "#68CCDB", name: "Q0.29.65" }, 
      { hex: "#387F89", name: "Q0.30.40" }, 
      { hex: "#4C9EA7", name: "Q0.30.50" }, 
      { hex: "#65B8C4", name: "Q0.30.60" }, 
      { hex: "#33A0AE", name: "Q0.40.50" }, 
      { hex: "#977E5A", name: "E8.25.45" }, 
      { hex: "#B7986D", name: "E8.25.55" }, 
      { hex: "#D6B481", name: "E8.25.65" }, 
      { hex: "#6F9BA9", name: "R0.20.50" }, 
      { hex: "#CAA36D", name: "E8.30.60" }, 
      { hex: "#468193", name: "R0.30.40" }, 
      { hex: "#519BB0", name: "R0.30.50" }, 
      { hex: "#6FB8D0", name: "R0.30.60" }, 
      { hex: "#2A829A", name: "R0.40.40" }, 
      { hex: "#349EBD", name: "R0.40.50" }, 
      { hex: "#E0B06A", name: "E8.35.65" }, 
      { hex: "#FFC67A", name: "E8.35.75" }, 
      { hex: "#4CACCA", name: "R2.33.55" }, 
      { hex: "#DBA257", name: "E8.40.60" }, 
      { hex: "#F8B965", name: "E8.40.70" }, 
      { hex: "#3696B9", name: "R4.42.47" }, 
      { hex: "#52AFD4", name: "R5.37.56" }, 
      { hex: "#5DA1BF", name: "R6.31.52" }, 
      { hex: "#F9B84B", name: "E8.50.70" }, 
      { hex: "#347C9D", name: "R8.40.39" }, 
      { hex: "#4C5658", name: "S0.05.25" }, 
      { hex: "#626D70", name: "S0.05.35" }, 
      { hex: "#7A868B", name: "S0.05.45" }, 
      { hex: "#526167", name: "S0.10.30" }, 
      { hex: "#6A7A81", name: "S0.10.40" }, 
      { hex: "#8096A2", name: "S0.10.50" }, 
      { hex: "#425E6C", name: "S0.20.30" }, 
      { hex: "#587B8D", name: "S0.20.40" }, 
      { hex: "#DEBD89", name: "F0.25.70" }, 
      { hex: "#F9D79D", name: "F0.25.75" }, 
      { hex: "#5998B8", name: "S0.30.50" }, 
      { hex: "#71B5DA", name: "S0.30.60" }, 
      { hex: "#307FA5", name: "S0.40.40" }, 
      { hex: "#3C98C5", name: "S0.40.50" }, 
      { hex: "#4FBAE7", name: "S0.40.60" }, 
      { hex: "#53ACDC", name: "S1.38.56" }, 
      { hex: "#87C1E9", name: "S4.26.64" }, 
      { hex: "#3392C1", name: "S4.43.46" }, 
      { hex: "#3C99CE", name: "S4.43.49" }, 
      { hex: "#2183B6", name: "S5.48.41" }, 
      { hex: "#83B8E1", name: "S7.27.61" }, 
      { hex: "#677D8E", name: "S8.15.41" }, 
      { hex: "#57A4D6", name: "S8.34.54" }, 
      { hex: "#397193", name: "S9.32.35" }, 
      { hex: "#73A8DB", name: "S9.35.56" }, 
      { hex: "#6A7171", name: "SN.02.37" }, 
      { hex: "#81888A", name: "SN.02.47" }, 
      { hex: "#51616C", name: "T0.10.30" }, 
      { hex: "#687883", name: "T0.10.40" }, 
      { hex: "#6D93A8", name: "S0.20.50" }, 
      { hex: "#86B2CB", name: "S0.20.60" }, 
      { hex: "#4B809B", name: "S0.30.40" }, 
      { hex: "#8091A0", name: "T0.10.50" }, 
      { hex: "#466074", name: "T0.20.30" }, 
      { hex: "#5E7992", name: "T0.20.40" }, 
      { hex: "#7393AE", name: "T0.20.50" }, 
      { hex: "#6B90B0", name: "T0.23.48" }, 
      { hex: "#4E7DA2", name: "T0.30.40" }, 
      { hex: "#6094BD", name: "T0.30.50" }, 
      { hex: "#75B0E0", name: "T0.30.60" }, 
      { hex: "#357EB0", name: "T0.40.40" }, 
      { hex: "#4997D1", name: "T0.40.50" }, 
      { hex: "#7696B7", name: "T3.20.50" }, 
      { hex: "#90AED2", name: "T4.18.59" }, 
      { hex: "#4E7094", name: "T4.27.36" }, 
      { hex: "#646C72", name: "U0.05.35" }, 
      { hex: "#7D858E", name: "U0.05.45" }, 
      { hex: "#959FA9", name: "U0.05.55" }, 
      { hex: "#54606D", name: "U0.10.30" }, 
      { hex: "#6B7686", name: "U0.10.40" }, 
      { hex: "#8490A4", name: "U0.10.50" }, 
      { hex: "#889DBD", name: "U0.15.55" }, 
      { hex: "#607797", name: "U0.20.40" }, 
      { hex: "#7B93BB", name: "U0.20.50" }, 
      { hex: "#93AFDD", name: "U0.20.60" }, 
      { hex: "#8BB0E2", name: "U0.25.60" }, 
      { hex: "#5075A9", name: "U0.30.40" }, 
      { hex: "#99ADD1", name: "U2.16.60" }, 
      { hex: "#6F84B8", name: "U6.26.46" }, 
      { hex: "#5B6C9C", name: "U7.27.36" }, 
      { hex: "#8B95C1", name: "V0.20.50" }, 
      { hex: "#5F6A97", name: "V0.25.35" }, 
      { hex: "#7180B4", name: "V0.25.45" }, 
      { hex: "#686974", name: "W0.05.35" }, 
      { hex: "#83828E", name: "W0.05.45" }, 
      { hex: "#5C5C6F", name: "W0.10.30" }, 
      { hex: "#747287", name: "W0.10.40" }, 
      { hex: "#8E8DA6", name: "W0.10.50" }, 
      { hex: "#8380A2", name: "W0.15.45" }, 
      { hex: "#9C97BF", name: "W0.15.55" }, 
      { hex: "#75719D", name: "W0.20.40" }, 
      { hex: "#888AC1", name: "W0.20.50" }, 
      { hex: "#ACA5D5", name: "W0.20.60" }, 
      { hex: "#746EA7", name: "W0.25.40" }, 
      { hex: "#615A6B", name: "X0.10.30" }, 
      { hex: "#7D7388", name: "X0.10.40" }, 
      { hex: "#958AA4", name: "X0.10.50" }, 
      { hex: "#9D8BB1", name: "X0.15.50" }, 
      { hex: "#806A93", name: "X0.20.40" }, 
      { hex: "#9B83B3", name: "X0.20.50" }, 
      { hex: "#635664", name: "Y0.10.30" }, 
      { hex: "#827183", name: "Y0.10.40" }, 
      { hex: "#9F8AA1", name: "Y0.10.50" }, 
      { hex: "#88658A", name: "Y0.20.40" }, 
      { hex: "#A882A7", name: "Y0.20.50" }, 
      { hex: "#926480", name: "Z0.20.40" }, 
      { hex: "#B0819D", name: "Z0.20.50" }, 
      { hex: "#D392B6", name: "Z0.20.60" }, 
      { hex: "#C56A92", name: "Z5.31.48" }, 
      { hex: "#FFDD93", name: "F2.30.80" }, 
      { hex: "#898B86", name: "FN.02.47" }, 
      { hex: "#FFE33C", name: "G0.55.80" }, 
      { hex: "#FEED54", name: "G2.51.81" }, 
      { hex: "#EBFA7D", name: "H1.39.83" }, 
      { hex: "#BB5361", name: "B0.39.40" }, 
      { hex: "#83CABC", name: "N1.21.65" }, 
      { hex: "#959997", name: "ON.00.53" }, 
      { hex: "#5BC9CB", name: "P2.32.63" }, 
      { hex: "#7D949B", name: "Q9.10.50" }, 
      { hex: "#81B6C7", name: "R0.20.60" }, 
      { hex: "#70BCE2", name: "R7.31.62" }, 
      { hex: "#91A29E", name: "N1.05.55" }, 
      { hex: "#F7B38D", name: "D4.23.71" }, 
      { hex: "#8D8080", name: "B1.05.45" }, 
      { hex: "#7F7472", name: "B3.05.40" }, 
      { hex: "#FCC3C1", name: "B3.14.73" }, 
      { hex: "#F8ADAB", name: "B3.19.67" }, 
      { hex: "#F9B7A9", name: "C0.17.72" }, 
      { hex: "#F5BEAB", name: "C3.20.73" }, 
      { hex: "#FDB99F", name: "C7.22.72" }, 
      { hex: "#FFC4AC", name: "C8.19.74" }, 
      { hex: "#A1B3E3", name: "U6.18.63" }, 
      { hex: "#FFC694", name: "D9.25.74" }, 
      { hex: "#A39686", name: "E0.09.53" }, 
      { hex: "#FFDEB0", name: "E6.19.80" }, 
      { hex: "#929E9C", name: "P0.03.55" }, 
      { hex: "#FBAE93", name: "C7.26.67" }, 
      { hex: "#A28998", name: "Z0.10.50" }, 
      { hex: "#9EAADC", name: "V0.20.60" }, 
      { hex: "#AC8B6A", name: "E1.22.47" }, 
      { hex: "#FFAF6C", name: "D9.40.68" }, 
      { hex: "#6A827E", name: "N0.05.44" }, 
      { hex: "#827D8D", name: "W7.07.44" }, 
      { hex: "#BC9A6F", name: "E1.26.54" }, 
      { hex: "#706DA4", name: "V9.26.39" }, 
      { hex: "#FA9B77", name: "C8.34.63" }, 
      { hex: "#43B29F", name: "N1.37.55" }, 
      { hex: "#79D39D", name: "L4.32.66" }, 
      { hex: "#B3E39A", name: "J6.26.76" }, 
      { hex: "#7A7F6C", name: "H3.10.43" }, 
      { hex: "#656866", name: "ON.00.33" }, 
      { hex: "#A38F6A", name: "F1.22.52" }, 
      { hex: "#5C6964", name: "M8.06.34" }, 
      { hex: "#748283", name: "Q5.05.44" }, 
      { hex: "#9FB187", name: "H3.18.60" }, 
      { hex: "#99719A", name: "X9.21.44" }, 
      { hex: "#82B89D", name: "L8.19.60" }, 
      { hex: "#B38DB5", name: "X7.18.54" }, 
      { hex: "#AB8E6C", name: "E5.21.49" }, 
      { hex: "#42AAAE", name: "P3.35.53" }, 
      { hex: "#9999CC", name: "V6.20.55" }, 
      { hex: "#856E7A", name: "Z1.10.40" }, 
      { hex: "#5585A6", name: "S6.29.43" }, 
      { hex: "#716867", name: "B1.05.35" }, 
      { hex: "#EE9494", name: "B3.25.60" }, 
      { hex: "#E57D80", name: "B3.31.54" }, 
      { hex: "#3681B0", name: "S9.39.41" }, 
      { hex: "#9390C1", name: "V9.17.54" }, 
      { hex: "#7B7EB6", name: "V5.25.45" }, 
      { hex: "#A48170", name: "C8.16.48" }, 
      { hex: "#FFEB88", name: "G0.31.84" }, 
      { hex: "#E58B7D", name: "C0.28.58" }, 
      { hex: "#5E6D77", name: "S8.10.35" }, 
      { hex: "#2D84A8", name: "R7.44.41" }, 
      { hex: "#4F93B1", name: "R7.33.47" }, 
      { hex: "#F29A86", name: "C2.24.65" }, 
      { hex: "#7F7BAF", name: "V8.23.44" }, 
      { hex: "#516266", name: "R3.10.30" }, 
      { hex: "#D78DA7", name: "Z8.23.57" }, 
      { hex: "#6B6969", name: "AN.02.35" }, 
      { hex: "#657A7E", name: "Q9.10.40" }, 
      { hex: "#758077", name: "K2.05.43" }, 
      { hex: "#6B5962", name: "Z0.10.30" }, 
      { hex: "#CF6D8E", name: "Z9.32.49" }, 
      { hex: "#6A6674", name: "W7.07.34" }, 
      { hex: "#3AAB71", name: "L5.47.52" }, 
      { hex: "#3D728A", name: "R8.33.36" }, 
      { hex: "#5F6860", name: "K3.06.34" }, 
      { hex: "#476073", name: "S8.22.29" }, 
      { hex: "#88C56D", name: "J6.39.63" }, 
      { hex: "#268F92", name: "P3.40.44" }, 
      { hex: "#FADFAC", name: "F2.20.80" }, 
      { hex: "#FEFCAE", name: "G5.24.85" }, 
      { hex: "#F8FCA4", name: "G9.27.84" }, 
      { hex: "#B6EDA3", name: "K0.28.76" }, 
      { hex: "#B45254", name: "B6.40.40" }, 
      { hex: "#FCBD86", name: "E0.30.70" }, 
      { hex: "#F9BE64", name: "F0.40.70" }, 
      { hex: "#AA5756", name: "B6.35.40" }, 
      { hex: "#948C68", name: "G0.20.50" }, 
      { hex: "#D9C360", name: "G0.40.70" }, 
      { hex: "#FCE473", name: "G0.40.80" }, 
      { hex: "#FFE565", name: "G0.45.80" }, 
      { hex: "#FFF363", name: "G3.46.83" }, 
      { hex: "#FFF98F", name: "G4.34.84" }, 
      { hex: "#E9EA5C", name: "G8.45.80" }, 
      { hex: "#F6FB8B", name: "G9.35.84" }, 
      { hex: "#D0F37E", name: "H7.38.79" }, 
      { hex: "#AAD66D", name: "J0.40.70" }, 
      { hex: "#ACD957", name: "J0.48.70" }, 
      { hex: "#91E07B", name: "J8.41.70" }, 
      { hex: "#94DD82", name: "K2.40.70" }, 
      { hex: "#72CF77", name: "K5.44.64" }, 
      { hex: "#40A680", name: "M2.40.50" }, 
      { hex: "#F1C17E", name: "E8.30.70" }, 
      { hex: "#EDC37F", name: "F0.30.70" }, 
      { hex: "#827657", name: "F6.20.40" }, 
      { hex: "#FBDD0", name: "G0.70.76" }, 
      { hex: "#C0C438", name: "G7.57.66" }, 
      { hex: "#D7E640", name: "G9.56.76" }, 
      { hex: "#8EB749", name: "J0.50.60" }, 
      { hex: "#35513C", name: "L0.30.20" }, 
      { hex: "#1E8942", name: "L0.70.40" }, 
      { hex: "#9F7B49", name: "E8.35.45" }, 
      { hex: "#715B32", name: "F2.40.30" }, 
      { hex: "#385536", name: "K2.45.20" }, 
      { hex: "#315B35", name: "K4.54.23" }, 
      { hex: "#824A69", name: "Z0.30.30" }, 
      { hex: "#6A8569", name: "K4.20.45" }, 
      { hex: "#F2F1E7", name: "FN.02.82" }, 
      { hex: "#D6CA96", name: "G0.20.70" }, 
      { hex: "#F9CF95", name: "E8.25.75" }, 
      { hex: "#DAD9C8", name: "G0.05.75" }, 
      { hex: "#E4DDC7", name: "F6.07.77" }, 
      { hex: "#EFD1B0", name: "E4.15.75" }
    ],
      "Little green": [      { hex: "#F0EFEE", name: "105 - Slaked Lime" }, 
      { hex: "#F9FBF9", name: "129 - Shirting" }, 
      { hex: "#DDD7CE", name: "117 - Lead Colour" }, 
      { hex: "#EBEAE1", name: "81 - Clockface" }, 
      { hex: "#D7C7B8", name: "38 - Hammock" }, 
      { hex: "#EFECE5", name: "33 - Linen Wash" }, 
      { hex: "#DDD7CE", name: "130 - Joanna" }, 
      { hex: "#8D9193", name: "114 - Mid Lead Colour" }, 
      { hex: "#B9BEC2", name: "217 - Mono" }, 
      { hex: "#AB9073", name: "36 - Stone Dark Warm" }, 
      { hex: "#FAF5E4", name: "49 - First Light" }, 
      { hex: "#6B474A", name: "7 - Adventurer" }, 
      { hex: "#E2C5A1", name: "131 - Aged Ivory" }, 
      { hex: "#EDE7E7", name: "1 - China Clay" }, 
      { hex: "#F2F0D1", name: "89 - Linnet" }, 
      { hex: "#ECE5DD", name: "25 - Hollyhock" }, 
      { hex: "#97645E", name: "6 - Ashes Of Roses" }, 
      { hex: "#E1D0B2", name: "65 - Stone Pale Cool" }, 
      { hex: "#C2B29D", name: "67 - Stone Dark Cool" }, 
      { hex: "#E6D6BF", name: "35 - Stone Pale Warm" }, 
      { hex: "#E9D4A4", name: "134 - Woodbine" }, 
      { hex: "#DDC6A2", name: "132 - Chamois" }, 
      { hex: "#C1A9A4", name: "3 - Light Peachblossom" }, 
      { hex: "#374E61", name: "208 - Hicks Blue" }, 
      { hex: "#C7B8A9", name: "142 - Mushroom" }, 
      { hex: "#F5EDE9", name: "9 - Rusling" }, 
      { hex: "#D9D2BD", name: "76 - Acre" }, 
      { hex: "#72605B", name: "145 - Felt" }, 
      { hex: "#9F8678", name: "40 - Silt" }, 
      { hex: "#E6BD9A", name: "35 - Stone Mid Warm" }, 
      { hex: "#ECF3EE", name: "97 - Starlings Egg" }, 
      { hex: "#CFC7C7", name: "4 - Mirage II" }, 
      { hex: "#DBC389", name: "135 - Sunlight" }, 
      { hex: "#EED3AB", name: "62 - Ivory" }, 
      { hex: "#F5F0E1", name: "74 - White Lead" }, 
      { hex: "#D6BA8C", name: "63 - Oak Apple" }, 
      { hex: "#D9DCD8", name: "219 - Mirror" }, 
      { hex: "#824A41", name: "214 - Callaghan" }, 
      { hex: "#D4A454", name: "46 - Yellow Pink" }, 
      { hex: "#60A3C1", name: "104 - Blue Verditer" }, 
      { hex: "#82916B", name: "86 - Garden" }, 
      { hex: "#D9D7DD", name: "109 - Welcome" }, 
      { hex: "#FAE6C6", name: "42 - Creamerie" }, 
      { hex: "#D7D4DF", name: "5 - Whisper" }, 
      { hex: "#4A8E8E", name: "94 - Canton" }, 
      { hex: "#94D065", name: "199 - Phthalo Green" }, 
      { hex: "#CDBCBF", name: "213 - Dorchester Pink" }, 
      { hex: "#003C6B", name: "207 - Deep Space Blue" }, 
      { hex: "#006176", name: "95 - Marine Blue" }, 
      { hex: "#A7506B", name: "13 - Mischief" }, 
      { hex: "#516B7C", name: "115 - Juniper Ash" }, 
      { hex: "#ACCDD3", name: "203 - Brighton" }, 
      { hex: "#C5D9CA", name: "201 - Cupboard Green" }, 
      { hex: "#F2E7DF", name: "146 - Old Paper" }, 
      { hex: "#B9A291", name: "31 - Roman Plaster" }, 
      { hex: "#DBC8CC", name: "220 - Pink Slip" }, 
      { hex: "#C5B0C0", name: "187 - Milk Thistle" }, 
      { hex: "#BFBFAE", name: "78 - Tracery II" }, 
      { hex: "#CB7176", name: "189 - Carmine" }, 
      { hex: "#473A6F", name: "188 - Purpleheart" }, 
      { hex: "#EAB961", name: "47 - Mister David" }, 
      { hex: "#8FA7BC", name: "108 - James" }, 
      { hex: "#FEE19C", name: "148 - Carys" }, 
      { hex: "#ECE1D1", name: "28 - 50 S Magnolia" }, 
      { hex: "#F6E4B6", name: "133 - Custard" }, 
      { hex: "#555735", name: "72 - Olive Colour" }, 
      { hex: "#5A97C5", name: "206 - Tivoli" }, 
      { hex: "#F2E9DA", name: "41 - Whitening" }, 
      { hex: "#C4BB8E", name: "137 - Apple" }, 
      { hex: "#81C3AA", name: "92 - Green Verditer" }, 
      { hex: "#D3C3A9", name: "66 - Stone Mid Cool" }, 
      { hex: "#E7DBE1", name: "139 - Chemise" }, 
      { hex: "#FBC9C9", name: "185 - Angie" }, 
      { hex: "#CBD6DA", name: "183 - Bone China Blue Mid" }, 
      { hex: "#AE482F", name: "16 - Drummond" }, 
      { hex: "#3B434F", name: "221 - Basalt" }, 
      { hex: "#D3D9DE", name: "164 - Gauze Mid" }, 
      { hex: "#BBBA9F", name: "85 - Kitchen Green" }, 
      { hex: "#563B2F", name: "32 - Spanish Brown" }, 
      { hex: "#D5CFC5", name: "150 - Slaked Lime Deep" }, 
      { hex: "#58574A", name: "45 - Invisible Green" }, 
      { hex: "#BBC2C9", name: "166 - Gauze Dark" }, 
      { hex: "#F19233", name: "209 - Marigold" }, 
      { hex: "#C1CBC5", name: "99 - Salix" }, 
      { hex: "#D7D9C1", name: "87 - Acorn" }, 
      { hex: "#ABB5AA", name: "138 - Aquamarine" }, 
      { hex: "#93C0B7", name: "202 - Spearmint" }, 
      { hex: "#4965AF", name: "112 - Mambo" }, 
      { hex: "#B8BDB4", name: "169 - Pearl Colour Dark" }, 
      { hex: "#C0C19A", name: "90 - Eau De Nil" }, 
      { hex: "#A99C6F", name: "84 - Boxington" }, 
      { hex: "#92A99B", name: "198 - Aquamarine Deep" }, 
      { hex: "#B95227", name: "24 - Heat" }, 
      { hex: "#D9E2E5", name: "182 - Bone China Blue Pale" }, 
      { hex: "#2B254E", name: "116 - Thai Sapphire" }, 
      { hex: "#BEC2A3", name: "83 - Olive Oil" }, 
      { hex: "#D9525F", name: "191 - Leather" }, 
      { hex: "#00B4A9", name: "93 - Turquoise Blue" }, 
      { hex: "#8E002F", name: "14 - Baked Cherry" }, 
      { hex: "#CCD1CA", name: "100 - Pearl Colour" }, 
      { hex: "#2A332E", name: "216 - Obsidian Green" }, 
      { hex: "#E8ECE8", name: "167 - Pearl Colour Pale" }, 
      { hex: "#9FB199", name: "91 - Pea Green" }, 
      { hex: "#B15F4F", name: "140 - Tuscan Red" }, 
      { hex: "#ACAC99", name: "79 - Normandy Grey" }, 
      { hex: "#C7BDAD", name: "156 - Portland Stone Deep" }, 
      { hex: "#8D7F3A", name: "71 - Citrine" }, 
      { hex: "#282523", name: "119 - Jack Black" }, 
      { hex: "#E7E4DD", name: "149 - Slaked Lime Mid" }, 
      { hex: "#8F3929", name: "15 - Bronze Red" }, 
      { hex: "#D3DAE0", name: "106 - Gauze" }, 
      { hex: "#F2E33A", name: "196 - Trumpet" }, 
      { hex: "#64737F", name: "326 - Etruria" }, 
      { hex: "#E3E2E6", name: "179 - Welcome Pale" }, 
      { hex: "#EEC256", name: "337 - Giallo" }, 
      { hex: "#DCE9E7", name: "282 - Aquamarine Pale" }, 
      { hex: "#C9B9B3", name: "178 - China Clay Dark" }, 
      { hex: "#B7C8C0", name: "284 - Aquamarine Mid" }, 
      { hex: "#B7B3B8", name: "181 - Welcome Dark" }, 
      { hex: "#9FA6AC", name: "327 - Obscura" }, 
      { hex: "#ECDEC9", name: "173 - Welcome Dark" }, 
      { hex: "#DED4D2", name: "176 - China Clay Mid" }, 
      { hex: "#F2EBD6", name: "170 - White Lead Mid" }, 
      { hex: "#F6F2E9", name: "328 - Silent White Pale" }, 
      { hex: "#E5CEC2", name: "332 - Masquerade Light" }, 
      { hex: "#A23533", name: "192 - Theatre Red" }, 
      { hex: "#EE775C", name: "21 - Orange Aurora" }, 
      { hex: "#E3CAB7", name: "154 - Clay Deep" }, 
      { hex: "#EEDED2", name: "26 - Julies Dream" }, 
      { hex: "#D2C5A6", name: "175 - Stock Dark" }, 
      { hex: "#E3D6C0", name: "331 - Silent White Deep" }, 
      { hex: "#F2EBDF", name: "329 - Silent White" }, 
      { hex: "#D6C9C5", name: "177 - China Clay Deep" }, 
      { hex: "#E4D4AF", name: "172 - White Lead Dark" }, 
      { hex: "#B8C5CB", name: "325 - Bone China Blue Faint" }, 
      { hex: "#E6D4BC", name: "174 - Stock Deep" }, 
      { hex: "#CBA694", name: "334 - Masquerade" }, 
      { hex: "#B7915B", name: "336 - Bassoon" }, 
      { hex: "#EDE2C5", name: "171 - White Lead Deep" }, 
      { hex: "#E14618", name: "190 - Atomic Red" }, 
      { hex: "#CDCACE", name: "180 - Welcome Deep" }, 
      { hex: "#B17136", name: "122 - Middle Buff" }, 
      { hex: "#627393", name: "278 - Pale Lupin" }, 
      { hex: "#849DAF", name: "276 - Grey Stone" }, 
      { hex: "#CBB08F", name: "64 - Bath Stone" }, 
      { hex: "#56736F", name: "280 - Pleat" }, 
      { hex: "#CCDAD5", name: "283 - Aquamarine Light" }, 
      { hex: "#E2B379", name: "265 - Mortlake Yellow" }, 
      { hex: "#DEB364", name: "53 - Light Gold" }, 
      { hex: "#CCD9DC", name: "217 - Drizzleï¿½Little" }, 
      { hex: "#DCBFB0", name: "333 - Masquerade Mid" }, 
      { hex: "#DAE7EB", name: "98 - Echo" }, 
      { hex: "#004F4F", name: "96 - Mid Azure Green" }, 
      { hex: "#C7BFB3", name: "151 - Slaked Lime Dark" }, 
      { hex: "#ECE2D1", name: "330 - Silent White Mid" }, 
      { hex: "#B0BFC3", name: "184 - Bone China Blue Deep" }, 
      { hex: "#C4BB65", name: "70 - Pale Lime" }, 
      { hex: "#C2E3EC", name: "102 - Gentle Sky" }, 
      { hex: "#CCD3DA", name: "165 - Gauze Deep" }, 
      { hex: "#90C0D1", name: "103 - Sky Blue" }, 
      { hex: "#E4D1A0", name: "69 - Lemon Tree" }, 
      { hex: "#DDD4CD", name: "159 - Rolling Fog Mid" }, 
      { hex: "#DDE1DC", name: "168 - Pearl Colour Mid" }, 
      { hex: "#EBCB5B", name: "335 - Indian yellow" }, 
      { hex: "#A0AFB3", name: "107 - Bone China Blue" }
    ],
      "Herfst & Helder": [      { hex: "#2A4540", name: "1846" }, 
      { hex: "#F5EAB7", name: "1127" }, 
      { hex: "#E9E9D3", name: "1615" }, 
      { hex: "#FAFDF5", name: "1618" }, 
      { hex: "#FFF7E0", name: "1644" }, 
      { hex: "#EDF3DF", name: "1646" }, 
      { hex: "#FEF9E6", name: "1648" }, 
      { hex: "#FBFEF5", name: "1651" }, 
      { hex: "#FDFCE6", name: "1126" }, 
      { hex: "#FDF6D8", name: "1122" }, 
      { hex: "#E9E1C8", name: "1636" }, 
      { hex: "#FEEEBD", name: "1119" }, 
      { hex: "#A9B8B3", name: "1477" }, 
      { hex: "#D5D2C0", name: "1616" }, 
      { hex: "#EBE7C7", name: "1614" }, 
      { hex: "#E3ECDC", name: "1620" }, 
      { hex: "#EDECDC", name: "919" }, 
      { hex: "#E9E3C7", name: "1637" }, 
      { hex: "#DED8B8", name: "1638" }, 
      { hex: "#E8E0C8", name: "1640" }, 
      { hex: "#F1E3C2", name: "1641" }, 
      { hex: "#F3E5C7", name: "1642" }, 
      { hex: "#EFE3C2", name: "1643" }, 
      { hex: "#F2F0E0", name: "1645" }, 
      { hex: "#E0D0B4", name: "1647" }, 
      { hex: "#F8F4E3", name: "1649" }, 
      { hex: "#ECE4D5", name: "1650" }, 
      { hex: "#EFF3E9", name: "1619" }, 
      { hex: "#F3E7B1", name: "1128" }, 
      { hex: "#FAF3D6", name: "1639" }, 
      { hex: "#F1A82F", name: "1135" }, 
      { hex: "#4F5A3C", name: "1745" }, 
      { hex: "#9B3933", name: "1256" }, 
      { hex: "#374C3F", name: "1751" }, 
      { hex: "#673A3A", name: "1257" }, 
      { hex: "#305140", name: "1749" }, 
      { hex: "#38533B", name: "1748" }, 
      { hex: "#333D46", name: "1580" }, 
      { hex: "#323B46", name: "1577" }, 
      { hex: "#2E4A67", name: "1573" }, 
      { hex: "#3B5457", name: "1568" }, 
      { hex: "#313634", name: "1500" }, 
      { hex: "#36443C", name: "1845" }, 
      { hex: "#5E3C3A", name: "1258" }, 
      { hex: "#323A38", name: "1848" }, 
      { hex: "#7A4B42", name: "1254" }, 
      { hex: "#6D4338", name: "1253" }, 
      { hex: "#54443C", name: "1250" }, 
      { hex: "#43403B", name: "1249" }, 
      { hex: "#A77A41", name: "1134" }, 
      { hex: "#2F5842", name: "1885" }, 
      { hex: "#4B6C4F", name: "1895" }, 
      { hex: "#543938", name: "1259" }, 
      { hex: "#264D53", name: "1567" }, 
      { hex: "#254C69", name: "1571" }, 
      { hex: "#473D38", name: "1251" }, 
      { hex: "#304C41", name: "1750" }, 
      { hex: "#783D37", name: "1255" }, 
      { hex: "#34433B", name: "1844" }, 
      { hex: "#344149", name: "1575" }, 
      { hex: "#356241", name: "1747" }, 
      { hex: "#30413F", name: "1847" }, 
      { hex: "#313836", name: "1851" }, 
      { hex: "#394B45", name: "1875" }, 
      { hex: "#323D3A", name: "1850" }, 
      { hex: "#343D3B", name: "1849" }, 
      { hex: "#78453A", name: "1252" }, 
      { hex: "#473837", name: "1260" }, 
      { hex: "#454C4C", name: "100" }, 
      { hex: "#256490", name: "1570" }, 
      { hex: "#44633B", name: "1746" }, 
      { hex: "#C7BFA4", name: "1617" }, 
      { hex: "#949D99", name: "1478" }, 
      { hex: "#F4DAA8", name: "1129" }, 
      { hex: "#E6D29E", name: "1635" }, 
      { hex: "#949995", name: "200" }, 
      { hex: "#DDB769", name: "1131" }, 
      { hex: "#D7CB86", name: "1634" }, 
      { hex: "#F3C36C", name: "1133" }, 
      { hex: "#D9B772", name: "1130" }, 
      { hex: "#496073", name: "1572" }, 
      { hex: "#EABB6E", name: "1132" }, 
      { hex: "#67706E", name: "1480" }, 
      { hex: "#818883", name: "1479" }, 
      { hex: "#415D6B", name: "1569" }
    ]
    };

    var currentPage = 1;
    var openBtn = document.getElementById('openColorPicker3');
    var popupContainer = document.getElementById('popupContainer3');
    var overlay = document.getElementById('colorPickerOverlay3');
    var closeBtn = document.getElementById('closeColorPicker3');
    var gridWrapper = document.querySelector('.grid-wrapper');
    var selectedColorNameEl = document.getElementById('selectedColorName3');
    var chooseColorBtn = document.getElementById('chooseColorBtn3');
    var selectedColor = null;
    function getContrast(hexcolor) {
      hexcolor = hexcolor.replace("#", "");
      var r = parseInt(hexcolor.substr(0,2), 16);
      var g = parseInt(hexcolor.substr(2,2), 16);
      var b = parseInt(hexcolor.substr(4,2), 16);
      var brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return (brightness > 186) ? "black" : "white";
    }
    function clearSelection() {
      selectedColor = null;
      selectedColorNameEl.textContent = 'Geen kleur geselecteerd';
      document.querySelectorAll('.color-box').forEach(function(b) { b.classList.remove('selected'); });
    }
    function createColorBox(color) {
      var box = document.createElement('div');
      box.className = 'color-box';
      box.style.width = '150px';
      box.style.height = '150px';
      var inner = document.createElement('div');
      inner.className = 'my-red-block';
      inner.setAttribute('style', 'background-color: ' + color.hex + ' !important;');
      var label = document.createElement('p');
      label.style.margin = '0';
      label.style.textAlign = 'center';
      label.style.fontSize = '14px';
      label.style.color = getContrast(color.hex);
      label.textContent = color.name;
      inner.appendChild(label);
      box.appendChild(inner);
      box.setAttribute('data-color-name', color.name);
      box.setAttribute('data-color-hex', color.hex);
      box.addEventListener('click', function() {
        document.querySelectorAll('.color-box').forEach(function(b) { b.classList.remove('selected'); });
        box.classList.add('selected');
        selectedColor = color;
        selectedColorNameEl.textContent = color.name;
      });
      return box;
    }
    var touchStartX = 0, touchEndX = 0, swipeThreshold = 50;
    gridWrapper.addEventListener('touchstart', function(e) {
      if (window.innerWidth < 768 && currentTabSet !== 'Zoeken') {
        touchStartX = e.changedTouches[0].screenX;
      }
    });
    gridWrapper.addEventListener('touchend', function(e) {
      if (window.innerWidth < 768 && currentTabSet !== 'Zoeken') {
        touchEndX = e.changedTouches[0].screenX;
        var perPage = (window.innerWidth < 768) ? 6 : 12;
        var totalPages = Math.ceil(colorSets[currentTabSet].length / perPage);
        if (touchStartX - touchEndX > swipeThreshold) {
          if (currentPage < totalPages) { currentPage++; renderGrid(); }
        } else if (touchEndX - touchStartX > swipeThreshold) {
          if (currentPage > 1) { currentPage--; renderGrid(); }
        }
      }
    });
    function renderGrid() {
      gridWrapper.innerHTML = '';
      var bodyContainer = popupContainer.querySelector('.color-picker-body');
      if (currentTabSet === 'Zoeken') {
        bodyContainer.classList.add('search-active');
      } else {
        bodyContainer.classList.remove('search-active');
      }
      if (currentTabSet === 'Zoeken') {
        var searchWrapper = document.createElement('div');
        searchWrapper.className = 'search-mode-container';
        if (window.innerWidth < 768) {
          searchWrapper.style.width = '300px';
          searchWrapper.style.maxWidth = '300px';
        } else {
          searchWrapper.style.width = '600px';
          searchWrapper.style.maxWidth = '600px';
        }
        var searchDiv = document.createElement('div');
        searchDiv.className = 'search-container';
        var searchInput = document.createElement('input');
        searchInput.type = 'text';
        searchInput.placeholder = 'Zoek naar een kleur...';
        searchInput.id = 'colorSearchInput3';
        searchDiv.appendChild(searchInput);
        searchWrapper.appendChild(searchDiv);
        var resultsDiv = document.createElement('div');
        resultsDiv.id = 'searchResults3';
        resultsDiv.className = 'search-results';
        searchWrapper.appendChild(resultsDiv);
        gridWrapper.appendChild(searchWrapper);
        if (window.innerWidth >= 768) { setTimeout(function(){ searchInput.focus(); }, 100); }
        searchInput.addEventListener('input', function() {
          var query = searchInput.value.toLowerCase();
          renderSearchResults(query);
        });
        return;
      }
      var gridContainer = document.createElement('div');
      gridContainer.id = 'colorGrid3';
      gridContainer.className = 'color-grid default-grid';
      gridWrapper.appendChild(gridContainer);
      var items = [];
      if (currentTabSet !== 'Zoeken') {
        var perPage = (window.innerWidth < 768) ? 6 : 12;
        var totalPages = Math.ceil(colorSets[currentTabSet].length / perPage);
        if (currentPage > totalPages) currentPage = totalPages;
        items = colorSets[currentTabSet].slice((currentPage - 1) * perPage, currentPage * perPage);
      }
      if (items.length === 0) {
        gridContainer.innerHTML = '<p style="text-align:center; color:#888;">Geen opties beschikbaar</p>';
      } else {
        items.forEach(function(item) {
          var box = createColorBox(item);
          gridContainer.appendChild(box);
        });
      }
      if (currentTabSet !== 'Zoeken') {
        if (totalPages > 1) {
          var paginationDiv = document.createElement('div');
          paginationDiv.className = 'pagination';
          var prevBtn = document.createElement('button');
          prevBtn.innerHTML = '<i class="fas fa-arrow-left"></i>';
          prevBtn.disabled = (currentPage === 1);
          prevBtn.addEventListener('click', function() { if (currentPage > 1) { currentPage--; renderGrid(); } });
          paginationDiv.appendChild(prevBtn);
          var pageIndicator = document.createElement('span');
          pageIndicator.textContent = 'Pagina ' + currentPage + ' van ' + totalPages;
          paginationDiv.appendChild(pageIndicator);
          var nextBtn = document.createElement('button');
          nextBtn.innerHTML = '<i class="fas fa-arrow-right"></i>';
          nextBtn.disabled = (currentPage === totalPages);
          nextBtn.addEventListener('click', function() { if (currentPage < totalPages) { currentPage++; renderGrid(); } });
          paginationDiv.appendChild(nextBtn);
          gridWrapper.appendChild(paginationDiv);
        }
      }
    }
    function renderSearchResults(query) {
      var resultsDiv = document.getElementById('searchResults3');
      resultsDiv.innerHTML = '';
      if (!query.trim()) {
        resultsDiv.innerHTML = '<p style="text-align:center; color:#888;">Typ een zoekterm</p>';
        return;
      }
      var maxResults = (window.innerWidth < 768) ? 4 : 8;
      var filtered = allColors.filter(function(c) {
        return c.name.toLowerCase().includes(query);
      }).slice(0, maxResults);
      if (filtered.length === 0) {
        resultsDiv.innerHTML = '<p style="text-align:center; color:#888;">Geen resultaten</p>';
        return;
      }
      filtered.forEach(function(color) {
        var box = createColorBox(color);
        resultsDiv.appendChild(box);
      });
    }
    var allColors = [];
    Object.keys(colorSets).forEach(function(key) {
      allColors = allColors.concat(colorSets[key]);
    });
    var tabButtons = document.querySelectorAll('.tab-button');
    tabButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        tabButtons.forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        currentTabSet = btn.getAttribute('data-tab');
        if (btn.getAttribute('data-tab') !== 'Zoeken') { currentPage = 1; }
        renderGrid();
        clearSelection();
        var extraDesc = document.getElementById('extraDescription3');
        if (extraInfo && extraInfo[currentTabSet]) {
          extraDesc.style.display = 'block';
          extraDesc.innerHTML = '<em>' + extraInfo[currentTabSet] + '</em>';
        } else {
          extraDesc.style.display = 'none';
        }
      });
    });
    openBtn.addEventListener('click', function() {
      if (window.innerWidth < 768) { document.body.style.overflow = 'hidden'; }
      if (window.innerWidth >= 768) {
        currentTabSet = 'Zoeken';
        tabButtons.forEach(function(b) {
          b.classList.remove('active');
          if (b.getAttribute('data-tab') === 'Zoeken') { b.classList.add('active'); }
        });
      }
      overlay.style.display = 'block';
      popupContainer.style.display = 'block';
      renderGrid();
    });
    closeBtn.addEventListener('click', function() {
      popupContainer.style.display = 'none';
      overlay.style.display = 'none';
      document.body.style.overflow = '';
      clearSelection();
    });
    document.getElementById('colorPickerOverlay3').addEventListener('click', function(e) {
      if (e.target === document.getElementById('colorPickerOverlay3')) {
        popupContainer.style.display = 'none';
        overlay.style.display = 'none';
        document.body.style.overflow = '';
        clearSelection();
      }
    });
    chooseColorBtn.addEventListener('click', function() {
      if (selectedColor) {
        var finalTab = currentTabSet;
        if (currentTabSet === 'Zoeken') {
          for (var key in colorSets) {
            if (colorSets[key].some(function(c) { return c.hex === selectedColor.hex && c.name === selectedColor.name; })) {
              finalTab = key;
              break;
            }
          }
        }
        var targetEl = document.getElementById('ymq-attrib-1tem3');
        if (targetEl) {
          targetEl.value = finalTab + ': ' + selectedColor.name;
        } else {
          alert("Textbox 'ymq-attrib-1tem3' niet gevonden.");
        }
        var contrast = getContrast(selectedColor.hex);
        openBtn.style.backgroundColor = selectedColor.hex;
        openBtn.style.backgroundImage = 'none';
        openBtn.style.color = contrast;
        var icon = openBtn.querySelector('i');
        if (icon) { icon.style.color = contrast; }
        popupContainer.style.display = 'none';
        overlay.style.display = 'none';
        document.body.style.overflow = '';
        clearSelection();
      }
    });
    window.addEventListener('resize', function() {
      if (document.body.style.overflow === 'hidden') { renderGrid(); }
    });
  });
